/**
 * Generated by orval v6.22.1 🍺
 * Do not edit manually.
 * apiserv
 * connectRN API server responsible for handling the backend processes for the connectRN Web and Mobile app.
 * OpenAPI spec version: 2.27.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  DeleteAdminDeletednrParams,
  DeleteAdminJobhistoryDeleteParams,
  DeleteAdminOrganizationParams,
  DeleteAdminOrganizationsUserDeleteParams,
  DeleteAdminRequirementRemoveV2Params,
  DeleteAdminUserDeleteParams,
  DeleteAnnouncementsId200,
  DeleteFilterParams,
  DeleteNurseDeleteresumeParams,
  DeleteNurseRequirementRemoveV2Params,
  DeleteShiftsIdBonus200,
  DeleteShiftsIdBonus400,
  DeleteShiftsIdBonus500,
  DeleteUserRejectshiftapplicant200,
  DeleteUserRejectshiftapplicantParams,
  GetAccessLevels200Item,
  GetAccessLevelsIdScopes200,
  GetAccessLevelsParams,
  GetAdminDepartmentDeptidGet200,
  GetAdminDepartmentDeptidRequirements200Item,
  GetAdminDnrlist200,
  GetAdminDnrlistParams,
  GetAdminDownloadorganizationsParams,
  GetAdminFilteredRequirementSearch200Item,
  GetAdminFilteredRequirementSearchParams,
  GetAdminGetreasons200Item,
  GetAdminGetreasonsParams,
  GetAdminLocationLocid200,
  GetAdminLocationLocidHolidayConfiguration200,
  GetAdminLocationLocidRequirements200Item,
  GetAdminLocationLocidUsers200Item,
  GetAdminLocationshifttimesLocid200Item,
  GetAdminNurse200,
  GetAdminNurseParams,
  GetAdminNursesearch200Item,
  GetAdminNursesearchParams,
  GetAdminOrganizationOrgid200,
  GetAdminOrganizationOrgidAcquisition200Item,
  GetAdminOrganizationOrgidRequirements200Item,
  GetAdminOrganizations200,
  GetAdminOrganizationsOrgstatustypes200Item,
  GetAdminOrganizationsParams,
  GetAdminOrganizationsSupervisorlistOrgid200Item,
  GetAdminOrganizationsTypes200Item,
  GetAdminRequirementsLocationFieldsLocid200,
  GetAdminRequirementsUserUserid200Item,
  GetAdminRequirementsUserUseridReqid200,
  GetAdminShiftRequirementsUserUseridShiftid200Item,
  GetAdminShifts200,
  GetAdminShifts500,
  GetAdminShiftsParams,
  GetAdminTimesheets200,
  GetAdminTimesheetsDownloadParams,
  GetAdminTimesheetsParams,
  GetAdminTimezones200Item,
  GetAdminUsers200,
  GetAdminUsersDownloadParams,
  GetAdminUsersParams,
  GetAdminUsersearch200Item,
  GetAdminUsersearchParams,
  GetAlertGetalert200Item,
  GetAlertGetalertParams,
  GetAnnouncements200,
  GetBackfillShifts200Item,
  GetBackfillShifts401,
  GetBackfillShifts500,
  GetBackfillShiftsParams,
  GetBonusStatuses200Item,
  GetBonusTypes200Item,
  GetBonuses200,
  GetBonusesDownloadParams,
  GetBonusesParams,
  GetCancellationCheck200,
  GetCicoBanners200,
  GetCicoBanners500,
  GetClinicianpools200,
  GetDepartmentDeptIdRoleRateMappings200,
  GetEmr200Item,
  GetEnterpriseSettings200Item,
  GetEnterpriseSettingsEvaluate200,
  GetEnterpriseSettingsEvaluateParams,
  GetFeaturesGlobal200Item,
  GetFeaturesUser200Item,
  GetFiltersv2200Item,
  GetGetsavedfilters200Item,
  GetHolidays200Item,
  GetHolidaysParams,
  GetLocationLocid200,
  GetLocationsLocIdSettings200,
  GetLoyaltyLevels200Item,
  GetLoyaltyLoyaltylevelandfaqs200,
  GetMarkets200Item,
  GetMarketsParams,
  GetMobileLatestversion200,
  GetNps200Item,
  GetNpsAvailable200,
  GetNurseCheckcredentialexpire200Item,
  GetNurseFullShiftHistory200,
  GetNurseFullShiftHistoryParams,
  GetNurseRequirements200Item,
  GetNurseRequirementsV2200,
  GetNurseShiftTimesheet200,
  GetNurseShiftTimesheetComponents200Item,
  GetNurseShiftTimesheetComponentsParams,
  GetNurseShiftTimesheetNotes200Item,
  GetNurseShiftTimesheetNotesParams,
  GetNurseShiftTimesheetNotesv2200Item,
  GetNurseShiftTimesheetNotesv2Params,
  GetNurseShiftTimesheetParams,
  GetNurseShifthistory200Item,
  GetNurseShifthistoryParams,
  GetNurses200,
  GetNursesParams,
  GetNursesRequestableShifts200,
  GetNursesRequestableShifts400,
  GetNursesRequestableShiftsParams,
  GetNursesShiftsUpcoming200,
  GetNursesShiftsUpcoming500,
  GetOnboardingJobhistory200,
  GetOrgGetorgshifttimes200Item,
  GetOrgLocationshifttimes200,
  GetOrgLocationshifttimesParams,
  GetOrganizationOrgid200Item,
  GetOrganizationOrgidLocidSupervisors200Item,
  GetOrganizations200Item,
  GetOrganizationsOrgIdSettings200Item,
  GetOrgfeatures200Item,
  GetOrgfeaturesParams,
  GetOverdueTimesheets200,
  GetOverdueTimesheets500,
  GetQrCodeUrl200,
  GetQrCodeUrlParams,
  GetQuestionnaireQuestionnaireId200,
  GetQuestionnaireQuestionnaireId404,
  GetQuestionnaireQuestionnaireId500,
  GetQuestionnaireQuestionnaireIdSettings200,
  GetQuestionnaireQuestionnaireIdSettings404,
  GetQuestionnaireQuestionnaireIdSettings500,
  GetRateincreaseoptions200Item,
  GetRateincreaseoptionsParams,
  GetRatingGetRatingQuestions200Item,
  GetRatingGetRatingQuestionsParams,
  GetRecentOverdueTimesheet200,
  GetRecentOverdueTimesheet500,
  GetRegistryAllDef200Item,
  GetRegistryDefId200,
  GetRegistryExplainDocuments200,
  GetRegistryExplainGlobal200,
  GetRegistryExplainShiftShiftid200,
  GetRegistryExplainShiftShiftidParams,
  GetRegistryExplainTraining200,
  GetRegistryExplainTrainingCritical200,
  GetRegistryFulfillmentTypes200Item,
  GetRegistryItemId200,
  GetRegistryRegdefRegdefidUserUseridSummary200,
  GetRegistryUserUserid200Item,
  GetRequestedShifts200Item,
  GetRequestedShifts401,
  GetRequestedShifts500,
  GetRequestedShiftsCount200,
  GetRequestedShiftsCount401,
  GetRequestedShiftsCount500,
  GetRequestsAdminPending200Item,
  GetRequestsClosed200,
  GetRequestsClosedParams,
  GetRequestsPending200,
  GetRequestsPendingParams,
  GetRequirementId200,
  GetRequirementIdOrgid200,
  GetRequirements200Item,
  GetRequirementsConnectrn200Item,
  GetRequirementsParams,
  GetRequirementsSearch200Item,
  GetRequirementsSearchParams,
  GetRequirementsSearchV2200,
  GetRequirementsSearchV2Params,
  GetRequirementsSearchV3200,
  GetRequirementsSearchV3Params,
  GetRequirementsShiftrequirement200Item,
  GetRequirementsShiftrequirementParams,
  GetRoles200Item,
  GetScopes200Item,
  GetShiftShiftid200,
  GetShiftmatchPaneldataUserDateDate200,
  GetShiftmatchPaneldataUserDateDateParams,
  GetShiftmatchUserFilters200,
  GetShiftsAcceptedandapplied200,
  GetShiftsAcceptedandappliedParams,
  GetShiftsAvailablev3200,
  GetShiftsAvailablev3Params,
  GetShiftsLog200Item,
  GetShiftsLogParams,
  GetShiftsOpenshifts200,
  GetShiftsOpenshiftsParams,
  GetSignoffCanSelfCheckout200,
  GetSignoffCanSelfCheckoutParams,
  GetSpecialties200Item,
  GetStates200Item,
  GetSupervisorAvailabilityOrgid200,
  GetSupervisorAvailabilityOrgid400,
  GetSupervisorAvailabilityOrgid401,
  GetSupervisorAvailabilityOrgid500,
  GetSupervisorGettimesheet200,
  GetSupervisorGettimesheetParams,
  GetSupervisorSearch200,
  GetSupervisorSearchParams,
  GetSupervisorShiftShiftid200,
  GetSupervisorShiftsBydate200Item,
  GetSupervisorShiftsBydateParams,
  GetSupervisorShiftsCalendar200,
  GetSupervisorShiftsForDnrOrIssue200Item,
  GetSupervisorShiftsForDnrOrIssue400,
  GetSupervisorShiftsForDnrOrIssueParams,
  GetSupervisorShiftsQuickActions200Item,
  GetSupervisorShiftsQuickActionsParams,
  GetSupervisorTimesheets200,
  GetSupervisorTimesheetsCount200,
  GetSupervisorTimesheetsCountParams,
  GetSupervisorTimesheetsDownloadParams,
  GetSupervisorTimesheetsParams,
  GetSupportSubtopics200Item,
  GetSupportTopics200Item,
  GetSurveysIdQuestions200,
  GetSurveysIdQuestions404,
  GetSurveysIdQuestions500,
  GetTaskTypes200Item,
  GetTest200,
  GetToscheduleRequirementId200,
  GetUserAdminDownloadshiftlistParams,
  GetUserAdminShiftlist200,
  GetUserAdminShiftlistParams,
  GetUserBackfillShiftsShiftid200,
  GetUserBasicnurseinfo200,
  GetUserBasicnurseinfoParams,
  GetUserCallouts200,
  GetUserCalloutsParams,
  GetUserDoubleCheckShiftid200,
  GetUserGetDefaultPreferences200,
  GetUserGetPreferences200,
  GetUserGetacceptedshiftapplicantId200Item,
  GetUserGetonboardingpreferences200,
  GetUserGetshiftapplicantId200Item,
  GetUserGetuserbyid200,
  GetUserGetuserbyidParams,
  GetUserImpersonateUserid200,
  GetUserImpersonateUserid400,
  GetUserImpersonateUserid500,
  GetUserInfo200,
  GetUserInfoMobile200,
  GetUserJobhistory200,
  GetUserJobhistoryParams,
  GetUserLoyaltyEventsNurseId200Item,
  GetUserLoyaltyEventsNurseIdParams,
  GetUserMetrics200,
  GetUserNoticeCount200,
  GetUserNoticeUnseenCount200,
  GetUserNoticeUnseenCount401,
  GetUserNoticeUnseenCount500,
  GetUserNotices200Item,
  GetUserNurseAccountactivity200Item,
  GetUserNurseAccountactivity400,
  GetUserNurseAccountactivity500,
  GetUserNurseAccountactivityParams,
  GetUserNurseWorkedUseridNumdaysback200Item,
  GetUserNurseWorkedUseridNumdaysback400,
  GetUserNurseWorkedUseridNumdaysback500,
  GetUserNurseWorkedUseridNumdaysbackFriendid200,
  GetUserNurseWorkedUseridNumdaysbackFriendid400,
  GetUserNurseWorkedUseridNumdaysbackFriendid500,
  GetUserOrganizationMessages200Item,
  GetUserOrganizationMessages400,
  GetUserOrganizationMessages500,
  GetUserOrganizationMessagesParams,
  GetUserPayrate200Item,
  GetUserProfileDownloadPDFUserIDParams,
  GetUserRecentShiftsStatus200,
  GetUserShiftDetailShiftID200,
  GetUserShiftcalloutexcuse200,
  GetUserShiftsShiftid200,
  GetUserShiftsShiftidShared200,
  GetUserShiftsv2200Item,
  GetUserShowonboardingflow200,
  GetUserShowredirecttofountain200,
  GetUserSupervisordashboard200,
  GetUserSupervisordashboardParams,
  GetUserSupervisordashboardv2200,
  GetUserSupervisordashboardv2Params,
  GetUserWebshiftspageforcefilteruser200,
  GetUserWorkwithfriendsBlockedusers200Item,
  GetUserWorkwithfriendsBlockedusers500,
  GetUserWorkwithfriendsStatus200Item,
  GetUserWorkwithfriendsStatus500,
  GetUsersUserIdOneTimeEventsEventName200,
  GetUsersUserIdSkills200,
  GetYearsofexp200Item,
  PatchOrganizationsOrgid500,
  PatchOrganizationsOrgidBody,
  PatchShiftsShiftid400,
  PatchShiftsShiftid401,
  PatchShiftsShiftid404,
  PatchShiftsShiftid500,
  PatchShiftsShiftidBody,
  PatchShiftsShiftidRequestsRequestid200,
  PatchShiftsShiftidRequestsRequestid400,
  PatchShiftsShiftidRequestsRequestid500,
  PatchTimesheetsId400,
  PatchTimesheetsId401,
  PatchTimesheetsId500,
  PatchTimesheetsIdBody,
  PatchUserShiftApplicantId400,
  PatchUserShiftApplicantId401,
  PatchUserShiftApplicantId500,
  PostAccessLevels200,
  PostAccessLevelsBody,
  PostAccessLevelsIdScopesBody,
  PostAdminCreateMultipleSmartlinxBody,
  PostAdminCreatednrBody,
  PostAdminJobhistoryCreateBody,
  PostAdminLocationLocidHolidayConfiguration200,
  PostAdminLocationLocidHolidayConfigurationBody,
  PostAdminOrgRequirementsOrgidReqidAssignBody,
  PostAdminOrgRequirementsOrgidReqidUpdateassignBody,
  PostAdminOrganizationOrgidAcquisitionBody,
  PostAdminOrganizationsAddupdateBody,
  PostAdminOrganizationsAddusersBody,
  PostAdminOrganizationsDepartmentsAddupdateBody,
  PostAdminOrganizationsDepartmentsUpdatenameBody,
  PostAdminOrganizationsLocationsAddupdateBody,
  PostAdminOrganizationsLocationsRateincreaseBody,
  PostAdminOrganizationsSetSupervisorlistOrgidBodyItem,
  PostAdminOrganizationsUserAddBody,
  PostAdminRequestApprovalBody,
  PostAdminRequirementApprovalBody,
  PostAdminRequirementsLocationFieldsLocidBody,
  PostAdminRequirementsUserUseridAddBody,
  PostAdminRequirementsUserUseridUpdateV2Body,
  PostAdminShiftCreateApplyBody,
  PostAdminShiftsShiftidApplyBody,
  PostAdminTimesheetCheckin200,
  PostAdminTimesheetCheckinBody,
  PostAdminUserCreate200,
  PostAdminUserCreateBody,
  PostAlertCreateBody,
  PostAnnouncements200,
  PostAnnouncementsBody,
  PostApplicantVerificationcodeGenerateBody,
  PostApplicantVerificationcodeVerify200,
  PostApplicantVerificationcodeVerifyBody,
  PostBonuses200,
  PostBonusesBody,
  PostFeedback200,
  PostFeedbackBody,
  PostFile200,
  PostFileBody,
  PostIterableEventBody,
  PostMobileDeviceinfo200,
  PostMobileDeviceinfoBody,
  PostNpsSubmitBody,
  PostNurseAppSessionBody,
  PostNurseJobhistoryCreateBody,
  PostNurseRequirementsAdd200,
  PostNurseRequirementsAddBody,
  PostNurseRequirementsAddV2200,
  PostNurseRequirementsAddV2Body,
  PostNurseShiftTimesheetAsyncNoteBody,
  PostNurseShiftTimesheetComponentAdd200,
  PostNurseShiftTimesheetComponentAddBody,
  PostNurseShiftTimesheetNote200Item,
  PostNurseShiftTimesheetNoteBodyItem,
  PostNurseShiftsRequests400,
  PostNurseShiftsRequests500,
  PostNurseShiftsRequestsBody,
  PostNurseTimesheetCheckin200,
  PostNurseTimesheetCheckinBody,
  PostNurseTimesheetLogBody,
  PostOnboardingJobhistoryBody,
  PostQrCodeUrlValidate200,
  PostQrCodeUrlValidateBody,
  PostQrUnavailableSupervisorBody,
  PostQuestionnaire400,
  PostQuestionnaire413,
  PostQuestionnaire415,
  PostQuestionnaire500,
  PostQuestionnaireBody,
  PostRatingDismissNurseRatingBody,
  PostRatingDismissOrganizationRatingBody,
  PostRatingSubmitNurseRatingV2Body,
  PostRatingSubmitOrganizationRatingV2Body,
  PostRegistryDef200,
  PostRegistryDefBody,
  PostRegistryImportItem200,
  PostRegistryImportItemBody,
  PostRegistryItem200,
  PostRegistryItemBody,
  PostRegistryMultisignBody,
  PostRegistryRequirement200,
  PostRegistryRequirementBody,
  PostRequirementsCreateBody,
  PostRequirementsEditBody,
  PostSavefilterBody,
  PostShiftShiftidAdmincalloutBody,
  PostShiftShiftidApply200,
  PostShiftShiftidApplyBody,
  PostShiftShiftidCalloutBody,
  PostShiftShiftidShareBody,
  PostShiftShiftidWithdrawBody,
  PostShiftsCreateBody,
  PostShiftsCreateMultipleBody,
  PostShiftsCreateMultipleV2400,
  PostShiftsCreateMultipleV2403,
  PostShiftsCreateMultipleV2500,
  PostShiftsCreateMultipleV2Body,
  PostSupervisorAvailability200,
  PostSupervisorAvailability400,
  PostSupervisorAvailability500,
  PostSupervisorAvailabilityBody,
  PostSupervisorNurseDnr200,
  PostSupervisorNurseDnr400,
  PostSupervisorNurseDnr500,
  PostSupervisorNurseDnrBody,
  PostSupervisorPinRecovery200,
  PostSupervisorPinRecoveryBody,
  PostSupervisorReportIssue200,
  PostSupervisorReportIssueBody,
  PostSupervisorReportNoshow200,
  PostSupervisorReportNoshowBody,
  PostSupportCases200,
  PostSupportCasesBody,
  PostSurveysIdResponses200,
  PostSurveysIdResponses400,
  PostSurveysIdResponses404,
  PostSurveysIdResponsesBodyItem,
  PostTimesheetAdjustedTimeBody,
  PostUserAcceptshiftapplicant200,
  PostUserAcceptshiftapplicantBody,
  PostUserAuth0Body,
  PostUserCheckbacktoback200,
  PostUserCheckbacktobackBody,
  PostUserFeaturesId200,
  PostUserFeaturesIdBody,
  PostUserForgotPasswordVerifyBody,
  PostUserForgotpasswordBody,
  PostUserFountainEmailValidation200,
  PostUserFountainEmailValidationBody,
  PostUserFountainStageTransitionBody,
  PostUserGenerateFountainApplicationLinks200,
  PostUserGenerateFountainApplicationLinksBody,
  PostUserHubspotShiftApplyIssueEventBody,
  PostUserLogin200,
  PostUserLoginBody,
  PostUserLoginMobile200,
  PostUserLoginMobileBody,
  PostUserOptOutPrefUnitBody,
  PostUserSendmessageBody,
  PostUserSetPreferencesBody,
  PostUserUpload200,
  PostUserUploadBody,
  PostUserUploadprofilepic200,
  PostUserUploadprofilepicBody,
  PostUserUploadresume200,
  PostUserUploadresumeBody,
  PostUserWorkwithfriendsToggleblockstatusBlockid200Item,
  PostUserWorkwithfriendsToggleblockstatusBlockid400,
  PostUserWorkwithfriendsToggleblockstatusBlockid500,
  PostUsersUserIdAccessLevelBody,
  PostUsersUserIdSkills200,
  PostUsersUserIdSkillsBody,
  PutAccessLevelsIdBody,
  PutAccessLevelsIdScopesBody,
  PutAdminBonusesPayallprocessedbonusParams,
  PutAdminBonusesProcessallParams,
  PutAdminJobhistoryUpdateBody,
  PutAdminLocationLocIdDetailsBody,
  PutAdminLocationshifttimes200,
  PutAdminLocationshifttimesBody,
  PutAdminOrganizationsUserUpdateBody,
  PutAdminPaidtimesheet200,
  PutAdminPaidtimesheetBody,
  PutAdminRequirementsLocationFieldsLocidBody,
  PutAdminTimesheetAutumnlakeSyncBody,
  PutAdminTimesheetCheckoutBody,
  PutAdminTimesheetUpdateId200,
  PutAdminTimesheetUpdateIdBody,
  PutAdminTimesheetUpdatestatusandtimeId200,
  PutAdminTimesheetUpdatestatusandtimeIdBody,
  PutAdminTimesheetsPayallParams,
  PutAdminTimesheetsProcessallParams,
  PutAdminUpdatesecuritycodebyadminBody,
  PutAdminUserApprovedBody,
  PutAdminUserEditsuspendBody,
  PutAdminUserRejectBody,
  PutAdminUserRemediationBody,
  PutAdminUserSuspendBody,
  PutAdminUserUnsuspendBody,
  PutAdminUserUpdate200,
  PutAdminUserUpdateActiveStatusIdBody,
  PutAdminUserUpdateBody,
  PutAdminUserUpdateincentivepermissionsBody,
  PutAdminUserUpdatetestuserBody,
  PutAnnouncementsId200,
  PutAnnouncementsIdBody,
  PutBonusesId200,
  PutBonusesIdBody,
  PutLocationsLocIdSettingsSettingIdBody,
  PutNurseJobhistoryUpdateBody,
  PutNurseRequirementsUpdate200,
  PutNurseRequirementsUpdateBody,
  PutNurseRequirementsUpdateV2200,
  PutNurseRequirementsUpdateV2Body,
  PutNurseShiftTimesheetComponentUpdate200,
  PutNurseShiftTimesheetComponentUpdateBody,
  PutNurseTimesheetCheckoutv2200,
  PutNurseTimesheetCheckoutv2Body,
  PutNursesSaveGeolocations400,
  PutNursesSaveGeolocationsBodyItem,
  PutOnboardingDemographicsBody,
  PutOnboardingUpdateBody,
  PutOrganizationsOrgIdSettingsSettingIdBody,
  PutOrgfeatureUpdateBody,
  PutQuestionnaireSettings400,
  PutQuestionnaireSettings413,
  PutQuestionnaireSettings415,
  PutQuestionnaireSettings500,
  PutQuestionnaireSettingsBody,
  PutRegistryDefBody,
  PutRegistryItemBody,
  PutRegistryRequirementBody,
  PutSetfilterasdefaultBody,
  PutShiftFeatureBody,
  PutShiftFeatureNameBody,
  PutShiftRemovePositionShiftIdBody,
  PutShiftmatchConfirmUserBody,
  PutShiftmatchUserFiltersBody,
  PutShiftsUpdateBody,
  PutSignoffCheckinsignoff200,
  PutSignoffCheckinsignoffBody,
  PutSignoffConfirmcheckout200,
  PutSignoffConfirmcheckoutBody,
  PutSignoffSelfCheckoutBody,
  PutSignoffSignoffcheckin200Item,
  PutSignoffSignoffcheckinBody,
  PutSignoffSkipBody,
  PutSignoffSkipSupervisor200,
  PutSignoffSkipSupervisor400,
  PutSignoffSkipSupervisor409,
  PutSignoffSkipSupervisor500,
  PutSignoffSkipSupervisorBody,
  PutSupervisorApprovedtimesheetBody,
  PutSupervisorAvailabilityId200,
  PutSupervisorAvailabilityId400,
  PutSupervisorAvailabilityId404,
  PutSupervisorAvailabilityId500,
  PutSupervisorAvailabilityIdBody,
  PutSupervisorSavetimesheetBody,
  PutSupervisorTimesheetsCheckoutBody,
  PutSupervisorUpdatesecuritycodeBody,
  PutUserBeatAdminBody,
  PutUserBeatJewelBody,
  PutUserCancelshiftBody,
  PutUserFeatureNameBody,
  PutUserNoticeMarkseen400,
  PutUserNoticeMarkseen500,
  PutUserNoticeMarkseenBody,
  PutUserPushBody,
  PutUserSupervisordetailsUpdateBody,
  PutUserUndorejectshiftapplicant200,
  PutUserUndorejectshiftapplicantBody,
  PutUserUpdateFlagFirstTimeAcceptedShiftBody,
  PutUserUpdatepasswordBody,
  PutUserUpdateshiftcalloutexcuseBody,
  PutUserUpdateuserhazardpayBody,
  PutUserWorkwithfriendsToggleblockstatus200Item,
  PutUserWorkwithfriendsToggleblockstatus500,
  PutUsersUserIdOneTimeEventsEventName200
} from './index.schemas'
import { request } from '../request';
import type { ErrorType } from '../request';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


/**
 * Obtain a list of access levels
 */
export const getAccessLevels = (
    params?: GetAccessLevelsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAccessLevels200Item[]>(
      {url: `/access-levels`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAccessLevelsQueryKey = (params?: GetAccessLevelsParams,) => {
    return [`/access-levels`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccessLevelsQueryOptions = <TData = Awaited<ReturnType<typeof getAccessLevels>>, TError = ErrorType<string>>(params?: GetAccessLevelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccessLevels>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessLevelsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessLevels>>> = ({ signal }) => getAccessLevels(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessLevels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccessLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessLevels>>>
export type GetAccessLevelsQueryError = ErrorType<string>

export const useGetAccessLevels = <TData = Awaited<ReturnType<typeof getAccessLevels>>, TError = ErrorType<string>>(
 params?: GetAccessLevelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccessLevels>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccessLevelsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new access level
 */
export const postAccessLevels = (
    postAccessLevelsBody: PostAccessLevelsBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostAccessLevels200>(
      {url: `/access-levels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAccessLevelsBody
    },
      options);
    }
  


export const getPostAccessLevelsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessLevels>>, TError,{data: PostAccessLevelsBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccessLevels>>, TError,{data: PostAccessLevelsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccessLevels>>, {data: PostAccessLevelsBody}> = (props) => {
          const {data} = props ?? {};

          return  postAccessLevels(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAccessLevelsMutationResult = NonNullable<Awaited<ReturnType<typeof postAccessLevels>>>
    export type PostAccessLevelsMutationBody = PostAccessLevelsBody
    export type PostAccessLevelsMutationError = ErrorType<string>

    export const usePostAccessLevels = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessLevels>>, TError,{data: PostAccessLevelsBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAccessLevelsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update an access level
 */
export const putAccessLevelsId = (
    id: number,
    putAccessLevelsIdBody: PutAccessLevelsIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/access-levels/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAccessLevelsIdBody
    },
      options);
    }
  


export const getPutAccessLevelsIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessLevelsId>>, TError,{id: number;data: PutAccessLevelsIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAccessLevelsId>>, TError,{id: number;data: PutAccessLevelsIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAccessLevelsId>>, {id: number;data: PutAccessLevelsIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putAccessLevelsId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAccessLevelsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAccessLevelsId>>>
    export type PutAccessLevelsIdMutationBody = PutAccessLevelsIdBody
    export type PutAccessLevelsIdMutationError = ErrorType<string>

    export const usePutAccessLevelsId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessLevelsId>>, TError,{id: number;data: PutAccessLevelsIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAccessLevelsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get scopes assigned to an access level
 */
export const getAccessLevelsIdScopes = (
    id: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAccessLevelsIdScopes200>(
      {url: `/access-levels/${id}/scopes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAccessLevelsIdScopesQueryKey = (id: number,) => {
    return [`/access-levels/${id}/scopes`] as const;
    }

    
export const getGetAccessLevelsIdScopesQueryOptions = <TData = Awaited<ReturnType<typeof getAccessLevelsIdScopes>>, TError = ErrorType<string>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccessLevelsIdScopes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessLevelsIdScopesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessLevelsIdScopes>>> = ({ signal }) => getAccessLevelsIdScopes(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessLevelsIdScopes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccessLevelsIdScopesQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessLevelsIdScopes>>>
export type GetAccessLevelsIdScopesQueryError = ErrorType<string>

export const useGetAccessLevelsIdScopes = <TData = Awaited<ReturnType<typeof getAccessLevelsIdScopes>>, TError = ErrorType<string>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccessLevelsIdScopes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccessLevelsIdScopesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Assign scopes to an access level
 */
export const postAccessLevelsIdScopes = (
    id: number,
    postAccessLevelsIdScopesBody: PostAccessLevelsIdScopesBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/access-levels/${id}/scopes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAccessLevelsIdScopesBody
    },
      options);
    }
  


export const getPostAccessLevelsIdScopesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessLevelsIdScopes>>, TError,{id: number;data: PostAccessLevelsIdScopesBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccessLevelsIdScopes>>, TError,{id: number;data: PostAccessLevelsIdScopesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccessLevelsIdScopes>>, {id: number;data: PostAccessLevelsIdScopesBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postAccessLevelsIdScopes(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAccessLevelsIdScopesMutationResult = NonNullable<Awaited<ReturnType<typeof postAccessLevelsIdScopes>>>
    export type PostAccessLevelsIdScopesMutationBody = PostAccessLevelsIdScopesBody
    export type PostAccessLevelsIdScopesMutationError = ErrorType<string>

    export const usePostAccessLevelsIdScopes = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessLevelsIdScopes>>, TError,{id: number;data: PostAccessLevelsIdScopesBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAccessLevelsIdScopesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update scopes from an access level
 */
export const putAccessLevelsIdScopes = (
    id: number,
    putAccessLevelsIdScopesBody: PutAccessLevelsIdScopesBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/access-levels/${id}/scopes`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAccessLevelsIdScopesBody
    },
      options);
    }
  


export const getPutAccessLevelsIdScopesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessLevelsIdScopes>>, TError,{id: number;data: PutAccessLevelsIdScopesBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAccessLevelsIdScopes>>, TError,{id: number;data: PutAccessLevelsIdScopesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAccessLevelsIdScopes>>, {id: number;data: PutAccessLevelsIdScopesBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putAccessLevelsIdScopes(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAccessLevelsIdScopesMutationResult = NonNullable<Awaited<ReturnType<typeof putAccessLevelsIdScopes>>>
    export type PutAccessLevelsIdScopesMutationBody = PutAccessLevelsIdScopesBody
    export type PutAccessLevelsIdScopesMutationError = ErrorType<string>

    export const usePutAccessLevelsIdScopes = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessLevelsIdScopes>>, TError,{id: number;data: PutAccessLevelsIdScopesBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAccessLevelsIdScopesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminBonusesPayall = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/bonuses/payall`, method: 'PUT'
    },
      options);
    }
  


export const getPutAdminBonusesPayallMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesPayall>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesPayall>>, TError,void, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminBonusesPayall>>, void> = () => {
          

          return  putAdminBonusesPayall(requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminBonusesPayallMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminBonusesPayall>>>
    
    export type PutAdminBonusesPayallMutationError = ErrorType<string>

    export const usePutAdminBonusesPayall = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesPayall>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminBonusesPayallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminBonusesPayallprocessedbonus = (
    params?: PutAdminBonusesPayallprocessedbonusParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/bonuses/payallprocessedbonus`, method: 'PUT',
        params
    },
      options);
    }
  


export const getPutAdminBonusesPayallprocessedbonusMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesPayallprocessedbonus>>, TError,{params?: PutAdminBonusesPayallprocessedbonusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesPayallprocessedbonus>>, TError,{params?: PutAdminBonusesPayallprocessedbonusParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminBonusesPayallprocessedbonus>>, {params?: PutAdminBonusesPayallprocessedbonusParams}> = (props) => {
          const {params} = props ?? {};

          return  putAdminBonusesPayallprocessedbonus(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminBonusesPayallprocessedbonusMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminBonusesPayallprocessedbonus>>>
    
    export type PutAdminBonusesPayallprocessedbonusMutationError = ErrorType<string>

    export const usePutAdminBonusesPayallprocessedbonus = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesPayallprocessedbonus>>, TError,{params?: PutAdminBonusesPayallprocessedbonusParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminBonusesPayallprocessedbonusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminBonusesProcessall = (
    params?: PutAdminBonusesProcessallParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/bonuses/processall`, method: 'PUT',
        params
    },
      options);
    }
  


export const getPutAdminBonusesProcessallMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesProcessall>>, TError,{params?: PutAdminBonusesProcessallParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesProcessall>>, TError,{params?: PutAdminBonusesProcessallParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminBonusesProcessall>>, {params?: PutAdminBonusesProcessallParams}> = (props) => {
          const {params} = props ?? {};

          return  putAdminBonusesProcessall(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminBonusesProcessallMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminBonusesProcessall>>>
    
    export type PutAdminBonusesProcessallMutationError = ErrorType<string>

    export const usePutAdminBonusesProcessall = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminBonusesProcessall>>, TError,{params?: PutAdminBonusesProcessallParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminBonusesProcessallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates multiple shifts for shift date array for Smartlinx Users
 */
export const postAdminCreateMultipleSmartlinx = (
    postAdminCreateMultipleSmartlinxBody: PostAdminCreateMultipleSmartlinxBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number[]>(
      {url: `/admin/create-multiple-smartlinx`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminCreateMultipleSmartlinxBody
    },
      options);
    }
  


export const getPostAdminCreateMultipleSmartlinxMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateMultipleSmartlinx>>, TError,{data: PostAdminCreateMultipleSmartlinxBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateMultipleSmartlinx>>, TError,{data: PostAdminCreateMultipleSmartlinxBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminCreateMultipleSmartlinx>>, {data: PostAdminCreateMultipleSmartlinxBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminCreateMultipleSmartlinx(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminCreateMultipleSmartlinxMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminCreateMultipleSmartlinx>>>
    export type PostAdminCreateMultipleSmartlinxMutationBody = PostAdminCreateMultipleSmartlinxBody
    export type PostAdminCreateMultipleSmartlinxMutationError = ErrorType<string>

    export const usePostAdminCreateMultipleSmartlinx = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreateMultipleSmartlinx>>, TError,{data: PostAdminCreateMultipleSmartlinxBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminCreateMultipleSmartlinxMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminCreatednr = (
    postAdminCreatednrBody: PostAdminCreatednrBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/creatednr`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminCreatednrBody
    },
      options);
    }
  


export const getPostAdminCreatednrMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatednr>>, TError,{data: PostAdminCreatednrBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatednr>>, TError,{data: PostAdminCreatednrBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminCreatednr>>, {data: PostAdminCreatednrBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminCreatednr(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminCreatednrMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminCreatednr>>>
    export type PostAdminCreatednrMutationBody = PostAdminCreatednrBody
    export type PostAdminCreatednrMutationError = ErrorType<string>

    export const usePostAdminCreatednr = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatednr>>, TError,{data: PostAdminCreatednrBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminCreatednrMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminDeletednr = (
    params: DeleteAdminDeletednrParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/deletednr`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAdminDeletednrMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDeletednr>>, TError,{params: DeleteAdminDeletednrParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDeletednr>>, TError,{params: DeleteAdminDeletednrParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminDeletednr>>, {params: DeleteAdminDeletednrParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAdminDeletednr(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminDeletednrMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminDeletednr>>>
    
    export type DeleteAdminDeletednrMutationError = ErrorType<string>

    export const useDeleteAdminDeletednr = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDeletednr>>, TError,{params: DeleteAdminDeletednrParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminDeletednrMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminDepRequirementsDeptidReqidAssign = (
    deptid: number,
    reqid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/dep/requirements/${deptid}/${reqid}/assign`, method: 'POST'
    },
      options);
    }
  


export const getPostAdminDepRequirementsDeptidReqidAssignMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDepRequirementsDeptidReqidAssign>>, TError,{deptid: number;reqid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminDepRequirementsDeptidReqidAssign>>, TError,{deptid: number;reqid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminDepRequirementsDeptidReqidAssign>>, {deptid: number;reqid: number}> = (props) => {
          const {deptid,reqid} = props ?? {};

          return  postAdminDepRequirementsDeptidReqidAssign(deptid,reqid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminDepRequirementsDeptidReqidAssignMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminDepRequirementsDeptidReqidAssign>>>
    
    export type PostAdminDepRequirementsDeptidReqidAssignMutationError = ErrorType<string>

    export const usePostAdminDepRequirementsDeptidReqidAssign = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminDepRequirementsDeptidReqidAssign>>, TError,{deptid: number;reqid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminDepRequirementsDeptidReqidAssignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminDepRequirementsDeptidReqidUnassign = (
    deptid: number,
    reqid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/dep/requirements/${deptid}/${reqid}/unassign`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminDepRequirementsDeptidReqidUnassignMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDepRequirementsDeptidReqidUnassign>>, TError,{deptid: number;reqid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDepRequirementsDeptidReqidUnassign>>, TError,{deptid: number;reqid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminDepRequirementsDeptidReqidUnassign>>, {deptid: number;reqid: number}> = (props) => {
          const {deptid,reqid} = props ?? {};

          return  deleteAdminDepRequirementsDeptidReqidUnassign(deptid,reqid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminDepRequirementsDeptidReqidUnassignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminDepRequirementsDeptidReqidUnassign>>>
    
    export type DeleteAdminDepRequirementsDeptidReqidUnassignMutationError = ErrorType<string>

    export const useDeleteAdminDepRequirementsDeptidReqidUnassign = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDepRequirementsDeptidReqidUnassign>>, TError,{deptid: number;reqid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminDepRequirementsDeptidReqidUnassignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminDepartmentDeptidGet = (
    deptid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminDepartmentDeptidGet200>(
      {url: `/admin/department/${deptid}/get`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminDepartmentDeptidGetQueryKey = (deptid: number,) => {
    return [`/admin/department/${deptid}/get`] as const;
    }

    
export const getGetAdminDepartmentDeptidGetQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDepartmentDeptidGet>>, TError = ErrorType<string>>(deptid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDepartmentDeptidGet>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDepartmentDeptidGetQueryKey(deptid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDepartmentDeptidGet>>> = ({ signal }) => getAdminDepartmentDeptidGet(deptid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(deptid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDepartmentDeptidGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminDepartmentDeptidGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDepartmentDeptidGet>>>
export type GetAdminDepartmentDeptidGetQueryError = ErrorType<string>

export const useGetAdminDepartmentDeptidGet = <TData = Awaited<ReturnType<typeof getAdminDepartmentDeptidGet>>, TError = ErrorType<string>>(
 deptid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDepartmentDeptidGet>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminDepartmentDeptidGetQueryOptions(deptid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteAdminDepartmentDeptidRemove = (
    deptid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/department/${deptid}/remove`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminDepartmentDeptidRemoveMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDepartmentDeptidRemove>>, TError,{deptid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDepartmentDeptidRemove>>, TError,{deptid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminDepartmentDeptidRemove>>, {deptid: number}> = (props) => {
          const {deptid} = props ?? {};

          return  deleteAdminDepartmentDeptidRemove(deptid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminDepartmentDeptidRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminDepartmentDeptidRemove>>>
    
    export type DeleteAdminDepartmentDeptidRemoveMutationError = ErrorType<string>

    export const useDeleteAdminDepartmentDeptidRemove = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminDepartmentDeptidRemove>>, TError,{deptid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminDepartmentDeptidRemoveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminDepartmentDeptidRequirements = (
    deptid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminDepartmentDeptidRequirements200Item[]>(
      {url: `/admin/department/${deptid}/requirements`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminDepartmentDeptidRequirementsQueryKey = (deptid: number,) => {
    return [`/admin/department/${deptid}/requirements`] as const;
    }

    
export const getGetAdminDepartmentDeptidRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDepartmentDeptidRequirements>>, TError = ErrorType<string>>(deptid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDepartmentDeptidRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDepartmentDeptidRequirementsQueryKey(deptid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDepartmentDeptidRequirements>>> = ({ signal }) => getAdminDepartmentDeptidRequirements(deptid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(deptid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDepartmentDeptidRequirements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminDepartmentDeptidRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDepartmentDeptidRequirements>>>
export type GetAdminDepartmentDeptidRequirementsQueryError = ErrorType<string>

export const useGetAdminDepartmentDeptidRequirements = <TData = Awaited<ReturnType<typeof getAdminDepartmentDeptidRequirements>>, TError = ErrorType<string>>(
 deptid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDepartmentDeptidRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminDepartmentDeptidRequirementsQueryOptions(deptid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminDnrlist = (
    params?: GetAdminDnrlistParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminDnrlist200>(
      {url: `/admin/dnrlist`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminDnrlistQueryKey = (params?: GetAdminDnrlistParams,) => {
    return [`/admin/dnrlist`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminDnrlistQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDnrlist>>, TError = ErrorType<string>>(params?: GetAdminDnrlistParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDnrlist>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDnrlistQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDnrlist>>> = ({ signal }) => getAdminDnrlist(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDnrlist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminDnrlistQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDnrlist>>>
export type GetAdminDnrlistQueryError = ErrorType<string>

export const useGetAdminDnrlist = <TData = Awaited<ReturnType<typeof getAdminDnrlist>>, TError = ErrorType<string>>(
 params?: GetAdminDnrlistParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDnrlist>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminDnrlistQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminDownloadorganizations = (
    params?: GetAdminDownloadorganizationsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Blob>(
      {url: `/admin/downloadorganizations`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetAdminDownloadorganizationsQueryKey = (params?: GetAdminDownloadorganizationsParams,) => {
    return [`/admin/downloadorganizations`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminDownloadorganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminDownloadorganizations>>, TError = ErrorType<string>>(params?: GetAdminDownloadorganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDownloadorganizations>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminDownloadorganizationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminDownloadorganizations>>> = ({ signal }) => getAdminDownloadorganizations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminDownloadorganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminDownloadorganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminDownloadorganizations>>>
export type GetAdminDownloadorganizationsQueryError = ErrorType<string>

export const useGetAdminDownloadorganizations = <TData = Awaited<ReturnType<typeof getAdminDownloadorganizations>>, TError = ErrorType<string>>(
 params?: GetAdminDownloadorganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminDownloadorganizations>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminDownloadorganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminFilteredRequirementSearch = (
    params?: GetAdminFilteredRequirementSearchParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminFilteredRequirementSearch200Item[]>(
      {url: `/admin/filtered/requirement/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminFilteredRequirementSearchQueryKey = (params?: GetAdminFilteredRequirementSearchParams,) => {
    return [`/admin/filtered/requirement/search`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminFilteredRequirementSearchQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFilteredRequirementSearch>>, TError = ErrorType<string>>(params?: GetAdminFilteredRequirementSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFilteredRequirementSearch>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFilteredRequirementSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFilteredRequirementSearch>>> = ({ signal }) => getAdminFilteredRequirementSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFilteredRequirementSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminFilteredRequirementSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFilteredRequirementSearch>>>
export type GetAdminFilteredRequirementSearchQueryError = ErrorType<string>

export const useGetAdminFilteredRequirementSearch = <TData = Awaited<ReturnType<typeof getAdminFilteredRequirementSearch>>, TError = ErrorType<string>>(
 params?: GetAdminFilteredRequirementSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFilteredRequirementSearch>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminFilteredRequirementSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminGetreasons = (
    params: GetAdminGetreasonsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminGetreasons200Item[]>(
      {url: `/admin/getreasons`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminGetreasonsQueryKey = (params: GetAdminGetreasonsParams,) => {
    return [`/admin/getreasons`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminGetreasonsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminGetreasons>>, TError = ErrorType<string>>(params: GetAdminGetreasonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminGetreasons>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminGetreasonsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminGetreasons>>> = ({ signal }) => getAdminGetreasons(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminGetreasons>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminGetreasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminGetreasons>>>
export type GetAdminGetreasonsQueryError = ErrorType<string>

export const useGetAdminGetreasons = <TData = Awaited<ReturnType<typeof getAdminGetreasons>>, TError = ErrorType<string>>(
 params: GetAdminGetreasonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminGetreasons>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminGetreasonsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAdminJobhistoryCreate = (
    postAdminJobhistoryCreateBody: PostAdminJobhistoryCreateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/jobhistory/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminJobhistoryCreateBody
    },
      options);
    }
  


export const getPostAdminJobhistoryCreateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminJobhistoryCreate>>, TError,{data: PostAdminJobhistoryCreateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminJobhistoryCreate>>, TError,{data: PostAdminJobhistoryCreateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminJobhistoryCreate>>, {data: PostAdminJobhistoryCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminJobhistoryCreate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminJobhistoryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminJobhistoryCreate>>>
    export type PostAdminJobhistoryCreateMutationBody = PostAdminJobhistoryCreateBody
    export type PostAdminJobhistoryCreateMutationError = ErrorType<string>

    export const usePostAdminJobhistoryCreate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminJobhistoryCreate>>, TError,{data: PostAdminJobhistoryCreateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminJobhistoryCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminJobhistoryDelete = (
    params?: DeleteAdminJobhistoryDeleteParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/jobhistory/delete`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAdminJobhistoryDeleteMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminJobhistoryDelete>>, TError,{params?: DeleteAdminJobhistoryDeleteParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminJobhistoryDelete>>, TError,{params?: DeleteAdminJobhistoryDeleteParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminJobhistoryDelete>>, {params?: DeleteAdminJobhistoryDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAdminJobhistoryDelete(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminJobhistoryDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminJobhistoryDelete>>>
    
    export type DeleteAdminJobhistoryDeleteMutationError = ErrorType<string>

    export const useDeleteAdminJobhistoryDelete = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminJobhistoryDelete>>, TError,{params?: DeleteAdminJobhistoryDeleteParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminJobhistoryDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminJobhistoryUpdate = (
    putAdminJobhistoryUpdateBody: PutAdminJobhistoryUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/jobhistory/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminJobhistoryUpdateBody
    },
      options);
    }
  


export const getPutAdminJobhistoryUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminJobhistoryUpdate>>, TError,{data: PutAdminJobhistoryUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminJobhistoryUpdate>>, TError,{data: PutAdminJobhistoryUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminJobhistoryUpdate>>, {data: PutAdminJobhistoryUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminJobhistoryUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminJobhistoryUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminJobhistoryUpdate>>>
    export type PutAdminJobhistoryUpdateMutationBody = PutAdminJobhistoryUpdateBody
    export type PutAdminJobhistoryUpdateMutationError = ErrorType<string>

    export const usePutAdminJobhistoryUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminJobhistoryUpdate>>, TError,{data: PutAdminJobhistoryUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminJobhistoryUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminLocRequirementsLocidReqidUnassign = (
    locid: number,
    reqid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/loc/requirements/${locid}/${reqid}/unassign`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminLocRequirementsLocidReqidUnassignMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocRequirementsLocidReqidUnassign>>, TError,{locid: number;reqid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocRequirementsLocidReqidUnassign>>, TError,{locid: number;reqid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminLocRequirementsLocidReqidUnassign>>, {locid: number;reqid: number}> = (props) => {
          const {locid,reqid} = props ?? {};

          return  deleteAdminLocRequirementsLocidReqidUnassign(locid,reqid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminLocRequirementsLocidReqidUnassignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminLocRequirementsLocidReqidUnassign>>>
    
    export type DeleteAdminLocRequirementsLocidReqidUnassignMutationError = ErrorType<string>

    export const useDeleteAdminLocRequirementsLocidReqidUnassign = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocRequirementsLocidReqidUnassign>>, TError,{locid: number;reqid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminLocRequirementsLocidReqidUnassignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminLocUserLocidUseridRemove = (
    locid: number,
    userid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/loc/user/${locid}/${userid}/remove`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminLocUserLocidUseridRemoveMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocUserLocidUseridRemove>>, TError,{locid: number;userid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocUserLocidUseridRemove>>, TError,{locid: number;userid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminLocUserLocidUseridRemove>>, {locid: number;userid: number}> = (props) => {
          const {locid,userid} = props ?? {};

          return  deleteAdminLocUserLocidUseridRemove(locid,userid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminLocUserLocidUseridRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminLocUserLocidUseridRemove>>>
    
    export type DeleteAdminLocUserLocidUseridRemoveMutationError = ErrorType<string>

    export const useDeleteAdminLocUserLocidUseridRemove = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocUserLocidUseridRemove>>, TError,{locid: number;userid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminLocUserLocidUseridRemoveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * update facility details
 * @summary facility details
 */
export const putAdminLocationLocIdDetails = (
    locId: number,
    putAdminLocationLocIdDetailsBody: PutAdminLocationLocIdDetailsBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/location/${locId}/details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminLocationLocIdDetailsBody
    },
      options);
    }
  


export const getPutAdminLocationLocIdDetailsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminLocationLocIdDetails>>, TError,{locId: number;data: PutAdminLocationLocIdDetailsBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminLocationLocIdDetails>>, TError,{locId: number;data: PutAdminLocationLocIdDetailsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminLocationLocIdDetails>>, {locId: number;data: PutAdminLocationLocIdDetailsBody}> = (props) => {
          const {locId,data} = props ?? {};

          return  putAdminLocationLocIdDetails(locId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminLocationLocIdDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminLocationLocIdDetails>>>
    export type PutAdminLocationLocIdDetailsMutationBody = PutAdminLocationLocIdDetailsBody
    export type PutAdminLocationLocIdDetailsMutationError = ErrorType<string>

    /**
 * @summary facility details
 */
export const usePutAdminLocationLocIdDetails = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminLocationLocIdDetails>>, TError,{locId: number;data: PutAdminLocationLocIdDetailsBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminLocationLocIdDetailsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminLocationLocid = (
    locid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminLocationLocid200>(
      {url: `/admin/location/${locid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminLocationLocidQueryKey = (locid: number,) => {
    return [`/admin/location/${locid}`] as const;
    }

    
export const getGetAdminLocationLocidQueryOptions = <TData = Awaited<ReturnType<typeof getAdminLocationLocid>>, TError = ErrorType<string>>(locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminLocationLocidQueryKey(locid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLocationLocid>>> = ({ signal }) => getAdminLocationLocid(locid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminLocationLocidQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLocationLocid>>>
export type GetAdminLocationLocidQueryError = ErrorType<string>

export const useGetAdminLocationLocid = <TData = Awaited<ReturnType<typeof getAdminLocationLocid>>, TError = ErrorType<string>>(
 locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminLocationLocidQueryOptions(locid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminLocationLocidHolidayConfiguration = (
    locid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminLocationLocidHolidayConfiguration200>(
      {url: `/admin/location/${locid}/holiday_configuration`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminLocationLocidHolidayConfigurationQueryKey = (locid: number,) => {
    return [`/admin/location/${locid}/holiday_configuration`] as const;
    }

    
export const getGetAdminLocationLocidHolidayConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getAdminLocationLocidHolidayConfiguration>>, TError = ErrorType<string>>(locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidHolidayConfiguration>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminLocationLocidHolidayConfigurationQueryKey(locid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLocationLocidHolidayConfiguration>>> = ({ signal }) => getAdminLocationLocidHolidayConfiguration(locid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidHolidayConfiguration>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminLocationLocidHolidayConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLocationLocidHolidayConfiguration>>>
export type GetAdminLocationLocidHolidayConfigurationQueryError = ErrorType<string>

export const useGetAdminLocationLocidHolidayConfiguration = <TData = Awaited<ReturnType<typeof getAdminLocationLocidHolidayConfiguration>>, TError = ErrorType<string>>(
 locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidHolidayConfiguration>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminLocationLocidHolidayConfigurationQueryOptions(locid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAdminLocationLocidHolidayConfiguration = (
    locid: number,
    postAdminLocationLocidHolidayConfigurationBody: PostAdminLocationLocidHolidayConfigurationBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostAdminLocationLocidHolidayConfiguration200>(
      {url: `/admin/location/${locid}/holiday_configuration`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminLocationLocidHolidayConfigurationBody
    },
      options);
    }
  


export const getPostAdminLocationLocidHolidayConfigurationMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminLocationLocidHolidayConfiguration>>, TError,{locid: number;data: PostAdminLocationLocidHolidayConfigurationBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminLocationLocidHolidayConfiguration>>, TError,{locid: number;data: PostAdminLocationLocidHolidayConfigurationBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminLocationLocidHolidayConfiguration>>, {locid: number;data: PostAdminLocationLocidHolidayConfigurationBody}> = (props) => {
          const {locid,data} = props ?? {};

          return  postAdminLocationLocidHolidayConfiguration(locid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminLocationLocidHolidayConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminLocationLocidHolidayConfiguration>>>
    export type PostAdminLocationLocidHolidayConfigurationMutationBody = PostAdminLocationLocidHolidayConfigurationBody
    export type PostAdminLocationLocidHolidayConfigurationMutationError = ErrorType<string>

    export const usePostAdminLocationLocidHolidayConfiguration = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminLocationLocidHolidayConfiguration>>, TError,{locid: number;data: PostAdminLocationLocidHolidayConfigurationBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminLocationLocidHolidayConfigurationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminLocationLocidRemove = (
    locid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/location/${locid}/remove`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminLocationLocidRemoveMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocationLocidRemove>>, TError,{locid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocationLocidRemove>>, TError,{locid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminLocationLocidRemove>>, {locid: number}> = (props) => {
          const {locid} = props ?? {};

          return  deleteAdminLocationLocidRemove(locid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminLocationLocidRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminLocationLocidRemove>>>
    
    export type DeleteAdminLocationLocidRemoveMutationError = ErrorType<string>

    export const useDeleteAdminLocationLocidRemove = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocationLocidRemove>>, TError,{locid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminLocationLocidRemoveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminLocationLocidRequirements = (
    locid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminLocationLocidRequirements200Item[]>(
      {url: `/admin/location/${locid}/requirements`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminLocationLocidRequirementsQueryKey = (locid: number,) => {
    return [`/admin/location/${locid}/requirements`] as const;
    }

    
export const getGetAdminLocationLocidRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminLocationLocidRequirements>>, TError = ErrorType<string>>(locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminLocationLocidRequirementsQueryKey(locid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLocationLocidRequirements>>> = ({ signal }) => getAdminLocationLocidRequirements(locid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidRequirements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminLocationLocidRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLocationLocidRequirements>>>
export type GetAdminLocationLocidRequirementsQueryError = ErrorType<string>

export const useGetAdminLocationLocidRequirements = <TData = Awaited<ReturnType<typeof getAdminLocationLocidRequirements>>, TError = ErrorType<string>>(
 locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminLocationLocidRequirementsQueryOptions(locid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminLocationLocidUsers = (
    locid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminLocationLocidUsers200Item[]>(
      {url: `/admin/location/${locid}/users`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminLocationLocidUsersQueryKey = (locid: number,) => {
    return [`/admin/location/${locid}/users`] as const;
    }

    
export const getGetAdminLocationLocidUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminLocationLocidUsers>>, TError = ErrorType<string>>(locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidUsers>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminLocationLocidUsersQueryKey(locid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLocationLocidUsers>>> = ({ signal }) => getAdminLocationLocidUsers(locid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminLocationLocidUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLocationLocidUsers>>>
export type GetAdminLocationLocidUsersQueryError = ErrorType<string>

export const useGetAdminLocationLocidUsers = <TData = Awaited<ReturnType<typeof getAdminLocationLocidUsers>>, TError = ErrorType<string>>(
 locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationLocidUsers>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminLocationLocidUsersQueryOptions(locid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Add or update a location specific shift time
 */
export const putAdminLocationshifttimes = (
    putAdminLocationshifttimesBody: PutAdminLocationshifttimesBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutAdminLocationshifttimes200>(
      {url: `/admin/locationshifttimes`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminLocationshifttimesBody
    },
      options);
    }
  


export const getPutAdminLocationshifttimesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminLocationshifttimes>>, TError,{data: PutAdminLocationshifttimesBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminLocationshifttimes>>, TError,{data: PutAdminLocationshifttimesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminLocationshifttimes>>, {data: PutAdminLocationshifttimesBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminLocationshifttimes(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminLocationshifttimesMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminLocationshifttimes>>>
    export type PutAdminLocationshifttimesMutationBody = PutAdminLocationshifttimesBody
    export type PutAdminLocationshifttimesMutationError = ErrorType<string>

    export const usePutAdminLocationshifttimes = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminLocationshifttimes>>, TError,{data: PutAdminLocationshifttimesBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminLocationshifttimesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Delete a location specific shift time
 */
export const deleteAdminLocationshifttimesLocationShiftTimeId = (
    locationShiftTimeId: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/locationshifttimes/${locationShiftTimeId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminLocationshifttimesLocationShiftTimeIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocationshifttimesLocationShiftTimeId>>, TError,{locationShiftTimeId: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocationshifttimesLocationShiftTimeId>>, TError,{locationShiftTimeId: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminLocationshifttimesLocationShiftTimeId>>, {locationShiftTimeId: number}> = (props) => {
          const {locationShiftTimeId} = props ?? {};

          return  deleteAdminLocationshifttimesLocationShiftTimeId(locationShiftTimeId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminLocationshifttimesLocationShiftTimeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminLocationshifttimesLocationShiftTimeId>>>
    
    export type DeleteAdminLocationshifttimesLocationShiftTimeIdMutationError = ErrorType<string>

    export const useDeleteAdminLocationshifttimesLocationShiftTimeId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminLocationshifttimesLocationShiftTimeId>>, TError,{locationShiftTimeId: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminLocationshifttimesLocationShiftTimeIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get a location specific shift times, if they do not exist, populate with defaults
 */
export const getAdminLocationshifttimesLocid = (
    locid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminLocationshifttimesLocid200Item[]>(
      {url: `/admin/locationshifttimes/${locid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminLocationshifttimesLocidQueryKey = (locid: number,) => {
    return [`/admin/locationshifttimes/${locid}`] as const;
    }

    
export const getGetAdminLocationshifttimesLocidQueryOptions = <TData = Awaited<ReturnType<typeof getAdminLocationshifttimesLocid>>, TError = ErrorType<string>>(locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationshifttimesLocid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminLocationshifttimesLocidQueryKey(locid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLocationshifttimesLocid>>> = ({ signal }) => getAdminLocationshifttimesLocid(locid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationshifttimesLocid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminLocationshifttimesLocidQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLocationshifttimesLocid>>>
export type GetAdminLocationshifttimesLocidQueryError = ErrorType<string>

export const useGetAdminLocationshifttimesLocid = <TData = Awaited<ReturnType<typeof getAdminLocationshifttimesLocid>>, TError = ErrorType<string>>(
 locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminLocationshifttimesLocid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminLocationshifttimesLocidQueryOptions(locid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminNurse = (
    params?: GetAdminNurseParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminNurse200>(
      {url: `/admin/nurse`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminNurseQueryKey = (params?: GetAdminNurseParams,) => {
    return [`/admin/nurse`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminNurseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminNurse>>, TError = ErrorType<string>>(params?: GetAdminNurseParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminNurse>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminNurseQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminNurse>>> = ({ signal }) => getAdminNurse(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminNurse>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminNurseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminNurse>>>
export type GetAdminNurseQueryError = ErrorType<string>

export const useGetAdminNurse = <TData = Awaited<ReturnType<typeof getAdminNurse>>, TError = ErrorType<string>>(
 params?: GetAdminNurseParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminNurse>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminNurseQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminNursesearch = (
    params?: GetAdminNursesearchParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminNursesearch200Item[]>(
      {url: `/admin/nursesearch`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminNursesearchQueryKey = (params?: GetAdminNursesearchParams,) => {
    return [`/admin/nursesearch`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminNursesearchQueryOptions = <TData = Awaited<ReturnType<typeof getAdminNursesearch>>, TError = ErrorType<string>>(params?: GetAdminNursesearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminNursesearch>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminNursesearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminNursesearch>>> = ({ signal }) => getAdminNursesearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminNursesearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminNursesearchQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminNursesearch>>>
export type GetAdminNursesearchQueryError = ErrorType<string>

export const useGetAdminNursesearch = <TData = Awaited<ReturnType<typeof getAdminNursesearch>>, TError = ErrorType<string>>(
 params?: GetAdminNursesearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminNursesearch>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminNursesearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAdminOrgRequirementsOrgidReqidAssign = (
    orgid: number,
    reqid: number,
    postAdminOrgRequirementsOrgidReqidAssignBody: PostAdminOrgRequirementsOrgidReqidAssignBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/org/requirements/${orgid}/${reqid}/assign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrgRequirementsOrgidReqidAssignBody
    },
      options);
    }
  


export const getPostAdminOrgRequirementsOrgidReqidAssignMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidAssign>>, TError,{orgid: number;reqid: number;data: PostAdminOrgRequirementsOrgidReqidAssignBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidAssign>>, TError,{orgid: number;reqid: number;data: PostAdminOrgRequirementsOrgidReqidAssignBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidAssign>>, {orgid: number;reqid: number;data: PostAdminOrgRequirementsOrgidReqidAssignBody}> = (props) => {
          const {orgid,reqid,data} = props ?? {};

          return  postAdminOrgRequirementsOrgidReqidAssign(orgid,reqid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrgRequirementsOrgidReqidAssignMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidAssign>>>
    export type PostAdminOrgRequirementsOrgidReqidAssignMutationBody = PostAdminOrgRequirementsOrgidReqidAssignBody
    export type PostAdminOrgRequirementsOrgidReqidAssignMutationError = ErrorType<string>

    export const usePostAdminOrgRequirementsOrgidReqidAssign = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidAssign>>, TError,{orgid: number;reqid: number;data: PostAdminOrgRequirementsOrgidReqidAssignBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrgRequirementsOrgidReqidAssignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminOrgRequirementsOrgidReqidUnassign = (
    orgid: number,
    reqid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/org/requirements/${orgid}/${reqid}/unassign`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAdminOrgRequirementsOrgidReqidUnassignMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrgRequirementsOrgidReqidUnassign>>, TError,{orgid: number;reqid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrgRequirementsOrgidReqidUnassign>>, TError,{orgid: number;reqid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminOrgRequirementsOrgidReqidUnassign>>, {orgid: number;reqid: number}> = (props) => {
          const {orgid,reqid} = props ?? {};

          return  deleteAdminOrgRequirementsOrgidReqidUnassign(orgid,reqid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminOrgRequirementsOrgidReqidUnassignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminOrgRequirementsOrgidReqidUnassign>>>
    
    export type DeleteAdminOrgRequirementsOrgidReqidUnassignMutationError = ErrorType<string>

    export const useDeleteAdminOrgRequirementsOrgidReqidUnassign = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrgRequirementsOrgidReqidUnassign>>, TError,{orgid: number;reqid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminOrgRequirementsOrgidReqidUnassignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminOrgRequirementsOrgidReqidUpdateassign = (
    orgid: number,
    reqid: number,
    postAdminOrgRequirementsOrgidReqidUpdateassignBody: PostAdminOrgRequirementsOrgidReqidUpdateassignBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/org/requirements/${orgid}/${reqid}/updateassign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrgRequirementsOrgidReqidUpdateassignBody
    },
      options);
    }
  


export const getPostAdminOrgRequirementsOrgidReqidUpdateassignMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidUpdateassign>>, TError,{orgid: number;reqid: number;data: PostAdminOrgRequirementsOrgidReqidUpdateassignBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidUpdateassign>>, TError,{orgid: number;reqid: number;data: PostAdminOrgRequirementsOrgidReqidUpdateassignBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidUpdateassign>>, {orgid: number;reqid: number;data: PostAdminOrgRequirementsOrgidReqidUpdateassignBody}> = (props) => {
          const {orgid,reqid,data} = props ?? {};

          return  postAdminOrgRequirementsOrgidReqidUpdateassign(orgid,reqid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrgRequirementsOrgidReqidUpdateassignMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidUpdateassign>>>
    export type PostAdminOrgRequirementsOrgidReqidUpdateassignMutationBody = PostAdminOrgRequirementsOrgidReqidUpdateassignBody
    export type PostAdminOrgRequirementsOrgidReqidUpdateassignMutationError = ErrorType<string>

    export const usePostAdminOrgRequirementsOrgidReqidUpdateassign = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrgRequirementsOrgidReqidUpdateassign>>, TError,{orgid: number;reqid: number;data: PostAdminOrgRequirementsOrgidReqidUpdateassignBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrgRequirementsOrgidReqidUpdateassignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Hard deleting organization and all its child records -- Non-production only
 */
export const deleteAdminOrganization = (
    params: DeleteAdminOrganizationParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organization/`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAdminOrganizationMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganization>>, TError,{params: DeleteAdminOrganizationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganization>>, TError,{params: DeleteAdminOrganizationParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminOrganization>>, {params: DeleteAdminOrganizationParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAdminOrganization(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminOrganization>>>
    
    export type DeleteAdminOrganizationMutationError = ErrorType<string>

    export const useDeleteAdminOrganization = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganization>>, TError,{params: DeleteAdminOrganizationParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminOrganizationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminOrganizationOrgid = (
    orgid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminOrganizationOrgid200>(
      {url: `/admin/organization/${orgid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminOrganizationOrgidQueryKey = (orgid: number,) => {
    return [`/admin/organization/${orgid}`] as const;
    }

    
export const getGetAdminOrganizationOrgidQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizationOrgid>>, TError = ErrorType<string>>(orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationOrgidQueryKey(orgid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizationOrgid>>> = ({ signal }) => getAdminOrganizationOrgid(orgid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationOrgidQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizationOrgid>>>
export type GetAdminOrganizationOrgidQueryError = ErrorType<string>

export const useGetAdminOrganizationOrgid = <TData = Awaited<ReturnType<typeof getAdminOrganizationOrgid>>, TError = ErrorType<string>>(
 orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminOrganizationOrgidQueryOptions(orgid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminOrganizationOrgidAcquisition = (
    orgid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminOrganizationOrgidAcquisition200Item[]>(
      {url: `/admin/organization/${orgid}/acquisition`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminOrganizationOrgidAcquisitionQueryKey = (orgid: number,) => {
    return [`/admin/organization/${orgid}/acquisition`] as const;
    }

    
export const getGetAdminOrganizationOrgidAcquisitionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizationOrgidAcquisition>>, TError = ErrorType<string>>(orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgidAcquisition>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationOrgidAcquisitionQueryKey(orgid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizationOrgidAcquisition>>> = ({ signal }) => getAdminOrganizationOrgidAcquisition(orgid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgidAcquisition>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationOrgidAcquisitionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizationOrgidAcquisition>>>
export type GetAdminOrganizationOrgidAcquisitionQueryError = ErrorType<string>

export const useGetAdminOrganizationOrgidAcquisition = <TData = Awaited<ReturnType<typeof getAdminOrganizationOrgidAcquisition>>, TError = ErrorType<string>>(
 orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgidAcquisition>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminOrganizationOrgidAcquisitionQueryOptions(orgid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAdminOrganizationOrgidAcquisition = (
    orgid: number,
    postAdminOrganizationOrgidAcquisitionBody: PostAdminOrganizationOrgidAcquisitionBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organization/${orgid}/acquisition`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationOrgidAcquisitionBody
    },
      options);
    }
  


export const getPostAdminOrganizationOrgidAcquisitionMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationOrgidAcquisition>>, TError,{orgid: number;data: PostAdminOrganizationOrgidAcquisitionBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationOrgidAcquisition>>, TError,{orgid: number;data: PostAdminOrganizationOrgidAcquisitionBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationOrgidAcquisition>>, {orgid: number;data: PostAdminOrganizationOrgidAcquisitionBody}> = (props) => {
          const {orgid,data} = props ?? {};

          return  postAdminOrganizationOrgidAcquisition(orgid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationOrgidAcquisitionMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationOrgidAcquisition>>>
    export type PostAdminOrganizationOrgidAcquisitionMutationBody = PostAdminOrganizationOrgidAcquisitionBody
    export type PostAdminOrganizationOrgidAcquisitionMutationError = ErrorType<string>

    export const usePostAdminOrganizationOrgidAcquisition = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationOrgidAcquisition>>, TError,{orgid: number;data: PostAdminOrganizationOrgidAcquisitionBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationOrgidAcquisitionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminOrganizationOrgidRequirements = (
    orgid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminOrganizationOrgidRequirements200Item[]>(
      {url: `/admin/organization/${orgid}/requirements`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminOrganizationOrgidRequirementsQueryKey = (orgid: number,) => {
    return [`/admin/organization/${orgid}/requirements`] as const;
    }

    
export const getGetAdminOrganizationOrgidRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizationOrgidRequirements>>, TError = ErrorType<string>>(orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgidRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationOrgidRequirementsQueryKey(orgid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizationOrgidRequirements>>> = ({ signal }) => getAdminOrganizationOrgidRequirements(orgid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgidRequirements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationOrgidRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizationOrgidRequirements>>>
export type GetAdminOrganizationOrgidRequirementsQueryError = ErrorType<string>

export const useGetAdminOrganizationOrgidRequirements = <TData = Awaited<ReturnType<typeof getAdminOrganizationOrgidRequirements>>, TError = ErrorType<string>>(
 orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationOrgidRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminOrganizationOrgidRequirementsQueryOptions(orgid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminOrganizations = (
    params?: GetAdminOrganizationsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminOrganizations200>(
      {url: `/admin/organizations`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminOrganizationsQueryKey = (params?: GetAdminOrganizationsParams,) => {
    return [`/admin/organizations`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizations>>, TError = ErrorType<string>>(params?: GetAdminOrganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizations>>> = ({ signal }) => getAdminOrganizations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizations>>>
export type GetAdminOrganizationsQueryError = ErrorType<string>

export const useGetAdminOrganizations = <TData = Awaited<ReturnType<typeof getAdminOrganizations>>, TError = ErrorType<string>>(
 params?: GetAdminOrganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizations>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminOrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAdminOrganizationsSetSupervisorlistOrgid = (
    orgid: number,
    postAdminOrganizationsSetSupervisorlistOrgidBodyItem: PostAdminOrganizationsSetSupervisorlistOrgidBodyItem[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/SetSupervisorlist/${orgid}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationsSetSupervisorlistOrgidBodyItem
    },
      options);
    }
  


export const getPostAdminOrganizationsSetSupervisorlistOrgidMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsSetSupervisorlistOrgid>>, TError,{orgid: number;data: PostAdminOrganizationsSetSupervisorlistOrgidBodyItem[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsSetSupervisorlistOrgid>>, TError,{orgid: number;data: PostAdminOrganizationsSetSupervisorlistOrgidBodyItem[]}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationsSetSupervisorlistOrgid>>, {orgid: number;data: PostAdminOrganizationsSetSupervisorlistOrgidBodyItem[]}> = (props) => {
          const {orgid,data} = props ?? {};

          return  postAdminOrganizationsSetSupervisorlistOrgid(orgid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationsSetSupervisorlistOrgidMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationsSetSupervisorlistOrgid>>>
    export type PostAdminOrganizationsSetSupervisorlistOrgidMutationBody = PostAdminOrganizationsSetSupervisorlistOrgidBodyItem[]
    export type PostAdminOrganizationsSetSupervisorlistOrgidMutationError = ErrorType<string>

    export const usePostAdminOrganizationsSetSupervisorlistOrgid = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsSetSupervisorlistOrgid>>, TError,{orgid: number;data: PostAdminOrganizationsSetSupervisorlistOrgidBodyItem[]}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationsSetSupervisorlistOrgidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminOrganizationsAddupdate = (
    postAdminOrganizationsAddupdateBody: PostAdminOrganizationsAddupdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/addupdate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationsAddupdateBody
    },
      options);
    }
  


export const getPostAdminOrganizationsAddupdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsAddupdate>>, TError,{data: PostAdminOrganizationsAddupdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsAddupdate>>, TError,{data: PostAdminOrganizationsAddupdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationsAddupdate>>, {data: PostAdminOrganizationsAddupdateBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminOrganizationsAddupdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationsAddupdateMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationsAddupdate>>>
    export type PostAdminOrganizationsAddupdateMutationBody = PostAdminOrganizationsAddupdateBody
    export type PostAdminOrganizationsAddupdateMutationError = ErrorType<string>

    export const usePostAdminOrganizationsAddupdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsAddupdate>>, TError,{data: PostAdminOrganizationsAddupdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationsAddupdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminOrganizationsAddusers = (
    postAdminOrganizationsAddusersBody: PostAdminOrganizationsAddusersBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/addusers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationsAddusersBody
    },
      options);
    }
  


export const getPostAdminOrganizationsAddusersMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsAddusers>>, TError,{data: PostAdminOrganizationsAddusersBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsAddusers>>, TError,{data: PostAdminOrganizationsAddusersBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationsAddusers>>, {data: PostAdminOrganizationsAddusersBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminOrganizationsAddusers(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationsAddusersMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationsAddusers>>>
    export type PostAdminOrganizationsAddusersMutationBody = PostAdminOrganizationsAddusersBody
    export type PostAdminOrganizationsAddusersMutationError = ErrorType<string>

    export const usePostAdminOrganizationsAddusers = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsAddusers>>, TError,{data: PostAdminOrganizationsAddusersBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationsAddusersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminOrganizationsDepartmentsAddupdate = (
    postAdminOrganizationsDepartmentsAddupdateBody: PostAdminOrganizationsDepartmentsAddupdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/departments/addupdate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationsDepartmentsAddupdateBody
    },
      options);
    }
  


export const getPostAdminOrganizationsDepartmentsAddupdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsAddupdate>>, TError,{data: PostAdminOrganizationsDepartmentsAddupdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsAddupdate>>, TError,{data: PostAdminOrganizationsDepartmentsAddupdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsAddupdate>>, {data: PostAdminOrganizationsDepartmentsAddupdateBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminOrganizationsDepartmentsAddupdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationsDepartmentsAddupdateMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsAddupdate>>>
    export type PostAdminOrganizationsDepartmentsAddupdateMutationBody = PostAdminOrganizationsDepartmentsAddupdateBody
    export type PostAdminOrganizationsDepartmentsAddupdateMutationError = ErrorType<string>

    export const usePostAdminOrganizationsDepartmentsAddupdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsAddupdate>>, TError,{data: PostAdminOrganizationsDepartmentsAddupdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationsDepartmentsAddupdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminOrganizationsDepartmentsUpdatename = (
    postAdminOrganizationsDepartmentsUpdatenameBody: PostAdminOrganizationsDepartmentsUpdatenameBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/departments/updatename`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationsDepartmentsUpdatenameBody
    },
      options);
    }
  


export const getPostAdminOrganizationsDepartmentsUpdatenameMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsUpdatename>>, TError,{data: PostAdminOrganizationsDepartmentsUpdatenameBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsUpdatename>>, TError,{data: PostAdminOrganizationsDepartmentsUpdatenameBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsUpdatename>>, {data: PostAdminOrganizationsDepartmentsUpdatenameBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminOrganizationsDepartmentsUpdatename(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationsDepartmentsUpdatenameMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsUpdatename>>>
    export type PostAdminOrganizationsDepartmentsUpdatenameMutationBody = PostAdminOrganizationsDepartmentsUpdatenameBody
    export type PostAdminOrganizationsDepartmentsUpdatenameMutationError = ErrorType<string>

    export const usePostAdminOrganizationsDepartmentsUpdatename = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsDepartmentsUpdatename>>, TError,{data: PostAdminOrganizationsDepartmentsUpdatenameBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationsDepartmentsUpdatenameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminOrganizationsLocationsAddupdate = (
    postAdminOrganizationsLocationsAddupdateBody: PostAdminOrganizationsLocationsAddupdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/locations/addupdate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationsLocationsAddupdateBody
    },
      options);
    }
  


export const getPostAdminOrganizationsLocationsAddupdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsLocationsAddupdate>>, TError,{data: PostAdminOrganizationsLocationsAddupdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsLocationsAddupdate>>, TError,{data: PostAdminOrganizationsLocationsAddupdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationsLocationsAddupdate>>, {data: PostAdminOrganizationsLocationsAddupdateBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminOrganizationsLocationsAddupdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationsLocationsAddupdateMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationsLocationsAddupdate>>>
    export type PostAdminOrganizationsLocationsAddupdateMutationBody = PostAdminOrganizationsLocationsAddupdateBody
    export type PostAdminOrganizationsLocationsAddupdateMutationError = ErrorType<string>

    export const usePostAdminOrganizationsLocationsAddupdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsLocationsAddupdate>>, TError,{data: PostAdminOrganizationsLocationsAddupdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationsLocationsAddupdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Organization
 */
export const postAdminOrganizationsLocationsRateincrease = (
    postAdminOrganizationsLocationsRateincreaseBody: PostAdminOrganizationsLocationsRateincreaseBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/locations/rateincrease`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationsLocationsRateincreaseBody
    },
      options);
    }
  


export const getPostAdminOrganizationsLocationsRateincreaseMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsLocationsRateincrease>>, TError,{data: PostAdminOrganizationsLocationsRateincreaseBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsLocationsRateincrease>>, TError,{data: PostAdminOrganizationsLocationsRateincreaseBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationsLocationsRateincrease>>, {data: PostAdminOrganizationsLocationsRateincreaseBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminOrganizationsLocationsRateincrease(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationsLocationsRateincreaseMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationsLocationsRateincrease>>>
    export type PostAdminOrganizationsLocationsRateincreaseMutationBody = PostAdminOrganizationsLocationsRateincreaseBody
    export type PostAdminOrganizationsLocationsRateincreaseMutationError = ErrorType<string>

    /**
 * @summary Organization
 */
export const usePostAdminOrganizationsLocationsRateincrease = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsLocationsRateincrease>>, TError,{data: PostAdminOrganizationsLocationsRateincreaseBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationsLocationsRateincreaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminOrganizationsOrgstatustypes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminOrganizationsOrgstatustypes200Item[]>(
      {url: `/admin/organizations/orgstatustypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminOrganizationsOrgstatustypesQueryKey = () => {
    return [`/admin/organizations/orgstatustypes`] as const;
    }

    
export const getGetAdminOrganizationsOrgstatustypesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizationsOrgstatustypes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsOrgstatustypes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationsOrgstatustypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizationsOrgstatustypes>>> = ({ signal }) => getAdminOrganizationsOrgstatustypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsOrgstatustypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationsOrgstatustypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizationsOrgstatustypes>>>
export type GetAdminOrganizationsOrgstatustypesQueryError = ErrorType<string>

export const useGetAdminOrganizationsOrgstatustypes = <TData = Awaited<ReturnType<typeof getAdminOrganizationsOrgstatustypes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsOrgstatustypes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminOrganizationsOrgstatustypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminOrganizationsSupervisorlistOrgid = (
    orgid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminOrganizationsSupervisorlistOrgid200Item[]>(
      {url: `/admin/organizations/supervisorlist/${orgid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminOrganizationsSupervisorlistOrgidQueryKey = (orgid: number,) => {
    return [`/admin/organizations/supervisorlist/${orgid}`] as const;
    }

    
export const getGetAdminOrganizationsSupervisorlistOrgidQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizationsSupervisorlistOrgid>>, TError = ErrorType<string>>(orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsSupervisorlistOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationsSupervisorlistOrgidQueryKey(orgid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizationsSupervisorlistOrgid>>> = ({ signal }) => getAdminOrganizationsSupervisorlistOrgid(orgid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsSupervisorlistOrgid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationsSupervisorlistOrgidQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizationsSupervisorlistOrgid>>>
export type GetAdminOrganizationsSupervisorlistOrgidQueryError = ErrorType<string>

export const useGetAdminOrganizationsSupervisorlistOrgid = <TData = Awaited<ReturnType<typeof getAdminOrganizationsSupervisorlistOrgid>>, TError = ErrorType<string>>(
 orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsSupervisorlistOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminOrganizationsSupervisorlistOrgidQueryOptions(orgid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminOrganizationsTypes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminOrganizationsTypes200Item[]>(
      {url: `/admin/organizations/types`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminOrganizationsTypesQueryKey = () => {
    return [`/admin/organizations/types`] as const;
    }

    
export const getGetAdminOrganizationsTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizationsTypes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsTypes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationsTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizationsTypes>>> = ({ signal }) => getAdminOrganizationsTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationsTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizationsTypes>>>
export type GetAdminOrganizationsTypesQueryError = ErrorType<string>

export const useGetAdminOrganizationsTypes = <TData = Awaited<ReturnType<typeof getAdminOrganizationsTypes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationsTypes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminOrganizationsTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAdminOrganizationsUserAdd = (
    postAdminOrganizationsUserAddBody: PostAdminOrganizationsUserAddBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/user/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminOrganizationsUserAddBody
    },
      options);
    }
  


export const getPostAdminOrganizationsUserAddMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsUserAdd>>, TError,{data: PostAdminOrganizationsUserAddBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsUserAdd>>, TError,{data: PostAdminOrganizationsUserAddBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminOrganizationsUserAdd>>, {data: PostAdminOrganizationsUserAddBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminOrganizationsUserAdd(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminOrganizationsUserAddMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminOrganizationsUserAdd>>>
    export type PostAdminOrganizationsUserAddMutationBody = PostAdminOrganizationsUserAddBody
    export type PostAdminOrganizationsUserAddMutationError = ErrorType<string>

    export const usePostAdminOrganizationsUserAdd = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminOrganizationsUserAdd>>, TError,{data: PostAdminOrganizationsUserAddBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminOrganizationsUserAddMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminOrganizationsUserDelete = (
    params: DeleteAdminOrganizationsUserDeleteParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/user/delete`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAdminOrganizationsUserDeleteMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganizationsUserDelete>>, TError,{params: DeleteAdminOrganizationsUserDeleteParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganizationsUserDelete>>, TError,{params: DeleteAdminOrganizationsUserDeleteParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminOrganizationsUserDelete>>, {params: DeleteAdminOrganizationsUserDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAdminOrganizationsUserDelete(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminOrganizationsUserDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminOrganizationsUserDelete>>>
    
    export type DeleteAdminOrganizationsUserDeleteMutationError = ErrorType<string>

    export const useDeleteAdminOrganizationsUserDelete = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganizationsUserDelete>>, TError,{params: DeleteAdminOrganizationsUserDeleteParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminOrganizationsUserDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminOrganizationsUserUpdate = (
    putAdminOrganizationsUserUpdateBody: PutAdminOrganizationsUserUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/organizations/user/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminOrganizationsUserUpdateBody
    },
      options);
    }
  


export const getPutAdminOrganizationsUserUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminOrganizationsUserUpdate>>, TError,{data: PutAdminOrganizationsUserUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminOrganizationsUserUpdate>>, TError,{data: PutAdminOrganizationsUserUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminOrganizationsUserUpdate>>, {data: PutAdminOrganizationsUserUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminOrganizationsUserUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminOrganizationsUserUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminOrganizationsUserUpdate>>>
    export type PutAdminOrganizationsUserUpdateMutationBody = PutAdminOrganizationsUserUpdateBody
    export type PutAdminOrganizationsUserUpdateMutationError = ErrorType<string>

    export const usePutAdminOrganizationsUserUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminOrganizationsUserUpdate>>, TError,{data: PutAdminOrganizationsUserUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminOrganizationsUserUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminPaidtimesheet = (
    putAdminPaidtimesheetBody: PutAdminPaidtimesheetBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutAdminPaidtimesheet200>(
      {url: `/admin/paidtimesheet`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminPaidtimesheetBody
    },
      options);
    }
  


export const getPutAdminPaidtimesheetMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPaidtimesheet>>, TError,{data: PutAdminPaidtimesheetBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminPaidtimesheet>>, TError,{data: PutAdminPaidtimesheetBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminPaidtimesheet>>, {data: PutAdminPaidtimesheetBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminPaidtimesheet(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminPaidtimesheetMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminPaidtimesheet>>>
    export type PutAdminPaidtimesheetMutationBody = PutAdminPaidtimesheetBody
    export type PutAdminPaidtimesheetMutationError = ErrorType<string>

    export const usePutAdminPaidtimesheet = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPaidtimesheet>>, TError,{data: PutAdminPaidtimesheetBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminPaidtimesheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Refreshes the cache of access levels and scopes
 */
export const postAdminRefreshPermissionsCache = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/refresh-permissions-cache`, method: 'POST'
    },
      options);
    }
  


export const getPostAdminRefreshPermissionsCacheMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRefreshPermissionsCache>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRefreshPermissionsCache>>, TError,void, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRefreshPermissionsCache>>, void> = () => {
          

          return  postAdminRefreshPermissionsCache(requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminRefreshPermissionsCacheMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRefreshPermissionsCache>>>
    
    export type PostAdminRefreshPermissionsCacheMutationError = ErrorType<string>

    export const usePostAdminRefreshPermissionsCache = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRefreshPermissionsCache>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminRefreshPermissionsCacheMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminRequestApproval = (
    postAdminRequestApprovalBody: PostAdminRequestApprovalBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/request/approval`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminRequestApprovalBody
    },
      options);
    }
  


export const getPostAdminRequestApprovalMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequestApproval>>, TError,{data: PostAdminRequestApprovalBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRequestApproval>>, TError,{data: PostAdminRequestApprovalBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRequestApproval>>, {data: PostAdminRequestApprovalBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminRequestApproval(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminRequestApprovalMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRequestApproval>>>
    export type PostAdminRequestApprovalMutationBody = PostAdminRequestApprovalBody
    export type PostAdminRequestApprovalMutationError = ErrorType<string>

    export const usePostAdminRequestApproval = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequestApproval>>, TError,{data: PostAdminRequestApprovalBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminRequestApprovalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminRequirementApproval = (
    postAdminRequirementApprovalBody: PostAdminRequirementApprovalBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/requirement/approval`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminRequirementApprovalBody
    },
      options);
    }
  


export const getPostAdminRequirementApprovalMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementApproval>>, TError,{data: PostAdminRequirementApprovalBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementApproval>>, TError,{data: PostAdminRequirementApprovalBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRequirementApproval>>, {data: PostAdminRequirementApprovalBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminRequirementApproval(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminRequirementApprovalMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRequirementApproval>>>
    export type PostAdminRequirementApprovalMutationBody = PostAdminRequirementApprovalBody
    export type PostAdminRequirementApprovalMutationError = ErrorType<string>

    export const usePostAdminRequirementApproval = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementApproval>>, TError,{data: PostAdminRequirementApprovalBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminRequirementApprovalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminRequirementRemoveV2 = (
    params?: DeleteAdminRequirementRemoveV2Params,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/requirement/removeV2`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAdminRequirementRemoveV2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminRequirementRemoveV2>>, TError,{params?: DeleteAdminRequirementRemoveV2Params}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminRequirementRemoveV2>>, TError,{params?: DeleteAdminRequirementRemoveV2Params}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminRequirementRemoveV2>>, {params?: DeleteAdminRequirementRemoveV2Params}> = (props) => {
          const {params} = props ?? {};

          return  deleteAdminRequirementRemoveV2(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminRequirementRemoveV2MutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminRequirementRemoveV2>>>
    
    export type DeleteAdminRequirementRemoveV2MutationError = ErrorType<string>

    export const useDeleteAdminRequirementRemoveV2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminRequirementRemoveV2>>, TError,{params?: DeleteAdminRequirementRemoveV2Params}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminRequirementRemoveV2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get requirement field to a location
 * @summary Location based requirement fields
 */
export const getAdminRequirementsLocationFieldsLocid = (
    locid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminRequirementsLocationFieldsLocid200>(
      {url: `/admin/requirements/location-fields/${locid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminRequirementsLocationFieldsLocidQueryKey = (locid: number,) => {
    return [`/admin/requirements/location-fields/${locid}`] as const;
    }

    
export const getGetAdminRequirementsLocationFieldsLocidQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRequirementsLocationFieldsLocid>>, TError = ErrorType<string>>(locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsLocationFieldsLocid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRequirementsLocationFieldsLocidQueryKey(locid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRequirementsLocationFieldsLocid>>> = ({ signal }) => getAdminRequirementsLocationFieldsLocid(locid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsLocationFieldsLocid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminRequirementsLocationFieldsLocidQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRequirementsLocationFieldsLocid>>>
export type GetAdminRequirementsLocationFieldsLocidQueryError = ErrorType<string>

/**
 * @summary Location based requirement fields
 */
export const useGetAdminRequirementsLocationFieldsLocid = <TData = Awaited<ReturnType<typeof getAdminRequirementsLocationFieldsLocid>>, TError = ErrorType<string>>(
 locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsLocationFieldsLocid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminRequirementsLocationFieldsLocidQueryOptions(locid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Add requirement field to a location
 * @summary Location based requirement fields
 */
export const postAdminRequirementsLocationFieldsLocid = (
    locid: number,
    postAdminRequirementsLocationFieldsLocidBody: PostAdminRequirementsLocationFieldsLocidBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/requirements/location-fields/${locid}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminRequirementsLocationFieldsLocidBody
    },
      options);
    }
  


export const getPostAdminRequirementsLocationFieldsLocidMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsLocationFieldsLocid>>, TError,{locid: number;data: PostAdminRequirementsLocationFieldsLocidBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsLocationFieldsLocid>>, TError,{locid: number;data: PostAdminRequirementsLocationFieldsLocidBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRequirementsLocationFieldsLocid>>, {locid: number;data: PostAdminRequirementsLocationFieldsLocidBody}> = (props) => {
          const {locid,data} = props ?? {};

          return  postAdminRequirementsLocationFieldsLocid(locid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminRequirementsLocationFieldsLocidMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRequirementsLocationFieldsLocid>>>
    export type PostAdminRequirementsLocationFieldsLocidMutationBody = PostAdminRequirementsLocationFieldsLocidBody
    export type PostAdminRequirementsLocationFieldsLocidMutationError = ErrorType<string>

    /**
 * @summary Location based requirement fields
 */
export const usePostAdminRequirementsLocationFieldsLocid = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsLocationFieldsLocid>>, TError,{locid: number;data: PostAdminRequirementsLocationFieldsLocidBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminRequirementsLocationFieldsLocidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Edit requirement field to a location
 * @summary Location based requirement fields
 */
export const putAdminRequirementsLocationFieldsLocid = (
    locid: number,
    putAdminRequirementsLocationFieldsLocidBody: PutAdminRequirementsLocationFieldsLocidBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/requirements/location-fields/${locid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminRequirementsLocationFieldsLocidBody
    },
      options);
    }
  


export const getPutAdminRequirementsLocationFieldsLocidMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminRequirementsLocationFieldsLocid>>, TError,{locid: number;data: PutAdminRequirementsLocationFieldsLocidBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminRequirementsLocationFieldsLocid>>, TError,{locid: number;data: PutAdminRequirementsLocationFieldsLocidBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminRequirementsLocationFieldsLocid>>, {locid: number;data: PutAdminRequirementsLocationFieldsLocidBody}> = (props) => {
          const {locid,data} = props ?? {};

          return  putAdminRequirementsLocationFieldsLocid(locid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminRequirementsLocationFieldsLocidMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminRequirementsLocationFieldsLocid>>>
    export type PutAdminRequirementsLocationFieldsLocidMutationBody = PutAdminRequirementsLocationFieldsLocidBody
    export type PutAdminRequirementsLocationFieldsLocidMutationError = ErrorType<string>

    /**
 * @summary Location based requirement fields
 */
export const usePutAdminRequirementsLocationFieldsLocid = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminRequirementsLocationFieldsLocid>>, TError,{locid: number;data: PutAdminRequirementsLocationFieldsLocidBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminRequirementsLocationFieldsLocidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminRequirementsUserUserid = (
    userid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminRequirementsUserUserid200Item[]>(
      {url: `/admin/requirements/user/${userid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminRequirementsUserUseridQueryKey = (userid: number,) => {
    return [`/admin/requirements/user/${userid}`] as const;
    }

    
export const getGetAdminRequirementsUserUseridQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRequirementsUserUserid>>, TError = ErrorType<string>>(userid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsUserUserid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRequirementsUserUseridQueryKey(userid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRequirementsUserUserid>>> = ({ signal }) => getAdminRequirementsUserUserid(userid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsUserUserid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminRequirementsUserUseridQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRequirementsUserUserid>>>
export type GetAdminRequirementsUserUseridQueryError = ErrorType<string>

export const useGetAdminRequirementsUserUserid = <TData = Awaited<ReturnType<typeof getAdminRequirementsUserUserid>>, TError = ErrorType<string>>(
 userid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsUserUserid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminRequirementsUserUseridQueryOptions(userid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAdminRequirementsUserUseridAdd = (
    userid: number,
    postAdminRequirementsUserUseridAddBody: PostAdminRequirementsUserUseridAddBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/requirements/user/${userid}/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminRequirementsUserUseridAddBody
    },
      options);
    }
  


export const getPostAdminRequirementsUserUseridAddMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsUserUseridAdd>>, TError,{userid: number;data: PostAdminRequirementsUserUseridAddBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsUserUseridAdd>>, TError,{userid: number;data: PostAdminRequirementsUserUseridAddBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRequirementsUserUseridAdd>>, {userid: number;data: PostAdminRequirementsUserUseridAddBody}> = (props) => {
          const {userid,data} = props ?? {};

          return  postAdminRequirementsUserUseridAdd(userid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminRequirementsUserUseridAddMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRequirementsUserUseridAdd>>>
    export type PostAdminRequirementsUserUseridAddMutationBody = PostAdminRequirementsUserUseridAddBody
    export type PostAdminRequirementsUserUseridAddMutationError = ErrorType<string>

    export const usePostAdminRequirementsUserUseridAdd = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsUserUseridAdd>>, TError,{userid: number;data: PostAdminRequirementsUserUseridAddBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminRequirementsUserUseridAddMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminRequirementsUserUseridUpdateV2 = (
    userid: number,
    postAdminRequirementsUserUseridUpdateV2Body: PostAdminRequirementsUserUseridUpdateV2Body,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/requirements/user/${userid}/updateV2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminRequirementsUserUseridUpdateV2Body
    },
      options);
    }
  


export const getPostAdminRequirementsUserUseridUpdateV2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsUserUseridUpdateV2>>, TError,{userid: number;data: PostAdminRequirementsUserUseridUpdateV2Body}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsUserUseridUpdateV2>>, TError,{userid: number;data: PostAdminRequirementsUserUseridUpdateV2Body}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRequirementsUserUseridUpdateV2>>, {userid: number;data: PostAdminRequirementsUserUseridUpdateV2Body}> = (props) => {
          const {userid,data} = props ?? {};

          return  postAdminRequirementsUserUseridUpdateV2(userid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminRequirementsUserUseridUpdateV2MutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRequirementsUserUseridUpdateV2>>>
    export type PostAdminRequirementsUserUseridUpdateV2MutationBody = PostAdminRequirementsUserUseridUpdateV2Body
    export type PostAdminRequirementsUserUseridUpdateV2MutationError = ErrorType<string>

    export const usePostAdminRequirementsUserUseridUpdateV2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRequirementsUserUseridUpdateV2>>, TError,{userid: number;data: PostAdminRequirementsUserUseridUpdateV2Body}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminRequirementsUserUseridUpdateV2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminRequirementsUserUseridReqid = (
    userid: number,
    reqid: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminRequirementsUserUseridReqid200>(
      {url: `/admin/requirements/user/${userid}/${reqid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminRequirementsUserUseridReqidQueryKey = (userid: number,
    reqid: string,) => {
    return [`/admin/requirements/user/${userid}/${reqid}`] as const;
    }

    
export const getGetAdminRequirementsUserUseridReqidQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRequirementsUserUseridReqid>>, TError = ErrorType<string>>(userid: number,
    reqid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsUserUseridReqid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRequirementsUserUseridReqidQueryKey(userid,reqid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRequirementsUserUseridReqid>>> = ({ signal }) => getAdminRequirementsUserUseridReqid(userid,reqid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userid && reqid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsUserUseridReqid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminRequirementsUserUseridReqidQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRequirementsUserUseridReqid>>>
export type GetAdminRequirementsUserUseridReqidQueryError = ErrorType<string>

export const useGetAdminRequirementsUserUseridReqid = <TData = Awaited<ReturnType<typeof getAdminRequirementsUserUseridReqid>>, TError = ErrorType<string>>(
 userid: number,
    reqid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRequirementsUserUseridReqid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminRequirementsUserUseridReqidQueryOptions(userid,reqid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create shift and assign nurse to shift
 */
export const postAdminShiftCreateApply = (
    postAdminShiftCreateApplyBody: PostAdminShiftCreateApplyBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/admin/shift/create/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminShiftCreateApplyBody
    },
      options);
    }
  


export const getPostAdminShiftCreateApplyMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminShiftCreateApply>>, TError,{data: PostAdminShiftCreateApplyBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminShiftCreateApply>>, TError,{data: PostAdminShiftCreateApplyBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminShiftCreateApply>>, {data: PostAdminShiftCreateApplyBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminShiftCreateApply(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminShiftCreateApplyMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminShiftCreateApply>>>
    export type PostAdminShiftCreateApplyMutationBody = PostAdminShiftCreateApplyBody
    export type PostAdminShiftCreateApplyMutationError = ErrorType<string>

    export const usePostAdminShiftCreateApply = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminShiftCreateApply>>, TError,{data: PostAdminShiftCreateApplyBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminShiftCreateApplyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminShiftRequirementsUserUseridShiftid = (
    userid: number,
    shiftid: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminShiftRequirementsUserUseridShiftid200Item[]>(
      {url: `/admin/shift/requirements/user/${userid}/${shiftid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminShiftRequirementsUserUseridShiftidQueryKey = (userid: number,
    shiftid: string,) => {
    return [`/admin/shift/requirements/user/${userid}/${shiftid}`] as const;
    }

    
export const getGetAdminShiftRequirementsUserUseridShiftidQueryOptions = <TData = Awaited<ReturnType<typeof getAdminShiftRequirementsUserUseridShiftid>>, TError = ErrorType<string>>(userid: number,
    shiftid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminShiftRequirementsUserUseridShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminShiftRequirementsUserUseridShiftidQueryKey(userid,shiftid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminShiftRequirementsUserUseridShiftid>>> = ({ signal }) => getAdminShiftRequirementsUserUseridShiftid(userid,shiftid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userid && shiftid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminShiftRequirementsUserUseridShiftid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminShiftRequirementsUserUseridShiftidQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminShiftRequirementsUserUseridShiftid>>>
export type GetAdminShiftRequirementsUserUseridShiftidQueryError = ErrorType<string>

export const useGetAdminShiftRequirementsUserUseridShiftid = <TData = Awaited<ReturnType<typeof getAdminShiftRequirementsUserUseridShiftid>>, TError = ErrorType<string>>(
 userid: number,
    shiftid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminShiftRequirementsUserUseridShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminShiftRequirementsUserUseridShiftidQueryOptions(userid,shiftid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get shifts based on filters
 */
export const getAdminShifts = (
    params: GetAdminShiftsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminShifts200>(
      {url: `/admin/shifts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminShiftsQueryKey = (params: GetAdminShiftsParams,) => {
    return [`/admin/shifts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminShiftsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminShifts>>, TError = ErrorType<string | GetAdminShifts500>>(params: GetAdminShiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminShifts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminShiftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminShifts>>> = ({ signal }) => getAdminShifts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminShifts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminShiftsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminShifts>>>
export type GetAdminShiftsQueryError = ErrorType<string | GetAdminShifts500>

export const useGetAdminShifts = <TData = Awaited<ReturnType<typeof getAdminShifts>>, TError = ErrorType<string | GetAdminShifts500>>(
 params: GetAdminShiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminShifts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminShiftsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Assign nurse to shift
 */
export const postAdminShiftsShiftidApply = (
    shiftid: number,
    postAdminShiftsShiftidApplyBody: PostAdminShiftsShiftidApplyBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/admin/shifts/${shiftid}/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminShiftsShiftidApplyBody
    },
      options);
    }
  


export const getPostAdminShiftsShiftidApplyMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminShiftsShiftidApply>>, TError,{shiftid: number;data: PostAdminShiftsShiftidApplyBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminShiftsShiftidApply>>, TError,{shiftid: number;data: PostAdminShiftsShiftidApplyBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminShiftsShiftidApply>>, {shiftid: number;data: PostAdminShiftsShiftidApplyBody}> = (props) => {
          const {shiftid,data} = props ?? {};

          return  postAdminShiftsShiftidApply(shiftid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminShiftsShiftidApplyMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminShiftsShiftidApply>>>
    export type PostAdminShiftsShiftidApplyMutationBody = PostAdminShiftsShiftidApplyBody
    export type PostAdminShiftsShiftidApplyMutationError = ErrorType<string>

    export const usePostAdminShiftsShiftidApply = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminShiftsShiftidApply>>, TError,{shiftid: number;data: PostAdminShiftsShiftidApplyBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminShiftsShiftidApplyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Admin check out autumn lake integration
 */
export const putAdminTimesheetAutumnlakeSync = (
    putAdminTimesheetAutumnlakeSyncBody: PutAdminTimesheetAutumnlakeSyncBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/timesheet/autumnlake/sync`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminTimesheetAutumnlakeSyncBody
    },
      options);
    }
  


export const getPutAdminTimesheetAutumnlakeSyncMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetAutumnlakeSync>>, TError,{data: PutAdminTimesheetAutumnlakeSyncBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetAutumnlakeSync>>, TError,{data: PutAdminTimesheetAutumnlakeSyncBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminTimesheetAutumnlakeSync>>, {data: PutAdminTimesheetAutumnlakeSyncBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminTimesheetAutumnlakeSync(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminTimesheetAutumnlakeSyncMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminTimesheetAutumnlakeSync>>>
    export type PutAdminTimesheetAutumnlakeSyncMutationBody = PutAdminTimesheetAutumnlakeSyncBody
    export type PutAdminTimesheetAutumnlakeSyncMutationError = ErrorType<string>

    export const usePutAdminTimesheetAutumnlakeSync = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetAutumnlakeSync>>, TError,{data: PutAdminTimesheetAutumnlakeSyncBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminTimesheetAutumnlakeSyncMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminTimesheetCheckin = (
    postAdminTimesheetCheckinBody: PostAdminTimesheetCheckinBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostAdminTimesheetCheckin200>(
      {url: `/admin/timesheet/checkin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminTimesheetCheckinBody
    },
      options);
    }
  


export const getPostAdminTimesheetCheckinMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminTimesheetCheckin>>, TError,{data: PostAdminTimesheetCheckinBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminTimesheetCheckin>>, TError,{data: PostAdminTimesheetCheckinBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminTimesheetCheckin>>, {data: PostAdminTimesheetCheckinBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminTimesheetCheckin(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminTimesheetCheckinMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminTimesheetCheckin>>>
    export type PostAdminTimesheetCheckinMutationBody = PostAdminTimesheetCheckinBody
    export type PostAdminTimesheetCheckinMutationError = ErrorType<string>

    export const usePostAdminTimesheetCheckin = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminTimesheetCheckin>>, TError,{data: PostAdminTimesheetCheckinBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminTimesheetCheckinMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Admin check out or smartlinx integration
 */
export const putAdminTimesheetCheckout = (
    putAdminTimesheetCheckoutBody: PutAdminTimesheetCheckoutBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/timesheet/checkout`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminTimesheetCheckoutBody
    },
      options);
    }
  


export const getPutAdminTimesheetCheckoutMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetCheckout>>, TError,{data: PutAdminTimesheetCheckoutBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetCheckout>>, TError,{data: PutAdminTimesheetCheckoutBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminTimesheetCheckout>>, {data: PutAdminTimesheetCheckoutBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminTimesheetCheckout(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminTimesheetCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminTimesheetCheckout>>>
    export type PutAdminTimesheetCheckoutMutationBody = PutAdminTimesheetCheckoutBody
    export type PutAdminTimesheetCheckoutMutationError = ErrorType<string>

    export const usePutAdminTimesheetCheckout = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetCheckout>>, TError,{data: PutAdminTimesheetCheckoutBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminTimesheetCheckoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates timesheet status by timesheet id
 * @summary Admin Timesheet
 */
export const putAdminTimesheetUpdateId = (
    id: number,
    putAdminTimesheetUpdateIdBody: PutAdminTimesheetUpdateIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutAdminTimesheetUpdateId200>(
      {url: `/admin/timesheet/update/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminTimesheetUpdateIdBody
    },
      options);
    }
  


export const getPutAdminTimesheetUpdateIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetUpdateId>>, TError,{id: number;data: PutAdminTimesheetUpdateIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetUpdateId>>, TError,{id: number;data: PutAdminTimesheetUpdateIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminTimesheetUpdateId>>, {id: number;data: PutAdminTimesheetUpdateIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminTimesheetUpdateId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminTimesheetUpdateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminTimesheetUpdateId>>>
    export type PutAdminTimesheetUpdateIdMutationBody = PutAdminTimesheetUpdateIdBody
    export type PutAdminTimesheetUpdateIdMutationError = ErrorType<string>

    /**
 * @summary Admin Timesheet
 */
export const usePutAdminTimesheetUpdateId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetUpdateId>>, TError,{id: number;data: PutAdminTimesheetUpdateIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminTimesheetUpdateIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Updates timesheet status and Endtime by timesheet id
 * @summary Admin Timesheet
 */
export const putAdminTimesheetUpdatestatusandtimeId = (
    id: number,
    putAdminTimesheetUpdatestatusandtimeIdBody: PutAdminTimesheetUpdatestatusandtimeIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutAdminTimesheetUpdatestatusandtimeId200>(
      {url: `/admin/timesheet/updatestatusandtime/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminTimesheetUpdatestatusandtimeIdBody
    },
      options);
    }
  


export const getPutAdminTimesheetUpdatestatusandtimeIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetUpdatestatusandtimeId>>, TError,{id: number;data: PutAdminTimesheetUpdatestatusandtimeIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetUpdatestatusandtimeId>>, TError,{id: number;data: PutAdminTimesheetUpdatestatusandtimeIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminTimesheetUpdatestatusandtimeId>>, {id: number;data: PutAdminTimesheetUpdatestatusandtimeIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminTimesheetUpdatestatusandtimeId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminTimesheetUpdatestatusandtimeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminTimesheetUpdatestatusandtimeId>>>
    export type PutAdminTimesheetUpdatestatusandtimeIdMutationBody = PutAdminTimesheetUpdatestatusandtimeIdBody
    export type PutAdminTimesheetUpdatestatusandtimeIdMutationError = ErrorType<string>

    /**
 * @summary Admin Timesheet
 */
export const usePutAdminTimesheetUpdatestatusandtimeId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetUpdatestatusandtimeId>>, TError,{id: number;data: PutAdminTimesheetUpdatestatusandtimeIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminTimesheetUpdatestatusandtimeIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminTimesheets = (
    params?: GetAdminTimesheetsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminTimesheets200>(
      {url: `/admin/timesheets`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminTimesheetsQueryKey = (params?: GetAdminTimesheetsParams,) => {
    return [`/admin/timesheets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminTimesheetsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTimesheets>>, TError = ErrorType<string>>(params?: GetAdminTimesheetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTimesheets>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTimesheetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTimesheets>>> = ({ signal }) => getAdminTimesheets(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminTimesheets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminTimesheetsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTimesheets>>>
export type GetAdminTimesheetsQueryError = ErrorType<string>

export const useGetAdminTimesheets = <TData = Awaited<ReturnType<typeof getAdminTimesheets>>, TError = ErrorType<string>>(
 params?: GetAdminTimesheetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTimesheets>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminTimesheetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminTimesheetsDownload = (
    params?: GetAdminTimesheetsDownloadParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Blob>(
      {url: `/admin/timesheets/download`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetAdminTimesheetsDownloadQueryKey = (params?: GetAdminTimesheetsDownloadParams,) => {
    return [`/admin/timesheets/download`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminTimesheetsDownloadQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTimesheetsDownload>>, TError = ErrorType<string>>(params?: GetAdminTimesheetsDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTimesheetsDownload>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTimesheetsDownloadQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTimesheetsDownload>>> = ({ signal }) => getAdminTimesheetsDownload(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminTimesheetsDownload>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminTimesheetsDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTimesheetsDownload>>>
export type GetAdminTimesheetsDownloadQueryError = ErrorType<string>

export const useGetAdminTimesheetsDownload = <TData = Awaited<ReturnType<typeof getAdminTimesheetsDownload>>, TError = ErrorType<string>>(
 params?: GetAdminTimesheetsDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTimesheetsDownload>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminTimesheetsDownloadQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putAdminTimesheetsPayall = (
    params?: PutAdminTimesheetsPayallParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/timesheets/payall`, method: 'PUT',
        params
    },
      options);
    }
  


export const getPutAdminTimesheetsPayallMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetsPayall>>, TError,{params?: PutAdminTimesheetsPayallParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetsPayall>>, TError,{params?: PutAdminTimesheetsPayallParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminTimesheetsPayall>>, {params?: PutAdminTimesheetsPayallParams}> = (props) => {
          const {params} = props ?? {};

          return  putAdminTimesheetsPayall(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminTimesheetsPayallMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminTimesheetsPayall>>>
    
    export type PutAdminTimesheetsPayallMutationError = ErrorType<string>

    export const usePutAdminTimesheetsPayall = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetsPayall>>, TError,{params?: PutAdminTimesheetsPayallParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminTimesheetsPayallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminTimesheetsProcessall = (
    params?: PutAdminTimesheetsProcessallParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/timesheets/processall`, method: 'PUT',
        params
    },
      options);
    }
  


export const getPutAdminTimesheetsProcessallMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetsProcessall>>, TError,{params?: PutAdminTimesheetsProcessallParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetsProcessall>>, TError,{params?: PutAdminTimesheetsProcessallParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminTimesheetsProcessall>>, {params?: PutAdminTimesheetsProcessallParams}> = (props) => {
          const {params} = props ?? {};

          return  putAdminTimesheetsProcessall(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminTimesheetsProcessallMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminTimesheetsProcessall>>>
    
    export type PutAdminTimesheetsProcessallMutationError = ErrorType<string>

    export const usePutAdminTimesheetsProcessall = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTimesheetsProcessall>>, TError,{params?: PutAdminTimesheetsProcessallParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminTimesheetsProcessallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminTimezones = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminTimezones200Item[]>(
      {url: `/admin/timezones`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAdminTimezonesQueryKey = () => {
    return [`/admin/timezones`] as const;
    }

    
export const getGetAdminTimezonesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTimezones>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTimezones>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTimezonesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTimezones>>> = ({ signal }) => getAdminTimezones(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminTimezones>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminTimezonesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTimezones>>>
export type GetAdminTimezonesQueryError = ErrorType<string>

export const useGetAdminTimezones = <TData = Awaited<ReturnType<typeof getAdminTimezones>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminTimezones>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminTimezonesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putAdminUpdatesecuritycodebyadmin = (
    putAdminUpdatesecuritycodebyadminBody: PutAdminUpdatesecuritycodebyadminBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/updatesecuritycodebyadmin`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUpdatesecuritycodebyadminBody
    },
      options);
    }
  


export const getPutAdminUpdatesecuritycodebyadminMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUpdatesecuritycodebyadmin>>, TError,{data: PutAdminUpdatesecuritycodebyadminBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUpdatesecuritycodebyadmin>>, TError,{data: PutAdminUpdatesecuritycodebyadminBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUpdatesecuritycodebyadmin>>, {data: PutAdminUpdatesecuritycodebyadminBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUpdatesecuritycodebyadmin(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUpdatesecuritycodebyadminMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUpdatesecuritycodebyadmin>>>
    export type PutAdminUpdatesecuritycodebyadminMutationBody = PutAdminUpdatesecuritycodebyadminBody
    export type PutAdminUpdatesecuritycodebyadminMutationError = ErrorType<string>

    export const usePutAdminUpdatesecuritycodebyadmin = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUpdatesecuritycodebyadmin>>, TError,{data: PutAdminUpdatesecuritycodebyadminBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUpdatesecuritycodebyadminMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminUserApproved = (
    putAdminUserApprovedBody: PutAdminUserApprovedBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/approved`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserApprovedBody
    },
      options);
    }
  


export const getPutAdminUserApprovedMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserApproved>>, TError,{data: PutAdminUserApprovedBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserApproved>>, TError,{data: PutAdminUserApprovedBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserApproved>>, {data: PutAdminUserApprovedBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserApproved(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserApprovedMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserApproved>>>
    export type PutAdminUserApprovedMutationBody = PutAdminUserApprovedBody
    export type PutAdminUserApprovedMutationError = ErrorType<string>

    export const usePutAdminUserApproved = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserApproved>>, TError,{data: PutAdminUserApprovedBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserApprovedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAdminUserCreate = (
    postAdminUserCreateBody: PostAdminUserCreateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostAdminUserCreate200>(
      {url: `/admin/user/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminUserCreateBody
    },
      options);
    }
  


export const getPostAdminUserCreateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUserCreate>>, TError,{data: PostAdminUserCreateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminUserCreate>>, TError,{data: PostAdminUserCreateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminUserCreate>>, {data: PostAdminUserCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  postAdminUserCreate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAdminUserCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminUserCreate>>>
    export type PostAdminUserCreateMutationBody = PostAdminUserCreateBody
    export type PostAdminUserCreateMutationError = ErrorType<string>

    export const usePostAdminUserCreate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUserCreate>>, TError,{data: PostAdminUserCreateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAdminUserCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAdminUserDelete = (
    params: DeleteAdminUserDeleteParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/delete`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAdminUserDeleteMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUserDelete>>, TError,{params: DeleteAdminUserDeleteParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUserDelete>>, TError,{params: DeleteAdminUserDeleteParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminUserDelete>>, {params: DeleteAdminUserDeleteParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAdminUserDelete(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminUserDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminUserDelete>>>
    
    export type DeleteAdminUserDeleteMutationError = ErrorType<string>

    export const useDeleteAdminUserDelete = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUserDelete>>, TError,{params: DeleteAdminUserDeleteParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAdminUserDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminUserEditsuspend = (
    putAdminUserEditsuspendBody: PutAdminUserEditsuspendBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/editsuspend`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserEditsuspendBody
    },
      options);
    }
  


export const getPutAdminUserEditsuspendMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserEditsuspend>>, TError,{data: PutAdminUserEditsuspendBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserEditsuspend>>, TError,{data: PutAdminUserEditsuspendBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserEditsuspend>>, {data: PutAdminUserEditsuspendBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserEditsuspend(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserEditsuspendMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserEditsuspend>>>
    export type PutAdminUserEditsuspendMutationBody = PutAdminUserEditsuspendBody
    export type PutAdminUserEditsuspendMutationError = ErrorType<string>

    export const usePutAdminUserEditsuspend = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserEditsuspend>>, TError,{data: PutAdminUserEditsuspendBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserEditsuspendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminUserReject = (
    putAdminUserRejectBody: PutAdminUserRejectBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/reject`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserRejectBody
    },
      options);
    }
  


export const getPutAdminUserRejectMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserReject>>, TError,{data: PutAdminUserRejectBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserReject>>, TError,{data: PutAdminUserRejectBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserReject>>, {data: PutAdminUserRejectBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserReject(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserRejectMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserReject>>>
    export type PutAdminUserRejectMutationBody = PutAdminUserRejectBody
    export type PutAdminUserRejectMutationError = ErrorType<string>

    export const usePutAdminUserReject = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserReject>>, TError,{data: PutAdminUserRejectBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserRejectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Set user in remediation
 */
export const putAdminUserRemediation = (
    putAdminUserRemediationBody: PutAdminUserRemediationBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/remediation`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserRemediationBody
    },
      options);
    }
  


export const getPutAdminUserRemediationMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserRemediation>>, TError,{data: PutAdminUserRemediationBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserRemediation>>, TError,{data: PutAdminUserRemediationBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserRemediation>>, {data: PutAdminUserRemediationBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserRemediation(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserRemediationMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserRemediation>>>
    export type PutAdminUserRemediationMutationBody = PutAdminUserRemediationBody
    export type PutAdminUserRemediationMutationError = ErrorType<string>

    export const usePutAdminUserRemediation = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserRemediation>>, TError,{data: PutAdminUserRemediationBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserRemediationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminUserSuspend = (
    putAdminUserSuspendBody: PutAdminUserSuspendBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/suspend`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserSuspendBody
    },
      options);
    }
  


export const getPutAdminUserSuspendMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserSuspend>>, TError,{data: PutAdminUserSuspendBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserSuspend>>, TError,{data: PutAdminUserSuspendBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserSuspend>>, {data: PutAdminUserSuspendBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserSuspend(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserSuspendMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserSuspend>>>
    export type PutAdminUserSuspendMutationBody = PutAdminUserSuspendBody
    export type PutAdminUserSuspendMutationError = ErrorType<string>

    export const usePutAdminUserSuspend = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserSuspend>>, TError,{data: PutAdminUserSuspendBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserSuspendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminUserUnsuspend = (
    putAdminUserUnsuspendBody: PutAdminUserUnsuspendBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/unsuspend`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserUnsuspendBody
    },
      options);
    }
  


export const getPutAdminUserUnsuspendMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUnsuspend>>, TError,{data: PutAdminUserUnsuspendBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUnsuspend>>, TError,{data: PutAdminUserUnsuspendBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserUnsuspend>>, {data: PutAdminUserUnsuspendBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserUnsuspend(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserUnsuspendMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserUnsuspend>>>
    export type PutAdminUserUnsuspendMutationBody = PutAdminUserUnsuspendBody
    export type PutAdminUserUnsuspendMutationError = ErrorType<string>

    export const usePutAdminUserUnsuspend = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUnsuspend>>, TError,{data: PutAdminUserUnsuspendBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserUnsuspendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminUserUpdate = (
    putAdminUserUpdateBody: PutAdminUserUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutAdminUserUpdate200>(
      {url: `/admin/user/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserUpdateBody
    },
      options);
    }
  


export const getPutAdminUserUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdate>>, TError,{data: PutAdminUserUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdate>>, TError,{data: PutAdminUserUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserUpdate>>, {data: PutAdminUserUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserUpdate>>>
    export type PutAdminUserUpdateMutationBody = PutAdminUserUpdateBody
    export type PutAdminUserUpdateMutationError = ErrorType<string>

    export const usePutAdminUserUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdate>>, TError,{data: PutAdminUserUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * updates user status
 */
export const putAdminUserUpdateActiveStatusId = (
    id: number,
    putAdminUserUpdateActiveStatusIdBody: PutAdminUserUpdateActiveStatusIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/update-active-status/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserUpdateActiveStatusIdBody
    },
      options);
    }
  


export const getPutAdminUserUpdateActiveStatusIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdateActiveStatusId>>, TError,{id: number;data: PutAdminUserUpdateActiveStatusIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdateActiveStatusId>>, TError,{id: number;data: PutAdminUserUpdateActiveStatusIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserUpdateActiveStatusId>>, {id: number;data: PutAdminUserUpdateActiveStatusIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminUserUpdateActiveStatusId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserUpdateActiveStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserUpdateActiveStatusId>>>
    export type PutAdminUserUpdateActiveStatusIdMutationBody = PutAdminUserUpdateActiveStatusIdBody
    export type PutAdminUserUpdateActiveStatusIdMutationError = ErrorType<string>

    export const usePutAdminUserUpdateActiveStatusId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdateActiveStatusId>>, TError,{id: number;data: PutAdminUserUpdateActiveStatusIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserUpdateActiveStatusIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminUserUpdateincentivepermissions = (
    putAdminUserUpdateincentivepermissionsBody: PutAdminUserUpdateincentivepermissionsBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/updateincentivepermissions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserUpdateincentivepermissionsBody
    },
      options);
    }
  


export const getPutAdminUserUpdateincentivepermissionsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdateincentivepermissions>>, TError,{data: PutAdminUserUpdateincentivepermissionsBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdateincentivepermissions>>, TError,{data: PutAdminUserUpdateincentivepermissionsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserUpdateincentivepermissions>>, {data: PutAdminUserUpdateincentivepermissionsBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserUpdateincentivepermissions(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserUpdateincentivepermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserUpdateincentivepermissions>>>
    export type PutAdminUserUpdateincentivepermissionsMutationBody = PutAdminUserUpdateincentivepermissionsBody
    export type PutAdminUserUpdateincentivepermissionsMutationError = ErrorType<string>

    export const usePutAdminUserUpdateincentivepermissions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdateincentivepermissions>>, TError,{data: PutAdminUserUpdateincentivepermissionsBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserUpdateincentivepermissionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAdminUserUpdatetestuser = (
    putAdminUserUpdatetestuserBody: PutAdminUserUpdatetestuserBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/admin/user/updatetestuser`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUserUpdatetestuserBody
    },
      options);
    }
  


export const getPutAdminUserUpdatetestuserMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdatetestuser>>, TError,{data: PutAdminUserUpdatetestuserBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdatetestuser>>, TError,{data: PutAdminUserUpdatetestuserBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUserUpdatetestuser>>, {data: PutAdminUserUpdatetestuserBody}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUserUpdatetestuser(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAdminUserUpdatetestuserMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUserUpdatetestuser>>>
    export type PutAdminUserUpdatetestuserMutationBody = PutAdminUserUpdatetestuserBody
    export type PutAdminUserUpdatetestuserMutationError = ErrorType<string>

    export const usePutAdminUserUpdatetestuser = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUserUpdatetestuser>>, TError,{data: PutAdminUserUpdatetestuserBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAdminUserUpdatetestuserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAdminUsers = (
    params?: GetAdminUsersParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminUsers200>(
      {url: `/admin/users`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminUsersQueryKey = (params?: GetAdminUsersParams,) => {
    return [`/admin/users`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ErrorType<string>>(params?: GetAdminUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsers>>> = ({ signal }) => getAdminUsers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsers>>>
export type GetAdminUsersQueryError = ErrorType<string>

export const useGetAdminUsers = <TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = ErrorType<string>>(
 params?: GetAdminUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminUsersDownload = (
    params?: GetAdminUsersDownloadParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Blob>(
      {url: `/admin/users/download`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetAdminUsersDownloadQueryKey = (params?: GetAdminUsersDownloadParams,) => {
    return [`/admin/users/download`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminUsersDownloadQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsersDownload>>, TError = ErrorType<string>>(params?: GetAdminUsersDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersDownload>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersDownloadQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsersDownload>>> = ({ signal }) => getAdminUsersDownload(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersDownload>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUsersDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsersDownload>>>
export type GetAdminUsersDownloadQueryError = ErrorType<string>

export const useGetAdminUsersDownload = <TData = Awaited<ReturnType<typeof getAdminUsersDownload>>, TError = ErrorType<string>>(
 params?: GetAdminUsersDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersDownload>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminUsersDownloadQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAdminUsersearch = (
    params?: GetAdminUsersearchParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAdminUsersearch200Item[]>(
      {url: `/admin/usersearch`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAdminUsersearchQueryKey = (params?: GetAdminUsersearchParams,) => {
    return [`/admin/usersearch`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminUsersearchQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsersearch>>, TError = ErrorType<string>>(params?: GetAdminUsersearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersearch>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsersearch>>> = ({ signal }) => getAdminUsersearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUsersearchQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsersearch>>>
export type GetAdminUsersearchQueryError = ErrorType<string>

export const useGetAdminUsersearch = <TData = Awaited<ReturnType<typeof getAdminUsersearch>>, TError = ErrorType<string>>(
 params?: GetAdminUsersearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersearch>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAdminUsersearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAlertCreate = (
    postAlertCreateBody: PostAlertCreateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/alert/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAlertCreateBody
    },
      options);
    }
  


export const getPostAlertCreateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAlertCreate>>, TError,{data: PostAlertCreateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAlertCreate>>, TError,{data: PostAlertCreateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAlertCreate>>, {data: PostAlertCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  postAlertCreate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAlertCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postAlertCreate>>>
    export type PostAlertCreateMutationBody = PostAlertCreateBody
    export type PostAlertCreateMutationError = ErrorType<string>

    export const usePostAlertCreate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAlertCreate>>, TError,{data: PostAlertCreateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAlertCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAlertGetalert = (
    params?: GetAlertGetalertParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAlertGetalert200Item[]>(
      {url: `/alert/getalert`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAlertGetalertQueryKey = (params?: GetAlertGetalertParams,) => {
    return [`/alert/getalert`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAlertGetalertQueryOptions = <TData = Awaited<ReturnType<typeof getAlertGetalert>>, TError = ErrorType<string>>(params?: GetAlertGetalertParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAlertGetalert>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAlertGetalertQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlertGetalert>>> = ({ signal }) => getAlertGetalert(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAlertGetalert>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAlertGetalertQueryResult = NonNullable<Awaited<ReturnType<typeof getAlertGetalert>>>
export type GetAlertGetalertQueryError = ErrorType<string>

export const useGetAlertGetalert = <TData = Awaited<ReturnType<typeof getAlertGetalert>>, TError = ErrorType<string>>(
 params?: GetAlertGetalertParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAlertGetalert>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAlertGetalertQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAnnouncements = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetAnnouncements200>(
      {url: `/announcements`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAnnouncementsQueryKey = () => {
    return [`/announcements`] as const;
    }

    
export const getGetAnnouncementsQueryOptions = <TData = Awaited<ReturnType<typeof getAnnouncements>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnnouncementsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnouncements>>> = ({ signal }) => getAnnouncements(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnnouncementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnouncements>>>
export type GetAnnouncementsQueryError = ErrorType<string>

export const useGetAnnouncements = <TData = Awaited<ReturnType<typeof getAnnouncements>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAnnouncementsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAnnouncements = (
    postAnnouncementsBody: PostAnnouncementsBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostAnnouncements200>(
      {url: `/announcements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAnnouncementsBody
    },
      options);
    }
  


export const getPostAnnouncementsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAnnouncements>>, TError,{data: PostAnnouncementsBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAnnouncements>>, TError,{data: PostAnnouncementsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAnnouncements>>, {data: PostAnnouncementsBody}> = (props) => {
          const {data} = props ?? {};

          return  postAnnouncements(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostAnnouncementsMutationResult = NonNullable<Awaited<ReturnType<typeof postAnnouncements>>>
    export type PostAnnouncementsMutationBody = PostAnnouncementsBody
    export type PostAnnouncementsMutationError = ErrorType<string>

    export const usePostAnnouncements = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAnnouncements>>, TError,{data: PostAnnouncementsBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostAnnouncementsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAnnouncementsId = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<DeleteAnnouncementsId200>(
      {url: `/announcements/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAnnouncementsIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnnouncementsId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAnnouncementsId>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAnnouncementsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAnnouncementsId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteAnnouncementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAnnouncementsId>>>
    
    export type DeleteAnnouncementsIdMutationError = ErrorType<string>

    export const useDeleteAnnouncementsId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnnouncementsId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteAnnouncementsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putAnnouncementsId = (
    id: number,
    putAnnouncementsIdBody: PutAnnouncementsIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutAnnouncementsId200>(
      {url: `/announcements/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAnnouncementsIdBody
    },
      options);
    }
  


export const getPutAnnouncementsIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAnnouncementsId>>, TError,{id: number;data: PutAnnouncementsIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putAnnouncementsId>>, TError,{id: number;data: PutAnnouncementsIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAnnouncementsId>>, {id: number;data: PutAnnouncementsIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putAnnouncementsId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutAnnouncementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAnnouncementsId>>>
    export type PutAnnouncementsIdMutationBody = PutAnnouncementsIdBody
    export type PutAnnouncementsIdMutationError = ErrorType<string>

    export const usePutAnnouncementsId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAnnouncementsId>>, TError,{id: number;data: PutAnnouncementsIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutAnnouncementsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * A route to handle applicants signing up as part of the onboarding process
 */
export const postApplicantVerificationcodeGenerate = (
    postApplicantVerificationcodeGenerateBody: PostApplicantVerificationcodeGenerateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/applicant/verificationcode/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApplicantVerificationcodeGenerateBody
    },
      options);
    }
  


export const getPostApplicantVerificationcodeGenerateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantVerificationcodeGenerate>>, TError,{data: PostApplicantVerificationcodeGenerateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplicantVerificationcodeGenerate>>, TError,{data: PostApplicantVerificationcodeGenerateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplicantVerificationcodeGenerate>>, {data: PostApplicantVerificationcodeGenerateBody}> = (props) => {
          const {data} = props ?? {};

          return  postApplicantVerificationcodeGenerate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostApplicantVerificationcodeGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof postApplicantVerificationcodeGenerate>>>
    export type PostApplicantVerificationcodeGenerateMutationBody = PostApplicantVerificationcodeGenerateBody
    export type PostApplicantVerificationcodeGenerateMutationError = ErrorType<string>

    export const usePostApplicantVerificationcodeGenerate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantVerificationcodeGenerate>>, TError,{data: PostApplicantVerificationcodeGenerateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostApplicantVerificationcodeGenerateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Verify the Magic Link
 */
export const postApplicantVerificationcodeVerify = (
    postApplicantVerificationcodeVerifyBody: PostApplicantVerificationcodeVerifyBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostApplicantVerificationcodeVerify200>(
      {url: `/applicant/verificationcode/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApplicantVerificationcodeVerifyBody
    },
      options);
    }
  


export const getPostApplicantVerificationcodeVerifyMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantVerificationcodeVerify>>, TError,{data: PostApplicantVerificationcodeVerifyBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplicantVerificationcodeVerify>>, TError,{data: PostApplicantVerificationcodeVerifyBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplicantVerificationcodeVerify>>, {data: PostApplicantVerificationcodeVerifyBody}> = (props) => {
          const {data} = props ?? {};

          return  postApplicantVerificationcodeVerify(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostApplicantVerificationcodeVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof postApplicantVerificationcodeVerify>>>
    export type PostApplicantVerificationcodeVerifyMutationBody = PostApplicantVerificationcodeVerifyBody
    export type PostApplicantVerificationcodeVerifyMutationError = ErrorType<string>

    export const usePostApplicantVerificationcodeVerify = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantVerificationcodeVerify>>, TError,{data: PostApplicantVerificationcodeVerifyBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostApplicantVerificationcodeVerifyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get Backfill needed shifts
 */
export const getBackfillShifts = (
    params?: GetBackfillShiftsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetBackfillShifts200Item[]>(
      {url: `/backfill-shifts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBackfillShiftsQueryKey = (params?: GetBackfillShiftsParams,) => {
    return [`/backfill-shifts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBackfillShiftsQueryOptions = <TData = Awaited<ReturnType<typeof getBackfillShifts>>, TError = ErrorType<GetBackfillShifts401 | GetBackfillShifts500>>(params?: GetBackfillShiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBackfillShifts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBackfillShiftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBackfillShifts>>> = ({ signal }) => getBackfillShifts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBackfillShifts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBackfillShiftsQueryResult = NonNullable<Awaited<ReturnType<typeof getBackfillShifts>>>
export type GetBackfillShiftsQueryError = ErrorType<GetBackfillShifts401 | GetBackfillShifts500>

export const useGetBackfillShifts = <TData = Awaited<ReturnType<typeof getBackfillShifts>>, TError = ErrorType<GetBackfillShifts401 | GetBackfillShifts500>>(
 params?: GetBackfillShiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBackfillShifts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBackfillShiftsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBonusStatuses = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetBonusStatuses200Item[]>(
      {url: `/bonus-statuses`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBonusStatusesQueryKey = () => {
    return [`/bonus-statuses`] as const;
    }

    
export const getGetBonusStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getBonusStatuses>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBonusStatuses>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBonusStatusesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBonusStatuses>>> = ({ signal }) => getBonusStatuses(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBonusStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBonusStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getBonusStatuses>>>
export type GetBonusStatusesQueryError = ErrorType<string>

export const useGetBonusStatuses = <TData = Awaited<ReturnType<typeof getBonusStatuses>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBonusStatuses>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBonusStatusesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBonusTypes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetBonusTypes200Item[]>(
      {url: `/bonus-types`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBonusTypesQueryKey = () => {
    return [`/bonus-types`] as const;
    }

    
export const getGetBonusTypesQueryOptions = <TData = Awaited<ReturnType<typeof getBonusTypes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBonusTypes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBonusTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBonusTypes>>> = ({ signal }) => getBonusTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBonusTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBonusTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getBonusTypes>>>
export type GetBonusTypesQueryError = ErrorType<string>

export const useGetBonusTypes = <TData = Awaited<ReturnType<typeof getBonusTypes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBonusTypes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBonusTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getBonuses = (
    params?: GetBonusesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetBonuses200>(
      {url: `/bonuses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBonusesQueryKey = (params?: GetBonusesParams,) => {
    return [`/bonuses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBonusesQueryOptions = <TData = Awaited<ReturnType<typeof getBonuses>>, TError = ErrorType<string>>(params?: GetBonusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBonuses>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBonusesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBonuses>>> = ({ signal }) => getBonuses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBonuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBonusesQueryResult = NonNullable<Awaited<ReturnType<typeof getBonuses>>>
export type GetBonusesQueryError = ErrorType<string>

export const useGetBonuses = <TData = Awaited<ReturnType<typeof getBonuses>>, TError = ErrorType<string>>(
 params?: GetBonusesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBonuses>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBonusesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postBonuses = (
    postBonusesBody: PostBonusesBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostBonuses200>(
      {url: `/bonuses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postBonusesBody
    },
      options);
    }
  


export const getPostBonusesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBonuses>>, TError,{data: PostBonusesBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postBonuses>>, TError,{data: PostBonusesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBonuses>>, {data: PostBonusesBody}> = (props) => {
          const {data} = props ?? {};

          return  postBonuses(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostBonusesMutationResult = NonNullable<Awaited<ReturnType<typeof postBonuses>>>
    export type PostBonusesMutationBody = PostBonusesBody
    export type PostBonusesMutationError = ErrorType<string>

    export const usePostBonuses = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBonuses>>, TError,{data: PostBonusesBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostBonusesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getBonusesDownload = (
    params?: GetBonusesDownloadParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Blob>(
      {url: `/bonuses/download`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetBonusesDownloadQueryKey = (params?: GetBonusesDownloadParams,) => {
    return [`/bonuses/download`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBonusesDownloadQueryOptions = <TData = Awaited<ReturnType<typeof getBonusesDownload>>, TError = ErrorType<string>>(params?: GetBonusesDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBonusesDownload>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBonusesDownloadQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBonusesDownload>>> = ({ signal }) => getBonusesDownload(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBonusesDownload>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBonusesDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getBonusesDownload>>>
export type GetBonusesDownloadQueryError = ErrorType<string>

export const useGetBonusesDownload = <TData = Awaited<ReturnType<typeof getBonusesDownload>>, TError = ErrorType<string>>(
 params?: GetBonusesDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBonusesDownload>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBonusesDownloadQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putBonusesId = (
    id: number,
    putBonusesIdBody: PutBonusesIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutBonusesId200>(
      {url: `/bonuses/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putBonusesIdBody
    },
      options);
    }
  


export const getPutBonusesIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBonusesId>>, TError,{id: number;data: PutBonusesIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putBonusesId>>, TError,{id: number;data: PutBonusesIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBonusesId>>, {id: number;data: PutBonusesIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putBonusesId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutBonusesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBonusesId>>>
    export type PutBonusesIdMutationBody = PutBonusesIdBody
    export type PutBonusesIdMutationError = ErrorType<string>

    export const usePutBonusesId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBonusesId>>, TError,{id: number;data: PutBonusesIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutBonusesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Check if next shift is cancelled
 */
export const getCancellationCheck = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetCancellationCheck200>(
      {url: `/cancellation-check`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCancellationCheckQueryKey = () => {
    return [`/cancellation-check`] as const;
    }

    
export const getGetCancellationCheckQueryOptions = <TData = Awaited<ReturnType<typeof getCancellationCheck>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCancellationCheck>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCancellationCheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancellationCheck>>> = ({ signal }) => getCancellationCheck(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCancellationCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCancellationCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getCancellationCheck>>>
export type GetCancellationCheckQueryError = ErrorType<string>

export const useGetCancellationCheck = <TData = Awaited<ReturnType<typeof getCancellationCheck>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCancellationCheck>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCancellationCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get CICO banners for nurse
 */
export const getCicoBanners = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetCicoBanners200>(
      {url: `/cico_banners`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCicoBannersQueryKey = () => {
    return [`/cico_banners`] as const;
    }

    
export const getGetCicoBannersQueryOptions = <TData = Awaited<ReturnType<typeof getCicoBanners>>, TError = ErrorType<string | GetCicoBanners500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCicoBanners>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCicoBannersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCicoBanners>>> = ({ signal }) => getCicoBanners(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCicoBanners>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCicoBannersQueryResult = NonNullable<Awaited<ReturnType<typeof getCicoBanners>>>
export type GetCicoBannersQueryError = ErrorType<string | GetCicoBanners500>

export const useGetCicoBanners = <TData = Awaited<ReturnType<typeof getCicoBanners>>, TError = ErrorType<string | GetCicoBanners500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCicoBanners>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCicoBannersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve all of the pools during shift creation
 * @summary Retrieve Smart IA pools
 */
export const getClinicianpools = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetClinicianpools200>(
      {url: `/clinicianpools`, method: 'GET', signal
    },
      options);
    }
  

export const getGetClinicianpoolsQueryKey = () => {
    return [`/clinicianpools`] as const;
    }

    
export const getGetClinicianpoolsQueryOptions = <TData = Awaited<ReturnType<typeof getClinicianpools>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClinicianpools>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClinicianpoolsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClinicianpools>>> = ({ signal }) => getClinicianpools(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClinicianpools>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClinicianpoolsQueryResult = NonNullable<Awaited<ReturnType<typeof getClinicianpools>>>
export type GetClinicianpoolsQueryError = ErrorType<string>

/**
 * @summary Retrieve Smart IA pools
 */
export const useGetClinicianpools = <TData = Awaited<ReturnType<typeof getClinicianpools>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClinicianpools>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetClinicianpoolsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Toggle whether a clinician should be part of the Preferred Connectors pool
 * @summary Add/remove clinicians to Preferred Connectors pool
 */
export const patchClinicianpoolsPreferredconnectorsIdToggle = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/clinicianpools/preferredconnectors/${id}/toggle`, method: 'PATCH'
    },
      options);
    }
  


export const getPatchClinicianpoolsPreferredconnectorsIdToggleMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClinicianpoolsPreferredconnectorsIdToggle>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof patchClinicianpoolsPreferredconnectorsIdToggle>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchClinicianpoolsPreferredconnectorsIdToggle>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchClinicianpoolsPreferredconnectorsIdToggle(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PatchClinicianpoolsPreferredconnectorsIdToggleMutationResult = NonNullable<Awaited<ReturnType<typeof patchClinicianpoolsPreferredconnectorsIdToggle>>>
    
    export type PatchClinicianpoolsPreferredconnectorsIdToggleMutationError = ErrorType<string>

    /**
 * @summary Add/remove clinicians to Preferred Connectors pool
 */
export const usePatchClinicianpoolsPreferredconnectorsIdToggle = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClinicianpoolsPreferredconnectorsIdToggle>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPatchClinicianpoolsPreferredconnectorsIdToggleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getDepartmentDeptIdRoleRateMappings = (
    deptId: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetDepartmentDeptIdRoleRateMappings200>(
      {url: `/department/${deptId}/role-rate-mappings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDepartmentDeptIdRoleRateMappingsQueryKey = (deptId: number,) => {
    return [`/department/${deptId}/role-rate-mappings`] as const;
    }

    
export const getGetDepartmentDeptIdRoleRateMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getDepartmentDeptIdRoleRateMappings>>, TError = ErrorType<string>>(deptId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDepartmentDeptIdRoleRateMappings>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentDeptIdRoleRateMappingsQueryKey(deptId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentDeptIdRoleRateMappings>>> = ({ signal }) => getDepartmentDeptIdRoleRateMappings(deptId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(deptId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartmentDeptIdRoleRateMappings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDepartmentDeptIdRoleRateMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartmentDeptIdRoleRateMappings>>>
export type GetDepartmentDeptIdRoleRateMappingsQueryError = ErrorType<string>

export const useGetDepartmentDeptIdRoleRateMappings = <TData = Awaited<ReturnType<typeof getDepartmentDeptIdRoleRateMappings>>, TError = ErrorType<string>>(
 deptId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDepartmentDeptIdRoleRateMappings>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDepartmentDeptIdRoleRateMappingsQueryOptions(deptId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getEmr = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetEmr200Item[]>(
      {url: `/emr`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEmrQueryKey = () => {
    return [`/emr`] as const;
    }

    
export const getGetEmrQueryOptions = <TData = Awaited<ReturnType<typeof getEmr>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmr>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmrQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmr>>> = ({ signal }) => getEmr(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmr>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmrQueryResult = NonNullable<Awaited<ReturnType<typeof getEmr>>>
export type GetEmrQueryError = ErrorType<string>

export const useGetEmr = <TData = Awaited<ReturnType<typeof getEmr>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmr>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetEmrQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetches the global enterprise settings
 */
export const getEnterpriseSettings = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetEnterpriseSettings200Item[]>(
      {url: `/enterprise-settings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEnterpriseSettingsQueryKey = () => {
    return [`/enterprise-settings`] as const;
    }

    
export const getGetEnterpriseSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getEnterpriseSettings>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnterpriseSettings>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnterpriseSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnterpriseSettings>>> = ({ signal }) => getEnterpriseSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnterpriseSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEnterpriseSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getEnterpriseSettings>>>
export type GetEnterpriseSettingsQueryError = ErrorType<string>

export const useGetEnterpriseSettings = <TData = Awaited<ReturnType<typeof getEnterpriseSettings>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnterpriseSettings>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetEnterpriseSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetches the enterprise setting ids with the value overridden to the appropriate level (org, loc, or dept)
 */
export const getEnterpriseSettingsEvaluate = (
    params?: GetEnterpriseSettingsEvaluateParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetEnterpriseSettingsEvaluate200>(
      {url: `/enterprise-settings-evaluate`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetEnterpriseSettingsEvaluateQueryKey = (params?: GetEnterpriseSettingsEvaluateParams,) => {
    return [`/enterprise-settings-evaluate`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEnterpriseSettingsEvaluateQueryOptions = <TData = Awaited<ReturnType<typeof getEnterpriseSettingsEvaluate>>, TError = ErrorType<string>>(params?: GetEnterpriseSettingsEvaluateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnterpriseSettingsEvaluate>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnterpriseSettingsEvaluateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnterpriseSettingsEvaluate>>> = ({ signal }) => getEnterpriseSettingsEvaluate(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnterpriseSettingsEvaluate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEnterpriseSettingsEvaluateQueryResult = NonNullable<Awaited<ReturnType<typeof getEnterpriseSettingsEvaluate>>>
export type GetEnterpriseSettingsEvaluateQueryError = ErrorType<string>

export const useGetEnterpriseSettingsEvaluate = <TData = Awaited<ReturnType<typeof getEnterpriseSettingsEvaluate>>, TError = ErrorType<string>>(
 params?: GetEnterpriseSettingsEvaluateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEnterpriseSettingsEvaluate>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetEnterpriseSettingsEvaluateQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all features list by user
 * @summary Global feature
 */
export const getFeaturesGlobal = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetFeaturesGlobal200Item[]>(
      {url: `/features/global`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFeaturesGlobalQueryKey = () => {
    return [`/features/global`] as const;
    }

    
export const getGetFeaturesGlobalQueryOptions = <TData = Awaited<ReturnType<typeof getFeaturesGlobal>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturesGlobal>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeaturesGlobalQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeaturesGlobal>>> = ({ signal }) => getFeaturesGlobal(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeaturesGlobal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeaturesGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof getFeaturesGlobal>>>
export type GetFeaturesGlobalQueryError = ErrorType<string>

/**
 * @summary Global feature
 */
export const useGetFeaturesGlobal = <TData = Awaited<ReturnType<typeof getFeaturesGlobal>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturesGlobal>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFeaturesGlobalQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all features list by user
 * @summary User feature
 */
export const getFeaturesUser = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetFeaturesUser200Item[]>(
      {url: `/features/user`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFeaturesUserQueryKey = () => {
    return [`/features/user`] as const;
    }

    
export const getGetFeaturesUserQueryOptions = <TData = Awaited<ReturnType<typeof getFeaturesUser>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturesUser>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeaturesUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeaturesUser>>> = ({ signal }) => getFeaturesUser(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeaturesUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeaturesUserQueryResult = NonNullable<Awaited<ReturnType<typeof getFeaturesUser>>>
export type GetFeaturesUserQueryError = ErrorType<string>

/**
 * @summary User feature
 */
export const useGetFeaturesUser = <TData = Awaited<ReturnType<typeof getFeaturesUser>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeaturesUser>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFeaturesUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update feature
 * @summary User feature
 */
export const putFeaturesId = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/features/${id}`, method: 'PUT'
    },
      options);
    }
  


export const getPutFeaturesIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFeaturesId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putFeaturesId>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putFeaturesId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  putFeaturesId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutFeaturesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putFeaturesId>>>
    
    export type PutFeaturesIdMutationError = ErrorType<string>

    /**
 * @summary User feature
 */
export const usePutFeaturesId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFeaturesId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutFeaturesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Submit feedback to app
 */
export const postFeedback = (
    postFeedbackBody: PostFeedbackBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostFeedback200>(
      {url: `/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postFeedbackBody
    },
      options);
    }
  


export const getPostFeedbackMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFeedback>>, TError,{data: PostFeedbackBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postFeedback>>, TError,{data: PostFeedbackBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFeedback>>, {data: PostFeedbackBody}> = (props) => {
          const {data} = props ?? {};

          return  postFeedback(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof postFeedback>>>
    export type PostFeedbackMutationBody = PostFeedbackBody
    export type PostFeedbackMutationError = ErrorType<string>

    export const usePostFeedback = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFeedback>>, TError,{data: PostFeedbackBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Uploads files to s3 bucket
 */
export const postFile = (
    postFileBody: PostFileBody,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(postFileBody.category !== undefined) {
 formData.append('category', postFileBody.category)
 }
if(postFileBody.file !== undefined) {
 formData.append('file', postFileBody.file)
 }

      return request<PostFile200>(
      {url: `/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostFileMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFile>>, TError,{data: PostFileBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postFile>>, TError,{data: PostFileBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFile>>, {data: PostFileBody}> = (props) => {
          const {data} = props ?? {};

          return  postFile(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostFileMutationResult = NonNullable<Awaited<ReturnType<typeof postFile>>>
    export type PostFileMutationBody = PostFileBody
    export type PostFileMutationError = ErrorType<string>

    export const usePostFile = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFile>>, TError,{data: PostFileBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get uploaded files
 */
export const getFileRelativeUrl = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<unknown>(
      {url: `/file/*relativeUrl`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFileRelativeUrlQueryKey = () => {
    return [`/file/*relativeUrl`] as const;
    }

    
export const getGetFileRelativeUrlQueryOptions = <TData = Awaited<ReturnType<typeof getFileRelativeUrl>>, TError = ErrorType<void | string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFileRelativeUrl>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFileRelativeUrlQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileRelativeUrl>>> = ({ signal }) => getFileRelativeUrl(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFileRelativeUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFileRelativeUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getFileRelativeUrl>>>
export type GetFileRelativeUrlQueryError = ErrorType<void | string>

export const useGetFileRelativeUrl = <TData = Awaited<ReturnType<typeof getFileRelativeUrl>>, TError = ErrorType<void | string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFileRelativeUrl>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFileRelativeUrlQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteFilter = (
    params?: DeleteFilterParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/filter`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteFilterMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFilter>>, TError,{params?: DeleteFilterParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFilter>>, TError,{params?: DeleteFilterParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFilter>>, {params?: DeleteFilterParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteFilter(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteFilterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFilter>>>
    
    export type DeleteFilterMutationError = ErrorType<string>

    export const useDeleteFilter = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFilter>>, TError,{params?: DeleteFilterParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteFilterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns all the filters for a clinician
 */
export const getFiltersv2 = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetFiltersv2200Item[]>(
      {url: `/filtersv2`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFiltersv2QueryKey = () => {
    return [`/filtersv2`] as const;
    }

    
export const getGetFiltersv2QueryOptions = <TData = Awaited<ReturnType<typeof getFiltersv2>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFiltersv2>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFiltersv2QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiltersv2>>> = ({ signal }) => getFiltersv2(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFiltersv2>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFiltersv2QueryResult = NonNullable<Awaited<ReturnType<typeof getFiltersv2>>>
export type GetFiltersv2QueryError = ErrorType<string>

export const useGetFiltersv2 = <TData = Awaited<ReturnType<typeof getFiltersv2>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFiltersv2>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFiltersv2QueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetsavedfilters = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetGetsavedfilters200Item[]>(
      {url: `/getsavedfilters`, method: 'GET', signal
    },
      options);
    }
  

export const getGetGetsavedfiltersQueryKey = () => {
    return [`/getsavedfilters`] as const;
    }

    
export const getGetGetsavedfiltersQueryOptions = <TData = Awaited<ReturnType<typeof getGetsavedfilters>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGetsavedfilters>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGetsavedfiltersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGetsavedfilters>>> = ({ signal }) => getGetsavedfilters(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGetsavedfilters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGetsavedfiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getGetsavedfilters>>>
export type GetGetsavedfiltersQueryError = ErrorType<string>

export const useGetGetsavedfilters = <TData = Awaited<ReturnType<typeof getGetsavedfilters>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGetsavedfilters>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetGetsavedfiltersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getHolidays = (
    params?: GetHolidaysParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetHolidays200Item[]>(
      {url: `/holidays`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetHolidaysQueryKey = (params?: GetHolidaysParams,) => {
    return [`/holidays`, ...(params ? [params]: [])] as const;
    }

    
export const getGetHolidaysQueryOptions = <TData = Awaited<ReturnType<typeof getHolidays>>, TError = ErrorType<string>>(params?: GetHolidaysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHolidaysQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHolidays>>> = ({ signal }) => getHolidays(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHolidaysQueryResult = NonNullable<Awaited<ReturnType<typeof getHolidays>>>
export type GetHolidaysQueryError = ErrorType<string>

export const useGetHolidays = <TData = Awaited<ReturnType<typeof getHolidays>>, TError = ErrorType<string>>(
 params?: GetHolidaysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHolidays>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetHolidaysQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Sends an event to Iterable for each userID in the request
 */
export const postIterableEvent = (
    postIterableEventBody: PostIterableEventBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/iterable/event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIterableEventBody
    },
      options);
    }
  


export const getPostIterableEventMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIterableEvent>>, TError,{data: PostIterableEventBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postIterableEvent>>, TError,{data: PostIterableEventBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIterableEvent>>, {data: PostIterableEventBody}> = (props) => {
          const {data} = props ?? {};

          return  postIterableEvent(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostIterableEventMutationResult = NonNullable<Awaited<ReturnType<typeof postIterableEvent>>>
    export type PostIterableEventMutationBody = PostIterableEventBody
    export type PostIterableEventMutationError = ErrorType<string>

    export const usePostIterableEvent = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIterableEvent>>, TError,{data: PostIterableEventBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostIterableEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getLocationLocid = (
    locid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetLocationLocid200>(
      {url: `/location/${locid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationLocidQueryKey = (locid: number,) => {
    return [`/location/${locid}`] as const;
    }

    
export const getGetLocationLocidQueryOptions = <TData = Awaited<ReturnType<typeof getLocationLocid>>, TError = ErrorType<string>>(locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocationLocid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationLocidQueryKey(locid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationLocid>>> = ({ signal }) => getLocationLocid(locid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationLocid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLocationLocidQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationLocid>>>
export type GetLocationLocidQueryError = ErrorType<string>

export const useGetLocationLocid = <TData = Awaited<ReturnType<typeof getLocationLocid>>, TError = ErrorType<string>>(
 locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocationLocid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLocationLocidQueryOptions(locid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetches the location's enterprise settings
 */
export const getLocationsLocIdSettings = (
    locId: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetLocationsLocIdSettings200>(
      {url: `/locations/${locId}/settings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationsLocIdSettingsQueryKey = (locId: number,) => {
    return [`/locations/${locId}/settings`] as const;
    }

    
export const getGetLocationsLocIdSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getLocationsLocIdSettings>>, TError = ErrorType<string>>(locId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocationsLocIdSettings>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsLocIdSettingsQueryKey(locId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationsLocIdSettings>>> = ({ signal }) => getLocationsLocIdSettings(locId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationsLocIdSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLocationsLocIdSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationsLocIdSettings>>>
export type GetLocationsLocIdSettingsQueryError = ErrorType<string>

export const useGetLocationsLocIdSettings = <TData = Awaited<ReturnType<typeof getLocationsLocIdSettings>>, TError = ErrorType<string>>(
 locId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLocationsLocIdSettings>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLocationsLocIdSettingsQueryOptions(locId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Clears the location's enterprise setting
 */
export const deleteLocationsLocIdSettingsSettingId = (
    locId: number,
    settingId: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/locations/${locId}/settings/${settingId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteLocationsLocIdSettingsSettingIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocationsLocIdSettingsSettingId>>, TError,{locId: number;settingId: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLocationsLocIdSettingsSettingId>>, TError,{locId: number;settingId: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLocationsLocIdSettingsSettingId>>, {locId: number;settingId: number}> = (props) => {
          const {locId,settingId} = props ?? {};

          return  deleteLocationsLocIdSettingsSettingId(locId,settingId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteLocationsLocIdSettingsSettingIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLocationsLocIdSettingsSettingId>>>
    
    export type DeleteLocationsLocIdSettingsSettingIdMutationError = ErrorType<unknown>

    export const useDeleteLocationsLocIdSettingsSettingId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocationsLocIdSettingsSettingId>>, TError,{locId: number;settingId: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteLocationsLocIdSettingsSettingIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Sets the location's enterprise setting
 */
export const putLocationsLocIdSettingsSettingId = (
    locId: number,
    settingId: number,
    putLocationsLocIdSettingsSettingIdBody: PutLocationsLocIdSettingsSettingIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/locations/${locId}/settings/${settingId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putLocationsLocIdSettingsSettingIdBody
    },
      options);
    }
  


export const getPutLocationsLocIdSettingsSettingIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLocationsLocIdSettingsSettingId>>, TError,{locId: number;settingId: number;data: PutLocationsLocIdSettingsSettingIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putLocationsLocIdSettingsSettingId>>, TError,{locId: number;settingId: number;data: PutLocationsLocIdSettingsSettingIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLocationsLocIdSettingsSettingId>>, {locId: number;settingId: number;data: PutLocationsLocIdSettingsSettingIdBody}> = (props) => {
          const {locId,settingId,data} = props ?? {};

          return  putLocationsLocIdSettingsSettingId(locId,settingId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutLocationsLocIdSettingsSettingIdMutationResult = NonNullable<Awaited<ReturnType<typeof putLocationsLocIdSettingsSettingId>>>
    export type PutLocationsLocIdSettingsSettingIdMutationBody = PutLocationsLocIdSettingsSettingIdBody
    export type PutLocationsLocIdSettingsSettingIdMutationError = ErrorType<unknown>

    export const usePutLocationsLocIdSettingsSettingId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLocationsLocIdSettingsSettingId>>, TError,{locId: number;settingId: number;data: PutLocationsLocIdSettingsSettingIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutLocationsLocIdSettingsSettingIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns loyalty levels
 */
export const getLoyaltyLevels = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetLoyaltyLevels200Item[]>(
      {url: `/loyalty/levels`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLoyaltyLevelsQueryKey = () => {
    return [`/loyalty/levels`] as const;
    }

    
export const getGetLoyaltyLevelsQueryOptions = <TData = Awaited<ReturnType<typeof getLoyaltyLevels>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLevels>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoyaltyLevelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoyaltyLevels>>> = ({ signal }) => getLoyaltyLevels(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLevels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLoyaltyLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoyaltyLevels>>>
export type GetLoyaltyLevelsQueryError = ErrorType<string>

export const useGetLoyaltyLevels = <TData = Awaited<ReturnType<typeof getLoyaltyLevels>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLevels>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLoyaltyLevelsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns faq
 */
export const getLoyaltyLoyaltylevelandfaqs = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetLoyaltyLoyaltylevelandfaqs200>(
      {url: `/loyalty/loyaltylevelandfaqs`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLoyaltyLoyaltylevelandfaqsQueryKey = () => {
    return [`/loyalty/loyaltylevelandfaqs`] as const;
    }

    
export const getGetLoyaltyLoyaltylevelandfaqsQueryOptions = <TData = Awaited<ReturnType<typeof getLoyaltyLoyaltylevelandfaqs>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLoyaltylevelandfaqs>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoyaltyLoyaltylevelandfaqsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoyaltyLoyaltylevelandfaqs>>> = ({ signal }) => getLoyaltyLoyaltylevelandfaqs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLoyaltylevelandfaqs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLoyaltyLoyaltylevelandfaqsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoyaltyLoyaltylevelandfaqs>>>
export type GetLoyaltyLoyaltylevelandfaqsQueryError = ErrorType<string>

export const useGetLoyaltyLoyaltylevelandfaqs = <TData = Awaited<ReturnType<typeof getLoyaltyLoyaltylevelandfaqs>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLoyaltylevelandfaqs>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetLoyaltyLoyaltylevelandfaqsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns a list of markets, optionally filtered by active only
 */
export const getMarkets = (
    params?: GetMarketsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetMarkets200Item[]>(
      {url: `/markets`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetMarketsQueryKey = (params?: GetMarketsParams,) => {
    return [`/markets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMarketsQueryOptions = <TData = Awaited<ReturnType<typeof getMarkets>>, TError = ErrorType<string>>(params?: GetMarketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarkets>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarkets>>> = ({ signal }) => getMarkets(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarkets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarkets>>>
export type GetMarketsQueryError = ErrorType<string>

export const useGetMarkets = <TData = Awaited<ReturnType<typeof getMarkets>>, TError = ErrorType<string>>(
 params?: GetMarketsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarkets>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMarketsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Prometheus metrics endpoint
 */
export const getMetrics = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/metrics`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMetricsQueryKey = () => {
    return [`/metrics`] as const;
    }

    
export const getGetMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getMetrics>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetricsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetrics>>> = ({ signal }) => getMetrics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getMetrics>>>
export type GetMetricsQueryError = ErrorType<string>

export const useGetMetrics = <TData = Awaited<ReturnType<typeof getMetrics>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetrics>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetricsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMobileDeviceinfo = (
    postMobileDeviceinfoBody: PostMobileDeviceinfoBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostMobileDeviceinfo200>(
      {url: `/mobile/deviceinfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postMobileDeviceinfoBody
    },
      options);
    }
  


export const getPostMobileDeviceinfoMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMobileDeviceinfo>>, TError,{data: PostMobileDeviceinfoBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMobileDeviceinfo>>, TError,{data: PostMobileDeviceinfoBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMobileDeviceinfo>>, {data: PostMobileDeviceinfoBody}> = (props) => {
          const {data} = props ?? {};

          return  postMobileDeviceinfo(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostMobileDeviceinfoMutationResult = NonNullable<Awaited<ReturnType<typeof postMobileDeviceinfo>>>
    export type PostMobileDeviceinfoMutationBody = PostMobileDeviceinfoBody
    export type PostMobileDeviceinfoMutationError = ErrorType<string>

    export const usePostMobileDeviceinfo = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMobileDeviceinfo>>, TError,{data: PostMobileDeviceinfoBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostMobileDeviceinfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns latest version of the app mobile app
 */
export const getMobileLatestversion = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetMobileLatestversion200>(
      {url: `/mobile/latestversion`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMobileLatestversionQueryKey = () => {
    return [`/mobile/latestversion`] as const;
    }

    
export const getGetMobileLatestversionQueryOptions = <TData = Awaited<ReturnType<typeof getMobileLatestversion>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileLatestversion>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMobileLatestversionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMobileLatestversion>>> = ({ signal }) => getMobileLatestversion(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMobileLatestversion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMobileLatestversionQueryResult = NonNullable<Awaited<ReturnType<typeof getMobileLatestversion>>>
export type GetMobileLatestversionQueryError = ErrorType<string>

export const useGetMobileLatestversion = <TData = Awaited<ReturnType<typeof getMobileLatestversion>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMobileLatestversion>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMobileLatestversionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get All NPS
 */
export const getNps = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNps200Item[]>(
      {url: `/nps`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNpsQueryKey = () => {
    return [`/nps`] as const;
    }

    
export const getGetNpsQueryOptions = <TData = Awaited<ReturnType<typeof getNps>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNps>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNps>>> = ({ signal }) => getNps(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNps>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNpsQueryResult = NonNullable<Awaited<ReturnType<typeof getNps>>>
export type GetNpsQueryError = ErrorType<string>

export const useGetNps = <TData = Awaited<ReturnType<typeof getNps>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNps>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNpsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Available NPS for the user
 */
export const getNpsAvailable = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNpsAvailable200>(
      {url: `/nps/available`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNpsAvailableQueryKey = () => {
    return [`/nps/available`] as const;
    }

    
export const getGetNpsAvailableQueryOptions = <TData = Awaited<ReturnType<typeof getNpsAvailable>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNpsAvailable>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsAvailableQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsAvailable>>> = ({ signal }) => getNpsAvailable(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNpsAvailable>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNpsAvailableQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsAvailable>>>
export type GetNpsAvailableQueryError = ErrorType<string>

export const useGetNpsAvailable = <TData = Awaited<ReturnType<typeof getNpsAvailable>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNpsAvailable>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNpsAvailableQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Submit NPS
 */
export const postNpsSubmit = (
    postNpsSubmitBody: PostNpsSubmitBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nps/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNpsSubmitBody
    },
      options);
    }
  


export const getPostNpsSubmitMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNpsSubmit>>, TError,{data: PostNpsSubmitBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNpsSubmit>>, TError,{data: PostNpsSubmitBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNpsSubmit>>, {data: PostNpsSubmitBody}> = (props) => {
          const {data} = props ?? {};

          return  postNpsSubmit(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNpsSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof postNpsSubmit>>>
    export type PostNpsSubmitMutationBody = PostNpsSubmitBody
    export type PostNpsSubmitMutationError = ErrorType<string>

    export const usePostNpsSubmit = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNpsSubmit>>, TError,{data: PostNpsSubmitBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNpsSubmitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Sends nurse app session data to Iterable
 * @summary Nurse App Session
 */
export const postNurseAppSession = (
    postNurseAppSessionBody: PostNurseAppSessionBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/app-session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseAppSessionBody
    },
      options);
    }
  


export const getPostNurseAppSessionMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseAppSession>>, TError,{data: PostNurseAppSessionBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseAppSession>>, TError,{data: PostNurseAppSessionBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseAppSession>>, {data: PostNurseAppSessionBody}> = (props) => {
          const {data} = props ?? {};

          return  postNurseAppSession(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseAppSessionMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseAppSession>>>
    export type PostNurseAppSessionMutationBody = PostNurseAppSessionBody
    export type PostNurseAppSessionMutationError = ErrorType<string>

    /**
 * @summary Nurse App Session
 */
export const usePostNurseAppSession = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseAppSession>>, TError,{data: PostNurseAppSessionBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseAppSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Deprecated
 */
export const getNurseCheckcredentialexpire = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseCheckcredentialexpire200Item[]>(
      {url: `/nurse/checkcredentialexpire`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNurseCheckcredentialexpireQueryKey = () => {
    return [`/nurse/checkcredentialexpire`] as const;
    }

    
export const getGetNurseCheckcredentialexpireQueryOptions = <TData = Awaited<ReturnType<typeof getNurseCheckcredentialexpire>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseCheckcredentialexpire>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseCheckcredentialexpireQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseCheckcredentialexpire>>> = ({ signal }) => getNurseCheckcredentialexpire(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseCheckcredentialexpire>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseCheckcredentialexpireQueryResult = NonNullable<Awaited<ReturnType<typeof getNurseCheckcredentialexpire>>>
export type GetNurseCheckcredentialexpireQueryError = ErrorType<string>

export const useGetNurseCheckcredentialexpire = <TData = Awaited<ReturnType<typeof getNurseCheckcredentialexpire>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseCheckcredentialexpire>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseCheckcredentialexpireQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteNurseDeleteresume = (
    params?: DeleteNurseDeleteresumeParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/deleteresume`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteNurseDeleteresumeMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNurseDeleteresume>>, TError,{params?: DeleteNurseDeleteresumeParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNurseDeleteresume>>, TError,{params?: DeleteNurseDeleteresumeParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNurseDeleteresume>>, {params?: DeleteNurseDeleteresumeParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteNurseDeleteresume(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteNurseDeleteresumeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNurseDeleteresume>>>
    
    export type DeleteNurseDeleteresumeMutationError = ErrorType<string>

    export const useDeleteNurseDeleteresume = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNurseDeleteresume>>, TError,{params?: DeleteNurseDeleteresumeParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteNurseDeleteresumeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get shift history of nurse for supervisor
 */
export const getNurseFullShiftHistory = (
    params: GetNurseFullShiftHistoryParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseFullShiftHistory200>(
      {url: `/nurse/full-shift-history`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNurseFullShiftHistoryQueryKey = (params: GetNurseFullShiftHistoryParams,) => {
    return [`/nurse/full-shift-history`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNurseFullShiftHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getNurseFullShiftHistory>>, TError = ErrorType<string>>(params: GetNurseFullShiftHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseFullShiftHistory>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseFullShiftHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseFullShiftHistory>>> = ({ signal }) => getNurseFullShiftHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseFullShiftHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseFullShiftHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getNurseFullShiftHistory>>>
export type GetNurseFullShiftHistoryQueryError = ErrorType<string>

export const useGetNurseFullShiftHistory = <TData = Awaited<ReturnType<typeof getNurseFullShiftHistory>>, TError = ErrorType<string>>(
 params: GetNurseFullShiftHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseFullShiftHistory>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseFullShiftHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postNurseJobhistoryCreate = (
    postNurseJobhistoryCreateBody: PostNurseJobhistoryCreateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/jobhistory/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseJobhistoryCreateBody
    },
      options);
    }
  


export const getPostNurseJobhistoryCreateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseJobhistoryCreate>>, TError,{data: PostNurseJobhistoryCreateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseJobhistoryCreate>>, TError,{data: PostNurseJobhistoryCreateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseJobhistoryCreate>>, {data: PostNurseJobhistoryCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  postNurseJobhistoryCreate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseJobhistoryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseJobhistoryCreate>>>
    export type PostNurseJobhistoryCreateMutationBody = PostNurseJobhistoryCreateBody
    export type PostNurseJobhistoryCreateMutationError = ErrorType<string>

    export const usePostNurseJobhistoryCreate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseJobhistoryCreate>>, TError,{data: PostNurseJobhistoryCreateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseJobhistoryCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putNurseJobhistoryUpdate = (
    putNurseJobhistoryUpdateBody: PutNurseJobhistoryUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/jobhistory/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putNurseJobhistoryUpdateBody
    },
      options);
    }
  


export const getPutNurseJobhistoryUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseJobhistoryUpdate>>, TError,{data: PutNurseJobhistoryUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putNurseJobhistoryUpdate>>, TError,{data: PutNurseJobhistoryUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNurseJobhistoryUpdate>>, {data: PutNurseJobhistoryUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putNurseJobhistoryUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutNurseJobhistoryUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putNurseJobhistoryUpdate>>>
    export type PutNurseJobhistoryUpdateMutationBody = PutNurseJobhistoryUpdateBody
    export type PutNurseJobhistoryUpdateMutationError = ErrorType<string>

    export const usePutNurseJobhistoryUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseJobhistoryUpdate>>, TError,{data: PutNurseJobhistoryUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutNurseJobhistoryUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteNurseRequirementRemoveV2 = (
    params?: DeleteNurseRequirementRemoveV2Params,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/requirement/removeV2`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteNurseRequirementRemoveV2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNurseRequirementRemoveV2>>, TError,{params?: DeleteNurseRequirementRemoveV2Params}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNurseRequirementRemoveV2>>, TError,{params?: DeleteNurseRequirementRemoveV2Params}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNurseRequirementRemoveV2>>, {params?: DeleteNurseRequirementRemoveV2Params}> = (props) => {
          const {params} = props ?? {};

          return  deleteNurseRequirementRemoveV2(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteNurseRequirementRemoveV2MutationResult = NonNullable<Awaited<ReturnType<typeof deleteNurseRequirementRemoveV2>>>
    
    export type DeleteNurseRequirementRemoveV2MutationError = ErrorType<string>

    export const useDeleteNurseRequirementRemoveV2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNurseRequirementRemoveV2>>, TError,{params?: DeleteNurseRequirementRemoveV2Params}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteNurseRequirementRemoveV2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get all requirements for a clinician
 */
export const getNurseRequirements = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseRequirements200Item[]>(
      {url: `/nurse/requirements`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNurseRequirementsQueryKey = () => {
    return [`/nurse/requirements`] as const;
    }

    
export const getGetNurseRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof getNurseRequirements>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseRequirementsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseRequirements>>> = ({ signal }) => getNurseRequirements(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseRequirements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof getNurseRequirements>>>
export type GetNurseRequirementsQueryError = ErrorType<string>

export const useGetNurseRequirements = <TData = Awaited<ReturnType<typeof getNurseRequirements>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseRequirementsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postNurseRequirementsAdd = (
    postNurseRequirementsAddBody: PostNurseRequirementsAddBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostNurseRequirementsAdd200>(
      {url: `/nurse/requirements/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseRequirementsAddBody
    },
      options);
    }
  


export const getPostNurseRequirementsAddMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseRequirementsAdd>>, TError,{data: PostNurseRequirementsAddBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseRequirementsAdd>>, TError,{data: PostNurseRequirementsAddBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseRequirementsAdd>>, {data: PostNurseRequirementsAddBody}> = (props) => {
          const {data} = props ?? {};

          return  postNurseRequirementsAdd(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseRequirementsAddMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseRequirementsAdd>>>
    export type PostNurseRequirementsAddMutationBody = PostNurseRequirementsAddBody
    export type PostNurseRequirementsAddMutationError = ErrorType<string>

    export const usePostNurseRequirementsAdd = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseRequirementsAdd>>, TError,{data: PostNurseRequirementsAddBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseRequirementsAddMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNurseRequirementsAddV2 = (
    postNurseRequirementsAddV2Body: PostNurseRequirementsAddV2Body,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostNurseRequirementsAddV2200>(
      {url: `/nurse/requirements/addV2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseRequirementsAddV2Body
    },
      options);
    }
  


export const getPostNurseRequirementsAddV2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseRequirementsAddV2>>, TError,{data: PostNurseRequirementsAddV2Body}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseRequirementsAddV2>>, TError,{data: PostNurseRequirementsAddV2Body}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseRequirementsAddV2>>, {data: PostNurseRequirementsAddV2Body}> = (props) => {
          const {data} = props ?? {};

          return  postNurseRequirementsAddV2(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseRequirementsAddV2MutationResult = NonNullable<Awaited<ReturnType<typeof postNurseRequirementsAddV2>>>
    export type PostNurseRequirementsAddV2MutationBody = PostNurseRequirementsAddV2Body
    export type PostNurseRequirementsAddV2MutationError = ErrorType<string>

    export const usePostNurseRequirementsAddV2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseRequirementsAddV2>>, TError,{data: PostNurseRequirementsAddV2Body}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseRequirementsAddV2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putNurseRequirementsUpdate = (
    putNurseRequirementsUpdateBody: PutNurseRequirementsUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutNurseRequirementsUpdate200>(
      {url: `/nurse/requirements/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putNurseRequirementsUpdateBody
    },
      options);
    }
  


export const getPutNurseRequirementsUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseRequirementsUpdate>>, TError,{data: PutNurseRequirementsUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putNurseRequirementsUpdate>>, TError,{data: PutNurseRequirementsUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNurseRequirementsUpdate>>, {data: PutNurseRequirementsUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putNurseRequirementsUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutNurseRequirementsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putNurseRequirementsUpdate>>>
    export type PutNurseRequirementsUpdateMutationBody = PutNurseRequirementsUpdateBody
    export type PutNurseRequirementsUpdateMutationError = ErrorType<string>

    export const usePutNurseRequirementsUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseRequirementsUpdate>>, TError,{data: PutNurseRequirementsUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutNurseRequirementsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putNurseRequirementsUpdateV2 = (
    putNurseRequirementsUpdateV2Body: PutNurseRequirementsUpdateV2Body,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutNurseRequirementsUpdateV2200>(
      {url: `/nurse/requirements/updateV2`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putNurseRequirementsUpdateV2Body
    },
      options);
    }
  


export const getPutNurseRequirementsUpdateV2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseRequirementsUpdateV2>>, TError,{data: PutNurseRequirementsUpdateV2Body}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putNurseRequirementsUpdateV2>>, TError,{data: PutNurseRequirementsUpdateV2Body}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNurseRequirementsUpdateV2>>, {data: PutNurseRequirementsUpdateV2Body}> = (props) => {
          const {data} = props ?? {};

          return  putNurseRequirementsUpdateV2(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutNurseRequirementsUpdateV2MutationResult = NonNullable<Awaited<ReturnType<typeof putNurseRequirementsUpdateV2>>>
    export type PutNurseRequirementsUpdateV2MutationBody = PutNurseRequirementsUpdateV2Body
    export type PutNurseRequirementsUpdateV2MutationError = ErrorType<string>

    export const usePutNurseRequirementsUpdateV2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseRequirementsUpdateV2>>, TError,{data: PutNurseRequirementsUpdateV2Body}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutNurseRequirementsUpdateV2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Gets all requirements for a clinician, as well as if requirements can be added or deleted
 */
export const getNurseRequirementsV2 = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseRequirementsV2200>(
      {url: `/nurse/requirementsV2`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNurseRequirementsV2QueryKey = () => {
    return [`/nurse/requirementsV2`] as const;
    }

    
export const getGetNurseRequirementsV2QueryOptions = <TData = Awaited<ReturnType<typeof getNurseRequirementsV2>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseRequirementsV2>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseRequirementsV2QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseRequirementsV2>>> = ({ signal }) => getNurseRequirementsV2(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseRequirementsV2>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseRequirementsV2QueryResult = NonNullable<Awaited<ReturnType<typeof getNurseRequirementsV2>>>
export type GetNurseRequirementsV2QueryError = ErrorType<string>

export const useGetNurseRequirementsV2 = <TData = Awaited<ReturnType<typeof getNurseRequirementsV2>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseRequirementsV2>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseRequirementsV2QueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getNurseShiftTimesheet = (
    params?: GetNurseShiftTimesheetParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseShiftTimesheet200>(
      {url: `/nurse/shift/timesheet`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNurseShiftTimesheetQueryKey = (params?: GetNurseShiftTimesheetParams,) => {
    return [`/nurse/shift/timesheet`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNurseShiftTimesheetQueryOptions = <TData = Awaited<ReturnType<typeof getNurseShiftTimesheet>>, TError = ErrorType<string>>(params?: GetNurseShiftTimesheetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheet>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseShiftTimesheetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseShiftTimesheet>>> = ({ signal }) => getNurseShiftTimesheet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseShiftTimesheetQueryResult = NonNullable<Awaited<ReturnType<typeof getNurseShiftTimesheet>>>
export type GetNurseShiftTimesheetQueryError = ErrorType<string>

export const useGetNurseShiftTimesheet = <TData = Awaited<ReturnType<typeof getNurseShiftTimesheet>>, TError = ErrorType<string>>(
 params?: GetNurseShiftTimesheetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheet>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseShiftTimesheetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Adds a comment (AKA note or message) to a timesheet based on shift ID and user ID. Waits up to two minutes (asynchronously) for the timesheet to exist if it does not already.
 */
export const postNurseShiftTimesheetAsyncNote = (
    postNurseShiftTimesheetAsyncNoteBody: PostNurseShiftTimesheetAsyncNoteBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/shift/timesheet/async-note`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseShiftTimesheetAsyncNoteBody
    },
      options);
    }
  


export const getPostNurseShiftTimesheetAsyncNoteMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetAsyncNote>>, TError,{data: PostNurseShiftTimesheetAsyncNoteBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetAsyncNote>>, TError,{data: PostNurseShiftTimesheetAsyncNoteBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseShiftTimesheetAsyncNote>>, {data: PostNurseShiftTimesheetAsyncNoteBody}> = (props) => {
          const {data} = props ?? {};

          return  postNurseShiftTimesheetAsyncNote(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseShiftTimesheetAsyncNoteMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseShiftTimesheetAsyncNote>>>
    export type PostNurseShiftTimesheetAsyncNoteMutationBody = PostNurseShiftTimesheetAsyncNoteBody
    export type PostNurseShiftTimesheetAsyncNoteMutationError = ErrorType<string>

    export const usePostNurseShiftTimesheetAsyncNote = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetAsyncNote>>, TError,{data: PostNurseShiftTimesheetAsyncNoteBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseShiftTimesheetAsyncNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNurseShiftTimesheetComponentAdd = (
    postNurseShiftTimesheetComponentAddBody: PostNurseShiftTimesheetComponentAddBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostNurseShiftTimesheetComponentAdd200>(
      {url: `/nurse/shift/timesheet/component/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseShiftTimesheetComponentAddBody
    },
      options);
    }
  


export const getPostNurseShiftTimesheetComponentAddMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetComponentAdd>>, TError,{data: PostNurseShiftTimesheetComponentAddBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetComponentAdd>>, TError,{data: PostNurseShiftTimesheetComponentAddBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseShiftTimesheetComponentAdd>>, {data: PostNurseShiftTimesheetComponentAddBody}> = (props) => {
          const {data} = props ?? {};

          return  postNurseShiftTimesheetComponentAdd(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseShiftTimesheetComponentAddMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseShiftTimesheetComponentAdd>>>
    export type PostNurseShiftTimesheetComponentAddMutationBody = PostNurseShiftTimesheetComponentAddBody
    export type PostNurseShiftTimesheetComponentAddMutationError = ErrorType<string>

    export const usePostNurseShiftTimesheetComponentAdd = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetComponentAdd>>, TError,{data: PostNurseShiftTimesheetComponentAddBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseShiftTimesheetComponentAddMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteNurseShiftTimesheetComponentDeleteId = (
    id: string,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/shift/timesheet/component/delete/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteNurseShiftTimesheetComponentDeleteIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNurseShiftTimesheetComponentDeleteId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNurseShiftTimesheetComponentDeleteId>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNurseShiftTimesheetComponentDeleteId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteNurseShiftTimesheetComponentDeleteId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteNurseShiftTimesheetComponentDeleteIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNurseShiftTimesheetComponentDeleteId>>>
    
    export type DeleteNurseShiftTimesheetComponentDeleteIdMutationError = ErrorType<string>

    export const useDeleteNurseShiftTimesheetComponentDeleteId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNurseShiftTimesheetComponentDeleteId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteNurseShiftTimesheetComponentDeleteIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putNurseShiftTimesheetComponentUpdate = (
    putNurseShiftTimesheetComponentUpdateBody: PutNurseShiftTimesheetComponentUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutNurseShiftTimesheetComponentUpdate200>(
      {url: `/nurse/shift/timesheet/component/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putNurseShiftTimesheetComponentUpdateBody
    },
      options);
    }
  


export const getPutNurseShiftTimesheetComponentUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseShiftTimesheetComponentUpdate>>, TError,{data: PutNurseShiftTimesheetComponentUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putNurseShiftTimesheetComponentUpdate>>, TError,{data: PutNurseShiftTimesheetComponentUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNurseShiftTimesheetComponentUpdate>>, {data: PutNurseShiftTimesheetComponentUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putNurseShiftTimesheetComponentUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutNurseShiftTimesheetComponentUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putNurseShiftTimesheetComponentUpdate>>>
    export type PutNurseShiftTimesheetComponentUpdateMutationBody = PutNurseShiftTimesheetComponentUpdateBody
    export type PutNurseShiftTimesheetComponentUpdateMutationError = ErrorType<string>

    export const usePutNurseShiftTimesheetComponentUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseShiftTimesheetComponentUpdate>>, TError,{data: PutNurseShiftTimesheetComponentUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutNurseShiftTimesheetComponentUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getNurseShiftTimesheetComponents = (
    params?: GetNurseShiftTimesheetComponentsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseShiftTimesheetComponents200Item[]>(
      {url: `/nurse/shift/timesheet/components`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNurseShiftTimesheetComponentsQueryKey = (params?: GetNurseShiftTimesheetComponentsParams,) => {
    return [`/nurse/shift/timesheet/components`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNurseShiftTimesheetComponentsQueryOptions = <TData = Awaited<ReturnType<typeof getNurseShiftTimesheetComponents>>, TError = ErrorType<string>>(params?: GetNurseShiftTimesheetComponentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetComponents>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseShiftTimesheetComponentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseShiftTimesheetComponents>>> = ({ signal }) => getNurseShiftTimesheetComponents(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetComponents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseShiftTimesheetComponentsQueryResult = NonNullable<Awaited<ReturnType<typeof getNurseShiftTimesheetComponents>>>
export type GetNurseShiftTimesheetComponentsQueryError = ErrorType<string>

export const useGetNurseShiftTimesheetComponents = <TData = Awaited<ReturnType<typeof getNurseShiftTimesheetComponents>>, TError = ErrorType<string>>(
 params?: GetNurseShiftTimesheetComponentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetComponents>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseShiftTimesheetComponentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postNurseShiftTimesheetNote = (
    postNurseShiftTimesheetNoteBodyItem: PostNurseShiftTimesheetNoteBodyItem[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostNurseShiftTimesheetNote200Item[]>(
      {url: `/nurse/shift/timesheet/note`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseShiftTimesheetNoteBodyItem
    },
      options);
    }
  


export const getPostNurseShiftTimesheetNoteMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetNote>>, TError,{data: PostNurseShiftTimesheetNoteBodyItem[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetNote>>, TError,{data: PostNurseShiftTimesheetNoteBodyItem[]}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseShiftTimesheetNote>>, {data: PostNurseShiftTimesheetNoteBodyItem[]}> = (props) => {
          const {data} = props ?? {};

          return  postNurseShiftTimesheetNote(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseShiftTimesheetNoteMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseShiftTimesheetNote>>>
    export type PostNurseShiftTimesheetNoteMutationBody = PostNurseShiftTimesheetNoteBodyItem[]
    export type PostNurseShiftTimesheetNoteMutationError = ErrorType<string>

    export const usePostNurseShiftTimesheetNote = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftTimesheetNote>>, TError,{data: PostNurseShiftTimesheetNoteBodyItem[]}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseShiftTimesheetNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getNurseShiftTimesheetNotes = (
    params?: GetNurseShiftTimesheetNotesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseShiftTimesheetNotes200Item[]>(
      {url: `/nurse/shift/timesheet/notes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNurseShiftTimesheetNotesQueryKey = (params?: GetNurseShiftTimesheetNotesParams,) => {
    return [`/nurse/shift/timesheet/notes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNurseShiftTimesheetNotesQueryOptions = <TData = Awaited<ReturnType<typeof getNurseShiftTimesheetNotes>>, TError = ErrorType<string>>(params?: GetNurseShiftTimesheetNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetNotes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseShiftTimesheetNotesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseShiftTimesheetNotes>>> = ({ signal }) => getNurseShiftTimesheetNotes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetNotes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseShiftTimesheetNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getNurseShiftTimesheetNotes>>>
export type GetNurseShiftTimesheetNotesQueryError = ErrorType<string>

export const useGetNurseShiftTimesheetNotes = <TData = Awaited<ReturnType<typeof getNurseShiftTimesheetNotes>>, TError = ErrorType<string>>(
 params?: GetNurseShiftTimesheetNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetNotes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseShiftTimesheetNotesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getNurseShiftTimesheetNotesv2 = (
    params?: GetNurseShiftTimesheetNotesv2Params,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseShiftTimesheetNotesv2200Item[]>(
      {url: `/nurse/shift/timesheet/notesv2`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNurseShiftTimesheetNotesv2QueryKey = (params?: GetNurseShiftTimesheetNotesv2Params,) => {
    return [`/nurse/shift/timesheet/notesv2`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNurseShiftTimesheetNotesv2QueryOptions = <TData = Awaited<ReturnType<typeof getNurseShiftTimesheetNotesv2>>, TError = ErrorType<string>>(params?: GetNurseShiftTimesheetNotesv2Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetNotesv2>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseShiftTimesheetNotesv2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseShiftTimesheetNotesv2>>> = ({ signal }) => getNurseShiftTimesheetNotesv2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetNotesv2>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseShiftTimesheetNotesv2QueryResult = NonNullable<Awaited<ReturnType<typeof getNurseShiftTimesheetNotesv2>>>
export type GetNurseShiftTimesheetNotesv2QueryError = ErrorType<string>

export const useGetNurseShiftTimesheetNotesv2 = <TData = Awaited<ReturnType<typeof getNurseShiftTimesheetNotesv2>>, TError = ErrorType<string>>(
 params?: GetNurseShiftTimesheetNotesv2Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShiftTimesheetNotesv2>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseShiftTimesheetNotesv2QueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getNurseShifthistory = (
    params: GetNurseShifthistoryParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurseShifthistory200Item[]>(
      {url: `/nurse/shifthistory`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNurseShifthistoryQueryKey = (params: GetNurseShifthistoryParams,) => {
    return [`/nurse/shifthistory`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNurseShifthistoryQueryOptions = <TData = Awaited<ReturnType<typeof getNurseShifthistory>>, TError = ErrorType<string>>(params: GetNurseShifthistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShifthistory>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNurseShifthistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurseShifthistory>>> = ({ signal }) => getNurseShifthistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurseShifthistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNurseShifthistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getNurseShifthistory>>>
export type GetNurseShifthistoryQueryError = ErrorType<string>

export const useGetNurseShifthistory = <TData = Awaited<ReturnType<typeof getNurseShifthistory>>, TError = ErrorType<string>>(
 params: GetNurseShifthistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurseShifthistory>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNurseShifthistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates multiple shift requests for a nurse
 * @summary Nurse Shifts Request
 */
export const postNurseShiftsRequests = (
    postNurseShiftsRequestsBody: PostNurseShiftsRequestsBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/shifts/requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseShiftsRequestsBody
    },
      options);
    }
  


export const getPostNurseShiftsRequestsMutationOptions = <TError = ErrorType<PostNurseShiftsRequests400 | string | PostNurseShiftsRequests500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftsRequests>>, TError,{data: PostNurseShiftsRequestsBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftsRequests>>, TError,{data: PostNurseShiftsRequestsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseShiftsRequests>>, {data: PostNurseShiftsRequestsBody}> = (props) => {
          const {data} = props ?? {};

          return  postNurseShiftsRequests(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseShiftsRequestsMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseShiftsRequests>>>
    export type PostNurseShiftsRequestsMutationBody = PostNurseShiftsRequestsBody
    export type PostNurseShiftsRequestsMutationError = ErrorType<PostNurseShiftsRequests400 | string | PostNurseShiftsRequests500>

    /**
 * @summary Nurse Shifts Request
 */
export const usePostNurseShiftsRequests = <TError = ErrorType<PostNurseShiftsRequests400 | string | PostNurseShiftsRequests500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseShiftsRequests>>, TError,{data: PostNurseShiftsRequestsBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseShiftsRequestsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNurseTimesheetCheckin = (
    postNurseTimesheetCheckinBody: PostNurseTimesheetCheckinBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostNurseTimesheetCheckin200>(
      {url: `/nurse/timesheet/checkin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseTimesheetCheckinBody
    },
      options);
    }
  


export const getPostNurseTimesheetCheckinMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseTimesheetCheckin>>, TError,{data: PostNurseTimesheetCheckinBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseTimesheetCheckin>>, TError,{data: PostNurseTimesheetCheckinBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseTimesheetCheckin>>, {data: PostNurseTimesheetCheckinBody}> = (props) => {
          const {data} = props ?? {};

          return  postNurseTimesheetCheckin(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseTimesheetCheckinMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseTimesheetCheckin>>>
    export type PostNurseTimesheetCheckinMutationBody = PostNurseTimesheetCheckinBody
    export type PostNurseTimesheetCheckinMutationError = ErrorType<string>

    export const usePostNurseTimesheetCheckin = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseTimesheetCheckin>>, TError,{data: PostNurseTimesheetCheckinBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseTimesheetCheckinMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putNurseTimesheetCheckoutv2 = (
    putNurseTimesheetCheckoutv2Body: PutNurseTimesheetCheckoutv2Body,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutNurseTimesheetCheckoutv2200>(
      {url: `/nurse/timesheet/checkoutv2`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putNurseTimesheetCheckoutv2Body
    },
      options);
    }
  


export const getPutNurseTimesheetCheckoutv2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseTimesheetCheckoutv2>>, TError,{data: PutNurseTimesheetCheckoutv2Body}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putNurseTimesheetCheckoutv2>>, TError,{data: PutNurseTimesheetCheckoutv2Body}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNurseTimesheetCheckoutv2>>, {data: PutNurseTimesheetCheckoutv2Body}> = (props) => {
          const {data} = props ?? {};

          return  putNurseTimesheetCheckoutv2(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutNurseTimesheetCheckoutv2MutationResult = NonNullable<Awaited<ReturnType<typeof putNurseTimesheetCheckoutv2>>>
    export type PutNurseTimesheetCheckoutv2MutationBody = PutNurseTimesheetCheckoutv2Body
    export type PutNurseTimesheetCheckoutv2MutationError = ErrorType<string>

    export const usePutNurseTimesheetCheckoutv2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNurseTimesheetCheckoutv2>>, TError,{data: PutNurseTimesheetCheckoutv2Body}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutNurseTimesheetCheckoutv2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNurseTimesheetLog = (
    postNurseTimesheetLogBody: PostNurseTimesheetLogBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurse/timesheet/log`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postNurseTimesheetLogBody
    },
      options);
    }
  


export const getPostNurseTimesheetLogMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseTimesheetLog>>, TError,{data: PostNurseTimesheetLogBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNurseTimesheetLog>>, TError,{data: PostNurseTimesheetLogBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNurseTimesheetLog>>, {data: PostNurseTimesheetLogBody}> = (props) => {
          const {data} = props ?? {};

          return  postNurseTimesheetLog(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostNurseTimesheetLogMutationResult = NonNullable<Awaited<ReturnType<typeof postNurseTimesheetLog>>>
    export type PostNurseTimesheetLogMutationBody = PostNurseTimesheetLogBody
    export type PostNurseTimesheetLogMutationError = ErrorType<string>

    export const usePostNurseTimesheetLog = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNurseTimesheetLog>>, TError,{data: PostNurseTimesheetLogBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostNurseTimesheetLogMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get nurse list
 */
export const getNurses = (
    params?: GetNursesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNurses200>(
      {url: `/nurses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNursesQueryKey = (params?: GetNursesParams,) => {
    return [`/nurses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNursesQueryOptions = <TData = Awaited<ReturnType<typeof getNurses>>, TError = ErrorType<string>>(params?: GetNursesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurses>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNursesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNurses>>> = ({ signal }) => getNurses(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNurses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNursesQueryResult = NonNullable<Awaited<ReturnType<typeof getNurses>>>
export type GetNursesQueryError = ErrorType<string>

/**
 * @summary Get nurse list
 */
export const useGetNurses = <TData = Awaited<ReturnType<typeof getNurses>>, TError = ErrorType<string>>(
 params?: GetNursesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNurses>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNursesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Requstable shifts
 */
export const getNursesRequestableShifts = (
    params?: GetNursesRequestableShiftsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNursesRequestableShifts200>(
      {url: `/nurses/requestable-shifts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNursesRequestableShiftsQueryKey = (params?: GetNursesRequestableShiftsParams,) => {
    return [`/nurses/requestable-shifts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNursesRequestableShiftsQueryOptions = <TData = Awaited<ReturnType<typeof getNursesRequestableShifts>>, TError = ErrorType<GetNursesRequestableShifts400 | string>>(params?: GetNursesRequestableShiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNursesRequestableShifts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNursesRequestableShiftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNursesRequestableShifts>>> = ({ signal }) => getNursesRequestableShifts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNursesRequestableShifts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNursesRequestableShiftsQueryResult = NonNullable<Awaited<ReturnType<typeof getNursesRequestableShifts>>>
export type GetNursesRequestableShiftsQueryError = ErrorType<GetNursesRequestableShifts400 | string>

/**
 * @summary Requstable shifts
 */
export const useGetNursesRequestableShifts = <TData = Awaited<ReturnType<typeof getNursesRequestableShifts>>, TError = ErrorType<GetNursesRequestableShifts400 | string>>(
 params?: GetNursesRequestableShiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNursesRequestableShifts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNursesRequestableShiftsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * For the mobile app to submit reports of the nurse's latitude and longitude.
 * @summary Submit geolocation reports
 */
export const putNursesSaveGeolocations = (
    putNursesSaveGeolocationsBodyItem: PutNursesSaveGeolocationsBodyItem[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/nurses/save-geolocations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putNursesSaveGeolocationsBodyItem
    },
      options);
    }
  


export const getPutNursesSaveGeolocationsMutationOptions = <TError = ErrorType<PutNursesSaveGeolocations400 | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNursesSaveGeolocations>>, TError,{data: PutNursesSaveGeolocationsBodyItem[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putNursesSaveGeolocations>>, TError,{data: PutNursesSaveGeolocationsBodyItem[]}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNursesSaveGeolocations>>, {data: PutNursesSaveGeolocationsBodyItem[]}> = (props) => {
          const {data} = props ?? {};

          return  putNursesSaveGeolocations(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutNursesSaveGeolocationsMutationResult = NonNullable<Awaited<ReturnType<typeof putNursesSaveGeolocations>>>
    export type PutNursesSaveGeolocationsMutationBody = PutNursesSaveGeolocationsBodyItem[]
    export type PutNursesSaveGeolocationsMutationError = ErrorType<PutNursesSaveGeolocations400 | string>

    /**
 * @summary Submit geolocation reports
 */
export const usePutNursesSaveGeolocations = <TError = ErrorType<PutNursesSaveGeolocations400 | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNursesSaveGeolocations>>, TError,{data: PutNursesSaveGeolocationsBodyItem[]}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutNursesSaveGeolocationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Upcoming nurse Shifts
 */
export const getNursesShiftsUpcoming = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetNursesShiftsUpcoming200>(
      {url: `/nurses/shifts/upcoming`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNursesShiftsUpcomingQueryKey = () => {
    return [`/nurses/shifts/upcoming`] as const;
    }

    
export const getGetNursesShiftsUpcomingQueryOptions = <TData = Awaited<ReturnType<typeof getNursesShiftsUpcoming>>, TError = ErrorType<string | GetNursesShiftsUpcoming500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNursesShiftsUpcoming>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNursesShiftsUpcomingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNursesShiftsUpcoming>>> = ({ signal }) => getNursesShiftsUpcoming(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNursesShiftsUpcoming>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNursesShiftsUpcomingQueryResult = NonNullable<Awaited<ReturnType<typeof getNursesShiftsUpcoming>>>
export type GetNursesShiftsUpcomingQueryError = ErrorType<string | GetNursesShiftsUpcoming500>

/**
 * @summary Upcoming nurse Shifts
 */
export const useGetNursesShiftsUpcoming = <TData = Awaited<ReturnType<typeof getNursesShiftsUpcoming>>, TError = ErrorType<string | GetNursesShiftsUpcoming500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNursesShiftsUpcoming>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNursesShiftsUpcomingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putOnboardingDemographics = (
    putOnboardingDemographicsBody: PutOnboardingDemographicsBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/onboarding/demographics`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putOnboardingDemographicsBody
    },
      options);
    }
  


export const getPutOnboardingDemographicsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOnboardingDemographics>>, TError,{data: PutOnboardingDemographicsBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putOnboardingDemographics>>, TError,{data: PutOnboardingDemographicsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOnboardingDemographics>>, {data: PutOnboardingDemographicsBody}> = (props) => {
          const {data} = props ?? {};

          return  putOnboardingDemographics(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutOnboardingDemographicsMutationResult = NonNullable<Awaited<ReturnType<typeof putOnboardingDemographics>>>
    export type PutOnboardingDemographicsMutationBody = PutOnboardingDemographicsBody
    export type PutOnboardingDemographicsMutationError = ErrorType<string>

    export const usePutOnboardingDemographics = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOnboardingDemographics>>, TError,{data: PutOnboardingDemographicsBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutOnboardingDemographicsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getOnboardingJobhistory = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOnboardingJobhistory200>(
      {url: `/onboarding/jobhistory`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOnboardingJobhistoryQueryKey = () => {
    return [`/onboarding/jobhistory`] as const;
    }

    
export const getGetOnboardingJobhistoryQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingJobhistory>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingJobhistory>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingJobhistoryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingJobhistory>>> = ({ signal }) => getOnboardingJobhistory(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingJobhistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnboardingJobhistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingJobhistory>>>
export type GetOnboardingJobhistoryQueryError = ErrorType<string>

export const useGetOnboardingJobhistory = <TData = Awaited<ReturnType<typeof getOnboardingJobhistory>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingJobhistory>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOnboardingJobhistoryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postOnboardingJobhistory = (
    postOnboardingJobhistoryBody: PostOnboardingJobhistoryBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/onboarding/jobhistory`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postOnboardingJobhistoryBody
    },
      options);
    }
  


export const getPostOnboardingJobhistoryMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOnboardingJobhistory>>, TError,{data: PostOnboardingJobhistoryBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postOnboardingJobhistory>>, TError,{data: PostOnboardingJobhistoryBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOnboardingJobhistory>>, {data: PostOnboardingJobhistoryBody}> = (props) => {
          const {data} = props ?? {};

          return  postOnboardingJobhistory(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostOnboardingJobhistoryMutationResult = NonNullable<Awaited<ReturnType<typeof postOnboardingJobhistory>>>
    export type PostOnboardingJobhistoryMutationBody = PostOnboardingJobhistoryBody
    export type PostOnboardingJobhistoryMutationError = ErrorType<string>

    export const usePostOnboardingJobhistory = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOnboardingJobhistory>>, TError,{data: PostOnboardingJobhistoryBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostOnboardingJobhistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putOnboardingUpdate = (
    putOnboardingUpdateBody: PutOnboardingUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/onboarding/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putOnboardingUpdateBody
    },
      options);
    }
  


export const getPutOnboardingUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOnboardingUpdate>>, TError,{data: PutOnboardingUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putOnboardingUpdate>>, TError,{data: PutOnboardingUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOnboardingUpdate>>, {data: PutOnboardingUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putOnboardingUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutOnboardingUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putOnboardingUpdate>>>
    export type PutOnboardingUpdateMutationBody = PutOnboardingUpdateBody
    export type PutOnboardingUpdateMutationError = ErrorType<string>

    export const usePutOnboardingUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOnboardingUpdate>>, TError,{data: PutOnboardingUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutOnboardingUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getOrgGetorgshifttimes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOrgGetorgshifttimes200Item[]>(
      {url: `/org/getorgshifttimes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrgGetorgshifttimesQueryKey = () => {
    return [`/org/getorgshifttimes`] as const;
    }

    
export const getGetOrgGetorgshifttimesQueryOptions = <TData = Awaited<ReturnType<typeof getOrgGetorgshifttimes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgGetorgshifttimes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgGetorgshifttimesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgGetorgshifttimes>>> = ({ signal }) => getOrgGetorgshifttimes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgGetorgshifttimes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgGetorgshifttimesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgGetorgshifttimes>>>
export type GetOrgGetorgshifttimesQueryError = ErrorType<string>

export const useGetOrgGetorgshifttimes = <TData = Awaited<ReturnType<typeof getOrgGetorgshifttimes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgGetorgshifttimes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrgGetorgshifttimesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrgLocationshifttimes = (
    params: GetOrgLocationshifttimesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOrgLocationshifttimes200>(
      {url: `/org/locationshifttimes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetOrgLocationshifttimesQueryKey = (params: GetOrgLocationshifttimesParams,) => {
    return [`/org/locationshifttimes`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOrgLocationshifttimesQueryOptions = <TData = Awaited<ReturnType<typeof getOrgLocationshifttimes>>, TError = ErrorType<string>>(params: GetOrgLocationshifttimesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgLocationshifttimes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgLocationshifttimesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgLocationshifttimes>>> = ({ signal }) => getOrgLocationshifttimes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgLocationshifttimes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgLocationshifttimesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgLocationshifttimes>>>
export type GetOrgLocationshifttimesQueryError = ErrorType<string>

export const useGetOrgLocationshifttimes = <TData = Awaited<ReturnType<typeof getOrgLocationshifttimes>>, TError = ErrorType<string>>(
 params: GetOrgLocationshifttimesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgLocationshifttimes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrgLocationshifttimesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationOrgid = (
    orgid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOrganizationOrgid200Item[]>(
      {url: `/organization/${orgid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrganizationOrgidQueryKey = (orgid: number,) => {
    return [`/organization/${orgid}`] as const;
    }

    
export const getGetOrganizationOrgidQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationOrgid>>, TError = ErrorType<string>>(orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationOrgidQueryKey(orgid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationOrgid>>> = ({ signal }) => getOrganizationOrgid(orgid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationOrgid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationOrgidQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationOrgid>>>
export type GetOrganizationOrgidQueryError = ErrorType<string>

export const useGetOrganizationOrgid = <TData = Awaited<ReturnType<typeof getOrganizationOrgid>>, TError = ErrorType<string>>(
 orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrganizationOrgidQueryOptions(orgid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationOrgidLocidSupervisors = (
    orgid: number,
    locid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOrganizationOrgidLocidSupervisors200Item[]>(
      {url: `/organization/${orgid}/${locid}/supervisors`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrganizationOrgidLocidSupervisorsQueryKey = (orgid: number,
    locid: number,) => {
    return [`/organization/${orgid}/${locid}/supervisors`] as const;
    }

    
export const getGetOrganizationOrgidLocidSupervisorsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationOrgidLocidSupervisors>>, TError = ErrorType<string>>(orgid: number,
    locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationOrgidLocidSupervisors>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationOrgidLocidSupervisorsQueryKey(orgid,locid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationOrgidLocidSupervisors>>> = ({ signal }) => getOrganizationOrgidLocidSupervisors(orgid,locid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgid && locid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationOrgidLocidSupervisors>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationOrgidLocidSupervisorsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationOrgidLocidSupervisors>>>
export type GetOrganizationOrgidLocidSupervisorsQueryError = ErrorType<string>

export const useGetOrganizationOrgidLocidSupervisors = <TData = Awaited<ReturnType<typeof getOrganizationOrgidLocidSupervisors>>, TError = ErrorType<string>>(
 orgid: number,
    locid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationOrgidLocidSupervisors>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrganizationOrgidLocidSupervisorsQueryOptions(orgid,locid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizations = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOrganizations200Item[]>(
      {url: `/organizations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrganizationsQueryKey = () => {
    return [`/organizations`] as const;
    }

    
export const getGetOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizations>>> = ({ signal }) => getOrganizations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizations>>>
export type GetOrganizationsQueryError = ErrorType<string>

export const useGetOrganizations = <TData = Awaited<ReturnType<typeof getOrganizations>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizations>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetches the organization's enterprise settings
 */
export const getOrganizationsOrgIdSettings = (
    orgId: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOrganizationsOrgIdSettings200Item[]>(
      {url: `/organizations/${orgId}/settings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrganizationsOrgIdSettingsQueryKey = (orgId: number,) => {
    return [`/organizations/${orgId}/settings`] as const;
    }

    
export const getGetOrganizationsOrgIdSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationsOrgIdSettings>>, TError = ErrorType<string>>(orgId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationsOrgIdSettings>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationsOrgIdSettingsQueryKey(orgId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationsOrgIdSettings>>> = ({ signal }) => getOrganizationsOrgIdSettings(orgId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationsOrgIdSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationsOrgIdSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationsOrgIdSettings>>>
export type GetOrganizationsOrgIdSettingsQueryError = ErrorType<string>

export const useGetOrganizationsOrgIdSettings = <TData = Awaited<ReturnType<typeof getOrganizationsOrgIdSettings>>, TError = ErrorType<string>>(
 orgId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationsOrgIdSettings>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrganizationsOrgIdSettingsQueryOptions(orgId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Clears the organization's enterprise setting (the setting will use the global default)
 */
export const deleteOrganizationsOrgIdSettingsSettingId = (
    orgId: number,
    settingId: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/organizations/${orgId}/settings/${settingId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteOrganizationsOrgIdSettingsSettingIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationsOrgIdSettingsSettingId>>, TError,{orgId: number;settingId: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationsOrgIdSettingsSettingId>>, TError,{orgId: number;settingId: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganizationsOrgIdSettingsSettingId>>, {orgId: number;settingId: number}> = (props) => {
          const {orgId,settingId} = props ?? {};

          return  deleteOrganizationsOrgIdSettingsSettingId(orgId,settingId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationsOrgIdSettingsSettingIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganizationsOrgIdSettingsSettingId>>>
    
    export type DeleteOrganizationsOrgIdSettingsSettingIdMutationError = ErrorType<unknown>

    export const useDeleteOrganizationsOrgIdSettingsSettingId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationsOrgIdSettingsSettingId>>, TError,{orgId: number;settingId: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteOrganizationsOrgIdSettingsSettingIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Sets the organization's enterprise setting
 */
export const putOrganizationsOrgIdSettingsSettingId = (
    orgId: number,
    settingId: number,
    putOrganizationsOrgIdSettingsSettingIdBody: PutOrganizationsOrgIdSettingsSettingIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/organizations/${orgId}/settings/${settingId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putOrganizationsOrgIdSettingsSettingIdBody
    },
      options);
    }
  


export const getPutOrganizationsOrgIdSettingsSettingIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrganizationsOrgIdSettingsSettingId>>, TError,{orgId: number;settingId: number;data: PutOrganizationsOrgIdSettingsSettingIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putOrganizationsOrgIdSettingsSettingId>>, TError,{orgId: number;settingId: number;data: PutOrganizationsOrgIdSettingsSettingIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrganizationsOrgIdSettingsSettingId>>, {orgId: number;settingId: number;data: PutOrganizationsOrgIdSettingsSettingIdBody}> = (props) => {
          const {orgId,settingId,data} = props ?? {};

          return  putOrganizationsOrgIdSettingsSettingId(orgId,settingId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutOrganizationsOrgIdSettingsSettingIdMutationResult = NonNullable<Awaited<ReturnType<typeof putOrganizationsOrgIdSettingsSettingId>>>
    export type PutOrganizationsOrgIdSettingsSettingIdMutationBody = PutOrganizationsOrgIdSettingsSettingIdBody
    export type PutOrganizationsOrgIdSettingsSettingIdMutationError = ErrorType<unknown>

    export const usePutOrganizationsOrgIdSettingsSettingId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrganizationsOrgIdSettingsSettingId>>, TError,{orgId: number;settingId: number;data: PutOrganizationsOrgIdSettingsSettingIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutOrganizationsOrgIdSettingsSettingIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchOrganizationsOrgid = (
    orgid: number,
    patchOrganizationsOrgidBody: PatchOrganizationsOrgidBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/organizations/${orgid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchOrganizationsOrgidBody
    },
      options);
    }
  


export const getPatchOrganizationsOrgidMutationOptions = <TError = ErrorType<string | PatchOrganizationsOrgid500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationsOrgid>>, TError,{orgid: number;data: PatchOrganizationsOrgidBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationsOrgid>>, TError,{orgid: number;data: PatchOrganizationsOrgidBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchOrganizationsOrgid>>, {orgid: number;data: PatchOrganizationsOrgidBody}> = (props) => {
          const {orgid,data} = props ?? {};

          return  patchOrganizationsOrgid(orgid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PatchOrganizationsOrgidMutationResult = NonNullable<Awaited<ReturnType<typeof patchOrganizationsOrgid>>>
    export type PatchOrganizationsOrgidMutationBody = PatchOrganizationsOrgidBody
    export type PatchOrganizationsOrgidMutationError = ErrorType<string | PatchOrganizationsOrgid500>

    export const usePatchOrganizationsOrgid = <TError = ErrorType<string | PatchOrganizationsOrgid500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOrganizationsOrgid>>, TError,{orgid: number;data: PatchOrganizationsOrgidBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPatchOrganizationsOrgidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putOrgfeatureUpdate = (
    putOrgfeatureUpdateBody: PutOrgfeatureUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/orgfeature/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putOrgfeatureUpdateBody
    },
      options);
    }
  


export const getPutOrgfeatureUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrgfeatureUpdate>>, TError,{data: PutOrgfeatureUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putOrgfeatureUpdate>>, TError,{data: PutOrgfeatureUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrgfeatureUpdate>>, {data: PutOrgfeatureUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putOrgfeatureUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutOrgfeatureUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putOrgfeatureUpdate>>>
    export type PutOrgfeatureUpdateMutationBody = PutOrgfeatureUpdateBody
    export type PutOrgfeatureUpdateMutationError = ErrorType<string>

    export const usePutOrgfeatureUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrgfeatureUpdate>>, TError,{data: PutOrgfeatureUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutOrgfeatureUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getOrgfeatures = (
    params?: GetOrgfeaturesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOrgfeatures200Item[]>(
      {url: `/orgfeatures`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetOrgfeaturesQueryKey = (params?: GetOrgfeaturesParams,) => {
    return [`/orgfeatures`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOrgfeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getOrgfeatures>>, TError = ErrorType<string>>(params?: GetOrgfeaturesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgfeatures>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgfeaturesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgfeatures>>> = ({ signal }) => getOrgfeatures(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgfeatures>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgfeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgfeatures>>>
export type GetOrgfeaturesQueryError = ErrorType<string>

export const useGetOrgfeatures = <TData = Awaited<ReturnType<typeof getOrgfeatures>>, TError = ErrorType<string>>(
 params?: GetOrgfeaturesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgfeatures>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrgfeaturesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get overdue timesheets of nurse
 */
export const getOverdueTimesheets = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetOverdueTimesheets200>(
      {url: `/overdue-timesheets`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOverdueTimesheetsQueryKey = () => {
    return [`/overdue-timesheets`] as const;
    }

    
export const getGetOverdueTimesheetsQueryOptions = <TData = Awaited<ReturnType<typeof getOverdueTimesheets>>, TError = ErrorType<string | GetOverdueTimesheets500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOverdueTimesheets>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverdueTimesheetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverdueTimesheets>>> = ({ signal }) => getOverdueTimesheets(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverdueTimesheets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOverdueTimesheetsQueryResult = NonNullable<Awaited<ReturnType<typeof getOverdueTimesheets>>>
export type GetOverdueTimesheetsQueryError = ErrorType<string | GetOverdueTimesheets500>

export const useGetOverdueTimesheets = <TData = Awaited<ReturnType<typeof getOverdueTimesheets>>, TError = ErrorType<string | GetOverdueTimesheets500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOverdueTimesheets>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOverdueTimesheetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * For retrieving the url to create the QR for self checkout
 */
export const getQrCodeUrl = (
    params?: GetQrCodeUrlParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetQrCodeUrl200>(
      {url: `/qr-code-url`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetQrCodeUrlQueryKey = (params?: GetQrCodeUrlParams,) => {
    return [`/qr-code-url`, ...(params ? [params]: [])] as const;
    }

    
export const getGetQrCodeUrlQueryOptions = <TData = Awaited<ReturnType<typeof getQrCodeUrl>>, TError = ErrorType<string>>(params?: GetQrCodeUrlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQrCodeUrl>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQrCodeUrlQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQrCodeUrl>>> = ({ signal }) => getQrCodeUrl(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQrCodeUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQrCodeUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getQrCodeUrl>>>
export type GetQrCodeUrlQueryError = ErrorType<string>

export const useGetQrCodeUrl = <TData = Awaited<ReturnType<typeof getQrCodeUrl>>, TError = ErrorType<string>>(
 params?: GetQrCodeUrlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQrCodeUrl>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetQrCodeUrlQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * For validating the qr signature for QR self checkout
 */
export const postQrCodeUrlValidate = (
    postQrCodeUrlValidateBody: PostQrCodeUrlValidateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostQrCodeUrlValidate200>(
      {url: `/qr-code-url/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postQrCodeUrlValidateBody
    },
      options);
    }
  


export const getPostQrCodeUrlValidateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQrCodeUrlValidate>>, TError,{data: PostQrCodeUrlValidateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postQrCodeUrlValidate>>, TError,{data: PostQrCodeUrlValidateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQrCodeUrlValidate>>, {data: PostQrCodeUrlValidateBody}> = (props) => {
          const {data} = props ?? {};

          return  postQrCodeUrlValidate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostQrCodeUrlValidateMutationResult = NonNullable<Awaited<ReturnType<typeof postQrCodeUrlValidate>>>
    export type PostQrCodeUrlValidateMutationBody = PostQrCodeUrlValidateBody
    export type PostQrCodeUrlValidateMutationError = ErrorType<string>

    export const usePostQrCodeUrlValidate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQrCodeUrlValidate>>, TError,{data: PostQrCodeUrlValidateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostQrCodeUrlValidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Handles checkout for QR codes when a supervisor is unavailable
 */
export const postQrUnavailableSupervisor = (
    postQrUnavailableSupervisorBody: PostQrUnavailableSupervisorBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/qr-unavailable-supervisor`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postQrUnavailableSupervisorBody
    },
      options);
    }
  


export const getPostQrUnavailableSupervisorMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQrUnavailableSupervisor>>, TError,{data: PostQrUnavailableSupervisorBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postQrUnavailableSupervisor>>, TError,{data: PostQrUnavailableSupervisorBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQrUnavailableSupervisor>>, {data: PostQrUnavailableSupervisorBody}> = (props) => {
          const {data} = props ?? {};

          return  postQrUnavailableSupervisor(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostQrUnavailableSupervisorMutationResult = NonNullable<Awaited<ReturnType<typeof postQrUnavailableSupervisor>>>
    export type PostQrUnavailableSupervisorMutationBody = PostQrUnavailableSupervisorBody
    export type PostQrUnavailableSupervisorMutationError = ErrorType<string>

    export const usePostQrUnavailableSupervisor = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQrUnavailableSupervisor>>, TError,{data: PostQrUnavailableSupervisorBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostQrUnavailableSupervisorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Adds new answers for a user to a questionnaire
 */
export const postQuestionnaire = (
    postQuestionnaireBody: PostQuestionnaireBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/questionnaire`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postQuestionnaireBody
    },
      options);
    }
  


export const getPostQuestionnaireMutationOptions = <TError = ErrorType<PostQuestionnaire400 | string | PostQuestionnaire413 | PostQuestionnaire415 | PostQuestionnaire500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuestionnaire>>, TError,{data: PostQuestionnaireBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuestionnaire>>, TError,{data: PostQuestionnaireBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuestionnaire>>, {data: PostQuestionnaireBody}> = (props) => {
          const {data} = props ?? {};

          return  postQuestionnaire(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostQuestionnaireMutationResult = NonNullable<Awaited<ReturnType<typeof postQuestionnaire>>>
    export type PostQuestionnaireMutationBody = PostQuestionnaireBody
    export type PostQuestionnaireMutationError = ErrorType<PostQuestionnaire400 | string | PostQuestionnaire413 | PostQuestionnaire415 | PostQuestionnaire500>

    export const usePostQuestionnaire = <TError = ErrorType<PostQuestionnaire400 | string | PostQuestionnaire413 | PostQuestionnaire415 | PostQuestionnaire500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuestionnaire>>, TError,{data: PostQuestionnaireBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostQuestionnaireMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update the users settings for a questionnaire
 */
export const putQuestionnaireSettings = (
    putQuestionnaireSettingsBody: PutQuestionnaireSettingsBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/questionnaire/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putQuestionnaireSettingsBody
    },
      options);
    }
  


export const getPutQuestionnaireSettingsMutationOptions = <TError = ErrorType<PutQuestionnaireSettings400 | string | PutQuestionnaireSettings413 | PutQuestionnaireSettings415 | PutQuestionnaireSettings500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQuestionnaireSettings>>, TError,{data: PutQuestionnaireSettingsBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putQuestionnaireSettings>>, TError,{data: PutQuestionnaireSettingsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putQuestionnaireSettings>>, {data: PutQuestionnaireSettingsBody}> = (props) => {
          const {data} = props ?? {};

          return  putQuestionnaireSettings(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutQuestionnaireSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putQuestionnaireSettings>>>
    export type PutQuestionnaireSettingsMutationBody = PutQuestionnaireSettingsBody
    export type PutQuestionnaireSettingsMutationError = ErrorType<PutQuestionnaireSettings400 | string | PutQuestionnaireSettings413 | PutQuestionnaireSettings415 | PutQuestionnaireSettings500>

    export const usePutQuestionnaireSettings = <TError = ErrorType<PutQuestionnaireSettings400 | string | PutQuestionnaireSettings413 | PutQuestionnaireSettings415 | PutQuestionnaireSettings500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQuestionnaireSettings>>, TError,{data: PutQuestionnaireSettingsBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutQuestionnaireSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get answers for a user to a questionnaire
 */
export const getQuestionnaireQuestionnaireId = (
    questionnaireId: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetQuestionnaireQuestionnaireId200>(
      {url: `/questionnaire/${questionnaireId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetQuestionnaireQuestionnaireIdQueryKey = (questionnaireId: number,) => {
    return [`/questionnaire/${questionnaireId}`] as const;
    }

    
export const getGetQuestionnaireQuestionnaireIdQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionnaireQuestionnaireId>>, TError = ErrorType<string | GetQuestionnaireQuestionnaireId404 | GetQuestionnaireQuestionnaireId500>>(questionnaireId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireQuestionnaireIdQueryKey(questionnaireId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireId>>> = ({ signal }) => getQuestionnaireQuestionnaireId(questionnaireId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionnaireId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuestionnaireQuestionnaireIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireId>>>
export type GetQuestionnaireQuestionnaireIdQueryError = ErrorType<string | GetQuestionnaireQuestionnaireId404 | GetQuestionnaireQuestionnaireId500>

export const useGetQuestionnaireQuestionnaireId = <TData = Awaited<ReturnType<typeof getQuestionnaireQuestionnaireId>>, TError = ErrorType<string | GetQuestionnaireQuestionnaireId404 | GetQuestionnaireQuestionnaireId500>>(
 questionnaireId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetQuestionnaireQuestionnaireIdQueryOptions(questionnaireId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a users settings for a questionnaire
 */
export const getQuestionnaireQuestionnaireIdSettings = (
    questionnaireId: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetQuestionnaireQuestionnaireIdSettings200>(
      {url: `/questionnaire/${questionnaireId}/settings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetQuestionnaireQuestionnaireIdSettingsQueryKey = (questionnaireId: number,) => {
    return [`/questionnaire/${questionnaireId}/settings`] as const;
    }

    
export const getGetQuestionnaireQuestionnaireIdSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionnaireQuestionnaireIdSettings>>, TError = ErrorType<string | GetQuestionnaireQuestionnaireIdSettings404 | GetQuestionnaireQuestionnaireIdSettings500>>(questionnaireId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireIdSettings>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireQuestionnaireIdSettingsQueryKey(questionnaireId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireIdSettings>>> = ({ signal }) => getQuestionnaireQuestionnaireIdSettings(questionnaireId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionnaireId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireIdSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetQuestionnaireQuestionnaireIdSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireIdSettings>>>
export type GetQuestionnaireQuestionnaireIdSettingsQueryError = ErrorType<string | GetQuestionnaireQuestionnaireIdSettings404 | GetQuestionnaireQuestionnaireIdSettings500>

export const useGetQuestionnaireQuestionnaireIdSettings = <TData = Awaited<ReturnType<typeof getQuestionnaireQuestionnaireIdSettings>>, TError = ErrorType<string | GetQuestionnaireQuestionnaireIdSettings404 | GetQuestionnaireQuestionnaireIdSettings500>>(
 questionnaireId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireQuestionnaireIdSettings>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetQuestionnaireQuestionnaireIdSettingsQueryOptions(questionnaireId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRateincreaseoptions = (
    params?: GetRateincreaseoptionsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRateincreaseoptions200Item[]>(
      {url: `/rateincreaseoptions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRateincreaseoptionsQueryKey = (params?: GetRateincreaseoptionsParams,) => {
    return [`/rateincreaseoptions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRateincreaseoptionsQueryOptions = <TData = Awaited<ReturnType<typeof getRateincreaseoptions>>, TError = ErrorType<string>>(params?: GetRateincreaseoptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRateincreaseoptions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRateincreaseoptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRateincreaseoptions>>> = ({ signal }) => getRateincreaseoptions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRateincreaseoptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRateincreaseoptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRateincreaseoptions>>>
export type GetRateincreaseoptionsQueryError = ErrorType<string>

export const useGetRateincreaseoptions = <TData = Awaited<ReturnType<typeof getRateincreaseoptions>>, TError = ErrorType<string>>(
 params?: GetRateincreaseoptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRateincreaseoptions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRateincreaseoptionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postRatingDismissNurseRating = (
    postRatingDismissNurseRatingBody: PostRatingDismissNurseRatingBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/rating/dismissNurseRating`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRatingDismissNurseRatingBody
    },
      options);
    }
  


export const getPostRatingDismissNurseRatingMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRatingDismissNurseRating>>, TError,{data: PostRatingDismissNurseRatingBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRatingDismissNurseRating>>, TError,{data: PostRatingDismissNurseRatingBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRatingDismissNurseRating>>, {data: PostRatingDismissNurseRatingBody}> = (props) => {
          const {data} = props ?? {};

          return  postRatingDismissNurseRating(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRatingDismissNurseRatingMutationResult = NonNullable<Awaited<ReturnType<typeof postRatingDismissNurseRating>>>
    export type PostRatingDismissNurseRatingMutationBody = PostRatingDismissNurseRatingBody
    export type PostRatingDismissNurseRatingMutationError = ErrorType<string>

    export const usePostRatingDismissNurseRating = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRatingDismissNurseRating>>, TError,{data: PostRatingDismissNurseRatingBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRatingDismissNurseRatingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRatingDismissOrganizationRating = (
    postRatingDismissOrganizationRatingBody: PostRatingDismissOrganizationRatingBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/rating/dismissOrganizationRating`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRatingDismissOrganizationRatingBody
    },
      options);
    }
  


export const getPostRatingDismissOrganizationRatingMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRatingDismissOrganizationRating>>, TError,{data: PostRatingDismissOrganizationRatingBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRatingDismissOrganizationRating>>, TError,{data: PostRatingDismissOrganizationRatingBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRatingDismissOrganizationRating>>, {data: PostRatingDismissOrganizationRatingBody}> = (props) => {
          const {data} = props ?? {};

          return  postRatingDismissOrganizationRating(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRatingDismissOrganizationRatingMutationResult = NonNullable<Awaited<ReturnType<typeof postRatingDismissOrganizationRating>>>
    export type PostRatingDismissOrganizationRatingMutationBody = PostRatingDismissOrganizationRatingBody
    export type PostRatingDismissOrganizationRatingMutationError = ErrorType<string>

    export const usePostRatingDismissOrganizationRating = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRatingDismissOrganizationRating>>, TError,{data: PostRatingDismissOrganizationRatingBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRatingDismissOrganizationRatingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getRatingGetRatingQuestions = (
    params?: GetRatingGetRatingQuestionsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRatingGetRatingQuestions200Item[]>(
      {url: `/rating/getRatingQuestions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRatingGetRatingQuestionsQueryKey = (params?: GetRatingGetRatingQuestionsParams,) => {
    return [`/rating/getRatingQuestions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRatingGetRatingQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof getRatingGetRatingQuestions>>, TError = ErrorType<string>>(params?: GetRatingGetRatingQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRatingGetRatingQuestions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRatingGetRatingQuestionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRatingGetRatingQuestions>>> = ({ signal }) => getRatingGetRatingQuestions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRatingGetRatingQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRatingGetRatingQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRatingGetRatingQuestions>>>
export type GetRatingGetRatingQuestionsQueryError = ErrorType<string>

export const useGetRatingGetRatingQuestions = <TData = Awaited<ReturnType<typeof getRatingGetRatingQuestions>>, TError = ErrorType<string>>(
 params?: GetRatingGetRatingQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRatingGetRatingQuestions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRatingGetRatingQuestionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Records a supervisor's rating for a clinician
 */
export const postRatingSubmitNurseRatingV2 = (
    postRatingSubmitNurseRatingV2Body: PostRatingSubmitNurseRatingV2Body,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/rating/submitNurseRatingV2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRatingSubmitNurseRatingV2Body
    },
      options);
    }
  


export const getPostRatingSubmitNurseRatingV2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRatingSubmitNurseRatingV2>>, TError,{data: PostRatingSubmitNurseRatingV2Body}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRatingSubmitNurseRatingV2>>, TError,{data: PostRatingSubmitNurseRatingV2Body}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRatingSubmitNurseRatingV2>>, {data: PostRatingSubmitNurseRatingV2Body}> = (props) => {
          const {data} = props ?? {};

          return  postRatingSubmitNurseRatingV2(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRatingSubmitNurseRatingV2MutationResult = NonNullable<Awaited<ReturnType<typeof postRatingSubmitNurseRatingV2>>>
    export type PostRatingSubmitNurseRatingV2MutationBody = PostRatingSubmitNurseRatingV2Body
    export type PostRatingSubmitNurseRatingV2MutationError = ErrorType<string>

    export const usePostRatingSubmitNurseRatingV2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRatingSubmitNurseRatingV2>>, TError,{data: PostRatingSubmitNurseRatingV2Body}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRatingSubmitNurseRatingV2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Records a clinician's rating for an organization
 */
export const postRatingSubmitOrganizationRatingV2 = (
    postRatingSubmitOrganizationRatingV2Body: PostRatingSubmitOrganizationRatingV2Body,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/rating/submitOrganizationRatingV2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRatingSubmitOrganizationRatingV2Body
    },
      options);
    }
  


export const getPostRatingSubmitOrganizationRatingV2MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRatingSubmitOrganizationRatingV2>>, TError,{data: PostRatingSubmitOrganizationRatingV2Body}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRatingSubmitOrganizationRatingV2>>, TError,{data: PostRatingSubmitOrganizationRatingV2Body}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRatingSubmitOrganizationRatingV2>>, {data: PostRatingSubmitOrganizationRatingV2Body}> = (props) => {
          const {data} = props ?? {};

          return  postRatingSubmitOrganizationRatingV2(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRatingSubmitOrganizationRatingV2MutationResult = NonNullable<Awaited<ReturnType<typeof postRatingSubmitOrganizationRatingV2>>>
    export type PostRatingSubmitOrganizationRatingV2MutationBody = PostRatingSubmitOrganizationRatingV2Body
    export type PostRatingSubmitOrganizationRatingV2MutationError = ErrorType<string>

    export const usePostRatingSubmitOrganizationRatingV2 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRatingSubmitOrganizationRatingV2>>, TError,{data: PostRatingSubmitOrganizationRatingV2Body}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRatingSubmitOrganizationRatingV2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get recent overdue timesheet of nurse
 */
export const getRecentOverdueTimesheet = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRecentOverdueTimesheet200>(
      {url: `/recent-overdue-timesheet`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRecentOverdueTimesheetQueryKey = () => {
    return [`/recent-overdue-timesheet`] as const;
    }

    
export const getGetRecentOverdueTimesheetQueryOptions = <TData = Awaited<ReturnType<typeof getRecentOverdueTimesheet>>, TError = ErrorType<string | GetRecentOverdueTimesheet500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentOverdueTimesheet>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecentOverdueTimesheetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentOverdueTimesheet>>> = ({ signal }) => getRecentOverdueTimesheet(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecentOverdueTimesheet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRecentOverdueTimesheetQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentOverdueTimesheet>>>
export type GetRecentOverdueTimesheetQueryError = ErrorType<string | GetRecentOverdueTimesheet500>

export const useGetRecentOverdueTimesheet = <TData = Awaited<ReturnType<typeof getRecentOverdueTimesheet>>, TError = ErrorType<string | GetRecentOverdueTimesheet500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentOverdueTimesheet>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRecentOverdueTimesheetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Read all registry definitions
 */
export const getRegistryAllDef = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryAllDef200Item[]>(
      {url: `/registry/all/def`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryAllDefQueryKey = () => {
    return [`/registry/all/def`] as const;
    }

    
export const getGetRegistryAllDefQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryAllDef>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryAllDef>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryAllDefQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryAllDef>>> = ({ signal }) => getRegistryAllDef(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryAllDef>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryAllDefQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryAllDef>>>
export type GetRegistryAllDefQueryError = ErrorType<string>

export const useGetRegistryAllDef = <TData = Awaited<ReturnType<typeof getRegistryAllDef>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryAllDef>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryAllDefQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Admin create a registry definition
 */
export const postRegistryDef = (
    postRegistryDefBody: PostRegistryDefBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostRegistryDef200>(
      {url: `/registry/def`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRegistryDefBody
    },
      options);
    }
  


export const getPostRegistryDefMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryDef>>, TError,{data: PostRegistryDefBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRegistryDef>>, TError,{data: PostRegistryDefBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRegistryDef>>, {data: PostRegistryDefBody}> = (props) => {
          const {data} = props ?? {};

          return  postRegistryDef(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRegistryDefMutationResult = NonNullable<Awaited<ReturnType<typeof postRegistryDef>>>
    export type PostRegistryDefMutationBody = PostRegistryDefBody
    export type PostRegistryDefMutationError = ErrorType<string>

    export const usePostRegistryDef = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryDef>>, TError,{data: PostRegistryDefBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRegistryDefMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Admin update registry definition
 */
export const putRegistryDef = (
    putRegistryDefBody: PutRegistryDefBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/registry/def`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putRegistryDefBody
    },
      options);
    }
  


export const getPutRegistryDefMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRegistryDef>>, TError,{data: PutRegistryDefBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putRegistryDef>>, TError,{data: PutRegistryDefBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putRegistryDef>>, {data: PutRegistryDefBody}> = (props) => {
          const {data} = props ?? {};

          return  putRegistryDef(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutRegistryDefMutationResult = NonNullable<Awaited<ReturnType<typeof putRegistryDef>>>
    export type PutRegistryDefMutationBody = PutRegistryDefBody
    export type PutRegistryDefMutationError = ErrorType<string>

    export const usePutRegistryDef = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRegistryDef>>, TError,{data: PutRegistryDefBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutRegistryDefMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Admin delete registry definitions
 */
export const deleteRegistryDefId = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/registry/def/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRegistryDefIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryDefId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryDefId>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRegistryDefId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRegistryDefId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteRegistryDefIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRegistryDefId>>>
    
    export type DeleteRegistryDefIdMutationError = ErrorType<string>

    export const useDeleteRegistryDefId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryDefId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteRegistryDefIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Read a registry definition
 */
export const getRegistryDefId = (
    id: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryDefId200>(
      {url: `/registry/def/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryDefIdQueryKey = (id: number,) => {
    return [`/registry/def/${id}`] as const;
    }

    
export const getGetRegistryDefIdQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryDefId>>, TError = ErrorType<string>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryDefId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryDefIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryDefId>>> = ({ signal }) => getRegistryDefId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryDefId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryDefIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryDefId>>>
export type GetRegistryDefIdQueryError = ErrorType<string>

export const useGetRegistryDefId = <TData = Awaited<ReturnType<typeof getRegistryDefId>>, TError = ErrorType<string>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryDefId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryDefIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Explain Employment Documents for a user. This is a temporary endpoint/solution for the I-9 Reverification project. Eventually that project will end and this endpoint may be repurposed or removed entirely.
 */
export const getRegistryExplainDocuments = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryExplainDocuments200>(
      {url: `/registry/explain/documents`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryExplainDocumentsQueryKey = () => {
    return [`/registry/explain/documents`] as const;
    }

    
export const getGetRegistryExplainDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryExplainDocuments>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainDocuments>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryExplainDocumentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryExplainDocuments>>> = ({ signal }) => getRegistryExplainDocuments(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryExplainDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryExplainDocuments>>>
export type GetRegistryExplainDocumentsQueryError = ErrorType<string>

export const useGetRegistryExplainDocuments = <TData = Awaited<ReturnType<typeof getRegistryExplainDocuments>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainDocuments>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryExplainDocumentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Explain Global requirements for a user
 */
export const getRegistryExplainGlobal = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryExplainGlobal200>(
      {url: `/registry/explain/global`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryExplainGlobalQueryKey = () => {
    return [`/registry/explain/global`] as const;
    }

    
export const getGetRegistryExplainGlobalQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryExplainGlobal>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainGlobal>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryExplainGlobalQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryExplainGlobal>>> = ({ signal }) => getRegistryExplainGlobal(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainGlobal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryExplainGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryExplainGlobal>>>
export type GetRegistryExplainGlobalQueryError = ErrorType<string>

export const useGetRegistryExplainGlobal = <TData = Awaited<ReturnType<typeof getRegistryExplainGlobal>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainGlobal>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryExplainGlobalQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Explain the requirements the user needs to apply to the shift
 */
export const getRegistryExplainShiftShiftid = (
    shiftid: number,
    params?: GetRegistryExplainShiftShiftidParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryExplainShiftShiftid200>(
      {url: `/registry/explain/shift/${shiftid}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRegistryExplainShiftShiftidQueryKey = (shiftid: number,
    params?: GetRegistryExplainShiftShiftidParams,) => {
    return [`/registry/explain/shift/${shiftid}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRegistryExplainShiftShiftidQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryExplainShiftShiftid>>, TError = ErrorType<string>>(shiftid: number,
    params?: GetRegistryExplainShiftShiftidParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainShiftShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryExplainShiftShiftidQueryKey(shiftid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryExplainShiftShiftid>>> = ({ signal }) => getRegistryExplainShiftShiftid(shiftid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shiftid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainShiftShiftid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryExplainShiftShiftidQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryExplainShiftShiftid>>>
export type GetRegistryExplainShiftShiftidQueryError = ErrorType<string>

export const useGetRegistryExplainShiftShiftid = <TData = Awaited<ReturnType<typeof getRegistryExplainShiftShiftid>>, TError = ErrorType<string>>(
 shiftid: number,
    params?: GetRegistryExplainShiftShiftidParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainShiftShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryExplainShiftShiftidQueryOptions(shiftid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Explain Policy and Training requirements for a user
 */
export const getRegistryExplainTraining = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryExplainTraining200>(
      {url: `/registry/explain/training`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryExplainTrainingQueryKey = () => {
    return [`/registry/explain/training`] as const;
    }

    
export const getGetRegistryExplainTrainingQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryExplainTraining>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainTraining>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryExplainTrainingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryExplainTraining>>> = ({ signal }) => getRegistryExplainTraining(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainTraining>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryExplainTrainingQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryExplainTraining>>>
export type GetRegistryExplainTrainingQueryError = ErrorType<string>

export const useGetRegistryExplainTraining = <TData = Awaited<ReturnType<typeof getRegistryExplainTraining>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainTraining>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryExplainTrainingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Explain Critical Policy and Training requirements for a user (ones needed to apply to any shift at all)
 */
export const getRegistryExplainTrainingCritical = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryExplainTrainingCritical200>(
      {url: `/registry/explain/training/critical`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryExplainTrainingCriticalQueryKey = () => {
    return [`/registry/explain/training/critical`] as const;
    }

    
export const getGetRegistryExplainTrainingCriticalQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryExplainTrainingCritical>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainTrainingCritical>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryExplainTrainingCriticalQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryExplainTrainingCritical>>> = ({ signal }) => getRegistryExplainTrainingCritical(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainTrainingCritical>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryExplainTrainingCriticalQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryExplainTrainingCritical>>>
export type GetRegistryExplainTrainingCriticalQueryError = ErrorType<string>

export const useGetRegistryExplainTrainingCritical = <TData = Awaited<ReturnType<typeof getRegistryExplainTrainingCritical>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryExplainTrainingCritical>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryExplainTrainingCriticalQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * List fulfillment types
 */
export const getRegistryFulfillmentTypes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryFulfillmentTypes200Item[]>(
      {url: `/registry/fulfillmentTypes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryFulfillmentTypesQueryKey = () => {
    return [`/registry/fulfillmentTypes`] as const;
    }

    
export const getGetRegistryFulfillmentTypesQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryFulfillmentTypes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryFulfillmentTypes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryFulfillmentTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryFulfillmentTypes>>> = ({ signal }) => getRegistryFulfillmentTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryFulfillmentTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryFulfillmentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryFulfillmentTypes>>>
export type GetRegistryFulfillmentTypesQueryError = ErrorType<string>

export const useGetRegistryFulfillmentTypes = <TData = Awaited<ReturnType<typeof getRegistryFulfillmentTypes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryFulfillmentTypes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryFulfillmentTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Import Registry entry
 */
export const postRegistryImportItem = (
    postRegistryImportItemBody: PostRegistryImportItemBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostRegistryImportItem200>(
      {url: `/registry/import/item`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRegistryImportItemBody
    },
      options);
    }
  


export const getPostRegistryImportItemMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryImportItem>>, TError,{data: PostRegistryImportItemBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRegistryImportItem>>, TError,{data: PostRegistryImportItemBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRegistryImportItem>>, {data: PostRegistryImportItemBody}> = (props) => {
          const {data} = props ?? {};

          return  postRegistryImportItem(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRegistryImportItemMutationResult = NonNullable<Awaited<ReturnType<typeof postRegistryImportItem>>>
    export type PostRegistryImportItemMutationBody = PostRegistryImportItemBody
    export type PostRegistryImportItemMutationError = ErrorType<string>

    export const usePostRegistryImportItem = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryImportItem>>, TError,{data: PostRegistryImportItemBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRegistryImportItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Create Registry entry
 */
export const postRegistryItem = (
    postRegistryItemBody: PostRegistryItemBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostRegistryItem200>(
      {url: `/registry/item`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRegistryItemBody
    },
      options);
    }
  


export const getPostRegistryItemMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryItem>>, TError,{data: PostRegistryItemBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRegistryItem>>, TError,{data: PostRegistryItemBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRegistryItem>>, {data: PostRegistryItemBody}> = (props) => {
          const {data} = props ?? {};

          return  postRegistryItem(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRegistryItemMutationResult = NonNullable<Awaited<ReturnType<typeof postRegistryItem>>>
    export type PostRegistryItemMutationBody = PostRegistryItemBody
    export type PostRegistryItemMutationError = ErrorType<string>

    export const usePostRegistryItem = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryItem>>, TError,{data: PostRegistryItemBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRegistryItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update Registry entry
 */
export const putRegistryItem = (
    putRegistryItemBody: PutRegistryItemBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/registry/item`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putRegistryItemBody
    },
      options);
    }
  


export const getPutRegistryItemMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRegistryItem>>, TError,{data: PutRegistryItemBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putRegistryItem>>, TError,{data: PutRegistryItemBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putRegistryItem>>, {data: PutRegistryItemBody}> = (props) => {
          const {data} = props ?? {};

          return  putRegistryItem(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutRegistryItemMutationResult = NonNullable<Awaited<ReturnType<typeof putRegistryItem>>>
    export type PutRegistryItemMutationBody = PutRegistryItemBody
    export type PutRegistryItemMutationError = ErrorType<string>

    export const usePutRegistryItem = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRegistryItem>>, TError,{data: PutRegistryItemBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutRegistryItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Attest Registry entry
 */
export const putRegistryItemAttestId = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/registry/item/attest/${id}`, method: 'PUT'
    },
      options);
    }
  


export const getPutRegistryItemAttestIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRegistryItemAttestId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putRegistryItemAttestId>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putRegistryItemAttestId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  putRegistryItemAttestId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutRegistryItemAttestIdMutationResult = NonNullable<Awaited<ReturnType<typeof putRegistryItemAttestId>>>
    
    export type PutRegistryItemAttestIdMutationError = ErrorType<string>

    export const usePutRegistryItemAttestId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRegistryItemAttestId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutRegistryItemAttestIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Delete Registry entry
 */
export const deleteRegistryItemId = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/registry/item/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRegistryItemIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryItemId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryItemId>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRegistryItemId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRegistryItemId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteRegistryItemIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRegistryItemId>>>
    
    export type DeleteRegistryItemIdMutationError = ErrorType<string>

    export const useDeleteRegistryItemId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryItemId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteRegistryItemIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Read Registry entry
 */
export const getRegistryItemId = (
    id: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryItemId200>(
      {url: `/registry/item/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryItemIdQueryKey = (id: number,) => {
    return [`/registry/item/${id}`] as const;
    }

    
export const getGetRegistryItemIdQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryItemId>>, TError = ErrorType<string>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryItemId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryItemIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryItemId>>> = ({ signal }) => getRegistryItemId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryItemId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryItemIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryItemId>>>
export type GetRegistryItemIdQueryError = ErrorType<string>

export const useGetRegistryItemId = <TData = Awaited<ReturnType<typeof getRegistryItemId>>, TError = ErrorType<string>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryItemId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryItemIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Multisign registry items designed for Training and Policies
 */
export const postRegistryMultisign = (
    postRegistryMultisignBody: PostRegistryMultisignBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/registry/multisign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRegistryMultisignBody
    },
      options);
    }
  


export const getPostRegistryMultisignMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryMultisign>>, TError,{data: PostRegistryMultisignBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRegistryMultisign>>, TError,{data: PostRegistryMultisignBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRegistryMultisign>>, {data: PostRegistryMultisignBody}> = (props) => {
          const {data} = props ?? {};

          return  postRegistryMultisign(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRegistryMultisignMutationResult = NonNullable<Awaited<ReturnType<typeof postRegistryMultisign>>>
    export type PostRegistryMultisignMutationBody = PostRegistryMultisignBody
    export type PostRegistryMultisignMutationError = ErrorType<string>

    export const usePostRegistryMultisign = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryMultisign>>, TError,{data: PostRegistryMultisignBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRegistryMultisignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get Registry Definition Summary for User
 */
export const getRegistryRegdefRegdefidUserUseridSummary = (
    regdefid: number,
    userid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryRegdefRegdefidUserUseridSummary200>(
      {url: `/registry/regdef/${regdefid}/user/${userid}/summary`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryRegdefRegdefidUserUseridSummaryQueryKey = (regdefid: number,
    userid: number,) => {
    return [`/registry/regdef/${regdefid}/user/${userid}/summary`] as const;
    }

    
export const getGetRegistryRegdefRegdefidUserUseridSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryRegdefRegdefidUserUseridSummary>>, TError = ErrorType<string>>(regdefid: number,
    userid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryRegdefRegdefidUserUseridSummary>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryRegdefRegdefidUserUseridSummaryQueryKey(regdefid,userid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryRegdefRegdefidUserUseridSummary>>> = ({ signal }) => getRegistryRegdefRegdefidUserUseridSummary(regdefid,userid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regdefid && userid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryRegdefRegdefidUserUseridSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryRegdefRegdefidUserUseridSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryRegdefRegdefidUserUseridSummary>>>
export type GetRegistryRegdefRegdefidUserUseridSummaryQueryError = ErrorType<string>

export const useGetRegistryRegdefRegdefidUserUseridSummary = <TData = Awaited<ReturnType<typeof getRegistryRegdefRegdefidUserUseridSummary>>, TError = ErrorType<string>>(
 regdefid: number,
    userid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryRegdefRegdefidUserUseridSummary>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryRegdefRegdefidUserUseridSummaryQueryOptions(regdefid,userid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Admin create requirement
 */
export const postRegistryRequirement = (
    postRegistryRequirementBody: PostRegistryRequirementBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostRegistryRequirement200>(
      {url: `/registry/requirement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRegistryRequirementBody
    },
      options);
    }
  


export const getPostRegistryRequirementMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryRequirement>>, TError,{data: PostRegistryRequirementBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRegistryRequirement>>, TError,{data: PostRegistryRequirementBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRegistryRequirement>>, {data: PostRegistryRequirementBody}> = (props) => {
          const {data} = props ?? {};

          return  postRegistryRequirement(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRegistryRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof postRegistryRequirement>>>
    export type PostRegistryRequirementMutationBody = PostRegistryRequirementBody
    export type PostRegistryRequirementMutationError = ErrorType<string>

    export const usePostRegistryRequirement = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRegistryRequirement>>, TError,{data: PostRegistryRequirementBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRegistryRequirementMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Admin update requirement
 */
export const putRegistryRequirement = (
    putRegistryRequirementBody: PutRegistryRequirementBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/registry/requirement`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putRegistryRequirementBody
    },
      options);
    }
  


export const getPutRegistryRequirementMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRegistryRequirement>>, TError,{data: PutRegistryRequirementBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putRegistryRequirement>>, TError,{data: PutRegistryRequirementBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putRegistryRequirement>>, {data: PutRegistryRequirementBody}> = (props) => {
          const {data} = props ?? {};

          return  putRegistryRequirement(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutRegistryRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof putRegistryRequirement>>>
    export type PutRegistryRequirementMutationBody = PutRegistryRequirementBody
    export type PutRegistryRequirementMutationError = ErrorType<string>

    export const usePutRegistryRequirement = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putRegistryRequirement>>, TError,{data: PutRegistryRequirementBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutRegistryRequirementMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Admin delete requirement
 */
export const deleteRegistryRequirementId = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/registry/requirement/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRegistryRequirementIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryRequirementId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryRequirementId>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRegistryRequirementId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRegistryRequirementId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteRegistryRequirementIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRegistryRequirementId>>>
    
    export type DeleteRegistryRequirementIdMutationError = ErrorType<string>

    export const useDeleteRegistryRequirementId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegistryRequirementId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteRegistryRequirementIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Admin get requirement
 */
export const getRegistryRequirementId = (
    id: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/registry/requirement/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryRequirementIdQueryKey = (id: number,) => {
    return [`/registry/requirement/${id}`] as const;
    }

    
export const getGetRegistryRequirementIdQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryRequirementId>>, TError = ErrorType<string>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryRequirementId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryRequirementIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryRequirementId>>> = ({ signal }) => getRegistryRequirementId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryRequirementId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryRequirementIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryRequirementId>>>
export type GetRegistryRequirementIdQueryError = ErrorType<string>

export const useGetRegistryRequirementId = <TData = Awaited<ReturnType<typeof getRegistryRequirementId>>, TError = ErrorType<string>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryRequirementId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryRequirementIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all Registry Items for User
 */
export const getRegistryUserUserid = (
    userid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRegistryUserUserid200Item[]>(
      {url: `/registry/user/${userid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRegistryUserUseridQueryKey = (userid: number,) => {
    return [`/registry/user/${userid}`] as const;
    }

    
export const getGetRegistryUserUseridQueryOptions = <TData = Awaited<ReturnType<typeof getRegistryUserUserid>>, TError = ErrorType<string>>(userid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryUserUserid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistryUserUseridQueryKey(userid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistryUserUserid>>> = ({ signal }) => getRegistryUserUserid(userid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistryUserUserid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistryUserUseridQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistryUserUserid>>>
export type GetRegistryUserUseridQueryError = ErrorType<string>

export const useGetRegistryUserUserid = <TData = Awaited<ReturnType<typeof getRegistryUserUserid>>, TError = ErrorType<string>>(
 userid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRegistryUserUserid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistryUserUseridQueryOptions(userid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Requested Shifts
 */
export const getRequestedShifts = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequestedShifts200Item[]>(
      {url: `/requested-shifts`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequestedShiftsQueryKey = () => {
    return [`/requested-shifts`] as const;
    }

    
export const getGetRequestedShiftsQueryOptions = <TData = Awaited<ReturnType<typeof getRequestedShifts>>, TError = ErrorType<GetRequestedShifts401 | GetRequestedShifts500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestedShifts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestedShiftsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestedShifts>>> = ({ signal }) => getRequestedShifts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestedShifts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequestedShiftsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestedShifts>>>
export type GetRequestedShiftsQueryError = ErrorType<GetRequestedShifts401 | GetRequestedShifts500>

export const useGetRequestedShifts = <TData = Awaited<ReturnType<typeof getRequestedShifts>>, TError = ErrorType<GetRequestedShifts401 | GetRequestedShifts500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestedShifts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequestedShiftsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get Requested Shifts Count
 */
export const getRequestedShiftsCount = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequestedShiftsCount200>(
      {url: `/requested-shifts-count`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequestedShiftsCountQueryKey = () => {
    return [`/requested-shifts-count`] as const;
    }

    
export const getGetRequestedShiftsCountQueryOptions = <TData = Awaited<ReturnType<typeof getRequestedShiftsCount>>, TError = ErrorType<GetRequestedShiftsCount401 | GetRequestedShiftsCount500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestedShiftsCount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestedShiftsCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestedShiftsCount>>> = ({ signal }) => getRequestedShiftsCount(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestedShiftsCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequestedShiftsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestedShiftsCount>>>
export type GetRequestedShiftsCountQueryError = ErrorType<GetRequestedShiftsCount401 | GetRequestedShiftsCount500>

export const useGetRequestedShiftsCount = <TData = Awaited<ReturnType<typeof getRequestedShiftsCount>>, TError = ErrorType<GetRequestedShiftsCount401 | GetRequestedShiftsCount500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestedShiftsCount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequestedShiftsCountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRequestsAdminPending = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequestsAdminPending200Item[]>(
      {url: `/requests/admin/pending`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequestsAdminPendingQueryKey = () => {
    return [`/requests/admin/pending`] as const;
    }

    
export const getGetRequestsAdminPendingQueryOptions = <TData = Awaited<ReturnType<typeof getRequestsAdminPending>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestsAdminPending>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsAdminPendingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestsAdminPending>>> = ({ signal }) => getRequestsAdminPending(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestsAdminPending>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequestsAdminPendingQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestsAdminPending>>>
export type GetRequestsAdminPendingQueryError = ErrorType<string>

export const useGetRequestsAdminPending = <TData = Awaited<ReturnType<typeof getRequestsAdminPending>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestsAdminPending>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequestsAdminPendingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRequestsClosed = (
    params?: GetRequestsClosedParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequestsClosed200>(
      {url: `/requests/closed`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRequestsClosedQueryKey = (params?: GetRequestsClosedParams,) => {
    return [`/requests/closed`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRequestsClosedQueryOptions = <TData = Awaited<ReturnType<typeof getRequestsClosed>>, TError = ErrorType<string>>(params?: GetRequestsClosedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestsClosed>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsClosedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestsClosed>>> = ({ signal }) => getRequestsClosed(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestsClosed>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequestsClosedQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestsClosed>>>
export type GetRequestsClosedQueryError = ErrorType<string>

export const useGetRequestsClosed = <TData = Awaited<ReturnType<typeof getRequestsClosed>>, TError = ErrorType<string>>(
 params?: GetRequestsClosedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestsClosed>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequestsClosedQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRequestsPending = (
    params?: GetRequestsPendingParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequestsPending200>(
      {url: `/requests/pending`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRequestsPendingQueryKey = (params?: GetRequestsPendingParams,) => {
    return [`/requests/pending`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRequestsPendingQueryOptions = <TData = Awaited<ReturnType<typeof getRequestsPending>>, TError = ErrorType<string>>(params?: GetRequestsPendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestsPending>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequestsPendingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestsPending>>> = ({ signal }) => getRequestsPending(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequestsPending>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequestsPendingQueryResult = NonNullable<Awaited<ReturnType<typeof getRequestsPending>>>
export type GetRequestsPendingQueryError = ErrorType<string>

export const useGetRequestsPending = <TData = Awaited<ReturnType<typeof getRequestsPending>>, TError = ErrorType<string>>(
 params?: GetRequestsPendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequestsPending>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequestsPendingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a requirement by id
 */
export const getRequirementId = (
    id: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequirementId200>(
      {url: `/requirement/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequirementIdQueryKey = (id: number,) => {
    return [`/requirement/${id}`] as const;
    }

    
export const getGetRequirementIdQueryOptions = <TData = Awaited<ReturnType<typeof getRequirementId>>, TError = ErrorType<string>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequirementIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirementId>>> = ({ signal }) => getRequirementId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequirementId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequirementIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRequirementId>>>
export type GetRequirementIdQueryError = ErrorType<string>

export const useGetRequirementId = <TData = Awaited<ReturnType<typeof getRequirementId>>, TError = ErrorType<string>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequirementIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a requirement by id and organization
 */
export const getRequirementIdOrgid = (
    id: number,
    orgid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequirementIdOrgid200>(
      {url: `/requirement/${id}/${orgid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequirementIdOrgidQueryKey = (id: number,
    orgid: number,) => {
    return [`/requirement/${id}/${orgid}`] as const;
    }

    
export const getGetRequirementIdOrgidQueryOptions = <TData = Awaited<ReturnType<typeof getRequirementIdOrgid>>, TError = ErrorType<string>>(id: number,
    orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementIdOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequirementIdOrgidQueryKey(id,orgid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirementIdOrgid>>> = ({ signal }) => getRequirementIdOrgid(id,orgid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && orgid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequirementIdOrgid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequirementIdOrgidQueryResult = NonNullable<Awaited<ReturnType<typeof getRequirementIdOrgid>>>
export type GetRequirementIdOrgidQueryError = ErrorType<string>

export const useGetRequirementIdOrgid = <TData = Awaited<ReturnType<typeof getRequirementIdOrgid>>, TError = ErrorType<string>>(
 id: number,
    orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementIdOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequirementIdOrgidQueryOptions(id,orgid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Search requirements
 */
export const getRequirements = (
    params?: GetRequirementsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequirements200Item[]>(
      {url: `/requirements`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRequirementsQueryKey = (params?: GetRequirementsParams,) => {
    return [`/requirements`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof getRequirements>>, TError = ErrorType<string>>(params?: GetRequirementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequirementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirements>>> = ({ signal }) => getRequirements(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequirements>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequirements>>>
export type GetRequirementsQueryError = ErrorType<string>

export const useGetRequirements = <TData = Awaited<ReturnType<typeof getRequirements>>, TError = ErrorType<string>>(
 params?: GetRequirementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirements>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequirementsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRequirementsConnectrn = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequirementsConnectrn200Item[]>(
      {url: `/requirements/connectrn`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequirementsConnectrnQueryKey = () => {
    return [`/requirements/connectrn`] as const;
    }

    
export const getGetRequirementsConnectrnQueryOptions = <TData = Awaited<ReturnType<typeof getRequirementsConnectrn>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsConnectrn>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequirementsConnectrnQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirementsConnectrn>>> = ({ signal }) => getRequirementsConnectrn(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequirementsConnectrn>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequirementsConnectrnQueryResult = NonNullable<Awaited<ReturnType<typeof getRequirementsConnectrn>>>
export type GetRequirementsConnectrnQueryError = ErrorType<string>

export const useGetRequirementsConnectrn = <TData = Awaited<ReturnType<typeof getRequirementsConnectrn>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsConnectrn>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequirementsConnectrnQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a requirement
 */
export const postRequirementsCreate = (
    postRequirementsCreateBody: PostRequirementsCreateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/requirements/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRequirementsCreateBody
    },
      options);
    }
  


export const getPostRequirementsCreateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRequirementsCreate>>, TError,{data: PostRequirementsCreateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRequirementsCreate>>, TError,{data: PostRequirementsCreateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRequirementsCreate>>, {data: PostRequirementsCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  postRequirementsCreate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRequirementsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postRequirementsCreate>>>
    export type PostRequirementsCreateMutationBody = PostRequirementsCreateBody
    export type PostRequirementsCreateMutationError = ErrorType<string>

    export const usePostRequirementsCreate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRequirementsCreate>>, TError,{data: PostRequirementsCreateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRequirementsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteRequirementsDeleteId = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/requirements/delete/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRequirementsDeleteIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRequirementsDeleteId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRequirementsDeleteId>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRequirementsDeleteId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRequirementsDeleteId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteRequirementsDeleteIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRequirementsDeleteId>>>
    
    export type DeleteRequirementsDeleteIdMutationError = ErrorType<string>

    export const useDeleteRequirementsDeleteId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRequirementsDeleteId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteRequirementsDeleteIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update a requirement
 */
export const postRequirementsEdit = (
    postRequirementsEditBody: PostRequirementsEditBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/requirements/edit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRequirementsEditBody
    },
      options);
    }
  


export const getPostRequirementsEditMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRequirementsEdit>>, TError,{data: PostRequirementsEditBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRequirementsEdit>>, TError,{data: PostRequirementsEditBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRequirementsEdit>>, {data: PostRequirementsEditBody}> = (props) => {
          const {data} = props ?? {};

          return  postRequirementsEdit(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostRequirementsEditMutationResult = NonNullable<Awaited<ReturnType<typeof postRequirementsEdit>>>
    export type PostRequirementsEditMutationBody = PostRequirementsEditBody
    export type PostRequirementsEditMutationError = ErrorType<string>

    export const usePostRequirementsEdit = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRequirementsEdit>>, TError,{data: PostRequirementsEditBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostRequirementsEditMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Search for requirements
 */
export const getRequirementsSearch = (
    params?: GetRequirementsSearchParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequirementsSearch200Item[]>(
      {url: `/requirements/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRequirementsSearchQueryKey = (params?: GetRequirementsSearchParams,) => {
    return [`/requirements/search`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRequirementsSearchQueryOptions = <TData = Awaited<ReturnType<typeof getRequirementsSearch>>, TError = ErrorType<string>>(params?: GetRequirementsSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearch>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequirementsSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirementsSearch>>> = ({ signal }) => getRequirementsSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequirementsSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getRequirementsSearch>>>
export type GetRequirementsSearchQueryError = ErrorType<string>

export const useGetRequirementsSearch = <TData = Awaited<ReturnType<typeof getRequirementsSearch>>, TError = ErrorType<string>>(
 params?: GetRequirementsSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearch>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequirementsSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRequirementsSearchV2 = (
    params?: GetRequirementsSearchV2Params,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequirementsSearchV2200>(
      {url: `/requirements/searchV2`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRequirementsSearchV2QueryKey = (params?: GetRequirementsSearchV2Params,) => {
    return [`/requirements/searchV2`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRequirementsSearchV2QueryOptions = <TData = Awaited<ReturnType<typeof getRequirementsSearchV2>>, TError = ErrorType<string>>(params?: GetRequirementsSearchV2Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearchV2>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequirementsSearchV2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirementsSearchV2>>> = ({ signal }) => getRequirementsSearchV2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearchV2>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequirementsSearchV2QueryResult = NonNullable<Awaited<ReturnType<typeof getRequirementsSearchV2>>>
export type GetRequirementsSearchV2QueryError = ErrorType<string>

export const useGetRequirementsSearchV2 = <TData = Awaited<ReturnType<typeof getRequirementsSearchV2>>, TError = ErrorType<string>>(
 params?: GetRequirementsSearchV2Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearchV2>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequirementsSearchV2QueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRequirementsSearchV3 = (
    params?: GetRequirementsSearchV3Params,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequirementsSearchV3200>(
      {url: `/requirements/searchV3`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRequirementsSearchV3QueryKey = (params?: GetRequirementsSearchV3Params,) => {
    return [`/requirements/searchV3`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRequirementsSearchV3QueryOptions = <TData = Awaited<ReturnType<typeof getRequirementsSearchV3>>, TError = ErrorType<string>>(params?: GetRequirementsSearchV3Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearchV3>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequirementsSearchV3QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirementsSearchV3>>> = ({ signal }) => getRequirementsSearchV3(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearchV3>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequirementsSearchV3QueryResult = NonNullable<Awaited<ReturnType<typeof getRequirementsSearchV3>>>
export type GetRequirementsSearchV3QueryError = ErrorType<string>

export const useGetRequirementsSearchV3 = <TData = Awaited<ReturnType<typeof getRequirementsSearchV3>>, TError = ErrorType<string>>(
 params?: GetRequirementsSearchV3Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsSearchV3>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequirementsSearchV3QueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRequirementsShiftrequirement = (
    params?: GetRequirementsShiftrequirementParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRequirementsShiftrequirement200Item[]>(
      {url: `/requirements/shiftrequirement`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRequirementsShiftrequirementQueryKey = (params?: GetRequirementsShiftrequirementParams,) => {
    return [`/requirements/shiftrequirement`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRequirementsShiftrequirementQueryOptions = <TData = Awaited<ReturnType<typeof getRequirementsShiftrequirement>>, TError = ErrorType<string>>(params?: GetRequirementsShiftrequirementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsShiftrequirement>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequirementsShiftrequirementQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequirementsShiftrequirement>>> = ({ signal }) => getRequirementsShiftrequirement(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequirementsShiftrequirement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRequirementsShiftrequirementQueryResult = NonNullable<Awaited<ReturnType<typeof getRequirementsShiftrequirement>>>
export type GetRequirementsShiftrequirementQueryError = ErrorType<string>

export const useGetRequirementsShiftrequirement = <TData = Awaited<ReturnType<typeof getRequirementsShiftrequirement>>, TError = ErrorType<string>>(
 params?: GetRequirementsShiftrequirementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRequirementsShiftrequirement>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRequirementsShiftrequirementQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRoles = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetRoles200Item[]>(
      {url: `/roles`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRolesQueryKey = () => {
    return [`/roles`] as const;
    }

    
export const getGetRolesQueryOptions = <TData = Awaited<ReturnType<typeof getRoles>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRolesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoles>>> = ({ signal }) => getRoles(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getRoles>>>
export type GetRolesQueryError = ErrorType<string>

export const useGetRoles = <TData = Awaited<ReturnType<typeof getRoles>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRolesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postSavefilter = (
    postSavefilterBody: PostSavefilterBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/savefilter`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSavefilterBody
    },
      options);
    }
  


export const getPostSavefilterMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSavefilter>>, TError,{data: PostSavefilterBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSavefilter>>, TError,{data: PostSavefilterBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSavefilter>>, {data: PostSavefilterBody}> = (props) => {
          const {data} = props ?? {};

          return  postSavefilter(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostSavefilterMutationResult = NonNullable<Awaited<ReturnType<typeof postSavefilter>>>
    export type PostSavefilterMutationBody = PostSavefilterBody
    export type PostSavefilterMutationError = ErrorType<string>

    export const usePostSavefilter = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSavefilter>>, TError,{data: PostSavefilterBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostSavefilterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * get all scopes available
 */
export const getScopes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetScopes200Item[]>(
      {url: `/scopes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetScopesQueryKey = () => {
    return [`/scopes`] as const;
    }

    
export const getGetScopesQueryOptions = <TData = Awaited<ReturnType<typeof getScopes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScopes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScopesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScopes>>> = ({ signal }) => getScopes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScopes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetScopesQueryResult = NonNullable<Awaited<ReturnType<typeof getScopes>>>
export type GetScopesQueryError = ErrorType<string>

export const useGetScopes = <TData = Awaited<ReturnType<typeof getScopes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScopes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetScopesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putSetfilterasdefault = (
    putSetfilterasdefaultBody: PutSetfilterasdefaultBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/setfilterasdefault`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSetfilterasdefaultBody
    },
      options);
    }
  


export const getPutSetfilterasdefaultMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSetfilterasdefault>>, TError,{data: PutSetfilterasdefaultBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSetfilterasdefault>>, TError,{data: PutSetfilterasdefaultBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSetfilterasdefault>>, {data: PutSetfilterasdefaultBody}> = (props) => {
          const {data} = props ?? {};

          return  putSetfilterasdefault(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSetfilterasdefaultMutationResult = NonNullable<Awaited<ReturnType<typeof putSetfilterasdefault>>>
    export type PutSetfilterasdefaultMutationBody = PutSetfilterasdefaultBody
    export type PutSetfilterasdefaultMutationError = ErrorType<string>

    export const usePutSetfilterasdefault = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSetfilterasdefault>>, TError,{data: PutSetfilterasdefaultBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSetfilterasdefaultMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update feature
 * @summary Update shift feature
 */
export const putShiftFeature = (
    putShiftFeatureBody: PutShiftFeatureBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shift/feature`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putShiftFeatureBody
    },
      options);
    }
  


export const getPutShiftFeatureMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftFeature>>, TError,{data: PutShiftFeatureBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putShiftFeature>>, TError,{data: PutShiftFeatureBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putShiftFeature>>, {data: PutShiftFeatureBody}> = (props) => {
          const {data} = props ?? {};

          return  putShiftFeature(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutShiftFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof putShiftFeature>>>
    export type PutShiftFeatureMutationBody = PutShiftFeatureBody
    export type PutShiftFeatureMutationError = ErrorType<string>

    /**
 * @summary Update shift feature
 */
export const usePutShiftFeature = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftFeature>>, TError,{data: PutShiftFeatureBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutShiftFeatureMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update feature
 * @summary Update shift feature
 */
export const putShiftFeatureName = (
    putShiftFeatureNameBody: PutShiftFeatureNameBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shift/feature_name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putShiftFeatureNameBody
    },
      options);
    }
  


export const getPutShiftFeatureNameMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftFeatureName>>, TError,{data: PutShiftFeatureNameBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putShiftFeatureName>>, TError,{data: PutShiftFeatureNameBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putShiftFeatureName>>, {data: PutShiftFeatureNameBody}> = (props) => {
          const {data} = props ?? {};

          return  putShiftFeatureName(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutShiftFeatureNameMutationResult = NonNullable<Awaited<ReturnType<typeof putShiftFeatureName>>>
    export type PutShiftFeatureNameMutationBody = PutShiftFeatureNameBody
    export type PutShiftFeatureNameMutationError = ErrorType<string>

    /**
 * @summary Update shift feature
 */
export const usePutShiftFeatureName = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftFeatureName>>, TError,{data: PutShiftFeatureNameBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutShiftFeatureNameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Remove position from shift with conditions
 * @summary Remove position from shift after nurse call out
 */
export const putShiftRemovePositionShiftId = (
    shiftId: number,
    putShiftRemovePositionShiftIdBody: PutShiftRemovePositionShiftIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shift/remove-position/${shiftId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putShiftRemovePositionShiftIdBody
    },
      options);
    }
  


export const getPutShiftRemovePositionShiftIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftRemovePositionShiftId>>, TError,{shiftId: number;data: PutShiftRemovePositionShiftIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putShiftRemovePositionShiftId>>, TError,{shiftId: number;data: PutShiftRemovePositionShiftIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putShiftRemovePositionShiftId>>, {shiftId: number;data: PutShiftRemovePositionShiftIdBody}> = (props) => {
          const {shiftId,data} = props ?? {};

          return  putShiftRemovePositionShiftId(shiftId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutShiftRemovePositionShiftIdMutationResult = NonNullable<Awaited<ReturnType<typeof putShiftRemovePositionShiftId>>>
    export type PutShiftRemovePositionShiftIdMutationBody = PutShiftRemovePositionShiftIdBody
    export type PutShiftRemovePositionShiftIdMutationError = ErrorType<string>

    /**
 * @summary Remove position from shift after nurse call out
 */
export const usePutShiftRemovePositionShiftId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftRemovePositionShiftId>>, TError,{shiftId: number;data: PutShiftRemovePositionShiftIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutShiftRemovePositionShiftIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getShiftShiftid = (
    shiftid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetShiftShiftid200>(
      {url: `/shift/${shiftid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetShiftShiftidQueryKey = (shiftid: number,) => {
    return [`/shift/${shiftid}`] as const;
    }

    
export const getGetShiftShiftidQueryOptions = <TData = Awaited<ReturnType<typeof getShiftShiftid>>, TError = ErrorType<string>>(shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftShiftidQueryKey(shiftid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftShiftid>>> = ({ signal }) => getShiftShiftid(shiftid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shiftid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftShiftid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShiftShiftidQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftShiftid>>>
export type GetShiftShiftidQueryError = ErrorType<string>

export const useGetShiftShiftid = <TData = Awaited<ReturnType<typeof getShiftShiftid>>, TError = ErrorType<string>>(
 shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetShiftShiftidQueryOptions(shiftid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postShiftShiftidAdmincallout = (
    shiftid: number,
    postShiftShiftidAdmincalloutBody: PostShiftShiftidAdmincalloutBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shift/${shiftid}/admincallout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShiftShiftidAdmincalloutBody
    },
      options);
    }
  


export const getPostShiftShiftidAdmincalloutMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidAdmincallout>>, TError,{shiftid: number;data: PostShiftShiftidAdmincalloutBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidAdmincallout>>, TError,{shiftid: number;data: PostShiftShiftidAdmincalloutBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShiftShiftidAdmincallout>>, {shiftid: number;data: PostShiftShiftidAdmincalloutBody}> = (props) => {
          const {shiftid,data} = props ?? {};

          return  postShiftShiftidAdmincallout(shiftid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostShiftShiftidAdmincalloutMutationResult = NonNullable<Awaited<ReturnType<typeof postShiftShiftidAdmincallout>>>
    export type PostShiftShiftidAdmincalloutMutationBody = PostShiftShiftidAdmincalloutBody
    export type PostShiftShiftidAdmincalloutMutationError = ErrorType<string>

    export const usePostShiftShiftidAdmincallout = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidAdmincallout>>, TError,{shiftid: number;data: PostShiftShiftidAdmincalloutBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostShiftShiftidAdmincalloutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postShiftShiftidApply = (
    shiftid: number,
    postShiftShiftidApplyBody: PostShiftShiftidApplyBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostShiftShiftidApply200>(
      {url: `/shift/${shiftid}/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShiftShiftidApplyBody
    },
      options);
    }
  


export const getPostShiftShiftidApplyMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidApply>>, TError,{shiftid: number;data: PostShiftShiftidApplyBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidApply>>, TError,{shiftid: number;data: PostShiftShiftidApplyBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShiftShiftidApply>>, {shiftid: number;data: PostShiftShiftidApplyBody}> = (props) => {
          const {shiftid,data} = props ?? {};

          return  postShiftShiftidApply(shiftid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostShiftShiftidApplyMutationResult = NonNullable<Awaited<ReturnType<typeof postShiftShiftidApply>>>
    export type PostShiftShiftidApplyMutationBody = PostShiftShiftidApplyBody
    export type PostShiftShiftidApplyMutationError = ErrorType<string>

    export const usePostShiftShiftidApply = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidApply>>, TError,{shiftid: number;data: PostShiftShiftidApplyBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostShiftShiftidApplyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postShiftShiftidCallout = (
    shiftid: number,
    postShiftShiftidCalloutBody: PostShiftShiftidCalloutBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shift/${shiftid}/callout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShiftShiftidCalloutBody
    },
      options);
    }
  


export const getPostShiftShiftidCalloutMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidCallout>>, TError,{shiftid: number;data: PostShiftShiftidCalloutBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidCallout>>, TError,{shiftid: number;data: PostShiftShiftidCalloutBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShiftShiftidCallout>>, {shiftid: number;data: PostShiftShiftidCalloutBody}> = (props) => {
          const {shiftid,data} = props ?? {};

          return  postShiftShiftidCallout(shiftid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostShiftShiftidCalloutMutationResult = NonNullable<Awaited<ReturnType<typeof postShiftShiftidCallout>>>
    export type PostShiftShiftidCalloutMutationBody = PostShiftShiftidCalloutBody
    export type PostShiftShiftidCalloutMutationError = ErrorType<string>

    export const usePostShiftShiftidCallout = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidCallout>>, TError,{shiftid: number;data: PostShiftShiftidCalloutBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostShiftShiftidCalloutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Share this shift with nurses
 */
export const postShiftShiftidShare = (
    shiftid: number,
    postShiftShiftidShareBody: PostShiftShiftidShareBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shift/${shiftid}/share`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShiftShiftidShareBody
    },
      options);
    }
  


export const getPostShiftShiftidShareMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidShare>>, TError,{shiftid: number;data: PostShiftShiftidShareBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidShare>>, TError,{shiftid: number;data: PostShiftShiftidShareBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShiftShiftidShare>>, {shiftid: number;data: PostShiftShiftidShareBody}> = (props) => {
          const {shiftid,data} = props ?? {};

          return  postShiftShiftidShare(shiftid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostShiftShiftidShareMutationResult = NonNullable<Awaited<ReturnType<typeof postShiftShiftidShare>>>
    export type PostShiftShiftidShareMutationBody = PostShiftShiftidShareBody
    export type PostShiftShiftidShareMutationError = ErrorType<string>

    export const usePostShiftShiftidShare = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidShare>>, TError,{shiftid: number;data: PostShiftShiftidShareBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostShiftShiftidShareMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postShiftShiftidWithdraw = (
    shiftid: number,
    postShiftShiftidWithdrawBody: PostShiftShiftidWithdrawBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shift/${shiftid}/withdraw`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShiftShiftidWithdrawBody
    },
      options);
    }
  


export const getPostShiftShiftidWithdrawMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidWithdraw>>, TError,{shiftid: number;data: PostShiftShiftidWithdrawBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidWithdraw>>, TError,{shiftid: number;data: PostShiftShiftidWithdrawBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShiftShiftidWithdraw>>, {shiftid: number;data: PostShiftShiftidWithdrawBody}> = (props) => {
          const {shiftid,data} = props ?? {};

          return  postShiftShiftidWithdraw(shiftid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostShiftShiftidWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof postShiftShiftidWithdraw>>>
    export type PostShiftShiftidWithdrawMutationBody = PostShiftShiftidWithdrawBody
    export type PostShiftShiftidWithdrawMutationError = ErrorType<string>

    export const usePostShiftShiftidWithdraw = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftShiftidWithdraw>>, TError,{shiftid: number;data: PostShiftShiftidWithdrawBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostShiftShiftidWithdrawMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Sets the shift match confirmed dates for the given user
 */
export const putShiftmatchConfirmUser = (
    putShiftmatchConfirmUserBody: PutShiftmatchConfirmUserBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/shiftmatch/confirm/user`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putShiftmatchConfirmUserBody
    },
      options);
    }
  


export const getPutShiftmatchConfirmUserMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftmatchConfirmUser>>, TError,{data: PutShiftmatchConfirmUserBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putShiftmatchConfirmUser>>, TError,{data: PutShiftmatchConfirmUserBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putShiftmatchConfirmUser>>, {data: PutShiftmatchConfirmUserBody}> = (props) => {
          const {data} = props ?? {};

          return  putShiftmatchConfirmUser(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutShiftmatchConfirmUserMutationResult = NonNullable<Awaited<ReturnType<typeof putShiftmatchConfirmUser>>>
    export type PutShiftmatchConfirmUserMutationBody = PutShiftmatchConfirmUserBody
    export type PutShiftmatchConfirmUserMutationError = ErrorType<string>

    export const usePutShiftmatchConfirmUser = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftmatchConfirmUser>>, TError,{data: PutShiftmatchConfirmUserBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutShiftmatchConfirmUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Gets shift match from the given date and 7 days forward for the given user
 */
export const getShiftmatchPaneldataUserDateDate = (
    date: string,
    params?: GetShiftmatchPaneldataUserDateDateParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetShiftmatchPaneldataUserDateDate200>(
      {url: `/shiftmatch/paneldata/user/date/${date}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetShiftmatchPaneldataUserDateDateQueryKey = (date: string,
    params?: GetShiftmatchPaneldataUserDateDateParams,) => {
    return [`/shiftmatch/paneldata/user/date/${date}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetShiftmatchPaneldataUserDateDateQueryOptions = <TData = Awaited<ReturnType<typeof getShiftmatchPaneldataUserDateDate>>, TError = ErrorType<string>>(date: string,
    params?: GetShiftmatchPaneldataUserDateDateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftmatchPaneldataUserDateDate>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftmatchPaneldataUserDateDateQueryKey(date,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftmatchPaneldataUserDateDate>>> = ({ signal }) => getShiftmatchPaneldataUserDateDate(date,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(date), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftmatchPaneldataUserDateDate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShiftmatchPaneldataUserDateDateQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftmatchPaneldataUserDateDate>>>
export type GetShiftmatchPaneldataUserDateDateQueryError = ErrorType<string>

export const useGetShiftmatchPaneldataUserDateDate = <TData = Awaited<ReturnType<typeof getShiftmatchPaneldataUserDateDate>>, TError = ErrorType<string>>(
 date: string,
    params?: GetShiftmatchPaneldataUserDateDateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftmatchPaneldataUserDateDate>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetShiftmatchPaneldataUserDateDateQueryOptions(date,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Gets the availability filters the user has set for shift matching
 */
export const getShiftmatchUserFilters = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetShiftmatchUserFilters200>(
      {url: `/shiftmatch/user/filters`, method: 'GET', signal
    },
      options);
    }
  

export const getGetShiftmatchUserFiltersQueryKey = () => {
    return [`/shiftmatch/user/filters`] as const;
    }

    
export const getGetShiftmatchUserFiltersQueryOptions = <TData = Awaited<ReturnType<typeof getShiftmatchUserFilters>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftmatchUserFilters>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftmatchUserFiltersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftmatchUserFilters>>> = ({ signal }) => getShiftmatchUserFilters(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftmatchUserFilters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShiftmatchUserFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftmatchUserFilters>>>
export type GetShiftmatchUserFiltersQueryError = ErrorType<string>

export const useGetShiftmatchUserFilters = <TData = Awaited<ReturnType<typeof getShiftmatchUserFilters>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftmatchUserFilters>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetShiftmatchUserFiltersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Save the shift match recurring times given by user
 */
export const putShiftmatchUserFilters = (
    putShiftmatchUserFiltersBody: PutShiftmatchUserFiltersBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/shiftmatch/user/filters`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putShiftmatchUserFiltersBody
    },
      options);
    }
  


export const getPutShiftmatchUserFiltersMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftmatchUserFilters>>, TError,{data: PutShiftmatchUserFiltersBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putShiftmatchUserFilters>>, TError,{data: PutShiftmatchUserFiltersBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putShiftmatchUserFilters>>, {data: PutShiftmatchUserFiltersBody}> = (props) => {
          const {data} = props ?? {};

          return  putShiftmatchUserFilters(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutShiftmatchUserFiltersMutationResult = NonNullable<Awaited<ReturnType<typeof putShiftmatchUserFilters>>>
    export type PutShiftmatchUserFiltersMutationBody = PutShiftmatchUserFiltersBody
    export type PutShiftmatchUserFiltersMutationError = ErrorType<string>

    export const usePutShiftmatchUserFilters = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftmatchUserFilters>>, TError,{data: PutShiftmatchUserFiltersBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutShiftmatchUserFiltersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getShiftsAcceptedandapplied = (
    params: GetShiftsAcceptedandappliedParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetShiftsAcceptedandapplied200>(
      {url: `/shifts/acceptedandapplied`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetShiftsAcceptedandappliedQueryKey = (params: GetShiftsAcceptedandappliedParams,) => {
    return [`/shifts/acceptedandapplied`, ...(params ? [params]: [])] as const;
    }

    
export const getGetShiftsAcceptedandappliedQueryOptions = <TData = Awaited<ReturnType<typeof getShiftsAcceptedandapplied>>, TError = ErrorType<string>>(params: GetShiftsAcceptedandappliedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftsAcceptedandapplied>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftsAcceptedandappliedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftsAcceptedandapplied>>> = ({ signal }) => getShiftsAcceptedandapplied(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftsAcceptedandapplied>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShiftsAcceptedandappliedQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftsAcceptedandapplied>>>
export type GetShiftsAcceptedandappliedQueryError = ErrorType<string>

export const useGetShiftsAcceptedandapplied = <TData = Awaited<ReturnType<typeof getShiftsAcceptedandapplied>>, TError = ErrorType<string>>(
 params: GetShiftsAcceptedandappliedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftsAcceptedandapplied>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetShiftsAcceptedandappliedQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns shifts that are available/open for a clinician to apply to
 */
export const getShiftsAvailablev3 = (
    params?: GetShiftsAvailablev3Params,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetShiftsAvailablev3200>(
      {url: `/shifts/availablev3`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetShiftsAvailablev3QueryKey = (params?: GetShiftsAvailablev3Params,) => {
    return [`/shifts/availablev3`, ...(params ? [params]: [])] as const;
    }

    
export const getGetShiftsAvailablev3QueryOptions = <TData = Awaited<ReturnType<typeof getShiftsAvailablev3>>, TError = ErrorType<string>>(params?: GetShiftsAvailablev3Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftsAvailablev3>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftsAvailablev3QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftsAvailablev3>>> = ({ signal }) => getShiftsAvailablev3(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftsAvailablev3>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShiftsAvailablev3QueryResult = NonNullable<Awaited<ReturnType<typeof getShiftsAvailablev3>>>
export type GetShiftsAvailablev3QueryError = ErrorType<string>

export const useGetShiftsAvailablev3 = <TData = Awaited<ReturnType<typeof getShiftsAvailablev3>>, TError = ErrorType<string>>(
 params?: GetShiftsAvailablev3Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftsAvailablev3>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetShiftsAvailablev3QueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postShiftsCreate = (
    postShiftsCreateBody: PostShiftsCreateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/shifts/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShiftsCreateBody
    },
      options);
    }
  


export const getPostShiftsCreateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreate>>, TError,{data: PostShiftsCreateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreate>>, TError,{data: PostShiftsCreateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShiftsCreate>>, {data: PostShiftsCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  postShiftsCreate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostShiftsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postShiftsCreate>>>
    export type PostShiftsCreateMutationBody = PostShiftsCreateBody
    export type PostShiftsCreateMutationError = ErrorType<string>

    export const usePostShiftsCreate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreate>>, TError,{data: PostShiftsCreateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostShiftsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates multiple shifts for shift date array
 */
export const postShiftsCreateMultiple = (
    postShiftsCreateMultipleBody: PostShiftsCreateMultipleBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number[]>(
      {url: `/shifts/create-multiple`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShiftsCreateMultipleBody
    },
      options);
    }
  


export const getPostShiftsCreateMultipleMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreateMultiple>>, TError,{data: PostShiftsCreateMultipleBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreateMultiple>>, TError,{data: PostShiftsCreateMultipleBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShiftsCreateMultiple>>, {data: PostShiftsCreateMultipleBody}> = (props) => {
          const {data} = props ?? {};

          return  postShiftsCreateMultiple(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostShiftsCreateMultipleMutationResult = NonNullable<Awaited<ReturnType<typeof postShiftsCreateMultiple>>>
    export type PostShiftsCreateMultipleMutationBody = PostShiftsCreateMultipleBody
    export type PostShiftsCreateMultipleMutationError = ErrorType<string>

    export const usePostShiftsCreateMultiple = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreateMultiple>>, TError,{data: PostShiftsCreateMultipleBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostShiftsCreateMultipleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates multiple shifts for multiple shift dates and multiple shift times
 */
export const postShiftsCreateMultipleV2 = (
    postShiftsCreateMultipleV2Body: PostShiftsCreateMultipleV2Body,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number[]>(
      {url: `/shifts/create-multiple-v2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postShiftsCreateMultipleV2Body
    },
      options);
    }
  


export const getPostShiftsCreateMultipleV2MutationOptions = <TError = ErrorType<PostShiftsCreateMultipleV2400 | string | PostShiftsCreateMultipleV2403 | PostShiftsCreateMultipleV2500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreateMultipleV2>>, TError,{data: PostShiftsCreateMultipleV2Body}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreateMultipleV2>>, TError,{data: PostShiftsCreateMultipleV2Body}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postShiftsCreateMultipleV2>>, {data: PostShiftsCreateMultipleV2Body}> = (props) => {
          const {data} = props ?? {};

          return  postShiftsCreateMultipleV2(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostShiftsCreateMultipleV2MutationResult = NonNullable<Awaited<ReturnType<typeof postShiftsCreateMultipleV2>>>
    export type PostShiftsCreateMultipleV2MutationBody = PostShiftsCreateMultipleV2Body
    export type PostShiftsCreateMultipleV2MutationError = ErrorType<PostShiftsCreateMultipleV2400 | string | PostShiftsCreateMultipleV2403 | PostShiftsCreateMultipleV2500>

    export const usePostShiftsCreateMultipleV2 = <TError = ErrorType<PostShiftsCreateMultipleV2400 | string | PostShiftsCreateMultipleV2403 | PostShiftsCreateMultipleV2500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postShiftsCreateMultipleV2>>, TError,{data: PostShiftsCreateMultipleV2Body}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostShiftsCreateMultipleV2MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getShiftsLog = (
    params: GetShiftsLogParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetShiftsLog200Item[]>(
      {url: `/shifts/log`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetShiftsLogQueryKey = (params: GetShiftsLogParams,) => {
    return [`/shifts/log`, ...(params ? [params]: [])] as const;
    }

    
export const getGetShiftsLogQueryOptions = <TData = Awaited<ReturnType<typeof getShiftsLog>>, TError = ErrorType<string>>(params: GetShiftsLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftsLog>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftsLogQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftsLog>>> = ({ signal }) => getShiftsLog(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftsLog>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShiftsLogQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftsLog>>>
export type GetShiftsLogQueryError = ErrorType<string>

export const useGetShiftsLog = <TData = Awaited<ReturnType<typeof getShiftsLog>>, TError = ErrorType<string>>(
 params: GetShiftsLogParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftsLog>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetShiftsLogQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getShiftsOpenshifts = (
    params?: GetShiftsOpenshiftsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetShiftsOpenshifts200>(
      {url: `/shifts/openshifts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetShiftsOpenshiftsQueryKey = (params?: GetShiftsOpenshiftsParams,) => {
    return [`/shifts/openshifts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetShiftsOpenshiftsQueryOptions = <TData = Awaited<ReturnType<typeof getShiftsOpenshifts>>, TError = ErrorType<string>>(params?: GetShiftsOpenshiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftsOpenshifts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShiftsOpenshiftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShiftsOpenshifts>>> = ({ signal }) => getShiftsOpenshifts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShiftsOpenshifts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShiftsOpenshiftsQueryResult = NonNullable<Awaited<ReturnType<typeof getShiftsOpenshifts>>>
export type GetShiftsOpenshiftsQueryError = ErrorType<string>

export const useGetShiftsOpenshifts = <TData = Awaited<ReturnType<typeof getShiftsOpenshifts>>, TError = ErrorType<string>>(
 params?: GetShiftsOpenshiftsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShiftsOpenshifts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetShiftsOpenshiftsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putShiftsUpdate = (
    putShiftsUpdateBody: PutShiftsUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shifts/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putShiftsUpdateBody
    },
      options);
    }
  


export const getPutShiftsUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftsUpdate>>, TError,{data: PutShiftsUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putShiftsUpdate>>, TError,{data: PutShiftsUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putShiftsUpdate>>, {data: PutShiftsUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putShiftsUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutShiftsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putShiftsUpdate>>>
    export type PutShiftsUpdateMutationBody = PutShiftsUpdateBody
    export type PutShiftsUpdateMutationError = ErrorType<string>

    export const usePutShiftsUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putShiftsUpdate>>, TError,{data: PutShiftsUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutShiftsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Delete shift level bonus
 * @summary Delete Shift Bonus
 */
export const deleteShiftsIdBonus = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<DeleteShiftsIdBonus200>(
      {url: `/shifts/${id}/bonus`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteShiftsIdBonusMutationOptions = <TError = ErrorType<DeleteShiftsIdBonus400 | string | DeleteShiftsIdBonus500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShiftsIdBonus>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShiftsIdBonus>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShiftsIdBonus>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteShiftsIdBonus(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteShiftsIdBonusMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShiftsIdBonus>>>
    
    export type DeleteShiftsIdBonusMutationError = ErrorType<DeleteShiftsIdBonus400 | string | DeleteShiftsIdBonus500>

    /**
 * @summary Delete Shift Bonus
 */
export const useDeleteShiftsIdBonus = <TError = ErrorType<DeleteShiftsIdBonus400 | string | DeleteShiftsIdBonus500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShiftsIdBonus>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteShiftsIdBonusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchShiftsShiftid = (
    shiftid: number,
    patchShiftsShiftidBody: PatchShiftsShiftidBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/shifts/${shiftid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchShiftsShiftidBody
    },
      options);
    }
  


export const getPatchShiftsShiftidMutationOptions = <TError = ErrorType<PatchShiftsShiftid400 | PatchShiftsShiftid401 | PatchShiftsShiftid404 | PatchShiftsShiftid500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchShiftsShiftid>>, TError,{shiftid: number;data: PatchShiftsShiftidBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof patchShiftsShiftid>>, TError,{shiftid: number;data: PatchShiftsShiftidBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchShiftsShiftid>>, {shiftid: number;data: PatchShiftsShiftidBody}> = (props) => {
          const {shiftid,data} = props ?? {};

          return  patchShiftsShiftid(shiftid,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PatchShiftsShiftidMutationResult = NonNullable<Awaited<ReturnType<typeof patchShiftsShiftid>>>
    export type PatchShiftsShiftidMutationBody = PatchShiftsShiftidBody
    export type PatchShiftsShiftidMutationError = ErrorType<PatchShiftsShiftid400 | PatchShiftsShiftid401 | PatchShiftsShiftid404 | PatchShiftsShiftid500>

    export const usePatchShiftsShiftid = <TError = ErrorType<PatchShiftsShiftid400 | PatchShiftsShiftid401 | PatchShiftsShiftid404 | PatchShiftsShiftid500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchShiftsShiftid>>, TError,{shiftid: number;data: PatchShiftsShiftidBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPatchShiftsShiftidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update Shift request status
 */
export const patchShiftsShiftidRequestsRequestid = (
    shiftid: number,
    requestid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PatchShiftsShiftidRequestsRequestid200>(
      {url: `/shifts/${shiftid}/requests/${requestid}`, method: 'PATCH'
    },
      options);
    }
  


export const getPatchShiftsShiftidRequestsRequestidMutationOptions = <TError = ErrorType<PatchShiftsShiftidRequestsRequestid400 | string | PatchShiftsShiftidRequestsRequestid500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchShiftsShiftidRequestsRequestid>>, TError,{shiftid: number;requestid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof patchShiftsShiftidRequestsRequestid>>, TError,{shiftid: number;requestid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchShiftsShiftidRequestsRequestid>>, {shiftid: number;requestid: number}> = (props) => {
          const {shiftid,requestid} = props ?? {};

          return  patchShiftsShiftidRequestsRequestid(shiftid,requestid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PatchShiftsShiftidRequestsRequestidMutationResult = NonNullable<Awaited<ReturnType<typeof patchShiftsShiftidRequestsRequestid>>>
    
    export type PatchShiftsShiftidRequestsRequestidMutationError = ErrorType<PatchShiftsShiftidRequestsRequestid400 | string | PatchShiftsShiftidRequestsRequestid500>

    export const usePatchShiftsShiftidRequestsRequestid = <TError = ErrorType<PatchShiftsShiftidRequestsRequestid400 | string | PatchShiftsShiftidRequestsRequestid500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchShiftsShiftidRequestsRequestid>>, TError,{shiftid: number;requestid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPatchShiftsShiftidRequestsRequestidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Ask if the clinician can use the self checkout flow for a shift.
 * @summary Ask if we can use self checkout
 */
export const getSignoffCanSelfCheckout = (
    params?: GetSignoffCanSelfCheckoutParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSignoffCanSelfCheckout200>(
      {url: `/signoff/canSelfCheckout`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSignoffCanSelfCheckoutQueryKey = (params?: GetSignoffCanSelfCheckoutParams,) => {
    return [`/signoff/canSelfCheckout`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSignoffCanSelfCheckoutQueryOptions = <TData = Awaited<ReturnType<typeof getSignoffCanSelfCheckout>>, TError = ErrorType<string>>(params?: GetSignoffCanSelfCheckoutParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignoffCanSelfCheckout>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSignoffCanSelfCheckoutQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSignoffCanSelfCheckout>>> = ({ signal }) => getSignoffCanSelfCheckout(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSignoffCanSelfCheckout>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSignoffCanSelfCheckoutQueryResult = NonNullable<Awaited<ReturnType<typeof getSignoffCanSelfCheckout>>>
export type GetSignoffCanSelfCheckoutQueryError = ErrorType<string>

/**
 * @summary Ask if we can use self checkout
 */
export const useGetSignoffCanSelfCheckout = <TData = Awaited<ReturnType<typeof getSignoffCanSelfCheckout>>, TError = ErrorType<string>>(
 params?: GetSignoffCanSelfCheckoutParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSignoffCanSelfCheckout>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSignoffCanSelfCheckoutQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putSignoffCheckinsignoff = (
    putSignoffCheckinsignoffBody: PutSignoffCheckinsignoffBody,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(putSignoffCheckinsignoffBody.adjustment_date !== undefined) {
 formData.append('adjustment_date', putSignoffCheckinsignoffBody.adjustment_date)
 }
if(putSignoffCheckinsignoffBody.checkin_accuracy !== undefined) {
 formData.append('checkin_accuracy', putSignoffCheckinsignoffBody.checkin_accuracy)
 }
if(putSignoffCheckinsignoffBody.checkin_lat !== undefined) {
 formData.append('checkin_lat', putSignoffCheckinsignoffBody.checkin_lat)
 }
if(putSignoffCheckinsignoffBody.checkin_lng !== undefined) {
 formData.append('checkin_lng', putSignoffCheckinsignoffBody.checkin_lng)
 }
if(putSignoffCheckinsignoffBody.comment !== undefined) {
 formData.append('comment', putSignoffCheckinsignoffBody.comment)
 }
if(putSignoffCheckinsignoffBody.nurse_id !== undefined) {
 formData.append('nurse_id', putSignoffCheckinsignoffBody.nurse_id)
 }
if(putSignoffCheckinsignoffBody.shiftid !== undefined) {
 formData.append('shiftid', putSignoffCheckinsignoffBody.shiftid.toString())
 }
if(putSignoffCheckinsignoffBody.signature !== undefined) {
 formData.append('signature', putSignoffCheckinsignoffBody.signature)
 }
if(putSignoffCheckinsignoffBody.signature_time !== undefined) {
 formData.append('signature_time', putSignoffCheckinsignoffBody.signature_time)
 }
if(putSignoffCheckinsignoffBody.supervisor_name !== undefined) {
 formData.append('supervisor_name', putSignoffCheckinsignoffBody.supervisor_name)
 }

      return request<PutSignoffCheckinsignoff200>(
      {url: `/signoff/checkinsignoff`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPutSignoffCheckinsignoffMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffCheckinsignoff>>, TError,{data: PutSignoffCheckinsignoffBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSignoffCheckinsignoff>>, TError,{data: PutSignoffCheckinsignoffBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSignoffCheckinsignoff>>, {data: PutSignoffCheckinsignoffBody}> = (props) => {
          const {data} = props ?? {};

          return  putSignoffCheckinsignoff(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSignoffCheckinsignoffMutationResult = NonNullable<Awaited<ReturnType<typeof putSignoffCheckinsignoff>>>
    export type PutSignoffCheckinsignoffMutationBody = PutSignoffCheckinsignoffBody
    export type PutSignoffCheckinsignoffMutationError = ErrorType<string>

    export const usePutSignoffCheckinsignoff = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffCheckinsignoff>>, TError,{data: PutSignoffCheckinsignoffBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSignoffCheckinsignoffMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putSignoffConfirmcheckout = (
    putSignoffConfirmcheckoutBody: PutSignoffConfirmcheckoutBody,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(putSignoffConfirmcheckoutBody.break_exception_comment !== undefined) {
 formData.append('break_exception_comment', putSignoffConfirmcheckoutBody.break_exception_comment)
 }
if(putSignoffConfirmcheckoutBody.break_exception_type_id !== undefined) {
 formData.append('break_exception_type_id', putSignoffConfirmcheckoutBody.break_exception_type_id.toString())
 }
if(putSignoffConfirmcheckoutBody.checkout_accuracy !== undefined) {
 formData.append('checkout_accuracy', putSignoffConfirmcheckoutBody.checkout_accuracy)
 }
if(putSignoffConfirmcheckoutBody.checkout_lat !== undefined) {
 formData.append('checkout_lat', putSignoffConfirmcheckoutBody.checkout_lat)
 }
if(putSignoffConfirmcheckoutBody.checkout_lng !== undefined) {
 formData.append('checkout_lng', putSignoffConfirmcheckoutBody.checkout_lng)
 }
if(putSignoffConfirmcheckoutBody.checkout_time !== undefined) {
 formData.append('checkout_time', putSignoffConfirmcheckoutBody.checkout_time)
 }
if(putSignoffConfirmcheckoutBody.comment !== undefined) {
 formData.append('comment', putSignoffConfirmcheckoutBody.comment)
 }
if(putSignoffConfirmcheckoutBody.message_type !== undefined) {
 formData.append('message_type', putSignoffConfirmcheckoutBody.message_type)
 }
if(putSignoffConfirmcheckoutBody.note !== undefined) {
 formData.append('note', putSignoffConfirmcheckoutBody.note)
 }
if(putSignoffConfirmcheckoutBody.shift_id !== undefined) {
 formData.append('shift_id', putSignoffConfirmcheckoutBody.shift_id.toString())
 }
if(putSignoffConfirmcheckoutBody.signature !== undefined) {
 formData.append('signature', putSignoffConfirmcheckoutBody.signature)
 }
if(putSignoffConfirmcheckoutBody.signature_time !== undefined) {
 formData.append('signature_time', putSignoffConfirmcheckoutBody.signature_time)
 }
if(putSignoffConfirmcheckoutBody.status !== undefined) {
 formData.append('status', putSignoffConfirmcheckoutBody.status)
 }
if(putSignoffConfirmcheckoutBody.supervisor_name !== undefined) {
 formData.append('supervisor_name', putSignoffConfirmcheckoutBody.supervisor_name)
 }

      return request<PutSignoffConfirmcheckout200>(
      {url: `/signoff/confirmcheckout`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPutSignoffConfirmcheckoutMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffConfirmcheckout>>, TError,{data: PutSignoffConfirmcheckoutBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSignoffConfirmcheckout>>, TError,{data: PutSignoffConfirmcheckoutBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSignoffConfirmcheckout>>, {data: PutSignoffConfirmcheckoutBody}> = (props) => {
          const {data} = props ?? {};

          return  putSignoffConfirmcheckout(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSignoffConfirmcheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof putSignoffConfirmcheckout>>>
    export type PutSignoffConfirmcheckoutMutationBody = PutSignoffConfirmcheckoutBody
    export type PutSignoffConfirmcheckoutMutationError = ErrorType<string>

    export const usePutSignoffConfirmcheckout = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffConfirmcheckout>>, TError,{data: PutSignoffConfirmcheckoutBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSignoffConfirmcheckoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Check out of shift using the self checkout flow.
 */
export const putSignoffSelfCheckout = (
    putSignoffSelfCheckoutBody: PutSignoffSelfCheckoutBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/signoff/self-checkout`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSignoffSelfCheckoutBody
    },
      options);
    }
  


export const getPutSignoffSelfCheckoutMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffSelfCheckout>>, TError,{data: PutSignoffSelfCheckoutBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSignoffSelfCheckout>>, TError,{data: PutSignoffSelfCheckoutBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSignoffSelfCheckout>>, {data: PutSignoffSelfCheckoutBody}> = (props) => {
          const {data} = props ?? {};

          return  putSignoffSelfCheckout(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSignoffSelfCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof putSignoffSelfCheckout>>>
    export type PutSignoffSelfCheckoutMutationBody = PutSignoffSelfCheckoutBody
    export type PutSignoffSelfCheckoutMutationError = ErrorType<string>

    export const usePutSignoffSelfCheckout = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffSelfCheckout>>, TError,{data: PutSignoffSelfCheckoutBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSignoffSelfCheckoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putSignoffSignoffcheckin = (
    putSignoffSignoffcheckinBody: PutSignoffSignoffcheckinBody,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(putSignoffSignoffcheckinBody.checkin_time !== undefined) {
 formData.append('checkin_time', putSignoffSignoffcheckinBody.checkin_time)
 }
if(putSignoffSignoffcheckinBody.comment !== undefined) {
 formData.append('comment', putSignoffSignoffcheckinBody.comment)
 }
if(putSignoffSignoffcheckinBody.signature !== undefined) {
 formData.append('signature', putSignoffSignoffcheckinBody.signature)
 }
if(putSignoffSignoffcheckinBody.supervisor_name !== undefined) {
 formData.append('supervisor_name', putSignoffSignoffcheckinBody.supervisor_name)
 }
if(putSignoffSignoffcheckinBody.timesheet_id !== undefined) {
 formData.append('timesheet_id', putSignoffSignoffcheckinBody.timesheet_id.toString())
 }

      return request<PutSignoffSignoffcheckin200Item[]>(
      {url: `/signoff/signoffcheckin`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPutSignoffSignoffcheckinMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffSignoffcheckin>>, TError,{data: PutSignoffSignoffcheckinBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSignoffSignoffcheckin>>, TError,{data: PutSignoffSignoffcheckinBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSignoffSignoffcheckin>>, {data: PutSignoffSignoffcheckinBody}> = (props) => {
          const {data} = props ?? {};

          return  putSignoffSignoffcheckin(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSignoffSignoffcheckinMutationResult = NonNullable<Awaited<ReturnType<typeof putSignoffSignoffcheckin>>>
    export type PutSignoffSignoffcheckinMutationBody = PutSignoffSignoffcheckinBody
    export type PutSignoffSignoffcheckinMutationError = ErrorType<string>

    export const usePutSignoffSignoffcheckin = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffSignoffcheckin>>, TError,{data: PutSignoffSignoffcheckinBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSignoffSignoffcheckinMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putSignoffSkip = (
    putSignoffSkipBody: PutSignoffSkipBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/signoff/skip`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSignoffSkipBody
    },
      options);
    }
  


export const getPutSignoffSkipMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffSkip>>, TError,{data: PutSignoffSkipBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSignoffSkip>>, TError,{data: PutSignoffSkipBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSignoffSkip>>, {data: PutSignoffSkipBody}> = (props) => {
          const {data} = props ?? {};

          return  putSignoffSkip(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSignoffSkipMutationResult = NonNullable<Awaited<ReturnType<typeof putSignoffSkip>>>
    export type PutSignoffSkipMutationBody = PutSignoffSkipBody
    export type PutSignoffSkipMutationError = ErrorType<string>

    export const usePutSignoffSkip = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffSkip>>, TError,{data: PutSignoffSkipBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSignoffSkipMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Sign Off Skip Supervisor
 */
export const putSignoffSkipSupervisor = (
    putSignoffSkipSupervisorBody: PutSignoffSkipSupervisorBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutSignoffSkipSupervisor200>(
      {url: `/signoff/skip-supervisor`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSignoffSkipSupervisorBody
    },
      options);
    }
  


export const getPutSignoffSkipSupervisorMutationOptions = <TError = ErrorType<PutSignoffSkipSupervisor400 | string | PutSignoffSkipSupervisor409 | PutSignoffSkipSupervisor500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffSkipSupervisor>>, TError,{data: PutSignoffSkipSupervisorBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSignoffSkipSupervisor>>, TError,{data: PutSignoffSkipSupervisorBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSignoffSkipSupervisor>>, {data: PutSignoffSkipSupervisorBody}> = (props) => {
          const {data} = props ?? {};

          return  putSignoffSkipSupervisor(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSignoffSkipSupervisorMutationResult = NonNullable<Awaited<ReturnType<typeof putSignoffSkipSupervisor>>>
    export type PutSignoffSkipSupervisorMutationBody = PutSignoffSkipSupervisorBody
    export type PutSignoffSkipSupervisorMutationError = ErrorType<PutSignoffSkipSupervisor400 | string | PutSignoffSkipSupervisor409 | PutSignoffSkipSupervisor500>

    export const usePutSignoffSkipSupervisor = <TError = ErrorType<PutSignoffSkipSupervisor400 | string | PutSignoffSkipSupervisor409 | PutSignoffSkipSupervisor500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSignoffSkipSupervisor>>, TError,{data: PutSignoffSkipSupervisorBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSignoffSkipSupervisorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getSpecialties = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSpecialties200Item[]>(
      {url: `/specialties`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSpecialtiesQueryKey = () => {
    return [`/specialties`] as const;
    }

    
export const getGetSpecialtiesQueryOptions = <TData = Awaited<ReturnType<typeof getSpecialties>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpecialties>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpecialtiesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpecialties>>> = ({ signal }) => getSpecialties(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpecialties>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSpecialtiesQueryResult = NonNullable<Awaited<ReturnType<typeof getSpecialties>>>
export type GetSpecialtiesQueryError = ErrorType<string>

export const useGetSpecialties = <TData = Awaited<ReturnType<typeof getSpecialties>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSpecialties>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSpecialtiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getStates = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetStates200Item[]>(
      {url: `/states`, method: 'GET', signal
    },
      options);
    }
  

export const getGetStatesQueryKey = () => {
    return [`/states`] as const;
    }

    
export const getGetStatesQueryOptions = <TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStates>>> = ({ signal }) => getStates(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStatesQueryResult = NonNullable<Awaited<ReturnType<typeof getStates>>>
export type GetStatesQueryError = ErrorType<string>

export const useGetStates = <TData = Awaited<ReturnType<typeof getStates>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStates>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postSupervisorAvailability = (
    postSupervisorAvailabilityBody: PostSupervisorAvailabilityBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostSupervisorAvailability200>(
      {url: `/supervisor-availability`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSupervisorAvailabilityBody
    },
      options);
    }
  


export const getPostSupervisorAvailabilityMutationOptions = <TError = ErrorType<PostSupervisorAvailability400 | string | PostSupervisorAvailability500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorAvailability>>, TError,{data: PostSupervisorAvailabilityBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSupervisorAvailability>>, TError,{data: PostSupervisorAvailabilityBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupervisorAvailability>>, {data: PostSupervisorAvailabilityBody}> = (props) => {
          const {data} = props ?? {};

          return  postSupervisorAvailability(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostSupervisorAvailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof postSupervisorAvailability>>>
    export type PostSupervisorAvailabilityMutationBody = PostSupervisorAvailabilityBody
    export type PostSupervisorAvailabilityMutationError = ErrorType<PostSupervisorAvailability400 | string | PostSupervisorAvailability500>

    export const usePostSupervisorAvailability = <TError = ErrorType<PostSupervisorAvailability400 | string | PostSupervisorAvailability500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorAvailability>>, TError,{data: PostSupervisorAvailabilityBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostSupervisorAvailabilityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putSupervisorAvailabilityId = (
    id: number,
    putSupervisorAvailabilityIdBody: PutSupervisorAvailabilityIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutSupervisorAvailabilityId200>(
      {url: `/supervisor-availability/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSupervisorAvailabilityIdBody
    },
      options);
    }
  


export const getPutSupervisorAvailabilityIdMutationOptions = <TError = ErrorType<PutSupervisorAvailabilityId400 | string | PutSupervisorAvailabilityId404 | PutSupervisorAvailabilityId500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorAvailabilityId>>, TError,{id: number;data: PutSupervisorAvailabilityIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSupervisorAvailabilityId>>, TError,{id: number;data: PutSupervisorAvailabilityIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSupervisorAvailabilityId>>, {id: number;data: PutSupervisorAvailabilityIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putSupervisorAvailabilityId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSupervisorAvailabilityIdMutationResult = NonNullable<Awaited<ReturnType<typeof putSupervisorAvailabilityId>>>
    export type PutSupervisorAvailabilityIdMutationBody = PutSupervisorAvailabilityIdBody
    export type PutSupervisorAvailabilityIdMutationError = ErrorType<PutSupervisorAvailabilityId400 | string | PutSupervisorAvailabilityId404 | PutSupervisorAvailabilityId500>

    export const usePutSupervisorAvailabilityId = <TError = ErrorType<PutSupervisorAvailabilityId400 | string | PutSupervisorAvailabilityId404 | PutSupervisorAvailabilityId500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorAvailabilityId>>, TError,{id: number;data: PutSupervisorAvailabilityIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSupervisorAvailabilityIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getSupervisorAvailabilityOrgid = (
    orgid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorAvailabilityOrgid200>(
      {url: `/supervisor-availability/${orgid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSupervisorAvailabilityOrgidQueryKey = (orgid: number,) => {
    return [`/supervisor-availability/${orgid}`] as const;
    }

    
export const getGetSupervisorAvailabilityOrgidQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorAvailabilityOrgid>>, TError = ErrorType<GetSupervisorAvailabilityOrgid400 | GetSupervisorAvailabilityOrgid401 | GetSupervisorAvailabilityOrgid500>>(orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorAvailabilityOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorAvailabilityOrgidQueryKey(orgid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorAvailabilityOrgid>>> = ({ signal }) => getSupervisorAvailabilityOrgid(orgid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorAvailabilityOrgid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorAvailabilityOrgidQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorAvailabilityOrgid>>>
export type GetSupervisorAvailabilityOrgidQueryError = ErrorType<GetSupervisorAvailabilityOrgid400 | GetSupervisorAvailabilityOrgid401 | GetSupervisorAvailabilityOrgid500>

export const useGetSupervisorAvailabilityOrgid = <TData = Awaited<ReturnType<typeof getSupervisorAvailabilityOrgid>>, TError = ErrorType<GetSupervisorAvailabilityOrgid400 | GetSupervisorAvailabilityOrgid401 | GetSupervisorAvailabilityOrgid500>>(
 orgid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorAvailabilityOrgid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorAvailabilityOrgidQueryOptions(orgid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putSupervisorApprovedtimesheet = (
    putSupervisorApprovedtimesheetBody: PutSupervisorApprovedtimesheetBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/supervisor/approvedtimesheet`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSupervisorApprovedtimesheetBody
    },
      options);
    }
  


export const getPutSupervisorApprovedtimesheetMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorApprovedtimesheet>>, TError,{data: PutSupervisorApprovedtimesheetBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSupervisorApprovedtimesheet>>, TError,{data: PutSupervisorApprovedtimesheetBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSupervisorApprovedtimesheet>>, {data: PutSupervisorApprovedtimesheetBody}> = (props) => {
          const {data} = props ?? {};

          return  putSupervisorApprovedtimesheet(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSupervisorApprovedtimesheetMutationResult = NonNullable<Awaited<ReturnType<typeof putSupervisorApprovedtimesheet>>>
    export type PutSupervisorApprovedtimesheetMutationBody = PutSupervisorApprovedtimesheetBody
    export type PutSupervisorApprovedtimesheetMutationError = ErrorType<string>

    export const usePutSupervisorApprovedtimesheet = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorApprovedtimesheet>>, TError,{data: PutSupervisorApprovedtimesheetBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSupervisorApprovedtimesheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getSupervisorGettimesheet = (
    params?: GetSupervisorGettimesheetParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorGettimesheet200>(
      {url: `/supervisor/gettimesheet`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSupervisorGettimesheetQueryKey = (params?: GetSupervisorGettimesheetParams,) => {
    return [`/supervisor/gettimesheet`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupervisorGettimesheetQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorGettimesheet>>, TError = ErrorType<string>>(params?: GetSupervisorGettimesheetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorGettimesheet>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorGettimesheetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorGettimesheet>>> = ({ signal }) => getSupervisorGettimesheet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorGettimesheet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorGettimesheetQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorGettimesheet>>>
export type GetSupervisorGettimesheetQueryError = ErrorType<string>

export const useGetSupervisorGettimesheet = <TData = Awaited<ReturnType<typeof getSupervisorGettimesheet>>, TError = ErrorType<string>>(
 params?: GetSupervisorGettimesheetParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorGettimesheet>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorGettimesheetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postSupervisorNurseDnr = (
    postSupervisorNurseDnrBody: PostSupervisorNurseDnrBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostSupervisorNurseDnr200>(
      {url: `/supervisor/nurse-dnr`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSupervisorNurseDnrBody
    },
      options);
    }
  


export const getPostSupervisorNurseDnrMutationOptions = <TError = ErrorType<PostSupervisorNurseDnr400 | string | PostSupervisorNurseDnr500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorNurseDnr>>, TError,{data: PostSupervisorNurseDnrBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSupervisorNurseDnr>>, TError,{data: PostSupervisorNurseDnrBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupervisorNurseDnr>>, {data: PostSupervisorNurseDnrBody}> = (props) => {
          const {data} = props ?? {};

          return  postSupervisorNurseDnr(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostSupervisorNurseDnrMutationResult = NonNullable<Awaited<ReturnType<typeof postSupervisorNurseDnr>>>
    export type PostSupervisorNurseDnrMutationBody = PostSupervisorNurseDnrBody
    export type PostSupervisorNurseDnrMutationError = ErrorType<PostSupervisorNurseDnr400 | string | PostSupervisorNurseDnr500>

    export const usePostSupervisorNurseDnr = <TError = ErrorType<PostSupervisorNurseDnr400 | string | PostSupervisorNurseDnr500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorNurseDnr>>, TError,{data: PostSupervisorNurseDnrBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostSupervisorNurseDnrMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postSupervisorPinRecovery = (
    postSupervisorPinRecoveryBody: PostSupervisorPinRecoveryBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostSupervisorPinRecovery200>(
      {url: `/supervisor/pin-recovery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSupervisorPinRecoveryBody
    },
      options);
    }
  


export const getPostSupervisorPinRecoveryMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorPinRecovery>>, TError,{data: PostSupervisorPinRecoveryBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSupervisorPinRecovery>>, TError,{data: PostSupervisorPinRecoveryBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupervisorPinRecovery>>, {data: PostSupervisorPinRecoveryBody}> = (props) => {
          const {data} = props ?? {};

          return  postSupervisorPinRecovery(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostSupervisorPinRecoveryMutationResult = NonNullable<Awaited<ReturnType<typeof postSupervisorPinRecovery>>>
    export type PostSupervisorPinRecoveryMutationBody = PostSupervisorPinRecoveryBody
    export type PostSupervisorPinRecoveryMutationError = ErrorType<string>

    export const usePostSupervisorPinRecovery = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorPinRecovery>>, TError,{data: PostSupervisorPinRecoveryBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostSupervisorPinRecoveryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Supervisor Report an issue with a nurse
 */
export const postSupervisorReportIssue = (
    postSupervisorReportIssueBody: PostSupervisorReportIssueBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostSupervisorReportIssue200>(
      {url: `/supervisor/report-issue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSupervisorReportIssueBody
    },
      options);
    }
  


export const getPostSupervisorReportIssueMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorReportIssue>>, TError,{data: PostSupervisorReportIssueBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSupervisorReportIssue>>, TError,{data: PostSupervisorReportIssueBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupervisorReportIssue>>, {data: PostSupervisorReportIssueBody}> = (props) => {
          const {data} = props ?? {};

          return  postSupervisorReportIssue(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostSupervisorReportIssueMutationResult = NonNullable<Awaited<ReturnType<typeof postSupervisorReportIssue>>>
    export type PostSupervisorReportIssueMutationBody = PostSupervisorReportIssueBody
    export type PostSupervisorReportIssueMutationError = ErrorType<string>

    export const usePostSupervisorReportIssue = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorReportIssue>>, TError,{data: PostSupervisorReportIssueBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostSupervisorReportIssueMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postSupervisorReportNoshow = (
    postSupervisorReportNoshowBody: PostSupervisorReportNoshowBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostSupervisorReportNoshow200>(
      {url: `/supervisor/report-noshow`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSupervisorReportNoshowBody
    },
      options);
    }
  


export const getPostSupervisorReportNoshowMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorReportNoshow>>, TError,{data: PostSupervisorReportNoshowBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSupervisorReportNoshow>>, TError,{data: PostSupervisorReportNoshowBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupervisorReportNoshow>>, {data: PostSupervisorReportNoshowBody}> = (props) => {
          const {data} = props ?? {};

          return  postSupervisorReportNoshow(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostSupervisorReportNoshowMutationResult = NonNullable<Awaited<ReturnType<typeof postSupervisorReportNoshow>>>
    export type PostSupervisorReportNoshowMutationBody = PostSupervisorReportNoshowBody
    export type PostSupervisorReportNoshowMutationError = ErrorType<string>

    export const usePostSupervisorReportNoshow = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupervisorReportNoshow>>, TError,{data: PostSupervisorReportNoshowBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostSupervisorReportNoshowMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putSupervisorSavetimesheet = (
    putSupervisorSavetimesheetBody: PutSupervisorSavetimesheetBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/supervisor/savetimesheet`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSupervisorSavetimesheetBody
    },
      options);
    }
  


export const getPutSupervisorSavetimesheetMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorSavetimesheet>>, TError,{data: PutSupervisorSavetimesheetBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSupervisorSavetimesheet>>, TError,{data: PutSupervisorSavetimesheetBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSupervisorSavetimesheet>>, {data: PutSupervisorSavetimesheetBody}> = (props) => {
          const {data} = props ?? {};

          return  putSupervisorSavetimesheet(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSupervisorSavetimesheetMutationResult = NonNullable<Awaited<ReturnType<typeof putSupervisorSavetimesheet>>>
    export type PutSupervisorSavetimesheetMutationBody = PutSupervisorSavetimesheetBody
    export type PutSupervisorSavetimesheetMutationError = ErrorType<string>

    export const usePutSupervisorSavetimesheet = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorSavetimesheet>>, TError,{data: PutSupervisorSavetimesheetBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSupervisorSavetimesheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getSupervisorSearch = (
    params: GetSupervisorSearchParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorSearch200>(
      {url: `/supervisor/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSupervisorSearchQueryKey = (params: GetSupervisorSearchParams,) => {
    return [`/supervisor/search`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupervisorSearchQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorSearch>>, TError = ErrorType<string>>(params: GetSupervisorSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorSearch>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorSearch>>> = ({ signal }) => getSupervisorSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorSearch>>>
export type GetSupervisorSearchQueryError = ErrorType<string>

export const useGetSupervisorSearch = <TData = Awaited<ReturnType<typeof getSupervisorSearch>>, TError = ErrorType<string>>(
 params: GetSupervisorSearchParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorSearch>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSupervisorShiftShiftid = (
    shiftid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorShiftShiftid200>(
      {url: `/supervisor/shift/${shiftid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSupervisorShiftShiftidQueryKey = (shiftid: number,) => {
    return [`/supervisor/shift/${shiftid}`] as const;
    }

    
export const getGetSupervisorShiftShiftidQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorShiftShiftid>>, TError = ErrorType<string>>(shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorShiftShiftidQueryKey(shiftid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorShiftShiftid>>> = ({ signal }) => getSupervisorShiftShiftid(shiftid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shiftid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftShiftid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorShiftShiftidQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorShiftShiftid>>>
export type GetSupervisorShiftShiftidQueryError = ErrorType<string>

export const useGetSupervisorShiftShiftid = <TData = Awaited<ReturnType<typeof getSupervisorShiftShiftid>>, TError = ErrorType<string>>(
 shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorShiftShiftidQueryOptions(shiftid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * For retrieving the 10 latest shifts when submitting a DNR or reporting an issue with a nurse.
 * @summary Shifts for DNR or Report an Issue
 */
export const getSupervisorShiftsForDnrOrIssue = (
    params: GetSupervisorShiftsForDnrOrIssueParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorShiftsForDnrOrIssue200Item[]>(
      {url: `/supervisor/shifts-for-dnr-or-issue`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSupervisorShiftsForDnrOrIssueQueryKey = (params: GetSupervisorShiftsForDnrOrIssueParams,) => {
    return [`/supervisor/shifts-for-dnr-or-issue`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupervisorShiftsForDnrOrIssueQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorShiftsForDnrOrIssue>>, TError = ErrorType<GetSupervisorShiftsForDnrOrIssue400 | string>>(params: GetSupervisorShiftsForDnrOrIssueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsForDnrOrIssue>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorShiftsForDnrOrIssueQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorShiftsForDnrOrIssue>>> = ({ signal }) => getSupervisorShiftsForDnrOrIssue(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsForDnrOrIssue>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorShiftsForDnrOrIssueQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorShiftsForDnrOrIssue>>>
export type GetSupervisorShiftsForDnrOrIssueQueryError = ErrorType<GetSupervisorShiftsForDnrOrIssue400 | string>

/**
 * @summary Shifts for DNR or Report an Issue
 */
export const useGetSupervisorShiftsForDnrOrIssue = <TData = Awaited<ReturnType<typeof getSupervisorShiftsForDnrOrIssue>>, TError = ErrorType<GetSupervisorShiftsForDnrOrIssue400 | string>>(
 params: GetSupervisorShiftsForDnrOrIssueParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsForDnrOrIssue>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorShiftsForDnrOrIssueQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSupervisorShiftsBydate = (
    params?: GetSupervisorShiftsBydateParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorShiftsBydate200Item[]>(
      {url: `/supervisor/shifts/bydate`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSupervisorShiftsBydateQueryKey = (params?: GetSupervisorShiftsBydateParams,) => {
    return [`/supervisor/shifts/bydate`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupervisorShiftsBydateQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorShiftsBydate>>, TError = ErrorType<string>>(params?: GetSupervisorShiftsBydateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsBydate>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorShiftsBydateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorShiftsBydate>>> = ({ signal }) => getSupervisorShiftsBydate(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsBydate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorShiftsBydateQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorShiftsBydate>>>
export type GetSupervisorShiftsBydateQueryError = ErrorType<string>

export const useGetSupervisorShiftsBydate = <TData = Awaited<ReturnType<typeof getSupervisorShiftsBydate>>, TError = ErrorType<string>>(
 params?: GetSupervisorShiftsBydateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsBydate>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorShiftsBydateQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * For retrieving shift statuses for the next 60 days to display in the Supervisor calendar
 */
export const getSupervisorShiftsCalendar = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorShiftsCalendar200>(
      {url: `/supervisor/shifts/calendar`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSupervisorShiftsCalendarQueryKey = () => {
    return [`/supervisor/shifts/calendar`] as const;
    }

    
export const getGetSupervisorShiftsCalendarQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorShiftsCalendar>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsCalendar>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorShiftsCalendarQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorShiftsCalendar>>> = ({ signal }) => getSupervisorShiftsCalendar(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsCalendar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorShiftsCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorShiftsCalendar>>>
export type GetSupervisorShiftsCalendarQueryError = ErrorType<string>

export const useGetSupervisorShiftsCalendar = <TData = Awaited<ReturnType<typeof getSupervisorShiftsCalendar>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsCalendar>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorShiftsCalendarQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSupervisorShiftsQuickActions = (
    params?: GetSupervisorShiftsQuickActionsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorShiftsQuickActions200Item[]>(
      {url: `/supervisor/shifts/quick-actions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSupervisorShiftsQuickActionsQueryKey = (params?: GetSupervisorShiftsQuickActionsParams,) => {
    return [`/supervisor/shifts/quick-actions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupervisorShiftsQuickActionsQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorShiftsQuickActions>>, TError = ErrorType<string>>(params?: GetSupervisorShiftsQuickActionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsQuickActions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorShiftsQuickActionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorShiftsQuickActions>>> = ({ signal }) => getSupervisorShiftsQuickActions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsQuickActions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorShiftsQuickActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorShiftsQuickActions>>>
export type GetSupervisorShiftsQuickActionsQueryError = ErrorType<string>

export const useGetSupervisorShiftsQuickActions = <TData = Awaited<ReturnType<typeof getSupervisorShiftsQuickActions>>, TError = ErrorType<string>>(
 params?: GetSupervisorShiftsQuickActionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorShiftsQuickActions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorShiftsQuickActionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSupervisorTimesheets = (
    params?: GetSupervisorTimesheetsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorTimesheets200>(
      {url: `/supervisor/timesheets`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSupervisorTimesheetsQueryKey = (params?: GetSupervisorTimesheetsParams,) => {
    return [`/supervisor/timesheets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupervisorTimesheetsQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorTimesheets>>, TError = ErrorType<string>>(params?: GetSupervisorTimesheetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheets>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorTimesheetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorTimesheets>>> = ({ signal }) => getSupervisorTimesheets(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorTimesheetsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorTimesheets>>>
export type GetSupervisorTimesheetsQueryError = ErrorType<string>

export const useGetSupervisorTimesheets = <TData = Awaited<ReturnType<typeof getSupervisorTimesheets>>, TError = ErrorType<string>>(
 params?: GetSupervisorTimesheetsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheets>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorTimesheetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Allow supervisors to check clinicians out of a shift (or double shift) and approve the timesheet(s)
 */
export const putSupervisorTimesheetsCheckout = (
    putSupervisorTimesheetsCheckoutBody: PutSupervisorTimesheetsCheckoutBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/supervisor/timesheets/checkout`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSupervisorTimesheetsCheckoutBody
    },
      options);
    }
  


export const getPutSupervisorTimesheetsCheckoutMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorTimesheetsCheckout>>, TError,{data: PutSupervisorTimesheetsCheckoutBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSupervisorTimesheetsCheckout>>, TError,{data: PutSupervisorTimesheetsCheckoutBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSupervisorTimesheetsCheckout>>, {data: PutSupervisorTimesheetsCheckoutBody}> = (props) => {
          const {data} = props ?? {};

          return  putSupervisorTimesheetsCheckout(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSupervisorTimesheetsCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof putSupervisorTimesheetsCheckout>>>
    export type PutSupervisorTimesheetsCheckoutMutationBody = PutSupervisorTimesheetsCheckoutBody
    export type PutSupervisorTimesheetsCheckoutMutationError = ErrorType<string>

    export const usePutSupervisorTimesheetsCheckout = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorTimesheetsCheckout>>, TError,{data: PutSupervisorTimesheetsCheckoutBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSupervisorTimesheetsCheckoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getSupervisorTimesheetsCount = (
    params?: GetSupervisorTimesheetsCountParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupervisorTimesheetsCount200>(
      {url: `/supervisor/timesheets/count`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSupervisorTimesheetsCountQueryKey = (params?: GetSupervisorTimesheetsCountParams,) => {
    return [`/supervisor/timesheets/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupervisorTimesheetsCountQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorTimesheetsCount>>, TError = ErrorType<string>>(params?: GetSupervisorTimesheetsCountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheetsCount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorTimesheetsCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorTimesheetsCount>>> = ({ signal }) => getSupervisorTimesheetsCount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheetsCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorTimesheetsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorTimesheetsCount>>>
export type GetSupervisorTimesheetsCountQueryError = ErrorType<string>

export const useGetSupervisorTimesheetsCount = <TData = Awaited<ReturnType<typeof getSupervisorTimesheetsCount>>, TError = ErrorType<string>>(
 params?: GetSupervisorTimesheetsCountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheetsCount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorTimesheetsCountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSupervisorTimesheetsDownload = (
    params?: GetSupervisorTimesheetsDownloadParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Blob>(
      {url: `/supervisor/timesheets/download`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetSupervisorTimesheetsDownloadQueryKey = (params?: GetSupervisorTimesheetsDownloadParams,) => {
    return [`/supervisor/timesheets/download`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupervisorTimesheetsDownloadQueryOptions = <TData = Awaited<ReturnType<typeof getSupervisorTimesheetsDownload>>, TError = ErrorType<string>>(params?: GetSupervisorTimesheetsDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheetsDownload>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupervisorTimesheetsDownloadQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorTimesheetsDownload>>> = ({ signal }) => getSupervisorTimesheetsDownload(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheetsDownload>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupervisorTimesheetsDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorTimesheetsDownload>>>
export type GetSupervisorTimesheetsDownloadQueryError = ErrorType<string>

export const useGetSupervisorTimesheetsDownload = <TData = Awaited<ReturnType<typeof getSupervisorTimesheetsDownload>>, TError = ErrorType<string>>(
 params?: GetSupervisorTimesheetsDownloadParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupervisorTimesheetsDownload>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupervisorTimesheetsDownloadQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putSupervisorUpdatesecuritycode = (
    putSupervisorUpdatesecuritycodeBody: PutSupervisorUpdatesecuritycodeBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/supervisor/updatesecuritycode`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSupervisorUpdatesecuritycodeBody
    },
      options);
    }
  


export const getPutSupervisorUpdatesecuritycodeMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorUpdatesecuritycode>>, TError,{data: PutSupervisorUpdatesecuritycodeBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putSupervisorUpdatesecuritycode>>, TError,{data: PutSupervisorUpdatesecuritycodeBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSupervisorUpdatesecuritycode>>, {data: PutSupervisorUpdatesecuritycodeBody}> = (props) => {
          const {data} = props ?? {};

          return  putSupervisorUpdatesecuritycode(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutSupervisorUpdatesecuritycodeMutationResult = NonNullable<Awaited<ReturnType<typeof putSupervisorUpdatesecuritycode>>>
    export type PutSupervisorUpdatesecuritycodeMutationBody = PutSupervisorUpdatesecuritycodeBody
    export type PutSupervisorUpdatesecuritycodeMutationError = ErrorType<string>

    export const usePutSupervisorUpdatesecuritycode = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSupervisorUpdatesecuritycode>>, TError,{data: PutSupervisorUpdatesecuritycodeBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutSupervisorUpdatesecuritycodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Creates a new support case
 */
export const postSupportCases = (
    postSupportCasesBody: PostSupportCasesBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostSupportCases200>(
      {url: `/support/cases`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSupportCasesBody
    },
      options);
    }
  


export const getPostSupportCasesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupportCases>>, TError,{data: PostSupportCasesBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSupportCases>>, TError,{data: PostSupportCasesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupportCases>>, {data: PostSupportCasesBody}> = (props) => {
          const {data} = props ?? {};

          return  postSupportCases(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostSupportCasesMutationResult = NonNullable<Awaited<ReturnType<typeof postSupportCases>>>
    export type PostSupportCasesMutationBody = PostSupportCasesBody
    export type PostSupportCasesMutationError = ErrorType<string>

    export const usePostSupportCases = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupportCases>>, TError,{data: PostSupportCasesBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostSupportCasesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Retrieves all support subtopics for the user
 */
export const getSupportSubtopics = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupportSubtopics200Item[]>(
      {url: `/support/subtopics`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSupportSubtopicsQueryKey = () => {
    return [`/support/subtopics`] as const;
    }

    
export const getGetSupportSubtopicsQueryOptions = <TData = Awaited<ReturnType<typeof getSupportSubtopics>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportSubtopics>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportSubtopicsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportSubtopics>>> = ({ signal }) => getSupportSubtopics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportSubtopics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupportSubtopicsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportSubtopics>>>
export type GetSupportSubtopicsQueryError = ErrorType<string>

export const useGetSupportSubtopics = <TData = Awaited<ReturnType<typeof getSupportSubtopics>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportSubtopics>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupportSubtopicsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves all support topics for the user
 */
export const getSupportTopics = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSupportTopics200Item[]>(
      {url: `/support/topics`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSupportTopicsQueryKey = () => {
    return [`/support/topics`] as const;
    }

    
export const getGetSupportTopicsQueryOptions = <TData = Awaited<ReturnType<typeof getSupportTopics>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportTopics>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportTopicsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportTopics>>> = ({ signal }) => getSupportTopics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportTopics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupportTopicsQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportTopics>>>
export type GetSupportTopicsQueryError = ErrorType<string>

export const useGetSupportTopics = <TData = Awaited<ReturnType<typeof getSupportTopics>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportTopics>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupportTopicsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSurveysIdQuestions = (
    id: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetSurveysIdQuestions200>(
      {url: `/surveys/${id}/questions`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSurveysIdQuestionsQueryKey = (id: string,) => {
    return [`/surveys/${id}/questions`] as const;
    }

    
export const getGetSurveysIdQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof getSurveysIdQuestions>>, TError = ErrorType<string | GetSurveysIdQuestions404 | GetSurveysIdQuestions500>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSurveysIdQuestions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveysIdQuestionsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveysIdQuestions>>> = ({ signal }) => getSurveysIdQuestions(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveysIdQuestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSurveysIdQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveysIdQuestions>>>
export type GetSurveysIdQuestionsQueryError = ErrorType<string | GetSurveysIdQuestions404 | GetSurveysIdQuestions500>

export const useGetSurveysIdQuestions = <TData = Awaited<ReturnType<typeof getSurveysIdQuestions>>, TError = ErrorType<string | GetSurveysIdQuestions404 | GetSurveysIdQuestions500>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSurveysIdQuestions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSurveysIdQuestionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postSurveysIdResponses = (
    id: string,
    postSurveysIdResponsesBodyItem: PostSurveysIdResponsesBodyItem[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostSurveysIdResponses200>(
      {url: `/surveys/${id}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSurveysIdResponsesBodyItem
    },
      options);
    }
  


export const getPostSurveysIdResponsesMutationOptions = <TError = ErrorType<PostSurveysIdResponses400 | string | PostSurveysIdResponses404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveysIdResponses>>, TError,{id: string;data: PostSurveysIdResponsesBodyItem[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveysIdResponses>>, TError,{id: string;data: PostSurveysIdResponsesBodyItem[]}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveysIdResponses>>, {id: string;data: PostSurveysIdResponsesBodyItem[]}> = (props) => {
          const {id,data} = props ?? {};

          return  postSurveysIdResponses(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostSurveysIdResponsesMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveysIdResponses>>>
    export type PostSurveysIdResponsesMutationBody = PostSurveysIdResponsesBodyItem[]
    export type PostSurveysIdResponsesMutationError = ErrorType<PostSurveysIdResponses400 | string | PostSurveysIdResponses404>

    export const usePostSurveysIdResponses = <TError = ErrorType<PostSurveysIdResponses400 | string | PostSurveysIdResponses404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveysIdResponses>>, TError,{id: string;data: PostSurveysIdResponsesBodyItem[]}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostSurveysIdResponsesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns Task types
 */
export const getTaskTypes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetTaskTypes200Item[]>(
      {url: `/task-types`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTaskTypesQueryKey = () => {
    return [`/task-types`] as const;
    }

    
export const getGetTaskTypesQueryOptions = <TData = Awaited<ReturnType<typeof getTaskTypes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskTypes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskTypes>>> = ({ signal }) => getTaskTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskTypes>>>
export type GetTaskTypesQueryError = ErrorType<string>

export const useGetTaskTypes = <TData = Awaited<ReturnType<typeof getTaskTypes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskTypes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTaskTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Health check
 */
export const getTest = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetTest200>(
      {url: `/test`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTestQueryKey = () => {
    return [`/test`] as const;
    }

    
export const getGetTestQueryOptions = <TData = Awaited<ReturnType<typeof getTest>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTest>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTest>>> = ({ signal }) => getTest(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTestQueryResult = NonNullable<Awaited<ReturnType<typeof getTest>>>
export type GetTestQueryError = ErrorType<string>

export const useGetTest = <TData = Awaited<ReturnType<typeof getTest>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTest>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTestQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Saves the adjusted time of a user timesheet
 */
export const postTimesheetAdjustedTime = (
    postTimesheetAdjustedTimeBody: PostTimesheetAdjustedTimeBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/timesheet/adjusted-time`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTimesheetAdjustedTimeBody
    },
      options);
    }
  


export const getPostTimesheetAdjustedTimeMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTimesheetAdjustedTime>>, TError,{data: PostTimesheetAdjustedTimeBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTimesheetAdjustedTime>>, TError,{data: PostTimesheetAdjustedTimeBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTimesheetAdjustedTime>>, {data: PostTimesheetAdjustedTimeBody}> = (props) => {
          const {data} = props ?? {};

          return  postTimesheetAdjustedTime(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostTimesheetAdjustedTimeMutationResult = NonNullable<Awaited<ReturnType<typeof postTimesheetAdjustedTime>>>
    export type PostTimesheetAdjustedTimeMutationBody = PostTimesheetAdjustedTimeBody
    export type PostTimesheetAdjustedTimeMutationError = ErrorType<string>

    export const usePostTimesheetAdjustedTime = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTimesheetAdjustedTime>>, TError,{data: PostTimesheetAdjustedTimeBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostTimesheetAdjustedTimeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchTimesheetsId = (
    id: number,
    patchTimesheetsIdBody: PatchTimesheetsIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/timesheets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTimesheetsIdBody
    },
      options);
    }
  


export const getPatchTimesheetsIdMutationOptions = <TError = ErrorType<PatchTimesheetsId400 | PatchTimesheetsId401 | PatchTimesheetsId500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsId>>, TError,{id: number;data: PatchTimesheetsIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsId>>, TError,{id: number;data: PatchTimesheetsIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTimesheetsId>>, {id: number;data: PatchTimesheetsIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTimesheetsId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PatchTimesheetsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchTimesheetsId>>>
    export type PatchTimesheetsIdMutationBody = PatchTimesheetsIdBody
    export type PatchTimesheetsIdMutationError = ErrorType<PatchTimesheetsId400 | PatchTimesheetsId401 | PatchTimesheetsId500>

    export const usePatchTimesheetsId = <TError = ErrorType<PatchTimesheetsId400 | PatchTimesheetsId401 | PatchTimesheetsId500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsId>>, TError,{id: number;data: PatchTimesheetsIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPatchTimesheetsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get a requirement to schedule
 */
export const getToscheduleRequirementId = (
    id: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetToscheduleRequirementId200>(
      {url: `/toschedule/requirement/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetToscheduleRequirementIdQueryKey = (id: number,) => {
    return [`/toschedule/requirement/${id}`] as const;
    }

    
export const getGetToscheduleRequirementIdQueryOptions = <TData = Awaited<ReturnType<typeof getToscheduleRequirementId>>, TError = ErrorType<string>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getToscheduleRequirementId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetToscheduleRequirementIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getToscheduleRequirementId>>> = ({ signal }) => getToscheduleRequirementId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getToscheduleRequirementId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetToscheduleRequirementIdQueryResult = NonNullable<Awaited<ReturnType<typeof getToscheduleRequirementId>>>
export type GetToscheduleRequirementIdQueryError = ErrorType<string>

export const useGetToscheduleRequirementId = <TData = Awaited<ReturnType<typeof getToscheduleRequirementId>>, TError = ErrorType<string>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getToscheduleRequirementId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetToscheduleRequirementIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetDefaultPreferences = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserGetDefaultPreferences200>(
      {url: `/user/GetDefaultPreferences`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserGetDefaultPreferencesQueryKey = () => {
    return [`/user/GetDefaultPreferences`] as const;
    }

    
export const getGetUserGetDefaultPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetDefaultPreferences>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetDefaultPreferences>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetDefaultPreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetDefaultPreferences>>> = ({ signal }) => getUserGetDefaultPreferences(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetDefaultPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetDefaultPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetDefaultPreferences>>>
export type GetUserGetDefaultPreferencesQueryError = ErrorType<string>

export const useGetUserGetDefaultPreferences = <TData = Awaited<ReturnType<typeof getUserGetDefaultPreferences>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetDefaultPreferences>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetDefaultPreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetPreferences = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserGetPreferences200>(
      {url: `/user/GetPreferences`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserGetPreferencesQueryKey = () => {
    return [`/user/GetPreferences`] as const;
    }

    
export const getGetUserGetPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetPreferences>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetPreferences>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetPreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetPreferences>>> = ({ signal }) => getUserGetPreferences(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetPreferences>>>
export type GetUserGetPreferencesQueryError = ErrorType<string>

export const useGetUserGetPreferences = <TData = Awaited<ReturnType<typeof getUserGetPreferences>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetPreferences>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetPreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUserSetPreferences = (
    postUserSetPreferencesBody: PostUserSetPreferencesBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/SetPreferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserSetPreferencesBody
    },
      options);
    }
  


export const getPostUserSetPreferencesMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSetPreferences>>, TError,{data: PostUserSetPreferencesBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserSetPreferences>>, TError,{data: PostUserSetPreferencesBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserSetPreferences>>, {data: PostUserSetPreferencesBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserSetPreferences(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserSetPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof postUserSetPreferences>>>
    export type PostUserSetPreferencesMutationBody = PostUserSetPreferencesBody
    export type PostUserSetPreferencesMutationError = ErrorType<string>

    export const usePostUserSetPreferences = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSetPreferences>>, TError,{data: PostUserSetPreferencesBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserSetPreferencesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserAcceptshiftapplicant = (
    postUserAcceptshiftapplicantBody: PostUserAcceptshiftapplicantBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUserAcceptshiftapplicant200>(
      {url: `/user/acceptshiftapplicant`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserAcceptshiftapplicantBody
    },
      options);
    }
  


export const getPostUserAcceptshiftapplicantMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAcceptshiftapplicant>>, TError,{data: PostUserAcceptshiftapplicantBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserAcceptshiftapplicant>>, TError,{data: PostUserAcceptshiftapplicantBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserAcceptshiftapplicant>>, {data: PostUserAcceptshiftapplicantBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserAcceptshiftapplicant(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserAcceptshiftapplicantMutationResult = NonNullable<Awaited<ReturnType<typeof postUserAcceptshiftapplicant>>>
    export type PostUserAcceptshiftapplicantMutationBody = PostUserAcceptshiftapplicantBody
    export type PostUserAcceptshiftapplicantMutationError = ErrorType<string>

    export const usePostUserAcceptshiftapplicant = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAcceptshiftapplicant>>, TError,{data: PostUserAcceptshiftapplicantBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserAcceptshiftapplicantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Sets User status to Inactive with reject reason of Account Deleted
 */
export const postUserAccountDelete = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/account-delete`, method: 'POST'
    },
      options);
    }
  


export const getPostUserAccountDeleteMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAccountDelete>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserAccountDelete>>, TError,void, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserAccountDelete>>, void> = () => {
          

          return  postUserAccountDelete(requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserAccountDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postUserAccountDelete>>>
    
    export type PostUserAccountDeleteMutationError = ErrorType<string>

    export const usePostUserAccountDelete = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAccountDelete>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserAccountDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserAdminDownloadshiftlist = (
    params?: GetUserAdminDownloadshiftlistParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Blob>(
      {url: `/user/admin/downloadshiftlist`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetUserAdminDownloadshiftlistQueryKey = (params?: GetUserAdminDownloadshiftlistParams,) => {
    return [`/user/admin/downloadshiftlist`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserAdminDownloadshiftlistQueryOptions = <TData = Awaited<ReturnType<typeof getUserAdminDownloadshiftlist>>, TError = ErrorType<string>>(params?: GetUserAdminDownloadshiftlistParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAdminDownloadshiftlist>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAdminDownloadshiftlistQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAdminDownloadshiftlist>>> = ({ signal }) => getUserAdminDownloadshiftlist(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAdminDownloadshiftlist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserAdminDownloadshiftlistQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAdminDownloadshiftlist>>>
export type GetUserAdminDownloadshiftlistQueryError = ErrorType<string>

export const useGetUserAdminDownloadshiftlist = <TData = Awaited<ReturnType<typeof getUserAdminDownloadshiftlist>>, TError = ErrorType<string>>(
 params?: GetUserAdminDownloadshiftlistParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAdminDownloadshiftlist>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserAdminDownloadshiftlistQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserAdminShiftlist = (
    params: GetUserAdminShiftlistParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserAdminShiftlist200>(
      {url: `/user/admin/shiftlist`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserAdminShiftlistQueryKey = (params: GetUserAdminShiftlistParams,) => {
    return [`/user/admin/shiftlist`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserAdminShiftlistQueryOptions = <TData = Awaited<ReturnType<typeof getUserAdminShiftlist>>, TError = ErrorType<string>>(params: GetUserAdminShiftlistParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAdminShiftlist>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAdminShiftlistQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAdminShiftlist>>> = ({ signal }) => getUserAdminShiftlist(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAdminShiftlist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserAdminShiftlistQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAdminShiftlist>>>
export type GetUserAdminShiftlistQueryError = ErrorType<string>

export const useGetUserAdminShiftlist = <TData = Awaited<ReturnType<typeof getUserAdminShiftlist>>, TError = ErrorType<string>>(
 params: GetUserAdminShiftlistParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAdminShiftlist>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserAdminShiftlistQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a user in auth0 for authentication purposes
 */
export const postUserAuth0 = (
    postUserAuth0Body: PostUserAuth0Body,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/auth0`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserAuth0Body
    },
      options);
    }
  


export const getPostUserAuth0MutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAuth0>>, TError,{data: PostUserAuth0Body}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserAuth0>>, TError,{data: PostUserAuth0Body}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserAuth0>>, {data: PostUserAuth0Body}> = (props) => {
          const {data} = props ?? {};

          return  postUserAuth0(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserAuth0MutationResult = NonNullable<Awaited<ReturnType<typeof postUserAuth0>>>
    export type PostUserAuth0MutationBody = PostUserAuth0Body
    export type PostUserAuth0MutationError = ErrorType<string>

    export const usePostUserAuth0 = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAuth0>>, TError,{data: PostUserAuth0Body}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserAuth0MutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch ShiftDetails for Backfill Shifts
 */
export const getUserBackfillShiftsShiftid = (
    shiftid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserBackfillShiftsShiftid200>(
      {url: `/user/backfill-shifts/${shiftid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserBackfillShiftsShiftidQueryKey = (shiftid: number,) => {
    return [`/user/backfill-shifts/${shiftid}`] as const;
    }

    
export const getGetUserBackfillShiftsShiftidQueryOptions = <TData = Awaited<ReturnType<typeof getUserBackfillShiftsShiftid>>, TError = ErrorType<string>>(shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserBackfillShiftsShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBackfillShiftsShiftidQueryKey(shiftid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBackfillShiftsShiftid>>> = ({ signal }) => getUserBackfillShiftsShiftid(shiftid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shiftid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBackfillShiftsShiftid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserBackfillShiftsShiftidQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBackfillShiftsShiftid>>>
export type GetUserBackfillShiftsShiftidQueryError = ErrorType<string>

export const useGetUserBackfillShiftsShiftid = <TData = Awaited<ReturnType<typeof getUserBackfillShiftsShiftid>>, TError = ErrorType<string>>(
 shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserBackfillShiftsShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserBackfillShiftsShiftidQueryOptions(shiftid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get nurse details for slider
 */
export const getUserBasicnurseinfo = (
    params: GetUserBasicnurseinfoParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserBasicnurseinfo200>(
      {url: `/user/basicnurseinfo`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserBasicnurseinfoQueryKey = (params: GetUserBasicnurseinfoParams,) => {
    return [`/user/basicnurseinfo`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserBasicnurseinfoQueryOptions = <TData = Awaited<ReturnType<typeof getUserBasicnurseinfo>>, TError = ErrorType<string>>(params: GetUserBasicnurseinfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserBasicnurseinfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBasicnurseinfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBasicnurseinfo>>> = ({ signal }) => getUserBasicnurseinfo(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBasicnurseinfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserBasicnurseinfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBasicnurseinfo>>>
export type GetUserBasicnurseinfoQueryError = ErrorType<string>

export const useGetUserBasicnurseinfo = <TData = Awaited<ReturnType<typeof getUserBasicnurseinfo>>, TError = ErrorType<string>>(
 params: GetUserBasicnurseinfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserBasicnurseinfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserBasicnurseinfoQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update Beat Admin feature
 * @summary Update Beat Admin user feature
 */
export const putUserBeatAdmin = (
    putUserBeatAdminBody: PutUserBeatAdminBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/beat_admin`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserBeatAdminBody
    },
      options);
    }
  


export const getPutUserBeatAdminMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserBeatAdmin>>, TError,{data: PutUserBeatAdminBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserBeatAdmin>>, TError,{data: PutUserBeatAdminBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserBeatAdmin>>, {data: PutUserBeatAdminBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserBeatAdmin(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserBeatAdminMutationResult = NonNullable<Awaited<ReturnType<typeof putUserBeatAdmin>>>
    export type PutUserBeatAdminMutationBody = PutUserBeatAdminBody
    export type PutUserBeatAdminMutationError = ErrorType<string>

    /**
 * @summary Update Beat Admin user feature
 */
export const usePutUserBeatAdmin = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserBeatAdmin>>, TError,{data: PutUserBeatAdminBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserBeatAdminMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update Beat Jewel feature
 * @summary Update Beat Jewel user feature
 */
export const putUserBeatJewel = (
    putUserBeatJewelBody: PutUserBeatJewelBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/beat_jewel`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserBeatJewelBody
    },
      options);
    }
  


export const getPutUserBeatJewelMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserBeatJewel>>, TError,{data: PutUserBeatJewelBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserBeatJewel>>, TError,{data: PutUserBeatJewelBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserBeatJewel>>, {data: PutUserBeatJewelBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserBeatJewel(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserBeatJewelMutationResult = NonNullable<Awaited<ReturnType<typeof putUserBeatJewel>>>
    export type PutUserBeatJewelMutationBody = PutUserBeatJewelBody
    export type PutUserBeatJewelMutationError = ErrorType<string>

    /**
 * @summary Update Beat Jewel user feature
 */
export const usePutUserBeatJewel = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserBeatJewel>>, TError,{data: PutUserBeatJewelBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserBeatJewelMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch Nurse Call Out Shifts
 */
export const getUserCallouts = (
    params?: GetUserCalloutsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserCallouts200>(
      {url: `/user/callouts`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserCalloutsQueryKey = (params?: GetUserCalloutsParams,) => {
    return [`/user/callouts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserCalloutsQueryOptions = <TData = Awaited<ReturnType<typeof getUserCallouts>>, TError = ErrorType<string>>(params?: GetUserCalloutsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserCallouts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserCalloutsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserCallouts>>> = ({ signal }) => getUserCallouts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserCallouts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserCalloutsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserCallouts>>>
export type GetUserCalloutsQueryError = ErrorType<string>

export const useGetUserCallouts = <TData = Awaited<ReturnType<typeof getUserCallouts>>, TError = ErrorType<string>>(
 params?: GetUserCalloutsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserCallouts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserCalloutsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putUserCancelshift = (
    putUserCancelshiftBody: PutUserCancelshiftBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string>(
      {url: `/user/cancelshift`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserCancelshiftBody
    },
      options);
    }
  


export const getPutUserCancelshiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserCancelshift>>, TError,{data: PutUserCancelshiftBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserCancelshift>>, TError,{data: PutUserCancelshiftBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserCancelshift>>, {data: PutUserCancelshiftBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserCancelshift(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserCancelshiftMutationResult = NonNullable<Awaited<ReturnType<typeof putUserCancelshift>>>
    export type PutUserCancelshiftMutationBody = PutUserCancelshiftBody
    export type PutUserCancelshiftMutationError = ErrorType<unknown>

    export const usePutUserCancelshift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserCancelshift>>, TError,{data: PutUserCancelshiftBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserCancelshiftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserCheckbacktoback = (
    postUserCheckbacktobackBody: PostUserCheckbacktobackBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUserCheckbacktoback200>(
      {url: `/user/checkbacktoback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserCheckbacktobackBody
    },
      options);
    }
  


export const getPostUserCheckbacktobackMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserCheckbacktoback>>, TError,{data: PostUserCheckbacktobackBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserCheckbacktoback>>, TError,{data: PostUserCheckbacktobackBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserCheckbacktoback>>, {data: PostUserCheckbacktobackBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserCheckbacktoback(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserCheckbacktobackMutationResult = NonNullable<Awaited<ReturnType<typeof postUserCheckbacktoback>>>
    export type PostUserCheckbacktobackMutationBody = PostUserCheckbacktobackBody
    export type PostUserCheckbacktobackMutationError = ErrorType<string>

    export const usePostUserCheckbacktoback = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserCheckbacktoback>>, TError,{data: PostUserCheckbacktobackBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserCheckbacktobackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Check and return possible double shift
 */
export const getUserDoubleCheckShiftid = (
    shiftid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserDoubleCheckShiftid200>(
      {url: `/user/doubleCheck/${shiftid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserDoubleCheckShiftidQueryKey = (shiftid: number,) => {
    return [`/user/doubleCheck/${shiftid}`] as const;
    }

    
export const getGetUserDoubleCheckShiftidQueryOptions = <TData = Awaited<ReturnType<typeof getUserDoubleCheckShiftid>>, TError = ErrorType<string>>(shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserDoubleCheckShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDoubleCheckShiftidQueryKey(shiftid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDoubleCheckShiftid>>> = ({ signal }) => getUserDoubleCheckShiftid(shiftid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shiftid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserDoubleCheckShiftid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserDoubleCheckShiftidQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDoubleCheckShiftid>>>
export type GetUserDoubleCheckShiftidQueryError = ErrorType<string>

export const useGetUserDoubleCheckShiftid = <TData = Awaited<ReturnType<typeof getUserDoubleCheckShiftid>>, TError = ErrorType<string>>(
 shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserDoubleCheckShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserDoubleCheckShiftidQueryOptions(shiftid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update feature
 * @summary Update user feature
 */
export const putUserFeatureName = (
    putUserFeatureNameBody: PutUserFeatureNameBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/feature_name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserFeatureNameBody
    },
      options);
    }
  


export const getPutUserFeatureNameMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserFeatureName>>, TError,{data: PutUserFeatureNameBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserFeatureName>>, TError,{data: PutUserFeatureNameBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserFeatureName>>, {data: PutUserFeatureNameBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserFeatureName(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserFeatureNameMutationResult = NonNullable<Awaited<ReturnType<typeof putUserFeatureName>>>
    export type PutUserFeatureNameMutationBody = PutUserFeatureNameBody
    export type PutUserFeatureNameMutationError = ErrorType<string>

    /**
 * @summary Update user feature
 */
export const usePutUserFeatureName = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserFeatureName>>, TError,{data: PutUserFeatureNameBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserFeatureNameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns user feature (get or create)
 * @summary User feature
 */
export const postUserFeaturesId = (
    id: number,
    postUserFeaturesIdBody: PostUserFeaturesIdBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUserFeaturesId200>(
      {url: `/user/features/${id}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserFeaturesIdBody
    },
      options);
    }
  


export const getPostUserFeaturesIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFeaturesId>>, TError,{id: number;data: PostUserFeaturesIdBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserFeaturesId>>, TError,{id: number;data: PostUserFeaturesIdBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFeaturesId>>, {id: number;data: PostUserFeaturesIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postUserFeaturesId(id,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserFeaturesIdMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFeaturesId>>>
    export type PostUserFeaturesIdMutationBody = PostUserFeaturesIdBody
    export type PostUserFeaturesIdMutationError = ErrorType<string>

    /**
 * @summary User feature
 */
export const usePostUserFeaturesId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFeaturesId>>, TError,{id: number;data: PostUserFeaturesIdBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserFeaturesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserForgotPasswordVerify = (
    postUserForgotPasswordVerifyBody: PostUserForgotPasswordVerifyBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/forgot-password/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserForgotPasswordVerifyBody
    },
      options);
    }
  


export const getPostUserForgotPasswordVerifyMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserForgotPasswordVerify>>, TError,{data: PostUserForgotPasswordVerifyBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserForgotPasswordVerify>>, TError,{data: PostUserForgotPasswordVerifyBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserForgotPasswordVerify>>, {data: PostUserForgotPasswordVerifyBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserForgotPasswordVerify(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserForgotPasswordVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof postUserForgotPasswordVerify>>>
    export type PostUserForgotPasswordVerifyMutationBody = PostUserForgotPasswordVerifyBody
    export type PostUserForgotPasswordVerifyMutationError = ErrorType<string>

    export const usePostUserForgotPasswordVerify = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserForgotPasswordVerify>>, TError,{data: PostUserForgotPasswordVerifyBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserForgotPasswordVerifyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserForgotpassword = (
    postUserForgotpasswordBody: PostUserForgotpasswordBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/forgotpassword`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserForgotpasswordBody
    },
      options);
    }
  


export const getPostUserForgotpasswordMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserForgotpassword>>, TError,{data: PostUserForgotpasswordBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserForgotpassword>>, TError,{data: PostUserForgotpasswordBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserForgotpassword>>, {data: PostUserForgotpasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserForgotpassword(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserForgotpasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postUserForgotpassword>>>
    export type PostUserForgotpasswordMutationBody = PostUserForgotpasswordBody
    export type PostUserForgotpasswordMutationError = ErrorType<string>

    export const usePostUserForgotpassword = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserForgotpassword>>, TError,{data: PostUserForgotpasswordBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserForgotpasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * check if exist an user with the email, if not, check fountain applicant and return the funnel statuses
 */
export const postUserFountainEmailValidation = (
    postUserFountainEmailValidationBody: PostUserFountainEmailValidationBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUserFountainEmailValidation200>(
      {url: `/user/fountain-email-validation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserFountainEmailValidationBody
    },
      options);
    }
  


export const getPostUserFountainEmailValidationMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFountainEmailValidation>>, TError,{data: PostUserFountainEmailValidationBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserFountainEmailValidation>>, TError,{data: PostUserFountainEmailValidationBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFountainEmailValidation>>, {data: PostUserFountainEmailValidationBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserFountainEmailValidation(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserFountainEmailValidationMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFountainEmailValidation>>>
    export type PostUserFountainEmailValidationMutationBody = PostUserFountainEmailValidationBody
    export type PostUserFountainEmailValidationMutationError = ErrorType<string>

    export const usePostUserFountainEmailValidation = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFountainEmailValidation>>, TError,{data: PostUserFountainEmailValidationBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserFountainEmailValidationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Capture fountain user stage Transition
 */
export const postUserFountainStageTransition = (
    postUserFountainStageTransitionBody: PostUserFountainStageTransitionBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/fountain-stage-transition`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserFountainStageTransitionBody
    },
      options);
    }
  


export const getPostUserFountainStageTransitionMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFountainStageTransition>>, TError,{data: PostUserFountainStageTransitionBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserFountainStageTransition>>, TError,{data: PostUserFountainStageTransitionBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFountainStageTransition>>, {data: PostUserFountainStageTransitionBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserFountainStageTransition(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserFountainStageTransitionMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFountainStageTransition>>>
    export type PostUserFountainStageTransitionMutationBody = PostUserFountainStageTransitionBody
    export type PostUserFountainStageTransitionMutationError = ErrorType<string>

    export const usePostUserFountainStageTransition = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFountainStageTransition>>, TError,{data: PostUserFountainStageTransitionBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserFountainStageTransitionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * generate links and send email for each fountain application recieved
 */
export const postUserGenerateFountainApplicationLinks = (
    postUserGenerateFountainApplicationLinksBody: PostUserGenerateFountainApplicationLinksBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUserGenerateFountainApplicationLinks200>(
      {url: `/user/generate-fountain-application-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserGenerateFountainApplicationLinksBody
    },
      options);
    }
  


export const getPostUserGenerateFountainApplicationLinksMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserGenerateFountainApplicationLinks>>, TError,{data: PostUserGenerateFountainApplicationLinksBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserGenerateFountainApplicationLinks>>, TError,{data: PostUserGenerateFountainApplicationLinksBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserGenerateFountainApplicationLinks>>, {data: PostUserGenerateFountainApplicationLinksBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserGenerateFountainApplicationLinks(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserGenerateFountainApplicationLinksMutationResult = NonNullable<Awaited<ReturnType<typeof postUserGenerateFountainApplicationLinks>>>
    export type PostUserGenerateFountainApplicationLinksMutationBody = PostUserGenerateFountainApplicationLinksBody
    export type PostUserGenerateFountainApplicationLinksMutationError = ErrorType<string>

    export const usePostUserGenerateFountainApplicationLinks = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserGenerateFountainApplicationLinks>>, TError,{data: PostUserGenerateFountainApplicationLinksBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserGenerateFountainApplicationLinksMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserGetacceptedshiftapplicantId = (
    id: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserGetacceptedshiftapplicantId200Item[]>(
      {url: `/user/getacceptedshiftapplicant/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserGetacceptedshiftapplicantIdQueryKey = (id: string,) => {
    return [`/user/getacceptedshiftapplicant/${id}`] as const;
    }

    
export const getGetUserGetacceptedshiftapplicantIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetacceptedshiftapplicantId>>, TError = ErrorType<string>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetacceptedshiftapplicantId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetacceptedshiftapplicantIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetacceptedshiftapplicantId>>> = ({ signal }) => getUserGetacceptedshiftapplicantId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetacceptedshiftapplicantId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetacceptedshiftapplicantIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetacceptedshiftapplicantId>>>
export type GetUserGetacceptedshiftapplicantIdQueryError = ErrorType<string>

export const useGetUserGetacceptedshiftapplicantId = <TData = Awaited<ReturnType<typeof getUserGetacceptedshiftapplicantId>>, TError = ErrorType<string>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetacceptedshiftapplicantId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetacceptedshiftapplicantIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetonboardingpreferences = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserGetonboardingpreferences200>(
      {url: `/user/getonboardingpreferences`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserGetonboardingpreferencesQueryKey = () => {
    return [`/user/getonboardingpreferences`] as const;
    }

    
export const getGetUserGetonboardingpreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetonboardingpreferences>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetonboardingpreferences>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetonboardingpreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetonboardingpreferences>>> = ({ signal }) => getUserGetonboardingpreferences(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetonboardingpreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetonboardingpreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetonboardingpreferences>>>
export type GetUserGetonboardingpreferencesQueryError = ErrorType<string>

export const useGetUserGetonboardingpreferences = <TData = Awaited<ReturnType<typeof getUserGetonboardingpreferences>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetonboardingpreferences>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetonboardingpreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetshiftapplicantId = (
    id: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserGetshiftapplicantId200Item[]>(
      {url: `/user/getshiftapplicant/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserGetshiftapplicantIdQueryKey = (id: string,) => {
    return [`/user/getshiftapplicant/${id}`] as const;
    }

    
export const getGetUserGetshiftapplicantIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetshiftapplicantId>>, TError = ErrorType<string>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetshiftapplicantId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetshiftapplicantIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetshiftapplicantId>>> = ({ signal }) => getUserGetshiftapplicantId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetshiftapplicantId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetshiftapplicantIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetshiftapplicantId>>>
export type GetUserGetshiftapplicantIdQueryError = ErrorType<string>

export const useGetUserGetshiftapplicantId = <TData = Awaited<ReturnType<typeof getUserGetshiftapplicantId>>, TError = ErrorType<string>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetshiftapplicantId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetshiftapplicantIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetuserbyid = (
    params?: GetUserGetuserbyidParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserGetuserbyid200>(
      {url: `/user/getuserbyid`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserGetuserbyidQueryKey = (params?: GetUserGetuserbyidParams,) => {
    return [`/user/getuserbyid`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserGetuserbyidQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetuserbyid>>, TError = ErrorType<string>>(params?: GetUserGetuserbyidParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetuserbyid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetuserbyidQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetuserbyid>>> = ({ signal }) => getUserGetuserbyid(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetuserbyid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetuserbyidQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetuserbyid>>>
export type GetUserGetuserbyidQueryError = ErrorType<string>

export const useGetUserGetuserbyid = <TData = Awaited<ReturnType<typeof getUserGetuserbyid>>, TError = ErrorType<string>>(
 params?: GetUserGetuserbyidParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetuserbyid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetuserbyidQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Sends the User-Shift-Apply-Issue event along with other info to Hubspot
 * @summary Hubspot Integration
 */
export const postUserHubspotShiftApplyIssueEvent = (
    postUserHubspotShiftApplyIssueEventBody: PostUserHubspotShiftApplyIssueEventBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/hubspot-shift-apply-issue-event/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserHubspotShiftApplyIssueEventBody
    },
      options);
    }
  


export const getPostUserHubspotShiftApplyIssueEventMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserHubspotShiftApplyIssueEvent>>, TError,{data: PostUserHubspotShiftApplyIssueEventBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserHubspotShiftApplyIssueEvent>>, TError,{data: PostUserHubspotShiftApplyIssueEventBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserHubspotShiftApplyIssueEvent>>, {data: PostUserHubspotShiftApplyIssueEventBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserHubspotShiftApplyIssueEvent(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserHubspotShiftApplyIssueEventMutationResult = NonNullable<Awaited<ReturnType<typeof postUserHubspotShiftApplyIssueEvent>>>
    export type PostUserHubspotShiftApplyIssueEventMutationBody = PostUserHubspotShiftApplyIssueEventBody
    export type PostUserHubspotShiftApplyIssueEventMutationError = ErrorType<string>

    /**
 * @summary Hubspot Integration
 */
export const usePostUserHubspotShiftApplyIssueEvent = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserHubspotShiftApplyIssueEvent>>, TError,{data: PostUserHubspotShiftApplyIssueEventBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserHubspotShiftApplyIssueEventMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserImpersonateUserid = (
    userid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserImpersonateUserid200>(
      {url: `/user/impersonate/${userid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserImpersonateUseridQueryKey = (userid: number,) => {
    return [`/user/impersonate/${userid}`] as const;
    }

    
export const getGetUserImpersonateUseridQueryOptions = <TData = Awaited<ReturnType<typeof getUserImpersonateUserid>>, TError = ErrorType<GetUserImpersonateUserid400 | string | GetUserImpersonateUserid500>>(userid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserImpersonateUserid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserImpersonateUseridQueryKey(userid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserImpersonateUserid>>> = ({ signal }) => getUserImpersonateUserid(userid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserImpersonateUserid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserImpersonateUseridQueryResult = NonNullable<Awaited<ReturnType<typeof getUserImpersonateUserid>>>
export type GetUserImpersonateUseridQueryError = ErrorType<GetUserImpersonateUserid400 | string | GetUserImpersonateUserid500>

export const useGetUserImpersonateUserid = <TData = Awaited<ReturnType<typeof getUserImpersonateUserid>>, TError = ErrorType<GetUserImpersonateUserid400 | string | GetUserImpersonateUserid500>>(
 userid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserImpersonateUserid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserImpersonateUseridQueryOptions(userid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserInfo = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserInfo200>(
      {url: `/user/info`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserInfoQueryKey = () => {
    return [`/user/info`] as const;
    }

    
export const getGetUserInfoQueryOptions = <TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInfo>>> = ({ signal }) => getUserInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInfo>>>
export type GetUserInfoQueryError = ErrorType<string>

export const useGetUserInfo = <TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserInfoMobile = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserInfoMobile200>(
      {url: `/user/info-mobile`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserInfoMobileQueryKey = () => {
    return [`/user/info-mobile`] as const;
    }

    
export const getGetUserInfoMobileQueryOptions = <TData = Awaited<ReturnType<typeof getUserInfoMobile>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserInfoMobile>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInfoMobileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInfoMobile>>> = ({ signal }) => getUserInfoMobile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInfoMobile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserInfoMobileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInfoMobile>>>
export type GetUserInfoMobileQueryError = ErrorType<string>

export const useGetUserInfoMobile = <TData = Awaited<ReturnType<typeof getUserInfoMobile>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserInfoMobile>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserInfoMobileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserJobhistory = (
    params: GetUserJobhistoryParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserJobhistory200>(
      {url: `/user/jobhistory`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserJobhistoryQueryKey = (params: GetUserJobhistoryParams,) => {
    return [`/user/jobhistory`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserJobhistoryQueryOptions = <TData = Awaited<ReturnType<typeof getUserJobhistory>>, TError = ErrorType<string>>(params: GetUserJobhistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserJobhistory>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserJobhistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserJobhistory>>> = ({ signal }) => getUserJobhistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserJobhistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserJobhistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getUserJobhistory>>>
export type GetUserJobhistoryQueryError = ErrorType<string>

export const useGetUserJobhistory = <TData = Awaited<ReturnType<typeof getUserJobhistory>>, TError = ErrorType<string>>(
 params: GetUserJobhistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserJobhistory>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserJobhistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUserLogin = (
    postUserLoginBody: PostUserLoginBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUserLogin200>(
      {url: `/user/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserLoginBody
    },
      options);
    }
  


export const getPostUserLoginMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,{data: PostUserLoginBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,{data: PostUserLoginBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserLogin>>, {data: PostUserLoginBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserLogin(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postUserLogin>>>
    export type PostUserLoginMutationBody = PostUserLoginBody
    export type PostUserLoginMutationError = ErrorType<string>

    export const usePostUserLogin = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserLogin>>, TError,{data: PostUserLoginBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserLoginMobile = (
    postUserLoginMobileBody: PostUserLoginMobileBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUserLoginMobile200>(
      {url: `/user/login-mobile`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserLoginMobileBody
    },
      options);
    }
  


export const getPostUserLoginMobileMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserLoginMobile>>, TError,{data: PostUserLoginMobileBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserLoginMobile>>, TError,{data: PostUserLoginMobileBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserLoginMobile>>, {data: PostUserLoginMobileBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserLoginMobile(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserLoginMobileMutationResult = NonNullable<Awaited<ReturnType<typeof postUserLoginMobile>>>
    export type PostUserLoginMobileMutationBody = PostUserLoginMobileBody
    export type PostUserLoginMobileMutationError = ErrorType<string>

    export const usePostUserLoginMobile = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserLoginMobile>>, TError,{data: PostUserLoginMobileBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserLoginMobileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns nurse loyalty events by admin
 * @summary User loyalty events
 */
export const getUserLoyaltyEventsNurseId = (
    nurseId: number,
    params?: GetUserLoyaltyEventsNurseIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserLoyaltyEventsNurseId200Item[]>(
      {url: `/user/loyalty-events/${nurseId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserLoyaltyEventsNurseIdQueryKey = (nurseId: number,
    params?: GetUserLoyaltyEventsNurseIdParams,) => {
    return [`/user/loyalty-events/${nurseId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserLoyaltyEventsNurseIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserLoyaltyEventsNurseId>>, TError = ErrorType<string>>(nurseId: number,
    params?: GetUserLoyaltyEventsNurseIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserLoyaltyEventsNurseId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLoyaltyEventsNurseIdQueryKey(nurseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLoyaltyEventsNurseId>>> = ({ signal }) => getUserLoyaltyEventsNurseId(nurseId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(nurseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserLoyaltyEventsNurseId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserLoyaltyEventsNurseIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLoyaltyEventsNurseId>>>
export type GetUserLoyaltyEventsNurseIdQueryError = ErrorType<string>

/**
 * @summary User loyalty events
 */
export const useGetUserLoyaltyEventsNurseId = <TData = Awaited<ReturnType<typeof getUserLoyaltyEventsNurseId>>, TError = ErrorType<string>>(
 nurseId: number,
    params?: GetUserLoyaltyEventsNurseIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserLoyaltyEventsNurseId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserLoyaltyEventsNurseIdQueryOptions(nurseId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Nurse Metrics
 */
export const getUserMetrics = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserMetrics200>(
      {url: `/user/metrics`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserMetricsQueryKey = () => {
    return [`/user/metrics`] as const;
    }

    
export const getGetUserMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getUserMetrics>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserMetrics>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserMetricsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserMetrics>>> = ({ signal }) => getUserMetrics(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserMetrics>>>
export type GetUserMetricsQueryError = ErrorType<string>

export const useGetUserMetrics = <TData = Awaited<ReturnType<typeof getUserMetrics>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserMetrics>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserMetricsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserNoticeCount = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserNoticeCount200>(
      {url: `/user/notice/count`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserNoticeCountQueryKey = () => {
    return [`/user/notice/count`] as const;
    }

    
export const getGetUserNoticeCountQueryOptions = <TData = Awaited<ReturnType<typeof getUserNoticeCount>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNoticeCount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserNoticeCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNoticeCount>>> = ({ signal }) => getUserNoticeCount(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserNoticeCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserNoticeCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUserNoticeCount>>>
export type GetUserNoticeCountQueryError = ErrorType<string>

export const useGetUserNoticeCount = <TData = Awaited<ReturnType<typeof getUserNoticeCount>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNoticeCount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserNoticeCountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putUserNoticeMarkseen = (
    putUserNoticeMarkseenBody: PutUserNoticeMarkseenBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/notice/markseen`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserNoticeMarkseenBody
    },
      options);
    }
  


export const getPutUserNoticeMarkseenMutationOptions = <TError = ErrorType<PutUserNoticeMarkseen400 | string | PutUserNoticeMarkseen500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserNoticeMarkseen>>, TError,{data: PutUserNoticeMarkseenBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserNoticeMarkseen>>, TError,{data: PutUserNoticeMarkseenBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserNoticeMarkseen>>, {data: PutUserNoticeMarkseenBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserNoticeMarkseen(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserNoticeMarkseenMutationResult = NonNullable<Awaited<ReturnType<typeof putUserNoticeMarkseen>>>
    export type PutUserNoticeMarkseenMutationBody = PutUserNoticeMarkseenBody
    export type PutUserNoticeMarkseenMutationError = ErrorType<PutUserNoticeMarkseen400 | string | PutUserNoticeMarkseen500>

    export const usePutUserNoticeMarkseen = <TError = ErrorType<PutUserNoticeMarkseen400 | string | PutUserNoticeMarkseen500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserNoticeMarkseen>>, TError,{data: PutUserNoticeMarkseenBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserNoticeMarkseenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserNoticeUnseenCount = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserNoticeUnseenCount200>(
      {url: `/user/notice/unseen-count`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserNoticeUnseenCountQueryKey = () => {
    return [`/user/notice/unseen-count`] as const;
    }

    
export const getGetUserNoticeUnseenCountQueryOptions = <TData = Awaited<ReturnType<typeof getUserNoticeUnseenCount>>, TError = ErrorType<GetUserNoticeUnseenCount401 | GetUserNoticeUnseenCount500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNoticeUnseenCount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserNoticeUnseenCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNoticeUnseenCount>>> = ({ signal }) => getUserNoticeUnseenCount(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserNoticeUnseenCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserNoticeUnseenCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUserNoticeUnseenCount>>>
export type GetUserNoticeUnseenCountQueryError = ErrorType<GetUserNoticeUnseenCount401 | GetUserNoticeUnseenCount500>

export const useGetUserNoticeUnseenCount = <TData = Awaited<ReturnType<typeof getUserNoticeUnseenCount>>, TError = ErrorType<GetUserNoticeUnseenCount401 | GetUserNoticeUnseenCount500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNoticeUnseenCount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserNoticeUnseenCountQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteUserNoticeId = (
    id: string,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/notice/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUserNoticeIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserNoticeId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserNoticeId>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserNoticeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserNoticeId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteUserNoticeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserNoticeId>>>
    
    export type DeleteUserNoticeIdMutationError = ErrorType<string>

    export const useDeleteUserNoticeId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserNoticeId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteUserNoticeIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserNotices = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserNotices200Item[]>(
      {url: `/user/notices`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserNoticesQueryKey = () => {
    return [`/user/notices`] as const;
    }

    
export const getGetUserNoticesQueryOptions = <TData = Awaited<ReturnType<typeof getUserNotices>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNotices>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserNoticesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNotices>>> = ({ signal }) => getUserNotices(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserNotices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserNoticesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserNotices>>>
export type GetUserNoticesQueryError = ErrorType<string>

export const useGetUserNotices = <TData = Awaited<ReturnType<typeof getUserNotices>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNotices>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserNoticesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserNurseAccountactivity = (
    params?: GetUserNurseAccountactivityParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserNurseAccountactivity200Item[]>(
      {url: `/user/nurse/accountactivity`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserNurseAccountactivityQueryKey = (params?: GetUserNurseAccountactivityParams,) => {
    return [`/user/nurse/accountactivity`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserNurseAccountactivityQueryOptions = <TData = Awaited<ReturnType<typeof getUserNurseAccountactivity>>, TError = ErrorType<GetUserNurseAccountactivity400 | string | GetUserNurseAccountactivity500>>(params?: GetUserNurseAccountactivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNurseAccountactivity>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserNurseAccountactivityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNurseAccountactivity>>> = ({ signal }) => getUserNurseAccountactivity(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserNurseAccountactivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserNurseAccountactivityQueryResult = NonNullable<Awaited<ReturnType<typeof getUserNurseAccountactivity>>>
export type GetUserNurseAccountactivityQueryError = ErrorType<GetUserNurseAccountactivity400 | string | GetUserNurseAccountactivity500>

export const useGetUserNurseAccountactivity = <TData = Awaited<ReturnType<typeof getUserNurseAccountactivity>>, TError = ErrorType<GetUserNurseAccountactivity400 | string | GetUserNurseAccountactivity500>>(
 params?: GetUserNurseAccountactivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNurseAccountactivity>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserNurseAccountactivityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get clinicians worked together in the given duration in the past
 */
export const getUserNurseWorkedUseridNumdaysback = (
    userid: number,
    numdaysback: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserNurseWorkedUseridNumdaysback200Item[]>(
      {url: `/user/nurse/worked/${userid}/${numdaysback}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserNurseWorkedUseridNumdaysbackQueryKey = (userid: number,
    numdaysback: number,) => {
    return [`/user/nurse/worked/${userid}/${numdaysback}`] as const;
    }

    
export const getGetUserNurseWorkedUseridNumdaysbackQueryOptions = <TData = Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysback>>, TError = ErrorType<GetUserNurseWorkedUseridNumdaysback400 | string | GetUserNurseWorkedUseridNumdaysback500>>(userid: number,
    numdaysback: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysback>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserNurseWorkedUseridNumdaysbackQueryKey(userid,numdaysback);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysback>>> = ({ signal }) => getUserNurseWorkedUseridNumdaysback(userid,numdaysback, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userid && numdaysback), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysback>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserNurseWorkedUseridNumdaysbackQueryResult = NonNullable<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysback>>>
export type GetUserNurseWorkedUseridNumdaysbackQueryError = ErrorType<GetUserNurseWorkedUseridNumdaysback400 | string | GetUserNurseWorkedUseridNumdaysback500>

export const useGetUserNurseWorkedUseridNumdaysback = <TData = Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysback>>, TError = ErrorType<GetUserNurseWorkedUseridNumdaysback400 | string | GetUserNurseWorkedUseridNumdaysback500>>(
 userid: number,
    numdaysback: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysback>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserNurseWorkedUseridNumdaysbackQueryOptions(userid,numdaysback,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get specific clinician worked together in the given duration in the past
 */
export const getUserNurseWorkedUseridNumdaysbackFriendid = (
    userid: number,
    numdaysback: number,
    friendid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserNurseWorkedUseridNumdaysbackFriendid200>(
      {url: `/user/nurse/worked/${userid}/${numdaysback}/${friendid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserNurseWorkedUseridNumdaysbackFriendidQueryKey = (userid: number,
    numdaysback: number,
    friendid: number,) => {
    return [`/user/nurse/worked/${userid}/${numdaysback}/${friendid}`] as const;
    }

    
export const getGetUserNurseWorkedUseridNumdaysbackFriendidQueryOptions = <TData = Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysbackFriendid>>, TError = ErrorType<GetUserNurseWorkedUseridNumdaysbackFriendid400 | string | GetUserNurseWorkedUseridNumdaysbackFriendid500>>(userid: number,
    numdaysback: number,
    friendid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysbackFriendid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserNurseWorkedUseridNumdaysbackFriendidQueryKey(userid,numdaysback,friendid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysbackFriendid>>> = ({ signal }) => getUserNurseWorkedUseridNumdaysbackFriendid(userid,numdaysback,friendid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userid && numdaysback && friendid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysbackFriendid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserNurseWorkedUseridNumdaysbackFriendidQueryResult = NonNullable<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysbackFriendid>>>
export type GetUserNurseWorkedUseridNumdaysbackFriendidQueryError = ErrorType<GetUserNurseWorkedUseridNumdaysbackFriendid400 | string | GetUserNurseWorkedUseridNumdaysbackFriendid500>

export const useGetUserNurseWorkedUseridNumdaysbackFriendid = <TData = Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysbackFriendid>>, TError = ErrorType<GetUserNurseWorkedUseridNumdaysbackFriendid400 | string | GetUserNurseWorkedUseridNumdaysbackFriendid500>>(
 userid: number,
    numdaysback: number,
    friendid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserNurseWorkedUseridNumdaysbackFriendid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserNurseWorkedUseridNumdaysbackFriendidQueryOptions(userid,numdaysback,friendid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Stores the opt-out prefrence for Unit
 * @summary Unit Integration
 */
export const postUserOptOutPrefUnit = (
    postUserOptOutPrefUnitBody: PostUserOptOutPrefUnitBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/opt-out-pref-unit/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserOptOutPrefUnitBody
    },
      options);
    }
  


export const getPostUserOptOutPrefUnitMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserOptOutPrefUnit>>, TError,{data: PostUserOptOutPrefUnitBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserOptOutPrefUnit>>, TError,{data: PostUserOptOutPrefUnitBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserOptOutPrefUnit>>, {data: PostUserOptOutPrefUnitBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserOptOutPrefUnit(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserOptOutPrefUnitMutationResult = NonNullable<Awaited<ReturnType<typeof postUserOptOutPrefUnit>>>
    export type PostUserOptOutPrefUnitMutationBody = PostUserOptOutPrefUnitBody
    export type PostUserOptOutPrefUnitMutationError = ErrorType<string>

    /**
 * @summary Unit Integration
 */
export const usePostUserOptOutPrefUnit = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserOptOutPrefUnit>>, TError,{data: PostUserOptOutPrefUnitBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserOptOutPrefUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserOrganizationMessages = (
    params: GetUserOrganizationMessagesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserOrganizationMessages200Item[]>(
      {url: `/user/organization-messages`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserOrganizationMessagesQueryKey = (params: GetUserOrganizationMessagesParams,) => {
    return [`/user/organization-messages`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserOrganizationMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getUserOrganizationMessages>>, TError = ErrorType<GetUserOrganizationMessages400 | string | GetUserOrganizationMessages500>>(params: GetUserOrganizationMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserOrganizationMessages>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserOrganizationMessagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserOrganizationMessages>>> = ({ signal }) => getUserOrganizationMessages(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserOrganizationMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserOrganizationMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserOrganizationMessages>>>
export type GetUserOrganizationMessagesQueryError = ErrorType<GetUserOrganizationMessages400 | string | GetUserOrganizationMessages500>

export const useGetUserOrganizationMessages = <TData = Awaited<ReturnType<typeof getUserOrganizationMessages>>, TError = ErrorType<GetUserOrganizationMessages400 | string | GetUserOrganizationMessages500>>(
 params: GetUserOrganizationMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserOrganizationMessages>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserOrganizationMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Fetch Pay Rate for User
 */
export const getUserPayrate = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserPayrate200Item[]>(
      {url: `/user/payrate`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserPayrateQueryKey = () => {
    return [`/user/payrate`] as const;
    }

    
export const getGetUserPayrateQueryOptions = <TData = Awaited<ReturnType<typeof getUserPayrate>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserPayrate>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPayrateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPayrate>>> = ({ signal }) => getUserPayrate(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPayrate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserPayrateQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPayrate>>>
export type GetUserPayrateQueryError = ErrorType<string>

export const useGetUserPayrate = <TData = Awaited<ReturnType<typeof getUserPayrate>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserPayrate>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserPayrateQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns user profile pdf
 * @summary User profile pdf
 */
export const getUserProfileDownloadUserIdShiftId = (
    userId: number,
    shiftId: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Blob>(
      {url: `/user/profile/download/${userId}/${shiftId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetUserProfileDownloadUserIdShiftIdQueryKey = (userId: number,
    shiftId: number,) => {
    return [`/user/profile/download/${userId}/${shiftId}`] as const;
    }

    
export const getGetUserProfileDownloadUserIdShiftIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfileDownloadUserIdShiftId>>, TError = ErrorType<string>>(userId: number,
    shiftId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserProfileDownloadUserIdShiftId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileDownloadUserIdShiftIdQueryKey(userId,shiftId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfileDownloadUserIdShiftId>>> = ({ signal }) => getUserProfileDownloadUserIdShiftId(userId,shiftId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId && shiftId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserProfileDownloadUserIdShiftId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserProfileDownloadUserIdShiftIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfileDownloadUserIdShiftId>>>
export type GetUserProfileDownloadUserIdShiftIdQueryError = ErrorType<string>

/**
 * @summary User profile pdf
 */
export const useGetUserProfileDownloadUserIdShiftId = <TData = Awaited<ReturnType<typeof getUserProfileDownloadUserIdShiftId>>, TError = ErrorType<string>>(
 userId: number,
    shiftId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserProfileDownloadUserIdShiftId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserProfileDownloadUserIdShiftIdQueryOptions(userId,shiftId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns user profile pdf with all requirements or requirements based on either locationID or shiftID 
 * @summary User profile PDF with variable requirements
 */
export const getUserProfileDownloadPDFUserID = (
    userID: number,
    params?: GetUserProfileDownloadPDFUserIDParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Blob>(
      {url: `/user/profile/downloadPDF/${userID}`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  

export const getGetUserProfileDownloadPDFUserIDQueryKey = (userID: number,
    params?: GetUserProfileDownloadPDFUserIDParams,) => {
    return [`/user/profile/downloadPDF/${userID}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserProfileDownloadPDFUserIDQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfileDownloadPDFUserID>>, TError = ErrorType<string>>(userID: number,
    params?: GetUserProfileDownloadPDFUserIDParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserProfileDownloadPDFUserID>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileDownloadPDFUserIDQueryKey(userID,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfileDownloadPDFUserID>>> = ({ signal }) => getUserProfileDownloadPDFUserID(userID,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserProfileDownloadPDFUserID>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserProfileDownloadPDFUserIDQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfileDownloadPDFUserID>>>
export type GetUserProfileDownloadPDFUserIDQueryError = ErrorType<string>

/**
 * @summary User profile PDF with variable requirements
 */
export const useGetUserProfileDownloadPDFUserID = <TData = Awaited<ReturnType<typeof getUserProfileDownloadPDFUserID>>, TError = ErrorType<string>>(
 userID: number,
    params?: GetUserProfileDownloadPDFUserIDParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserProfileDownloadPDFUserID>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserProfileDownloadPDFUserIDQueryOptions(userID,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putUserPush = (
    putUserPushBody: PutUserPushBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/push`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserPushBody
    },
      options);
    }
  


export const getPutUserPushMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserPush>>, TError,{data: PutUserPushBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserPush>>, TError,{data: PutUserPushBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserPush>>, {data: PutUserPushBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserPush(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserPushMutationResult = NonNullable<Awaited<ReturnType<typeof putUserPush>>>
    export type PutUserPushMutationBody = PutUserPushBody
    export type PutUserPushMutationError = ErrorType<string>

    export const usePutUserPush = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserPush>>, TError,{data: PutUserPushBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserPushMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch Recent Nurse Shift Status
 */
export const getUserRecentShiftsStatus = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserRecentShiftsStatus200>(
      {url: `/user/recent-shifts-status`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserRecentShiftsStatusQueryKey = () => {
    return [`/user/recent-shifts-status`] as const;
    }

    
export const getGetUserRecentShiftsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserRecentShiftsStatus>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserRecentShiftsStatus>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRecentShiftsStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserRecentShiftsStatus>>> = ({ signal }) => getUserRecentShiftsStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserRecentShiftsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRecentShiftsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserRecentShiftsStatus>>>
export type GetUserRecentShiftsStatusQueryError = ErrorType<string>

export const useGetUserRecentShiftsStatus = <TData = Awaited<ReturnType<typeof getUserRecentShiftsStatus>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserRecentShiftsStatus>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserRecentShiftsStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteUserRejectshiftapplicant = (
    params: DeleteUserRejectshiftapplicantParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<DeleteUserRejectshiftapplicant200>(
      {url: `/user/rejectshiftapplicant`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteUserRejectshiftapplicantMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserRejectshiftapplicant>>, TError,{params: DeleteUserRejectshiftapplicantParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserRejectshiftapplicant>>, TError,{params: DeleteUserRejectshiftapplicantParams}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserRejectshiftapplicant>>, {params: DeleteUserRejectshiftapplicantParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteUserRejectshiftapplicant(params,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteUserRejectshiftapplicantMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserRejectshiftapplicant>>>
    
    export type DeleteUserRejectshiftapplicantMutationError = ErrorType<string>

    export const useDeleteUserRejectshiftapplicant = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserRejectshiftapplicant>>, TError,{params: DeleteUserRejectshiftapplicantParams}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteUserRejectshiftapplicantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteUserRequirementsDeletedocumentDocid = (
    docid: string,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/requirements/deletedocument/${docid}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUserRequirementsDeletedocumentDocidMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserRequirementsDeletedocumentDocid>>, TError,{docid: string}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserRequirementsDeletedocumentDocid>>, TError,{docid: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserRequirementsDeletedocumentDocid>>, {docid: string}> = (props) => {
          const {docid} = props ?? {};

          return  deleteUserRequirementsDeletedocumentDocid(docid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteUserRequirementsDeletedocumentDocidMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserRequirementsDeletedocumentDocid>>>
    
    export type DeleteUserRequirementsDeletedocumentDocidMutationError = ErrorType<string>

    export const useDeleteUserRequirementsDeletedocumentDocid = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserRequirementsDeletedocumentDocid>>, TError,{docid: string}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteUserRequirementsDeletedocumentDocidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns the logged in user's current scopes
 */
export const getUserScopes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<string[]>(
      {url: `/user/scopes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserScopesQueryKey = () => {
    return [`/user/scopes`] as const;
    }

    
export const getGetUserScopesQueryOptions = <TData = Awaited<ReturnType<typeof getUserScopes>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserScopes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserScopesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserScopes>>> = ({ signal }) => getUserScopes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserScopes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserScopesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserScopes>>>
export type GetUserScopesQueryError = ErrorType<string>

export const useGetUserScopes = <TData = Awaited<ReturnType<typeof getUserScopes>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserScopes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserScopesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUserSendmessage = (
    postUserSendmessageBody: PostUserSendmessageBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/sendmessage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserSendmessageBody
    },
      options);
    }
  


export const getPostUserSendmessageMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSendmessage>>, TError,{data: PostUserSendmessageBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserSendmessage>>, TError,{data: PostUserSendmessageBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserSendmessage>>, {data: PostUserSendmessageBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserSendmessage(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserSendmessageMutationResult = NonNullable<Awaited<ReturnType<typeof postUserSendmessage>>>
    export type PostUserSendmessageMutationBody = PostUserSendmessageBody
    export type PostUserSendmessageMutationError = ErrorType<string>

    export const usePostUserSendmessage = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSendmessage>>, TError,{data: PostUserSendmessageBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserSendmessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchUserShiftApplicantId = (
    id: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/shift-applicant/${id}`, method: 'PATCH'
    },
      options);
    }
  


export const getPatchUserShiftApplicantIdMutationOptions = <TError = ErrorType<PatchUserShiftApplicantId400 | PatchUserShiftApplicantId401 | PatchUserShiftApplicantId500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserShiftApplicantId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof patchUserShiftApplicantId>>, TError,{id: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserShiftApplicantId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patchUserShiftApplicantId(id,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PatchUserShiftApplicantIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserShiftApplicantId>>>
    
    export type PatchUserShiftApplicantIdMutationError = ErrorType<PatchUserShiftApplicantId400 | PatchUserShiftApplicantId401 | PatchUserShiftApplicantId500>

    export const usePatchUserShiftApplicantId = <TError = ErrorType<PatchUserShiftApplicantId400 | PatchUserShiftApplicantId401 | PatchUserShiftApplicantId500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserShiftApplicantId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPatchUserShiftApplicantIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Provide details for the specified shift including facility details and timesheet (if CICO completed)
 */
export const getUserShiftDetailShiftID = (
    shiftID: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserShiftDetailShiftID200>(
      {url: `/user/shift-detail/${shiftID}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserShiftDetailShiftIDQueryKey = (shiftID: number,) => {
    return [`/user/shift-detail/${shiftID}`] as const;
    }

    
export const getGetUserShiftDetailShiftIDQueryOptions = <TData = Awaited<ReturnType<typeof getUserShiftDetailShiftID>>, TError = ErrorType<string>>(shiftID: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftDetailShiftID>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserShiftDetailShiftIDQueryKey(shiftID);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserShiftDetailShiftID>>> = ({ signal }) => getUserShiftDetailShiftID(shiftID, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shiftID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserShiftDetailShiftID>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserShiftDetailShiftIDQueryResult = NonNullable<Awaited<ReturnType<typeof getUserShiftDetailShiftID>>>
export type GetUserShiftDetailShiftIDQueryError = ErrorType<string>

export const useGetUserShiftDetailShiftID = <TData = Awaited<ReturnType<typeof getUserShiftDetailShiftID>>, TError = ErrorType<string>>(
 shiftID: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftDetailShiftID>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserShiftDetailShiftIDQueryOptions(shiftID,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserShiftcalloutexcuse = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserShiftcalloutexcuse200>(
      {url: `/user/shiftcalloutexcuse`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserShiftcalloutexcuseQueryKey = () => {
    return [`/user/shiftcalloutexcuse`] as const;
    }

    
export const getGetUserShiftcalloutexcuseQueryOptions = <TData = Awaited<ReturnType<typeof getUserShiftcalloutexcuse>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftcalloutexcuse>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserShiftcalloutexcuseQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserShiftcalloutexcuse>>> = ({ signal }) => getUserShiftcalloutexcuse(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserShiftcalloutexcuse>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserShiftcalloutexcuseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserShiftcalloutexcuse>>>
export type GetUserShiftcalloutexcuseQueryError = ErrorType<string>

export const useGetUserShiftcalloutexcuse = <TData = Awaited<ReturnType<typeof getUserShiftcalloutexcuse>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftcalloutexcuse>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserShiftcalloutexcuseQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserShiftsShiftid = (
    shiftid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserShiftsShiftid200>(
      {url: `/user/shifts/${shiftid}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserShiftsShiftidQueryKey = (shiftid: number,) => {
    return [`/user/shifts/${shiftid}`] as const;
    }

    
export const getGetUserShiftsShiftidQueryOptions = <TData = Awaited<ReturnType<typeof getUserShiftsShiftid>>, TError = ErrorType<string>>(shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserShiftsShiftidQueryKey(shiftid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserShiftsShiftid>>> = ({ signal }) => getUserShiftsShiftid(shiftid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shiftid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsShiftid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserShiftsShiftidQueryResult = NonNullable<Awaited<ReturnType<typeof getUserShiftsShiftid>>>
export type GetUserShiftsShiftidQueryError = ErrorType<string>

export const useGetUserShiftsShiftid = <TData = Awaited<ReturnType<typeof getUserShiftsShiftid>>, TError = ErrorType<string>>(
 shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsShiftid>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserShiftsShiftidQueryOptions(shiftid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserShiftsShiftidShared = (
    shiftid: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserShiftsShiftidShared200>(
      {url: `/user/shifts/${shiftid}/shared`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserShiftsShiftidSharedQueryKey = (shiftid: number,) => {
    return [`/user/shifts/${shiftid}/shared`] as const;
    }

    
export const getGetUserShiftsShiftidSharedQueryOptions = <TData = Awaited<ReturnType<typeof getUserShiftsShiftidShared>>, TError = ErrorType<string>>(shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsShiftidShared>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserShiftsShiftidSharedQueryKey(shiftid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserShiftsShiftidShared>>> = ({ signal }) => getUserShiftsShiftidShared(shiftid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shiftid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsShiftidShared>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserShiftsShiftidSharedQueryResult = NonNullable<Awaited<ReturnType<typeof getUserShiftsShiftidShared>>>
export type GetUserShiftsShiftidSharedQueryError = ErrorType<string>

export const useGetUserShiftsShiftidShared = <TData = Awaited<ReturnType<typeof getUserShiftsShiftidShared>>, TError = ErrorType<string>>(
 shiftid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsShiftidShared>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserShiftsShiftidSharedQueryOptions(shiftid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserShiftsv2 = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserShiftsv2200Item[]>(
      {url: `/user/shiftsv2`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserShiftsv2QueryKey = () => {
    return [`/user/shiftsv2`] as const;
    }

    
export const getGetUserShiftsv2QueryOptions = <TData = Awaited<ReturnType<typeof getUserShiftsv2>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsv2>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserShiftsv2QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserShiftsv2>>> = ({ signal }) => getUserShiftsv2(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsv2>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserShiftsv2QueryResult = NonNullable<Awaited<ReturnType<typeof getUserShiftsv2>>>
export type GetUserShiftsv2QueryError = ErrorType<string>

export const useGetUserShiftsv2 = <TData = Awaited<ReturnType<typeof getUserShiftsv2>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShiftsv2>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserShiftsv2QueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserShowonboardingflow = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserShowonboardingflow200>(
      {url: `/user/showonboardingflow`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserShowonboardingflowQueryKey = () => {
    return [`/user/showonboardingflow`] as const;
    }

    
export const getGetUserShowonboardingflowQueryOptions = <TData = Awaited<ReturnType<typeof getUserShowonboardingflow>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShowonboardingflow>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserShowonboardingflowQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserShowonboardingflow>>> = ({ signal }) => getUserShowonboardingflow(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserShowonboardingflow>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserShowonboardingflowQueryResult = NonNullable<Awaited<ReturnType<typeof getUserShowonboardingflow>>>
export type GetUserShowonboardingflowQueryError = ErrorType<string>

export const useGetUserShowonboardingflow = <TData = Awaited<ReturnType<typeof getUserShowonboardingflow>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShowonboardingflow>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserShowonboardingflowQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserShowredirecttofountain = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserShowredirecttofountain200>(
      {url: `/user/showredirecttofountain`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserShowredirecttofountainQueryKey = () => {
    return [`/user/showredirecttofountain`] as const;
    }

    
export const getGetUserShowredirecttofountainQueryOptions = <TData = Awaited<ReturnType<typeof getUserShowredirecttofountain>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShowredirecttofountain>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserShowredirecttofountainQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserShowredirecttofountain>>> = ({ signal }) => getUserShowredirecttofountain(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserShowredirecttofountain>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserShowredirecttofountainQueryResult = NonNullable<Awaited<ReturnType<typeof getUserShowredirecttofountain>>>
export type GetUserShowredirecttofountainQueryError = ErrorType<string>

export const useGetUserShowredirecttofountain = <TData = Awaited<ReturnType<typeof getUserShowredirecttofountain>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserShowredirecttofountain>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserShowredirecttofountainQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserSupervisordashboard = (
    params?: GetUserSupervisordashboardParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserSupervisordashboard200>(
      {url: `/user/supervisordashboard`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserSupervisordashboardQueryKey = (params?: GetUserSupervisordashboardParams,) => {
    return [`/user/supervisordashboard`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserSupervisordashboardQueryOptions = <TData = Awaited<ReturnType<typeof getUserSupervisordashboard>>, TError = ErrorType<string>>(params?: GetUserSupervisordashboardParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSupervisordashboard>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSupervisordashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSupervisordashboard>>> = ({ signal }) => getUserSupervisordashboard(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSupervisordashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserSupervisordashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSupervisordashboard>>>
export type GetUserSupervisordashboardQueryError = ErrorType<string>

export const useGetUserSupervisordashboard = <TData = Awaited<ReturnType<typeof getUserSupervisordashboard>>, TError = ErrorType<string>>(
 params?: GetUserSupervisordashboardParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSupervisordashboard>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserSupervisordashboardQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserSupervisordashboardv2 = (
    params?: GetUserSupervisordashboardv2Params,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserSupervisordashboardv2200>(
      {url: `/user/supervisordashboardv2`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserSupervisordashboardv2QueryKey = (params?: GetUserSupervisordashboardv2Params,) => {
    return [`/user/supervisordashboardv2`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserSupervisordashboardv2QueryOptions = <TData = Awaited<ReturnType<typeof getUserSupervisordashboardv2>>, TError = ErrorType<string>>(params?: GetUserSupervisordashboardv2Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSupervisordashboardv2>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSupervisordashboardv2QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSupervisordashboardv2>>> = ({ signal }) => getUserSupervisordashboardv2(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSupervisordashboardv2>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserSupervisordashboardv2QueryResult = NonNullable<Awaited<ReturnType<typeof getUserSupervisordashboardv2>>>
export type GetUserSupervisordashboardv2QueryError = ErrorType<string>

export const useGetUserSupervisordashboardv2 = <TData = Awaited<ReturnType<typeof getUserSupervisordashboardv2>>, TError = ErrorType<string>>(
 params?: GetUserSupervisordashboardv2Params, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSupervisordashboardv2>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserSupervisordashboardv2QueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putUserSupervisordetailsUpdate = (
    putUserSupervisordetailsUpdateBody: PutUserSupervisordetailsUpdateBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/supervisordetails/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserSupervisordetailsUpdateBody
    },
      options);
    }
  


export const getPutUserSupervisordetailsUpdateMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserSupervisordetailsUpdate>>, TError,{data: PutUserSupervisordetailsUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserSupervisordetailsUpdate>>, TError,{data: PutUserSupervisordetailsUpdateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserSupervisordetailsUpdate>>, {data: PutUserSupervisordetailsUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserSupervisordetailsUpdate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserSupervisordetailsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof putUserSupervisordetailsUpdate>>>
    export type PutUserSupervisordetailsUpdateMutationBody = PutUserSupervisordetailsUpdateBody
    export type PutUserSupervisordetailsUpdateMutationError = ErrorType<string>

    export const usePutUserSupervisordetailsUpdate = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserSupervisordetailsUpdate>>, TError,{data: PutUserSupervisordetailsUpdateBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserSupervisordetailsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putUserUndorejectshiftapplicant = (
    putUserUndorejectshiftapplicantBody: PutUserUndorejectshiftapplicantBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutUserUndorejectshiftapplicant200>(
      {url: `/user/undorejectshiftapplicant`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserUndorejectshiftapplicantBody
    },
      options);
    }
  


export const getPutUserUndorejectshiftapplicantMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUndorejectshiftapplicant>>, TError,{data: PutUserUndorejectshiftapplicantBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserUndorejectshiftapplicant>>, TError,{data: PutUserUndorejectshiftapplicantBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserUndorejectshiftapplicant>>, {data: PutUserUndorejectshiftapplicantBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserUndorejectshiftapplicant(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserUndorejectshiftapplicantMutationResult = NonNullable<Awaited<ReturnType<typeof putUserUndorejectshiftapplicant>>>
    export type PutUserUndorejectshiftapplicantMutationBody = PutUserUndorejectshiftapplicantBody
    export type PutUserUndorejectshiftapplicantMutationError = ErrorType<string>

    export const usePutUserUndorejectshiftapplicant = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUndorejectshiftapplicant>>, TError,{data: PutUserUndorejectshiftapplicantBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserUndorejectshiftapplicantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update Flag for First time accepted shift
 */
export const putUserUpdateFlagFirstTimeAcceptedShift = (
    putUserUpdateFlagFirstTimeAcceptedShiftBody: PutUserUpdateFlagFirstTimeAcceptedShiftBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/update-flag-first-time-accepted-shift`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserUpdateFlagFirstTimeAcceptedShiftBody
    },
      options);
    }
  


export const getPutUserUpdateFlagFirstTimeAcceptedShiftMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateFlagFirstTimeAcceptedShift>>, TError,{data: PutUserUpdateFlagFirstTimeAcceptedShiftBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateFlagFirstTimeAcceptedShift>>, TError,{data: PutUserUpdateFlagFirstTimeAcceptedShiftBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserUpdateFlagFirstTimeAcceptedShift>>, {data: PutUserUpdateFlagFirstTimeAcceptedShiftBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserUpdateFlagFirstTimeAcceptedShift(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserUpdateFlagFirstTimeAcceptedShiftMutationResult = NonNullable<Awaited<ReturnType<typeof putUserUpdateFlagFirstTimeAcceptedShift>>>
    export type PutUserUpdateFlagFirstTimeAcceptedShiftMutationBody = PutUserUpdateFlagFirstTimeAcceptedShiftBody
    export type PutUserUpdateFlagFirstTimeAcceptedShiftMutationError = ErrorType<string>

    export const usePutUserUpdateFlagFirstTimeAcceptedShift = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateFlagFirstTimeAcceptedShift>>, TError,{data: PutUserUpdateFlagFirstTimeAcceptedShiftBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserUpdateFlagFirstTimeAcceptedShiftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putUserUpdatepassword = (
    putUserUpdatepasswordBody: PutUserUpdatepasswordBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/updatepassword`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserUpdatepasswordBody
    },
      options);
    }
  


export const getPutUserUpdatepasswordMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUpdatepassword>>, TError,{data: PutUserUpdatepasswordBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserUpdatepassword>>, TError,{data: PutUserUpdatepasswordBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserUpdatepassword>>, {data: PutUserUpdatepasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserUpdatepassword(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserUpdatepasswordMutationResult = NonNullable<Awaited<ReturnType<typeof putUserUpdatepassword>>>
    export type PutUserUpdatepasswordMutationBody = PutUserUpdatepasswordBody
    export type PutUserUpdatepasswordMutationError = ErrorType<string>

    export const usePutUserUpdatepassword = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUpdatepassword>>, TError,{data: PutUserUpdatepasswordBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserUpdatepasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putUserUpdateshiftcalloutexcuse = (
    putUserUpdateshiftcalloutexcuseBody: PutUserUpdateshiftcalloutexcuseBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/updateshiftcalloutexcuse`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserUpdateshiftcalloutexcuseBody
    },
      options);
    }
  


export const getPutUserUpdateshiftcalloutexcuseMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateshiftcalloutexcuse>>, TError,{data: PutUserUpdateshiftcalloutexcuseBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateshiftcalloutexcuse>>, TError,{data: PutUserUpdateshiftcalloutexcuseBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserUpdateshiftcalloutexcuse>>, {data: PutUserUpdateshiftcalloutexcuseBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserUpdateshiftcalloutexcuse(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserUpdateshiftcalloutexcuseMutationResult = NonNullable<Awaited<ReturnType<typeof putUserUpdateshiftcalloutexcuse>>>
    export type PutUserUpdateshiftcalloutexcuseMutationBody = PutUserUpdateshiftcalloutexcuseBody
    export type PutUserUpdateshiftcalloutexcuseMutationError = ErrorType<string>

    export const usePutUserUpdateshiftcalloutexcuse = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateshiftcalloutexcuse>>, TError,{data: PutUserUpdateshiftcalloutexcuseBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserUpdateshiftcalloutexcuseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putUserUpdateuserhazardpay = (
    putUserUpdateuserhazardpayBody: PutUserUpdateuserhazardpayBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/user/updateuserhazardpay`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserUpdateuserhazardpayBody
    },
      options);
    }
  


export const getPutUserUpdateuserhazardpayMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateuserhazardpay>>, TError,{data: PutUserUpdateuserhazardpayBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateuserhazardpay>>, TError,{data: PutUserUpdateuserhazardpayBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserUpdateuserhazardpay>>, {data: PutUserUpdateuserhazardpayBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserUpdateuserhazardpay(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserUpdateuserhazardpayMutationResult = NonNullable<Awaited<ReturnType<typeof putUserUpdateuserhazardpay>>>
    export type PutUserUpdateuserhazardpayMutationBody = PutUserUpdateuserhazardpayBody
    export type PutUserUpdateuserhazardpayMutationError = ErrorType<string>

    export const usePutUserUpdateuserhazardpay = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserUpdateuserhazardpay>>, TError,{data: PutUserUpdateuserhazardpayBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserUpdateuserhazardpayMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserUpload = (
    postUserUploadBody: PostUserUploadBody,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(postUserUploadBody.file !== undefined) {
 formData.append('file', postUserUploadBody.file)
 }
if(postUserUploadBody.user_id !== undefined) {
 formData.append('user_id', postUserUploadBody.user_id.toString())
 }

      return request<PostUserUpload200>(
      {url: `/user/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostUserUploadMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserUpload>>, TError,{data: PostUserUploadBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserUpload>>, TError,{data: PostUserUploadBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserUpload>>, {data: PostUserUploadBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserUpload(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postUserUpload>>>
    export type PostUserUploadMutationBody = PostUserUploadBody
    export type PostUserUploadMutationError = ErrorType<string>

    export const usePostUserUpload = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserUpload>>, TError,{data: PostUserUploadBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserUploadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserUploadprofilepic = (
    postUserUploadprofilepicBody: PostUserUploadprofilepicBody,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(postUserUploadprofilepicBody.file !== undefined) {
 formData.append('file', postUserUploadprofilepicBody.file)
 }
if(postUserUploadprofilepicBody.user_id !== undefined) {
 formData.append('user_id', postUserUploadprofilepicBody.user_id.toString())
 }

      return request<PostUserUploadprofilepic200>(
      {url: `/user/uploadprofilepic`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostUserUploadprofilepicMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserUploadprofilepic>>, TError,{data: PostUserUploadprofilepicBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserUploadprofilepic>>, TError,{data: PostUserUploadprofilepicBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserUploadprofilepic>>, {data: PostUserUploadprofilepicBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserUploadprofilepic(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserUploadprofilepicMutationResult = NonNullable<Awaited<ReturnType<typeof postUserUploadprofilepic>>>
    export type PostUserUploadprofilepicMutationBody = PostUserUploadprofilepicBody
    export type PostUserUploadprofilepicMutationError = ErrorType<string>

    export const usePostUserUploadprofilepic = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserUploadprofilepic>>, TError,{data: PostUserUploadprofilepicBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserUploadprofilepicMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserUploadresume = (
    postUserUploadresumeBody: PostUserUploadresumeBody,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(postUserUploadresumeBody.file !== undefined) {
 formData.append('file', postUserUploadresumeBody.file)
 }
if(postUserUploadresumeBody.user_id !== undefined) {
 formData.append('user_id', postUserUploadresumeBody.user_id.toString())
 }

      return request<PostUserUploadresume200>(
      {url: `/user/uploadresume`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPostUserUploadresumeMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserUploadresume>>, TError,{data: PostUserUploadresumeBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserUploadresume>>, TError,{data: PostUserUploadresumeBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserUploadresume>>, {data: PostUserUploadresumeBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserUploadresume(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserUploadresumeMutationResult = NonNullable<Awaited<ReturnType<typeof postUserUploadresume>>>
    export type PostUserUploadresumeMutationBody = PostUserUploadresumeBody
    export type PostUserUploadresumeMutationError = ErrorType<string>

    export const usePostUserUploadresume = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserUploadresume>>, TError,{data: PostUserUploadresumeBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserUploadresumeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserWebshiftspageforcefilteruser = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserWebshiftspageforcefilteruser200>(
      {url: `/user/webshiftspageforcefilteruser`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserWebshiftspageforcefilteruserQueryKey = () => {
    return [`/user/webshiftspageforcefilteruser`] as const;
    }

    
export const getGetUserWebshiftspageforcefilteruserQueryOptions = <TData = Awaited<ReturnType<typeof getUserWebshiftspageforcefilteruser>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserWebshiftspageforcefilteruser>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserWebshiftspageforcefilteruserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserWebshiftspageforcefilteruser>>> = ({ signal }) => getUserWebshiftspageforcefilteruser(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserWebshiftspageforcefilteruser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserWebshiftspageforcefilteruserQueryResult = NonNullable<Awaited<ReturnType<typeof getUserWebshiftspageforcefilteruser>>>
export type GetUserWebshiftspageforcefilteruserQueryError = ErrorType<string>

export const useGetUserWebshiftspageforcefilteruser = <TData = Awaited<ReturnType<typeof getUserWebshiftspageforcefilteruser>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserWebshiftspageforcefilteruser>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserWebshiftspageforcefilteruserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a clinician's list of blocked users
 */
export const getUserWorkwithfriendsBlockedusers = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserWorkwithfriendsBlockedusers200Item[]>(
      {url: `/user/workwithfriends/blockedusers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserWorkwithfriendsBlockedusersQueryKey = () => {
    return [`/user/workwithfriends/blockedusers`] as const;
    }

    
export const getGetUserWorkwithfriendsBlockedusersQueryOptions = <TData = Awaited<ReturnType<typeof getUserWorkwithfriendsBlockedusers>>, TError = ErrorType<string | GetUserWorkwithfriendsBlockedusers500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserWorkwithfriendsBlockedusers>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserWorkwithfriendsBlockedusersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserWorkwithfriendsBlockedusers>>> = ({ signal }) => getUserWorkwithfriendsBlockedusers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserWorkwithfriendsBlockedusers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserWorkwithfriendsBlockedusersQueryResult = NonNullable<Awaited<ReturnType<typeof getUserWorkwithfriendsBlockedusers>>>
export type GetUserWorkwithfriendsBlockedusersQueryError = ErrorType<string | GetUserWorkwithfriendsBlockedusers500>

export const useGetUserWorkwithfriendsBlockedusers = <TData = Awaited<ReturnType<typeof getUserWorkwithfriendsBlockedusers>>, TError = ErrorType<string | GetUserWorkwithfriendsBlockedusers500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserWorkwithfriendsBlockedusers>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserWorkwithfriendsBlockedusersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a clinician's global status for Work With Friends notification setup
 */
export const getUserWorkwithfriendsStatus = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserWorkwithfriendsStatus200Item[]>(
      {url: `/user/workwithfriends/status`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserWorkwithfriendsStatusQueryKey = () => {
    return [`/user/workwithfriends/status`] as const;
    }

    
export const getGetUserWorkwithfriendsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserWorkwithfriendsStatus>>, TError = ErrorType<string | GetUserWorkwithfriendsStatus500>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserWorkwithfriendsStatus>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserWorkwithfriendsStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserWorkwithfriendsStatus>>> = ({ signal }) => getUserWorkwithfriendsStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserWorkwithfriendsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserWorkwithfriendsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserWorkwithfriendsStatus>>>
export type GetUserWorkwithfriendsStatusQueryError = ErrorType<string | GetUserWorkwithfriendsStatus500>

export const useGetUserWorkwithfriendsStatus = <TData = Awaited<ReturnType<typeof getUserWorkwithfriendsStatus>>, TError = ErrorType<string | GetUserWorkwithfriendsStatus500>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserWorkwithfriendsStatus>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserWorkwithfriendsStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Toggles a clinicians global status for work with friend notification setup
 */
export const putUserWorkwithfriendsToggleblockstatus = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutUserWorkwithfriendsToggleblockstatus200Item[]>(
      {url: `/user/workwithfriends/toggleblockstatus`, method: 'PUT'
    },
      options);
    }
  


export const getPutUserWorkwithfriendsToggleblockstatusMutationOptions = <TError = ErrorType<string | PutUserWorkwithfriendsToggleblockstatus500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserWorkwithfriendsToggleblockstatus>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserWorkwithfriendsToggleblockstatus>>, TError,void, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserWorkwithfriendsToggleblockstatus>>, void> = () => {
          

          return  putUserWorkwithfriendsToggleblockstatus(requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUserWorkwithfriendsToggleblockstatusMutationResult = NonNullable<Awaited<ReturnType<typeof putUserWorkwithfriendsToggleblockstatus>>>
    
    export type PutUserWorkwithfriendsToggleblockstatusMutationError = ErrorType<string | PutUserWorkwithfriendsToggleblockstatus500>

    export const usePutUserWorkwithfriendsToggleblockstatus = <TError = ErrorType<string | PutUserWorkwithfriendsToggleblockstatus500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserWorkwithfriendsToggleblockstatus>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUserWorkwithfriendsToggleblockstatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Toggles a clinician's friend's blocked status
 */
export const postUserWorkwithfriendsToggleblockstatusBlockid = (
    blockid: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUserWorkwithfriendsToggleblockstatusBlockid200Item[]>(
      {url: `/user/workwithfriends/toggleblockstatus/${blockid}`, method: 'POST'
    },
      options);
    }
  


export const getPostUserWorkwithfriendsToggleblockstatusBlockidMutationOptions = <TError = ErrorType<PostUserWorkwithfriendsToggleblockstatusBlockid400 | string | PostUserWorkwithfriendsToggleblockstatusBlockid500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserWorkwithfriendsToggleblockstatusBlockid>>, TError,{blockid: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserWorkwithfriendsToggleblockstatusBlockid>>, TError,{blockid: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserWorkwithfriendsToggleblockstatusBlockid>>, {blockid: number}> = (props) => {
          const {blockid} = props ?? {};

          return  postUserWorkwithfriendsToggleblockstatusBlockid(blockid,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUserWorkwithfriendsToggleblockstatusBlockidMutationResult = NonNullable<Awaited<ReturnType<typeof postUserWorkwithfriendsToggleblockstatusBlockid>>>
    
    export type PostUserWorkwithfriendsToggleblockstatusBlockidMutationError = ErrorType<PostUserWorkwithfriendsToggleblockstatusBlockid400 | string | PostUserWorkwithfriendsToggleblockstatusBlockid500>

    export const usePostUserWorkwithfriendsToggleblockstatusBlockid = <TError = ErrorType<PostUserWorkwithfriendsToggleblockstatusBlockid400 | string | PostUserWorkwithfriendsToggleblockstatusBlockid500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserWorkwithfriendsToggleblockstatusBlockid>>, TError,{blockid: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUserWorkwithfriendsToggleblockstatusBlockidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUsersUserIdAccessLevel = (
    userId: number,
    postUsersUserIdAccessLevelBody: PostUsersUserIdAccessLevelBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/users/${userId}/access-level`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUsersUserIdAccessLevelBody
    },
      options);
    }
  


export const getPostUsersUserIdAccessLevelMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersUserIdAccessLevel>>, TError,{userId: number;data: PostUsersUserIdAccessLevelBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUsersUserIdAccessLevel>>, TError,{userId: number;data: PostUsersUserIdAccessLevelBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersUserIdAccessLevel>>, {userId: number;data: PostUsersUserIdAccessLevelBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  postUsersUserIdAccessLevel(userId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUsersUserIdAccessLevelMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersUserIdAccessLevel>>>
    export type PostUsersUserIdAccessLevelMutationBody = PostUsersUserIdAccessLevelBody
    export type PostUsersUserIdAccessLevelMutationError = ErrorType<string>

    export const usePostUsersUserIdAccessLevel = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersUserIdAccessLevel>>, TError,{userId: number;data: PostUsersUserIdAccessLevelBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUsersUserIdAccessLevelMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Get whether or not a one time event has happened for a user
 */
export const getUsersUserIdOneTimeEventsEventName = (
    userId: number,
    eventName: string,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUsersUserIdOneTimeEventsEventName200>(
      {url: `/users/${userId}/one-time-events/${eventName}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUsersUserIdOneTimeEventsEventNameQueryKey = (userId: number,
    eventName: string,) => {
    return [`/users/${userId}/one-time-events/${eventName}`] as const;
    }

    
export const getGetUsersUserIdOneTimeEventsEventNameQueryOptions = <TData = Awaited<ReturnType<typeof getUsersUserIdOneTimeEventsEventName>>, TError = ErrorType<string>>(userId: number,
    eventName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdOneTimeEventsEventName>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersUserIdOneTimeEventsEventNameQueryKey(userId,eventName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersUserIdOneTimeEventsEventName>>> = ({ signal }) => getUsersUserIdOneTimeEventsEventName(userId,eventName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId && eventName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdOneTimeEventsEventName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUsersUserIdOneTimeEventsEventNameQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersUserIdOneTimeEventsEventName>>>
export type GetUsersUserIdOneTimeEventsEventNameQueryError = ErrorType<string>

export const useGetUsersUserIdOneTimeEventsEventName = <TData = Awaited<ReturnType<typeof getUsersUserIdOneTimeEventsEventName>>, TError = ErrorType<string>>(
 userId: number,
    eventName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdOneTimeEventsEventName>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUsersUserIdOneTimeEventsEventNameQueryOptions(userId,eventName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Sets that a one time event has happened for a user
 */
export const putUsersUserIdOneTimeEventsEventName = (
    userId: number,
    eventName: string,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PutUsersUserIdOneTimeEventsEventName200>(
      {url: `/users/${userId}/one-time-events/${eventName}`, method: 'PUT'
    },
      options);
    }
  


export const getPutUsersUserIdOneTimeEventsEventNameMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdOneTimeEventsEventName>>, TError,{userId: number;eventName: string}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdOneTimeEventsEventName>>, TError,{userId: number;eventName: string}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersUserIdOneTimeEventsEventName>>, {userId: number;eventName: string}> = (props) => {
          const {userId,eventName} = props ?? {};

          return  putUsersUserIdOneTimeEventsEventName(userId,eventName,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUsersUserIdOneTimeEventsEventNameMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersUserIdOneTimeEventsEventName>>>
    
    export type PutUsersUserIdOneTimeEventsEventNameMutationError = ErrorType<string>

    export const usePutUsersUserIdOneTimeEventsEventName = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdOneTimeEventsEventName>>, TError,{userId: number;eventName: string}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUsersUserIdOneTimeEventsEventNameMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUsersUserIdSkills = (
    userId: number,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUsersUserIdSkills200>(
      {url: `/users/${userId}/skills`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUsersUserIdSkillsQueryKey = (userId: number,) => {
    return [`/users/${userId}/skills`] as const;
    }

    
export const getGetUsersUserIdSkillsQueryOptions = <TData = Awaited<ReturnType<typeof getUsersUserIdSkills>>, TError = ErrorType<string>>(userId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSkills>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersUserIdSkillsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersUserIdSkills>>> = ({ signal }) => getUsersUserIdSkills(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSkills>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUsersUserIdSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersUserIdSkills>>>
export type GetUsersUserIdSkillsQueryError = ErrorType<string>

export const useGetUsersUserIdSkills = <TData = Awaited<ReturnType<typeof getUsersUserIdSkills>>, TError = ErrorType<string>>(
 userId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSkills>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUsersUserIdSkillsQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUsersUserIdSkills = (
    userId: number,
    postUsersUserIdSkillsBody: PostUsersUserIdSkillsBody,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostUsersUserIdSkills200>(
      {url: `/users/${userId}/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUsersUserIdSkillsBody
    },
      options);
    }
  


export const getPostUsersUserIdSkillsMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersUserIdSkills>>, TError,{userId: number;data: PostUsersUserIdSkillsBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUsersUserIdSkills>>, TError,{userId: number;data: PostUsersUserIdSkillsBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersUserIdSkills>>, {userId: number;data: PostUsersUserIdSkillsBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  postUsersUserIdSkills(userId,data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PostUsersUserIdSkillsMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersUserIdSkills>>>
    export type PostUsersUserIdSkillsMutationBody = PostUsersUserIdSkillsBody
    export type PostUsersUserIdSkillsMutationError = ErrorType<string>

    export const usePostUsersUserIdSkills = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersUserIdSkills>>, TError,{userId: number;data: PostUsersUserIdSkillsBody}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPostUsersUserIdSkillsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Deletes a user-skill. Returns '204 No Content' if successful. Returns '404 Not Found' if there was no matching user-skill.
 */
export const deleteUsersUserIdSkillsSkillId = (
    userId: number,
    skillId: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/users/${userId}/skills/${skillId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUsersUserIdSkillsSkillIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersUserIdSkillsSkillId>>, TError,{userId: number;skillId: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUsersUserIdSkillsSkillId>>, TError,{userId: number;skillId: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUsersUserIdSkillsSkillId>>, {userId: number;skillId: number}> = (props) => {
          const {userId,skillId} = props ?? {};

          return  deleteUsersUserIdSkillsSkillId(userId,skillId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteUsersUserIdSkillsSkillIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUsersUserIdSkillsSkillId>>>
    
    export type DeleteUsersUserIdSkillsSkillIdMutationError = ErrorType<string>

    export const useDeleteUsersUserIdSkillsSkillId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersUserIdSkillsSkillId>>, TError,{userId: number;skillId: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getDeleteUsersUserIdSkillsSkillIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putUsersUserIdSkillsSkillId = (
    userId: number,
    skillId: number,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/users/${userId}/skills/${skillId}`, method: 'PUT'
    },
      options);
    }
  


export const getPutUsersUserIdSkillsSkillIdMutationOptions = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdSkillsSkillId>>, TError,{userId: number;skillId: number}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdSkillsSkillId>>, TError,{userId: number;skillId: number}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersUserIdSkillsSkillId>>, {userId: number;skillId: number}> = (props) => {
          const {userId,skillId} = props ?? {};

          return  putUsersUserIdSkillsSkillId(userId,skillId,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PutUsersUserIdSkillsSkillIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersUserIdSkillsSkillId>>>
    
    export type PutUsersUserIdSkillsSkillIdMutationError = ErrorType<string>

    export const usePutUsersUserIdSkillsSkillId = <TError = ErrorType<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdSkillsSkillId>>, TError,{userId: number;skillId: number}, TContext>, request?: SecondParameter<typeof request>}
) => {

      const mutationOptions = getPutUsersUserIdSkillsSkillIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getYearsofexp = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetYearsofexp200Item[]>(
      {url: `/yearsofexp`, method: 'GET', signal
    },
      options);
    }
  

export const getGetYearsofexpQueryKey = () => {
    return [`/yearsofexp`] as const;
    }

    
export const getGetYearsofexpQueryOptions = <TData = Awaited<ReturnType<typeof getYearsofexp>>, TError = ErrorType<string>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getYearsofexp>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetYearsofexpQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getYearsofexp>>> = ({ signal }) => getYearsofexp(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getYearsofexp>>, TError, TData> & { queryKey: QueryKey }
}

export type GetYearsofexpQueryResult = NonNullable<Awaited<ReturnType<typeof getYearsofexp>>>
export type GetYearsofexpQueryError = ErrorType<string>

export const useGetYearsofexp = <TData = Awaited<ReturnType<typeof getYearsofexp>>, TError = ErrorType<string>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getYearsofexp>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetYearsofexpQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




